/**
 * ALLOGGIATI WEB — Tabella Comuni / Luoghi (Polizia di Stato — Italia)
 *
 * code     = Codice numerico a 9 cifre dal portale Alloggiati Web (campo "Comune Nascita")
 * nome     = Nome ufficiale in MAIUSCOLO
 * provincia = Sigla provincia (2 lettere)
 *
 * Fonte ufficiale (scaricata direttamente dal portale):
 *   https://alloggiatiweb.poliziadistato.it/portalealloggiati/ashx/Download.ashx?ID=0&N=COMUNI
 *
 * Solo comuni attivi (DataFineVal vuota) — 7.898 comuni.
 * Il servizio AlloggiatiWebService invia il code nel campo [105-113] del tracciato.
 */

export const ALLOGGIATI_COMUNI = [
  { code: "405028001", nome: "ABANO TERME", provincia: "PD" },
  { code: "403098001", nome: "ABBADIA CERRETO", provincia: "LO" },
  { code: "403097001", nome: "ABBADIA LARIANA", provincia: "LC" },
  { code: "409052001", nome: "ABBADIA SAN SALVATORE", provincia: "SI" },
  { code: "420095001", nome: "ABBASANTA", provincia: "OR" },
  { code: "413068001", nome: "ABBATEGGIO", provincia: "PE" },
  { code: "403015002", nome: "ABBIATEGRASSO", provincia: "MI" },
  { code: "409047023", nome: "ABETONE CUTIGLIANO", provincia: "PT" },
  { code: "417076001", nome: "ABRIOLA", provincia: "PZ" },
  { code: "419088001", nome: "ACATE", provincia: "RG" },
  { code: "416071001", nome: "ACCADIA", provincia: "FG" },
  { code: "401004001", nome: "ACCEGLIO", provincia: "CN" },
  { code: "417077001", nome: "ACCETTURA", provincia: "MT" },
  { code: "413066001", nome: "ACCIANO", provincia: "AQ" },
  { code: "412057001", nome: "ACCUMOLI", provincia: "RI" },
  { code: "417076002", nome: "ACERENZA", provincia: "PZ" },
  { code: "415065001", nome: "ACERNO", provincia: "SA" },
  { code: "415063001", nome: "ACERRA", provincia: "NA" },
  { code: "419087001", nome: "ACI BONACCORSI", provincia: "CT" },
  { code: "419087002", nome: "ACI CASTELLO", provincia: "CT" },
  { code: "419087003", nome: "ACI CATENA", provincia: "CT" },
  { code: "419087005", nome: "ACI SANT\'ANTONIO", provincia: "CT" },
  { code: "419087004", nome: "ACIREALE", provincia: "CT" },
  { code: "412060001", nome: "ACQUAFONDATA", provincia: "FR" },
  { code: "418078001", nome: "ACQUAFORMOSA", provincia: "CS" },
  { code: "403017001", nome: "ACQUAFREDDA", provincia: "BS" },
  { code: "411141001", nome: "ACQUALAGNA", provincia: "PU" },
  { code: "403019001", nome: "ACQUANEGRA CREMONESE", provincia: "CR" },
  { code: "403020001", nome: "ACQUANEGRA SUL CHIESE", provincia: "MN" },
  { code: "412056001", nome: "ACQUAPENDENTE", provincia: "VT" },
  { code: "418078002", nome: "ACQUAPPESA", provincia: "CS" },
  { code: "418102001", nome: "ACQUARO", provincia: "VV" },
  { code: "411044001", nome: "ACQUASANTA TERME", provincia: "AP" },
  { code: "410055001", nome: "ACQUASPARTA", provincia: "TR" },
  { code: "414070001", nome: "ACQUAVIVA COLLECROCE", provincia: "CB" },
  { code: "414094001", nome: "ACQUAVIVA D\'ISERNIA", provincia: "IS" },
  { code: "416072001", nome: "ACQUAVIVA DELLE FONTI", provincia: "BA" },
  { code: "411044002", nome: "ACQUAVIVA PICENA", provincia: "AP" },
  { code: "419085001", nome: "ACQUAVIVA PLATANI", provincia: "CL" },
  { code: "419083107", nome: "ACQUEDOLCI", provincia: "ME" },
  { code: "401006001", nome: "ACQUI TERME", provincia: "AL" },
  { code: "418078003", nome: "ACRI", provincia: "CS" },
  { code: "412060002", nome: "ACUTO", provincia: "FR" },
  { code: "416072002", nome: "ADELFIA", provincia: "BA" },
  { code: "419087006", nome: "ADRANO", provincia: "CT" },
  { code: "403016001", nome: "ADRARA SAN MARTINO", provincia: "BG" },
  { code: "403016002", nome: "ADRARA SAN ROCCO", provincia: "BG" },
  { code: "405029001", nome: "ADRIA", provincia: "RO" },
  { code: "403017002", nome: "ADRO", provincia: "BS" },
  { code: "405023001", nome: "AFFI", provincia: "VR" },
  { code: "412058001", nome: "AFFILE", provincia: "RM" },
  { code: "415063002", nome: "AFRAGOLA", provincia: "NA" },
  { code: "418080001", nome: "AFRICO", provincia: "RC" },
  { code: "408033001", nome: "AGAZZANO", provincia: "PC" },
  { code: "415063003", nome: "AGEROLA", provincia: "NA" },
  { code: "420090001", nome: "AGGIUS", provincia: "SS" },
  { code: "419086001", nome: "AGIRA", provincia: "EN" },
  { code: "409047002", nome: "AGLIANA", provincia: "PT" },
  { code: "401005001", nome: "AGLIANO TERME", provincia: "AT" },
  { code: "401001001", nome: "AGLIE\'", provincia: "TO" },
  { code: "420090062", nome: "AGLIENTU", provincia: "SS" },
  { code: "405028002", nome: "AGNA", provincia: "PD" },
  { code: "403019002", nome: "AGNADELLO", provincia: "CR" },
  { code: "418080002", nome: "AGNANA CALABRA", provincia: "RC" },
  { code: "414094002", nome: "AGNONE", provincia: "IS" },
  { code: "403017003", nome: "AGNOSINE", provincia: "BS" },
  { code: "405025001", nome: "AGORDO", provincia: "BL" },
  { code: "412058002", nome: "AGOSTA", provincia: "RM" },
  { code: "403012001", nome: "AGRA", provincia: "VA" },
  { code: "403108001", nome: "AGRATE BRIANZA", provincia: "MB" },
  { code: "401003001", nome: "AGRATE CONTURBIA", provincia: "NO" },
  { code: "419084001", nome: "AGRIGENTO", provincia: "AG" },
  { code: "415065002", nome: "AGROPOLI", provincia: "SA" },
  { code: "411042001", nome: "AGUGLIANO", provincia: "AN" },
  { code: "405024001", nome: "AGUGLIARO", provincia: "VI" },
  { code: "403108002", nome: "AICURZIO", provincia: "MB" },
  { code: "420095002", nome: "AIDOMAGGIORE", provincia: "OR" },
  { code: "419086002", nome: "AIDONE", provincia: "EN" },
  { code: "413066002", nome: "AIELLI", provincia: "AQ" },
  { code: "418078004", nome: "AIELLO CALABRO", provincia: "CS" },
  { code: "406030001", nome: "AIELLO DEL FRIULI", provincia: "UD" },
  { code: "415064001", nome: "AIELLO DEL SABATO", provincia: "AV" },
  { code: "418078005", nome: "AIETA", provincia: "CS" },
  { code: "415061001", nome: "AILANO", provincia: "CE" },
  { code: "401096001", nome: "AILOCHE", provincia: "BI" },
  { code: "401001002", nome: "AIRASCA", provincia: "TO" },
  { code: "415062001", nome: "AIROLA", provincia: "BN" },
  { code: "407008001", nome: "AIROLE", provincia: "IM" },
  { code: "403097002", nome: "AIRUNO", provincia: "LC" },
  { code: "401004002", nome: "AISONE", provincia: "CN" },
  { code: "401001003", nome: "ALA DI STURA", provincia: "TO" },
  { code: "420090002", nome: "ALA\' DEI SARDI", provincia: "SS" },
  { code: "404022001", nome: "ALA", provincia: "TN" },
  { code: "401002002", nome: "ALAGNA VALSESIA", provincia: "VC" },
  { code: "403018001", nome: "ALAGNA", provincia: "PV" },
  { code: "413068002", nome: "ALANNO", provincia: "PE" },
  { code: "407009001", nome: "ALASSIO", provincia: "SV" },
  { code: "412060003", nome: "ALATRI", provincia: "FR" },
  { code: "413067001", nome: "ALBA ADRIATICA", provincia: "TE" },
  { code: "401004003", nome: "ALBA", provincia: "CN" },
  { code: "420095003", nome: "ALBAGIARA", provincia: "OR" },
  { code: "403015005", nome: "ALBAIRATE", provincia: "MI" },
  { code: "415065003", nome: "ALBANELLA", provincia: "SA" },
  { code: "417076003", nome: "ALBANO DI LUCANIA", provincia: "PZ" },
  { code: "412058003", nome: "ALBANO LAZIALE", provincia: "RM" },
  { code: "403016003", nome: "ALBANO SANT\'ALESSANDRO", provincia: "BG" },
  { code: "401002003", nome: "ALBANO VERCELLESE", provincia: "VC" },
  { code: "405023002", nome: "ALBAREDO D\'ADIGE", provincia: "VR" },
  { code: "403014001", nome: "ALBAREDO PER SAN MARCO", provincia: "SO" },
  { code: "408034001", nome: "ALBARETO", provincia: "PR" },
  { code: "401004004", nome: "ALBARETTO DELLA TORRE", provincia: "CN" },
  { code: "403013003", nome: "ALBAVILLA", provincia: "CO" },
  { code: "407009002", nome: "ALBENGA", provincia: "SV" },
  { code: "401006002", nome: "ALBERA LIGURE", provincia: "AL" },
  { code: "416072003", nome: "ALBEROBELLO", provincia: "BA" },
  { code: "416071002", nome: "ALBERONA", provincia: "FG" },
  { code: "403013004", nome: "ALBESE CON CASSANO", provincia: "CO" },
  { code: "405024002", nome: "ALBETTONE", provincia: "VI" },
  { code: "418079002", nome: "ALBI", provincia: "CZ" },
  { code: "401001004", nome: "ALBIANO D\'IVREA", provincia: "TO" },
  { code: "404022002", nome: "ALBIANO", provincia: "TN" },
  { code: "403108003", nome: "ALBIATE", provincia: "MB" },
  { code: "418078006", nome: "ALBIDONA", provincia: "CS" },
  { code: "405028003", nome: "ALBIGNASEGO", provincia: "PD" },
  { code: "408035001", nome: "ALBINEA", provincia: "RE" },
  { code: "403016004", nome: "ALBINO", provincia: "BG" },
  { code: "403013005", nome: "ALBIOLO", provincia: "CO" },
  { code: "407009004", nome: "ALBISOLA SUPERIORE", provincia: "SV" },
  { code: "407009003", nome: "ALBISSOLA MARINA", provincia: "SV" },
  { code: "403012002", nome: "ALBIZZATE", provincia: "VA" },
  { code: "403018003", nome: "ALBONESE", provincia: "PV" },
  { code: "403014002", nome: "ALBOSAGGIA", provincia: "SO" },
  { code: "401005002", nome: "ALBUGNANO", provincia: "AT" },
  { code: "403018004", nome: "ALBUZZANO", provincia: "PV" },
  { code: "419081001", nome: "ALCAMO", provincia: "TP" },
  { code: "419083001", nome: "ALCARA LI FUSI", provincia: "ME" },
  { code: "404022003", nome: "ALDENO", provincia: "TN" },
  { code: "404021001", nome: "ALDINO", provincia: "BZ" },
  { code: "420095004", nome: "ALES", provincia: "OR" },
  { code: "418078007", nome: "ALESSANDRIA DEL CARRETTO", provincia: "CS" },
  { code: "419084002", nome: "ALESSANDRIA DELLA ROCCA", provincia: "AG" },
  { code: "401006003", nome: "ALESSANDRIA", provincia: "AL" },
  { code: "416075002", nome: "ALESSANO", provincia: "LE" },
  { code: "416075003", nome: "ALEZIO", provincia: "LE" },
  { code: "415065004", nome: "ALFANO", provincia: "SA" },
  { code: "413066003", nome: "ALFEDENA", provincia: "AQ" },
  { code: "403017004", nome: "ALFIANELLO", provincia: "BS" },
  { code: "401006004", nome: "ALFIANO NATTA", provincia: "AL" },
  { code: "408039001", nome: "ALFONSINE", provincia: "RA" },
  { code: "420090003", nome: "ALGHERO", provincia: "SS" },
  { code: "403016248", nome: "ALGUA", provincia: "BG" },
  { code: "419083003", nome: "ALI\' TERME", provincia: "ME" },
  { code: "419083002", nome: "ALI\'", provincia: "ME" },
  { code: "419082001", nome: "ALIA", provincia: "PA" },
  { code: "417077002", nome: "ALIANO", provincia: "MT" },
  { code: "401006005", nome: "ALICE BEL COLLE", provincia: "AL" },
  { code: "401002004", nome: "ALICE CASTELLO", provincia: "VC" },
  { code: "415061002", nome: "ALIFE", provincia: "CE" },
  { code: "419082002", nome: "ALIMENA", provincia: "PA" },
  { code: "419082003", nome: "ALIMINUSA", provincia: "PA" },
  { code: "420095005", nome: "ALLAI", provincia: "OR" },
  { code: "405025003", nome: "ALLEGHE", provincia: "BL" },
  { code: "402007001", nome: "ALLEIN", provincia: "AO" },
  { code: "410055002", nome: "ALLERONA", provincia: "TR" },
  { code: "416075004", nome: "ALLISTE", provincia: "LE" },
  { code: "412058004", nome: "ALLUMIERE", provincia: "RM" },
  { code: "401006192", nome: "ALLUVIONI PIOVERA", provincia: "AL" },
  { code: "403016005", nome: "ALME\'", provincia: "BG" },
  { code: "403016006", nome: "ALMENNO SAN BARTOLOMEO", provincia: "BG" },
  { code: "403016007", nome: "ALMENNO SAN SALVATORE", provincia: "BG" },
  { code: "401001006", nome: "ALMESE", provincia: "TO" },
  { code: "405024003", nome: "ALONTE", provincia: "VI" },
  { code: "405025072", nome: "ALPAGO", provincia: "BL" },
  { code: "401001007", nome: "ALPETTE", provincia: "TO" },
  { code: "401001008", nome: "ALPIGNANO", provincia: "TO" },
  { code: "408033002", nome: "ALSENO", provincia: "PC" },
  { code: "403013006", nome: "ALSERIO", provincia: "CO" },
  { code: "408033049", nome: "ALTA VAL TIDONE", provincia: "PC" },
  { code: "403013253", nome: "ALTA VALLE INTELVI", provincia: "CO" },
  { code: "416072004", nome: "ALTAMURA", provincia: "BA" },
  { code: "407009005", nome: "ALTARE", provincia: "SV" },
  { code: "404022235", nome: "ALTAVALLE", provincia: "TN" },
  { code: "415064002", nome: "ALTAVILLA IRPINA", provincia: "AV" },
  { code: "419082004", nome: "ALTAVILLA MILICIA", provincia: "PA" },
  { code: "401006007", nome: "ALTAVILLA MONFERRATO", provincia: "AL" },
  { code: "415065005", nome: "ALTAVILLA SILENTINA", provincia: "SA" },
  { code: "405024004", nome: "ALTAVILLA VICENTINA", provincia: "VI" },
  { code: "411109001", nome: "ALTIDONA", provincia: "FM" },
  { code: "418078008", nome: "ALTILIA", provincia: "CS" },
  { code: "413069001", nome: "ALTINO", provincia: "CH" },
  { code: "405024005", nome: "ALTISSIMO", provincia: "VI" },
  { code: "405026001", nome: "ALTIVOLE", provincia: "TV" },
  { code: "408037062", nome: "ALTO RENO TERME", provincia: "BO" },
  { code: "401002170", nome: "ALTO SERMENZA", provincia: "VC" },
  { code: "401004005", nome: "ALTO", provincia: "CN" },
  { code: "419082005", nome: "ALTOFONTE", provincia: "PA" },
  { code: "418078009", nome: "ALTOMONTE", provincia: "CS" },
  { code: "409046001", nome: "ALTOPASCIO", provincia: "LU" },
  { code: "404022236", nome: "ALTOPIANO DELLA VIGOLANA", provincia: "TN" },
  { code: "410055003", nome: "ALVIANO", provincia: "TR" },
  { code: "415061003", nome: "ALVIGNANO", provincia: "CE" },
  { code: "412060004", nome: "ALVITO", provincia: "FR" },
  { code: "403016008", nome: "ALZANO LOMBARDO", provincia: "BG" },
  { code: "401006008", nome: "ALZANO SCRIVIA", provincia: "AL" },
  { code: "403013007", nome: "ALZATE BRIANZA", provincia: "CO" },
  { code: "415065006", nome: "AMALFI", provincia: "SA" },
  { code: "411109002", nome: "AMANDOLA", provincia: "FM" },
  { code: "418078010", nome: "AMANTEA", provincia: "CS" },
  { code: "406030002", nome: "AMARO", provincia: "UD" },
  { code: "418079003", nome: "AMARONI", provincia: "CZ" },
  { code: "412060005", nome: "AMASENO", provincia: "FR" },
  { code: "418079004", nome: "AMATO", provincia: "CZ" },
  { code: "412057002", nome: "AMATRICE", provincia: "RI" },
  { code: "403016009", nome: "AMBIVERE", provincia: "BG" },
  { code: "404022237", nome: "AMBLAR-DON", provincia: "TN" },
  { code: "407011001", nome: "AMEGLIA", provincia: "SP" },
  { code: "410055004", nome: "AMELIA", provincia: "TR" },
  { code: "418078011", nome: "AMENDOLARA", provincia: "CS" },
  { code: "401003002", nome: "AMENO", provincia: "NO" },
  { code: "415062002", nome: "AMOROSI", provincia: "BN" },
  { code: "406030003", nome: "AMPEZZO", provincia: "UD" },
  { code: "415063004", nome: "ANACAPRI", provincia: "NA" },
  { code: "412060006", nome: "ANAGNI", provincia: "FR" },
  { code: "413067002", nome: "ANCARANO", provincia: "TE" },
  { code: "411042002", nome: "ANCONA", provincia: "AN" },
  { code: "418079005", nome: "ANDALI", provincia: "CZ" },
  { code: "403014003", nome: "ANDALO VALTELLINO", provincia: "SO" },
  { code: "404022005", nome: "ANDALO", provincia: "TN" },
  { code: "401001009", nome: "ANDEZENO", provincia: "TO" },
  { code: "407009006", nome: "ANDORA", provincia: "SV" },
  { code: "401096002", nome: "ANDORNO MICCA", provincia: "BI" },
  { code: "416075005", nome: "ANDRANO", provincia: "LE" },
  { code: "401001010", nome: "ANDRATE", provincia: "TO" },
  { code: "406093001", nome: "ANDREIS", provincia: "PN" },
  { code: "415064003", nome: "ANDRETTA", provincia: "AV" },
  { code: "416110001", nome: "ANDRIA", provincia: "BT" },
  { code: "404021002", nome: "ANDRIANO", provincia: "BZ" },
  { code: "420090004", nome: "ANELA", provincia: "SS" },
  { code: "403017005", nome: "ANFO", provincia: "BS" },
  { code: "403012003", nome: "ANGERA", provincia: "VA" },
  { code: "409051001", nome: "ANGHIARI", provincia: "AR" },
  { code: "405023003", nome: "ANGIARI", provincia: "VR" },
  { code: "403017006", nome: "ANGOLO TERME", provincia: "BS" },
  { code: "415065007", nome: "ANGRI", provincia: "SA" },
  { code: "401001011", nome: "ANGROGNA", provincia: "TO" },
  { code: "412058005", nome: "ANGUILLARA SABAZIA", provincia: "RM" },
  { code: "405028004", nome: "ANGUILLARA VENETA", provincia: "PD" },
  { code: "403019003", nome: "ANNICCO", provincia: "CR" },
  { code: "403097003", nome: "ANNONE DI BRIANZA", provincia: "LC" },
  { code: "405027001", nome: "ANNONE VENETO", provincia: "VE" },
  { code: "418080003", nome: "ANOIA", provincia: "RC" },
  { code: "403016010", nome: "ANTEGNATE", provincia: "BG" },
  { code: "404021003", nome: "ANTERIVO", provincia: "BZ" },
  { code: "402007002", nome: "ANTEY-SAINT-ANDRE\'", provincia: "AO" },
  { code: "412058006", nome: "ANTICOLI CORRADO", provincia: "RM" },
  { code: "401005003", nome: "ANTIGNANO", provincia: "AT" },
  { code: "419083004", nome: "ANTILLO", provincia: "ME" },
  { code: "418080004", nome: "ANTONIMINA", provincia: "RC" },
  { code: "412057003", nome: "ANTRODOCO", provincia: "RI" },
  { code: "401103001", nome: "ANTRONA SCHIERANCO", provincia: "VB" },
  { code: "413066004", nome: "ANVERSA DEGLI ABRUZZI", provincia: "AQ" },
  { code: "403013009", nome: "ANZANO DEL PARCO", provincia: "CO" },
  { code: "416071003", nome: "ANZANO DI PUGLIA", provincia: "FG" },
  { code: "417076004", nome: "ANZI", provincia: "PZ" },
  { code: "412058007", nome: "ANZIO", provincia: "RM" },
  { code: "401103002", nome: "ANZOLA D\'OSSOLA", provincia: "VB" },
  { code: "408037001", nome: "ANZOLA DELL\'EMILIA", provincia: "BO" },
  { code: "402007003", nome: "AOSTA", provincia: "AO" },
  { code: "411141002", nome: "APECCHIO", provincia: "PU" },
  { code: "415062003", nome: "APICE", provincia: "BN" },
  { code: "411043002", nome: "APIRO", provincia: "MC" },
  { code: "415062004", nome: "APOLLOSA", provincia: "BN" },
  { code: "403013010", nome: "APPIANO GENTILE", provincia: "CO" },
  { code: "404021004", nome: "APPIANO SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "411044005", nome: "APPIGNANO DEL TRONTO", provincia: "AP" },
  { code: "411043003", nome: "APPIGNANO", provincia: "MC" },
  { code: "403014004", nome: "APRICA", provincia: "SO" },
  { code: "407008002", nome: "APRICALE", provincia: "IM" },
  { code: "416071004", nome: "APRICENA", provincia: "FG" },
  { code: "418078012", nome: "APRIGLIANO", provincia: "CS" },
  { code: "412059001", nome: "APRILIA", provincia: "LT" },
  { code: "415065008", nome: "AQUARA", provincia: "SA" },
  { code: "407008003", nome: "AQUILA D\'ARROSCIA", provincia: "IM" },
  { code: "406030004", nome: "AQUILEIA", provincia: "UD" },
  { code: "415064004", nome: "AQUILONIA", provincia: "AV" },
  { code: "412060007", nome: "AQUINO", provincia: "FR" },
  { code: "416075006", nome: "ARADEO", provincia: "LE" },
  { code: "419084003", nome: "ARAGONA", provincia: "AG" },
  { code: "401005004", nome: "ARAMENGO", provincia: "AT" },
  { code: "406093002", nome: "ARBA", provincia: "PN" },
  { code: "420095006", nome: "ARBOREA", provincia: "OR" },
  { code: "401002006", nome: "ARBORIO", provincia: "VC" },
  { code: "420092001", nome: "ARBUS", provincia: "CA" },
  { code: "405026002", nome: "ARCADE", provincia: "TV" },
  { code: "412060008", nome: "ARCE", provincia: "FR" },
  { code: "403016011", nome: "ARCENE", provincia: "BG" },
  { code: "411042003", nome: "ARCEVIA", provincia: "AN" },
  { code: "413069002", nome: "ARCHI", provincia: "CH" },
  { code: "409053001", nome: "ARCIDOSSO", provincia: "GR" },
  { code: "412058008", nome: "ARCINAZZO ROMANO", provincia: "RM" },
  { code: "403012004", nome: "ARCISATE", provincia: "VA" },
  { code: "404022006", nome: "ARCO", provincia: "TN" },
  { code: "407011002", nome: "ARCOLA", provincia: "SP" },
  { code: "405023004", nome: "ARCOLE", provincia: "VR" },
  { code: "403015007", nome: "ARCONATE", provincia: "MI" },
  { code: "403108004", nome: "ARCORE", provincia: "MB" },
  { code: "405024006", nome: "ARCUGNANO", provincia: "VI" },
  { code: "420090005", nome: "ARDARA", provincia: "SS" },
  { code: "420095007", nome: "ARDAULI", provincia: "OR" },
  { code: "412058117", nome: "ARDEA", provincia: "RM" },
  { code: "403014005", nome: "ARDENNO", provincia: "SO" },
  { code: "403016012", nome: "ARDESIO", provincia: "BG" },
  { code: "418080005", nome: "ARDORE", provincia: "RC" },
  { code: "403018005", nome: "ARENA PO", provincia: "PV" },
  { code: "418102002", nome: "ARENA", provincia: "VV" },
  { code: "407010001", nome: "ARENZANO", provincia: "GE" },
  { code: "403015009", nome: "ARESE", provincia: "MI" },
  { code: "409051002", nome: "AREZZO", provincia: "AR" },
  { code: "403013011", nome: "ARGEGNO", provincia: "CO" },
  { code: "408037002", nome: "ARGELATO", provincia: "BO" },
  { code: "408038001", nome: "ARGENTA", provincia: "FE" },
  { code: "401004006", nome: "ARGENTERA", provincia: "CN" },
  { code: "401004007", nome: "ARGUELLO", provincia: "CN" },
  { code: "418079007", nome: "ARGUSTO", provincia: "CZ" },
  { code: "413069003", nome: "ARI", provincia: "CH" },
  { code: "415064005", nome: "ARIANO IRPINO", provincia: "AV" },
  { code: "405029002", nome: "ARIANO NEL POLESINE", provincia: "RO" },
  { code: "412058009", nome: "ARICCIA", provincia: "RM" },
  { code: "413069004", nome: "ARIELLI", provincia: "CH" },
  { code: "415061004", nome: "ARIENZO", provincia: "CE" },
  { code: "401001012", nome: "ARIGNANO", provincia: "TO" },
  { code: "420091001", nome: "ARITZO", provincia: "NU" },
  { code: "401103003", nome: "ARIZZANO", provincia: "VB" },
  { code: "412056002", nome: "ARLENA DI CASTRO", provincia: "VT" },
  { code: "403015010", nome: "ARLUNO", provincia: "MI" },
  { code: "401003006", nome: "ARMENO", provincia: "NO" },
  { code: "417076005", nome: "ARMENTO", provincia: "PZ" },
  { code: "407008004", nome: "ARMO", provincia: "IM" },
  { code: "420092002", nome: "ARMUNGIA", provincia: "CA" },
  { code: "402007004", nome: "ARNAD", provincia: "AO" },
  { code: "412060009", nome: "ARNARA", provincia: "FR" },
  { code: "407009007", nome: "ARNASCO", provincia: "SV" },
  { code: "416075007", nome: "ARNESANO", provincia: "LE" },
  { code: "401103004", nome: "AROLA", provincia: "VB" },
  { code: "401003008", nome: "ARONA", provincia: "NO" },
  { code: "403013012", nome: "AROSIO", provincia: "CO" },
  { code: "415062005", nome: "ARPAIA", provincia: "BN" },
  { code: "415062006", nome: "ARPAISE", provincia: "BN" },
  { code: "412060010", nome: "ARPINO", provincia: "FR" },
  { code: "405028005", nome: "ARQUA\' PETRARCA", provincia: "PD" },
  { code: "405029003", nome: "ARQUA\' POLESINE", provincia: "RO" },
  { code: "411044006", nome: "ARQUATA DEL TRONTO", provincia: "AP" },
  { code: "401006009", nome: "ARQUATA SCRIVIA", provincia: "AL" },
  { code: "405028006", nome: "ARRE", provincia: "PD" },
  { code: "410055005", nome: "ARRONE", provincia: "TR" },
  { code: "403012005", nome: "ARSAGO SEPRIO", provincia: "VA" },
  { code: "405025004", nome: "ARSIE\'", provincia: "BL" },
  { code: "405024007", nome: "ARSIERO", provincia: "VI" },
  { code: "413067003", nome: "ARSITA", provincia: "TE" },
  { code: "412058010", nome: "ARSOLI", provincia: "RM" },
  { code: "406030005", nome: "ARTA TERME", provincia: "UD" },
  { code: "406030006", nome: "ARTEGNA", provincia: "UD" },
  { code: "412058011", nome: "ARTENA", provincia: "RM" },
  { code: "403017007", nome: "ARTOGNE", provincia: "BS" },
  { code: "402007005", nome: "ARVIER", provincia: "AO" },
  { code: "420090006", nome: "ARZACHENA", provincia: "SS" },
  { code: "403016013", nome: "ARZAGO D\'ADDA", provincia: "BG" },
  { code: "420091002", nome: "ARZANA", provincia: "NU" },
  { code: "415063005", nome: "ARZANO", provincia: "NA" },
  { code: "405028007", nome: "ARZERGRANDE", provincia: "PD" },
  { code: "405024008", nome: "ARZIGNANO", provincia: "VI" },
  { code: "415065009", nome: "ASCEA", provincia: "SA" },
  { code: "409052002", nome: "ASCIANO", provincia: "SI" },
  { code: "411044007", nome: "ASCOLI PICENO", provincia: "AP" },
  { code: "416071005", nome: "ASCOLI SATRIANO", provincia: "FG" },
  { code: "412057004", nome: "ASCREA", provincia: "RI" },
  { code: "405024009", nome: "ASIAGO", provincia: "VI" },
  { code: "405024010", nome: "ASIGLIANO VENETO", provincia: "VI" },
  { code: "401002007", nome: "ASIGLIANO VERCELLESE", provincia: "VC" },
  { code: "403020002", nome: "ASOLA", provincia: "MN" },
  { code: "405026003", nome: "ASOLO", provincia: "TV" },
  { code: "403015011", nome: "ASSAGO", provincia: "MI" },
  { code: "420092003", nome: "ASSEMINI", provincia: "CA" },
  { code: "410054001", nome: "ASSISI", provincia: "PG" },
  { code: "403013013", nome: "ASSO", provincia: "CO" },
  { code: "420095008", nome: "ASSOLO", provincia: "OR" },
  { code: "419086003", nome: "ASSORO", provincia: "EN" },
  { code: "401005005", nome: "ASTI", provincia: "AT" },
  { code: "420095009", nome: "ASUNI", provincia: "OR" },
  { code: "413066005", nome: "ATELETA", provincia: "AQ" },
  { code: "417076006", nome: "ATELLA", provincia: "PZ" },
  { code: "415065010", nome: "ATENA LUCANA", provincia: "SA" },
  { code: "413069005", nome: "ATESSA", provincia: "CH" },
  { code: "412060011", nome: "ATINA", provincia: "FR" },
  { code: "415065011", nome: "ATRANI", provincia: "SA" },
  { code: "413067004", nome: "ATRI", provincia: "TE" },
  { code: "415064006", nome: "ATRIPALDA", provincia: "AV" },
  { code: "410055006", nome: "ATTIGLIANO", provincia: "TR" },
  { code: "406030007", nome: "ATTIMIS", provincia: "UD" },
  { code: "420091003", nome: "ATZARA", provincia: "NU" },
  { code: "419089001", nome: "AUGUSTA", provincia: "SR" },
  { code: "415065012", nome: "AULETTA", provincia: "SA" },
  { code: "409045001", nome: "AULLA", provincia: "MS" },
  { code: "401103005", nome: "AURANO", provincia: "VB" },
  { code: "407008005", nome: "AURIGO", provincia: "IM" },
  { code: "405025005", nome: "AURONZO DI CADORE", provincia: "BL" },
  { code: "412060012", nome: "AUSONIA", provincia: "FR" },
  { code: "420091004", nome: "AUSTIS", provincia: "NU" },
  { code: "407010002", nome: "AVEGNO", provincia: "GE" },
  { code: "404021005", nome: "AVELENGO", provincia: "BZ" },
  { code: "415064007", nome: "AVELLA", provincia: "AV" },
  { code: "415064008", nome: "AVELLINO", provincia: "AV" },
  { code: "403016014", nome: "AVERARA", provincia: "BG" },
  { code: "415061005", nome: "AVERSA", provincia: "CE" },
  { code: "416073001", nome: "AVETRANA", provincia: "TA" },
  { code: "413066006", nome: "AVEZZANO", provincia: "AQ" },
  { code: "406093004", nome: "AVIANO", provincia: "PN" },
  { code: "403016015", nome: "AVIATICO", provincia: "BG" },
  { code: "401001013", nome: "AVIGLIANA", provincia: "TO" },
  { code: "410055033", nome: "AVIGLIANO UMBRO", provincia: "TR" },
  { code: "417076007", nome: "AVIGLIANO", provincia: "PZ" },
  { code: "404022007", nome: "AVIO", provincia: "TN" },
  { code: "402007006", nome: "AVISE", provincia: "AO" },
  { code: "419089002", nome: "AVOLA", provincia: "SR" },
  { code: "401006010", nome: "AVOLASCA", provincia: "AL" },
  { code: "402007007", nome: "AYAS", provincia: "AO" },
  { code: "402007008", nome: "AYMAVILLES", provincia: "AO" },
  { code: "401001014", nome: "AZEGLIO", provincia: "TO" },
  { code: "403019004", nome: "AZZANELLO", provincia: "CR" },
  { code: "401005006", nome: "AZZANO D\'ASTI", provincia: "AT" },
  { code: "406093005", nome: "AZZANO DECIMO", provincia: "PN" },
  { code: "403017008", nome: "AZZANO MELLA", provincia: "BS" },
  { code: "403016016", nome: "AZZANO SAN PAOLO", provincia: "BG" },
  { code: "403012006", nome: "AZZATE", provincia: "VA" },
  { code: "403012007", nome: "AZZIO", provincia: "VA" },
  { code: "403016017", nome: "AZZONE", provincia: "BG" },
  { code: "401103006", nome: "BACENO", provincia: "VB" },
  { code: "415063006", nome: "BACOLI", provincia: "NA" },
  { code: "407008006", nome: "BADALUCCO", provincia: "IM" },
  { code: "420090081", nome: "BADESI", provincia: "SS" },
  { code: "405023005", nome: "BADIA CALAVENA", provincia: "VR" },
  { code: "403018006", nome: "BADIA PAVESE", provincia: "PV" },
  { code: "405029004", nome: "BADIA POLESINE", provincia: "RO" },
  { code: "409051003", nome: "BADIA TEDALDA", provincia: "AR" },
  { code: "404021006", nome: "BADIA", provincia: "BZ" },
  { code: "418079008", nome: "BADOLATO", provincia: "CZ" },
  { code: "418080006", nome: "BAGALADI", provincia: "RC" },
  { code: "419082006", nome: "BAGHERIA", provincia: "PA" },
  { code: "408039002", nome: "BAGNACAVALLO", provincia: "RA" },
  { code: "418080007", nome: "BAGNARA CALABRA", provincia: "RC" },
  { code: "408039003", nome: "BAGNARA DI ROMAGNA", provincia: "RA" },
  { code: "406030008", nome: "BAGNARIA ARSA", provincia: "UD" },
  { code: "403018007", nome: "BAGNARIA", provincia: "PV" },
  { code: "401004008", nome: "BAGNASCO", provincia: "CN" },
  { code: "403016018", nome: "BAGNATICA", provincia: "BG" },
  { code: "409046002", nome: "BAGNI DI LUCCA", provincia: "LU" },
  { code: "409048001", nome: "BAGNO A RIPOLI", provincia: "FI" },
  { code: "408140001", nome: "BAGNO DI ROMAGNA", provincia: "FC" },
  { code: "414094003", nome: "BAGNOLI DEL TRIGNO", provincia: "IS" },
  { code: "405028008", nome: "BAGNOLI DI SOPRA", provincia: "PD" },
  { code: "415064009", nome: "BAGNOLI IRPINO", provincia: "AV" },
  { code: "403019005", nome: "BAGNOLO CREMASCO", provincia: "CR" },
  { code: "416075008", nome: "BAGNOLO DEL SALENTO", provincia: "LE" },
  { code: "405029005", nome: "BAGNOLO DI PO", provincia: "RO" },
  { code: "408035002", nome: "BAGNOLO IN PIANO", provincia: "RE" },
  { code: "403017009", nome: "BAGNOLO MELLA", provincia: "BS" },
  { code: "401004009", nome: "BAGNOLO PIEMONTE", provincia: "CN" },
  { code: "403020003", nome: "BAGNOLO SAN VITO", provincia: "MN" },
  { code: "409045002", nome: "BAGNONE", provincia: "MS" },
  { code: "412056003", nome: "BAGNOREGIO", provincia: "VT" },
  { code: "403017010", nome: "BAGOLINO", provincia: "BS" },
  { code: "415061006", nome: "BAIA E LATINA", provincia: "CE" },
  { code: "415064010", nome: "BAIANO", provincia: "AV" },
  { code: "401001015", nome: "BAIRO", provincia: "TO" },
  { code: "408035003", nome: "BAISO", provincia: "RE" },
  { code: "407008007", nome: "BAJARDO", provincia: "IM" },
  { code: "401001016", nome: "BALANGERO", provincia: "TO" },
  { code: "401005007", nome: "BALDICHIERI D\'ASTI", provincia: "AT" },
  { code: "401001017", nome: "BALDISSERO CANAVESE", provincia: "TO" },
  { code: "401004010", nome: "BALDISSERO D\'ALBA", provincia: "CN" },
  { code: "401001018", nome: "BALDISSERO TORINESE", provincia: "TO" },
  { code: "419082007", nome: "BALESTRATE", provincia: "PA" },
  { code: "407009008", nome: "BALESTRINO", provincia: "SV" },
  { code: "403097004", nome: "BALLABIO", provincia: "LC" },
  { code: "420092004", nome: "BALLAO", provincia: "CA" },
  { code: "401001019", nome: "BALME", provincia: "TO" },
  { code: "401002008", nome: "BALMUCCIA", provincia: "VC" },
  { code: "401002009", nome: "BALOCCO", provincia: "VC" },
  { code: "413066007", nome: "BALSORANO", provincia: "AQ" },
  { code: "417076008", nome: "BALVANO", provincia: "PZ" },
  { code: "401006011", nome: "BALZOLA", provincia: "AL" },
  { code: "420090007", nome: "BANARI", provincia: "SS" },
  { code: "401001020", nome: "BANCHETTE", provincia: "TO" },
  { code: "401103007", nome: "BANNIO ANZINO", provincia: "VB" },
  { code: "417076009", nome: "BANZI", provincia: "PZ" },
  { code: "405028009", nome: "BAONE", provincia: "PD" },
  { code: "420095010", nome: "BARADILI", provincia: "OR" },
  { code: "417076010", nome: "BARAGIANO", provincia: "PZ" },
  { code: "414070002", nome: "BARANELLO", provincia: "CB" },
  { code: "415063007", nome: "BARANO D\'ISCHIA", provincia: "NA" },
  { code: "403015250", nome: "BARANZATE", provincia: "MI" },
  { code: "403012008", nome: "BARASSO", provincia: "VA" },
  { code: "420095011", nome: "BARATILI SAN PIETRO", provincia: "OR" },
  { code: "401001021", nome: "BARBANIA", provincia: "TO" },
  { code: "411042004", nome: "BARBARA", provincia: "AN" },
  { code: "405024124", nome: "BARBARANO MOSSANO", provincia: "VI" },
  { code: "412056004", nome: "BARBARANO ROMANO", provincia: "VT" },
  { code: "401004011", nome: "BARBARESCO", provincia: "CN" },
  { code: "403017011", nome: "BARBARIGA", provincia: "BS" },
  { code: "403016019", nome: "BARBATA", provincia: "BG" },
  { code: "409048002", nome: "BARBERINO DI MUGELLO", provincia: "FI" },
  { code: "409048054", nome: "BARBERINO TAVARNELLE", provincia: "FI" },
  { code: "403018008", nome: "BARBIANELLO", provincia: "PV" },
  { code: "404021007", nome: "BARBIANO", provincia: "BZ" },
  { code: "405028010", nome: "BARBONA", provincia: "PD" },
  { code: "419083005", nome: "BARCELLONA POZZO DI GOTTO", provincia: "ME" },
  { code: "406093006", nome: "BARCIS", provincia: "PN" },
  { code: "402007009", nome: "BARD", provincia: "AO" },
  { code: "403012144", nome: "BARDELLO CON MALGESSO E BREGANO", provincia: "VA" },
  { code: "408034002", nome: "BARDI", provincia: "PR" },
  { code: "407009009", nome: "BARDINETO", provincia: "SV" },
  { code: "405023006", nome: "BARDOLINO", provincia: "VR" },
  { code: "401001022", nome: "BARDONECCHIA", provincia: "TO" },
  { code: "403015012", nome: "BAREGGIO", provincia: "MI" },
  { code: "401003012", nome: "BARENGO", provincia: "NO" },
  { code: "420095012", nome: "BARESSA", provincia: "OR" },
  { code: "413066008", nome: "BARETE", provincia: "AQ" },
  { code: "409046003", nome: "BARGA", provincia: "LU" },
  { code: "407010003", nome: "BARGAGLI", provincia: "GE" },
  { code: "401004012", nome: "BARGE", provincia: "CN" },
  { code: "403017012", nome: "BARGHE", provincia: "BS" },
  { code: "420091005", nome: "BARI SARDO", provincia: "NU" },
  { code: "416072006", nome: "BARI", provincia: "BA" },
  { code: "403016020", nome: "BARIANO", provincia: "BG" },
  { code: "408037003", nome: "BARICELLA", provincia: "BO" },
  { code: "417076011", nome: "BARILE", provincia: "PZ" },
  { code: "413066009", nome: "BARISCIANO", provincia: "AQ" },
  { code: "403108005", nome: "BARLASSINA", provincia: "MB" },
  { code: "416110002", nome: "BARLETTA", provincia: "BT" },
  { code: "403013015", nome: "BARNI", provincia: "CO" },
  { code: "401004013", nome: "BAROLO", provincia: "CN" },
  { code: "401001023", nome: "BARONE CANAVESE", provincia: "TO" },
  { code: "415065013", nome: "BARONISSI", provincia: "SA" },
  { code: "419086004", nome: "BARRAFRANCA", provincia: "EN" },
  { code: "420092005", nome: "BARRALI", provincia: "CA" },
  { code: "413066010", nome: "BARREA", provincia: "AQ" },
  { code: "420092006", nome: "BARUMINI", provincia: "CA" },
  { code: "403097005", nome: "BARZAGO", provincia: "LC" },
  { code: "403016021", nome: "BARZANA", provincia: "BG" },
  { code: "403097006", nome: "BARZANO\'", provincia: "LC" },
  { code: "403097007", nome: "BARZIO", provincia: "LC" },
  { code: "401006012", nome: "BASALUZZO", provincia: "AL" },
  { code: "403018009", nome: "BASCAPE\'", provincia: "PV" },
  { code: "410055007", nome: "BASCHI", provincia: "TR" },
  { code: "413067005", nome: "BASCIANO", provincia: "TE" },
  { code: "404022009", nome: "BASELGA DI PINE\'", provincia: "TN" },
  { code: "415062007", nome: "BASELICE", provincia: "BN" },
  { code: "403015014", nome: "BASIANO", provincia: "MI" },
  { code: "419083006", nome: "BASICO\'", provincia: "ME" },
  { code: "403015015", nome: "BASIGLIO", provincia: "MI" },
  { code: "406030009", nome: "BASILIANO", provincia: "UD" },
  { code: "403017013", nome: "BASSANO BRESCIANO", provincia: "BS" },
  { code: "405024012", nome: "BASSANO DEL GRAPPA", provincia: "VI" },
  { code: "412056006", nome: "BASSANO IN TEVERINA", provincia: "VT" },
  { code: "412056005", nome: "BASSANO ROMANO", provincia: "VT" },
  { code: "412059002", nome: "BASSIANO", provincia: "LT" },
  { code: "401006013", nome: "BASSIGNANA", provincia: "AL" },
  { code: "401004014", nome: "BASTIA MONDOVI\'", provincia: "CN" },
  { code: "410054002", nome: "BASTIA UMBRA", provincia: "PG" },
  { code: "403018011", nome: "BASTIDA PANCARANA", provincia: "PV" },
  { code: "408036001", nome: "BASTIGLIA", provincia: "MO" },
  { code: "405028011", nome: "BATTAGLIA TERME", provincia: "PD" },
  { code: "401004015", nome: "BATTIFOLLO", provincia: "CN" },
  { code: "415065014", nome: "BATTIPAGLIA", provincia: "SA" },
  { code: "403018012", nome: "BATTUDA", provincia: "PV" },
  { code: "419082008", nome: "BAUCINA", provincia: "PA" },
  { code: "420095013", nome: "BAULADU", provincia: "OR" },
  { code: "420091006", nome: "BAUNEI", provincia: "NU" },
  { code: "401103008", nome: "BAVENO", provincia: "VB" },
  { code: "403012010", nome: "BEDERO VALCUVIA", provincia: "VA" },
  { code: "403017014", nome: "BEDIZZOLE", provincia: "BS" },
  { code: "404022011", nome: "BEDOLLO", provincia: "TN" },
  { code: "408034003", nome: "BEDONIA", provincia: "PR" },
  { code: "403016022", nome: "BEDULITA", provincia: "BG" },
  { code: "401103009", nome: "BEE", provincia: "VB" },
  { code: "401001024", nome: "BEINASCO", provincia: "TO" },
  { code: "401004016", nome: "BEINETTE", provincia: "CN" },
  { code: "418079009", nome: "BELCASTRO", provincia: "CZ" },
  { code: "405023007", nome: "BELFIORE", provincia: "VR" },
  { code: "411141005", nome: "BELFORTE ALL\'ISAURO", provincia: "PU" },
  { code: "411043004", nome: "BELFORTE DEL CHIENTI", provincia: "MC" },
  { code: "401006014", nome: "BELFORTE MONFERRATO", provincia: "AL" },
  { code: "403018013", nome: "BELGIOIOSO", provincia: "PV" },
  { code: "401103010", nome: "BELGIRATE", provincia: "VB" },
  { code: "417076012", nome: "BELLA", provincia: "PZ" },
  { code: "403013250", nome: "BELLAGIO", provincia: "CO" },
  { code: "403097008", nome: "BELLANO", provincia: "LC" },
  { code: "413067006", nome: "BELLANTE", provincia: "TE" },
  { code: "408099001", nome: "BELLARIA-IGEA MARINA", provincia: "RN" },
  { code: "412058012", nome: "BELLEGRA", provincia: "RM" },
  { code: "401004017", nome: "BELLINO", provincia: "CN" },
  { code: "403015016", nome: "BELLINZAGO LOMBARDO", provincia: "MI" },
  { code: "401003016", nome: "BELLINZAGO NOVARESE", provincia: "NO" },
  { code: "415065158", nome: "BELLIZZI", provincia: "SA" },
  { code: "415061007", nome: "BELLONA", provincia: "CE" },
  { code: "415065015", nome: "BELLOSGUARDO", provincia: "SA" },
  { code: "405025006", nome: "BELLUNO", provincia: "BL" },
  { code: "403108006", nome: "BELLUSCO", provincia: "MB" },
  { code: "418078013", nome: "BELMONTE CALABRO", provincia: "CS" },
  { code: "412060013", nome: "BELMONTE CASTELLO", provincia: "FR" },
  { code: "414094004", nome: "BELMONTE DEL SANNIO", provincia: "IS" },
  { code: "412057005", nome: "BELMONTE IN SABINA", provincia: "RI" },
  { code: "419082009", nome: "BELMONTE MEZZAGNO", provincia: "PA" },
  { code: "411109003", nome: "BELMONTE PICENO", provincia: "FM" },
  { code: "419087007", nome: "BELPASSO", provincia: "CT" },
  { code: "418078014", nome: "BELSITO", provincia: "CS" },
  { code: "418101001", nome: "BELVEDERE DI SPINELLO", provincia: "KR" },
  { code: "401004018", nome: "BELVEDERE LANGHE", provincia: "CN" },
  { code: "418078015", nome: "BELVEDERE MARITTIMO", provincia: "CS" },
  { code: "411042005", nome: "BELVEDERE OSTRENSE", provincia: "AN" },
  { code: "401005008", nome: "BELVEGLIO", provincia: "AT" },
  { code: "420091007", nome: "BELVI", provincia: "NU" },
  { code: "403014006", nome: "BEMA", provincia: "SO" },
  { code: "403013021", nome: "BENE LARIO", provincia: "CO" },
  { code: "401004019", nome: "BENE VAGIENNA", provincia: "CN" },
  { code: "418080008", nome: "BENESTARE", provincia: "RC" },
  { code: "420090008", nome: "BENETUTTI", provincia: "SS" },
  { code: "401004020", nome: "BENEVELLO", provincia: "CN" },
  { code: "415062008", nome: "BENEVENTO", provincia: "BN" },
  { code: "401096003", nome: "BENNA", provincia: "BI" },
  { code: "408037005", nome: "BENTIVOGLIO", provincia: "BO" },
  { code: "403014007", nome: "BERBENNO DI VALTELLINA", provincia: "SO" },
  { code: "403016023", nome: "BERBENNO", provincia: "BG" },
  { code: "408034004", nome: "BERCETO", provincia: "PR" },
  { code: "420090009", nome: "BERCHIDDA", provincia: "SS" },
  { code: "403013022", nome: "BEREGAZZO CON FIGLIARO", provincia: "CO" },
  { code: "403018014", nome: "BEREGUARDO", provincia: "PV" },
  { code: "401006015", nome: "BERGAMASCO", provincia: "AL" },
  { code: "403016024", nome: "BERGAMO", provincia: "BG" },
  { code: "405029006", nome: "BERGANTINO", provincia: "RO" },
  { code: "407009010", nome: "BERGEGGI", provincia: "SV" },
  { code: "401004021", nome: "BERGOLO", provincia: "CN" },
  { code: "403017015", nome: "BERLINGO", provincia: "BS" },
  { code: "417077003", nome: "BERNALDA", provincia: "MT" },
  { code: "403108007", nome: "BERNAREGGIO", provincia: "MB" },
  { code: "403015019", nome: "BERNATE TICINO", provincia: "MI" },
  { code: "401004022", nome: "BERNEZZO", provincia: "CN" },
  { code: "408140003", nome: "BERTINORO", provincia: "FC" },
  { code: "406030010", nome: "BERTIOLO", provincia: "UD" },
  { code: "403098002", nome: "BERTONICO", provincia: "LO" },
  { code: "401005009", nome: "BERZANO DI SAN PIETRO", provincia: "AT" },
  { code: "401006016", nome: "BERZANO DI TORTONA", provincia: "AL" },
  { code: "403017016", nome: "BERZO DEMO", provincia: "BS" },
  { code: "403017017", nome: "BERZO INFERIORE", provincia: "BS" },
  { code: "403016025", nome: "BERZO SAN FERMO", provincia: "BG" },
  { code: "403108008", nome: "BESANA IN BRIANZA", provincia: "MB" },
  { code: "403012011", nome: "BESANO", provincia: "VA" },
  { code: "403015022", nome: "BESATE", provincia: "MI" },
  { code: "404022013", nome: "BESENELLO", provincia: "TN" },
  { code: "408033003", nome: "BESENZONE", provincia: "PC" },
  { code: "403012012", nome: "BESNATE", provincia: "VA" },
  { code: "403012013", nome: "BESOZZO", provincia: "VA" },
  { code: "420090010", nome: "BESSUDE", provincia: "SS" },
  { code: "408033004", nome: "BETTOLA", provincia: "PC" },
  { code: "410054003", nome: "BETTONA", provincia: "PG" },
  { code: "401103011", nome: "BEURA-CARDEZZA", provincia: "VB" },
  { code: "410054004", nome: "BEVAGNA", provincia: "PG" },
  { code: "407011003", nome: "BEVERINO", provincia: "SP" },
  { code: "405023008", nome: "BEVILACQUA", provincia: "VR" },
  { code: "419087008", nome: "BIANCAVILLA", provincia: "CT" },
  { code: "418078016", nome: "BIANCHI", provincia: "CS" },
  { code: "418080009", nome: "BIANCO", provincia: "RC" },
  { code: "401003018", nome: "BIANDRATE", provincia: "NO" },
  { code: "403012014", nome: "BIANDRONNO", provincia: "VA" },
  { code: "403016026", nome: "BIANZANO", provincia: "BG" },
  { code: "401002011", nome: "BIANZE\'", provincia: "VC" },
  { code: "403014008", nome: "BIANZONE", provincia: "SO" },
  { code: "403108009", nome: "BIASSONO", provincia: "MB" },
  { code: "408035004", nome: "BIBBIANO", provincia: "RE" },
  { code: "409051004", nome: "BIBBIENA", provincia: "AR" },
  { code: "409049001", nome: "BIBBONA", provincia: "LI" },
  { code: "401001025", nome: "BIBIANA", provincia: "TO" },
  { code: "416071006", nome: "BICCARI", provincia: "FG" },
  { code: "406030011", nome: "BICINICCO", provincia: "UD" },
  { code: "420095014", nome: "BIDONI\'", provincia: "OR" },
  { code: "401096004", nome: "BIELLA", provincia: "BI" },
  { code: "403017018", nome: "BIENNO", provincia: "BS" },
  { code: "404022015", nome: "BIENO", provincia: "TN" },
  { code: "409050001", nome: "BIENTINA", provincia: "PI" },
  { code: "403013023", nome: "BINAGO", provincia: "CO" },
  { code: "403015024", nome: "BINASCO", provincia: "MI" },
  { code: "416072008", nome: "BINETTO", provincia: "BA" },
  { code: "401096005", nome: "BIOGLIO", provincia: "BI" },
  { code: "402007010", nome: "BIONAZ", provincia: "AO" },
  { code: "403017019", nome: "BIONE", provincia: "BS" },
  { code: "420091008", nome: "BIRORI", provincia: "NU" },
  { code: "415064011", nome: "BISACCIA", provincia: "AV" },
  { code: "419082010", nome: "BISACQUINO", provincia: "PA" },
  { code: "416110003", nome: "BISCEGLIE", provincia: "BT" },
  { code: "413066011", nome: "BISEGNA", provincia: "AQ" },
  { code: "413067007", nome: "BISENTI", provincia: "TE" },
  { code: "418078017", nome: "BISIGNANO", provincia: "CS" },
  { code: "401006017", nome: "BISTAGNO", provincia: "AL" },
  { code: "403012015", nome: "BISUSCHIO", provincia: "VA" },
  { code: "416072010", nome: "BITETTO", provincia: "BA" },
  { code: "416072011", nome: "BITONTO", provincia: "BA" },
  { code: "416072012", nome: "BITRITTO", provincia: "BA" },
  { code: "420091009", nome: "BITTI", provincia: "NU" },
  { code: "419084004", nome: "BIVONA", provincia: "AG" },
  { code: "418080010", nome: "BIVONGI", provincia: "RC" },
  { code: "403013024", nome: "BIZZARONE", provincia: "CO" },
  { code: "404022017", nome: "BLEGGIO SUPERIORE", provincia: "TN" },
  { code: "403016027", nome: "BLELLO", provincia: "BG" },
  { code: "412056007", nome: "BLERA", provincia: "VT" },
  { code: "403013025", nome: "BLESSAGNO", provincia: "CO" },
  { code: "403013026", nome: "BLEVIO", provincia: "CO" },
  { code: "419082082", nome: "BLUFI", provincia: "PA" },
  { code: "405028012", nome: "BOARA PISANI", provincia: "PD" },
  { code: "401001026", nome: "BOBBIO PELLICE", provincia: "TO" },
  { code: "408033005", nome: "BOBBIO", provincia: "PC" },
  { code: "401003019", nome: "BOCA", provincia: "NO" },
  { code: "418078018", nome: "BOCCHIGLIERO", provincia: "CS" },
  { code: "401002014", nome: "BOCCIOLETO", provincia: "VC" },
  { code: "404022018", nome: "BOCENAGO", provincia: "TN" },
  { code: "403012016", nome: "BODIO LOMNAGO", provincia: "VA" },
  { code: "403098003", nome: "BOFFALORA D\'ADDA", provincia: "LO" },
  { code: "403015026", nome: "BOFFALORA SOPRA TICINO", provincia: "MI" },
  { code: "407010004", nome: "BOGLIASCO", provincia: "GE" },
  { code: "401103012", nome: "BOGNANCO", provincia: "VB" },
  { code: "401003021", nome: "BOGOGNO", provincia: "NO" },
  { code: "407009011", nome: "BOISSANO", provincia: "SV" },
  { code: "414070003", nome: "BOJANO", provincia: "CB" },
  { code: "407011004", nome: "BOLANO", provincia: "SP" },
  { code: "403016028", nome: "BOLGARE", provincia: "BG" },
  { code: "403015027", nome: "BOLLATE", provincia: "MI" },
  { code: "401001027", nome: "BOLLENGO", provincia: "TO" },
  { code: "408037006", nome: "BOLOGNA", provincia: "BO" },
  { code: "413068003", nome: "BOLOGNANO", provincia: "PE" },
  { code: "419082011", nome: "BOLOGNETTA", provincia: "PA" },
  { code: "411043005", nome: "BOLOGNOLA", provincia: "MC" },
  { code: "420091010", nome: "BOLOTANA", provincia: "NU" },
  { code: "412056008", nome: "BOLSENA", provincia: "VT" },
  { code: "403016029", nome: "BOLTIERE", provincia: "BG" },
  { code: "401003022", nome: "BOLZANO NOVARESE", provincia: "NO" },
  { code: "405024013", nome: "BOLZANO VICENTINO", provincia: "VI" },
  { code: "404021008", nome: "BOLZANO", provincia: "BZ" },
  { code: "412056009", nome: "BOMARZO", provincia: "VT" },
  { code: "413069006", nome: "BOMBA", provincia: "CH" },
  { code: "419085002", nome: "BOMPENSIERE", provincia: "CL" },
  { code: "419082012", nome: "BOMPIETRO", provincia: "PA" },
  { code: "408036002", nome: "BOMPORTO", provincia: "MO" },
  { code: "420095015", nome: "BONARCADO", provincia: "OR" },
  { code: "407011005", nome: "BONASSOLA", provincia: "SP" },
  { code: "403016030", nome: "BONATE SOPRA", provincia: "BG" },
  { code: "403016031", nome: "BONATE SOTTO", provincia: "BG" },
  { code: "405023009", nome: "BONAVIGO", provincia: "VR" },
  { code: "408038003", nome: "BONDENO", provincia: "FE" },
  { code: "404022021", nome: "BONDONE", provincia: "TN" },
  { code: "415062009", nome: "BONEA", provincia: "BN" },
  { code: "414070004", nome: "BONEFRO", provincia: "CB" },
  { code: "403019006", nome: "BONEMERSE", provincia: "CR" },
  { code: "418078019", nome: "BONIFATI", provincia: "CS" },
  { code: "415064012", nome: "BONITO", provincia: "AV" },
  { code: "420090011", nome: "BONNANARO", provincia: "SS" },
  { code: "420090012", nome: "BONO", provincia: "SS" },
  { code: "420090013", nome: "BONORVA", provincia: "SS" },
  { code: "401004023", nome: "BONVICINO", provincia: "CN" },
  { code: "412057006", nome: "BORBONA", provincia: "RI" },
  { code: "405025007", nome: "BORCA DI CADORE", provincia: "BL" },
  { code: "406030012", nome: "BORDANO", provincia: "UD" },
  { code: "407008008", nome: "BORDIGHERA", provincia: "IM" },
  { code: "403019007", nome: "BORDOLANO", provincia: "CR" },
  { code: "408034005", nome: "BORE", provincia: "PR" },
  { code: "408035005", nome: "BORETTO", provincia: "RE" },
  { code: "403018015", nome: "BORGARELLO", provincia: "PV" },
  { code: "401001028", nome: "BORGARO TORINESE", provincia: "TO" },
  { code: "419082013", nome: "BORGETTO", provincia: "PA" },
  { code: "407008009", nome: "BORGHETTO D\'ARROSCIA", provincia: "IM" },
  { code: "401006018", nome: "BORGHETTO DI BORBERA", provincia: "AL" },
  { code: "407011006", nome: "BORGHETTO DI VARA", provincia: "SP" },
  { code: "403098004", nome: "BORGHETTO LODIGIANO", provincia: "LO" },
  { code: "407009012", nome: "BORGHETTO SANTO SPIRITO", provincia: "SV" },
  { code: "408140004", nome: "BORGHI", provincia: "FC" },
  { code: "418079011", nome: "BORGIA", provincia: "CZ" },
  { code: "401001029", nome: "BORGIALLO", provincia: "TO" },
  { code: "407009013", nome: "BORGIO-VEREZZI", provincia: "SV" },
  { code: "409046004", nome: "BORGO A MOZZANO", provincia: "LU" },
  { code: "404022238", nome: "BORGO CHIESE", provincia: "TN" },
  { code: "401002015", nome: "BORGO D\'ALE", provincia: "VC" },
  { code: "404022252", nome: "BORGO D\'ANAUNIA", provincia: "TN" },
  { code: "403016032", nome: "BORGO DI TERZO", provincia: "BG" },
  { code: "404022239", nome: "BORGO LARES", provincia: "TN" },
  { code: "403020072", nome: "BORGO MANTOVANO", provincia: "MN" },
  { code: "411141006", nome: "BORGO PACE", provincia: "PU" },
  { code: "403018016", nome: "BORGO PRIOLO", provincia: "PV" },
  { code: "401004025", nome: "BORGO SAN DALMAZZO", provincia: "CN" },
  { code: "403017020", nome: "BORGO SAN GIACOMO", provincia: "BS" },
  { code: "403098005", nome: "BORGO SAN GIOVANNI", provincia: "LO" },
  { code: "409048004", nome: "BORGO SAN LORENZO", provincia: "FI" },
  { code: "401006020", nome: "BORGO SAN MARTINO", provincia: "AL" },
  { code: "403018018", nome: "BORGO SAN SIRO", provincia: "PV" },
  { code: "401003025", nome: "BORGO TICINO", provincia: "NO" },
  { code: "408037007", nome: "BORGO TOSSIGNANO", provincia: "BO" },
  { code: "408034006", nome: "BORGO VAL DI TARO", provincia: "PR" },
  { code: "405025074", nome: "BORGO VALBELLUNA", provincia: "BL" },
  { code: "404022022", nome: "BORGO VALSUGANA", provincia: "TN" },
  { code: "412057008", nome: "BORGO VELINO", provincia: "RI" },
  { code: "405028107", nome: "BORGO VENETO", provincia: "PD" },
  { code: "401002017", nome: "BORGO VERCELLI", provincia: "VC" },
  { code: "403020071", nome: "BORGO VIRGILIO", provincia: "MN" },
  { code: "403020073", nome: "BORGOCARBONARA", provincia: "MN" },
  { code: "401001030", nome: "BORGOFRANCO D\'IVREA", provincia: "TO" },
  { code: "401003023", nome: "BORGOLAVEZZARO", provincia: "NO" },
  { code: "401004024", nome: "BORGOMALE", provincia: "CN" },
  { code: "401003024", nome: "BORGOMANERO", provincia: "NO" },
  { code: "407008010", nome: "BORGOMARO", provincia: "IM" },
  { code: "401001031", nome: "BORGOMASINO", provincia: "TO" },
  { code: "401103078", nome: "BORGOMEZZAVALLE", provincia: "VB" },
  { code: "401001032", nome: "BORGONE SUSA", provincia: "TO" },
  { code: "408033006", nome: "BORGONOVO VAL TIDONE", provincia: "PC" },
  { code: "401006019", nome: "BORGORATTO ALESSANDRINO", provincia: "AL" },
  { code: "403018017", nome: "BORGORATTO MORMOROLO", provincia: "PV" },
  { code: "405028013", nome: "BORGORICCO", provincia: "PD" },
  { code: "412057007", nome: "BORGOROSE", provincia: "RI" },
  { code: "403017021", nome: "BORGOSATOLLO", provincia: "BS" },
  { code: "401002016", nome: "BORGOSESIA", provincia: "VC" },
  { code: "407009014", nome: "BORMIDA", provincia: "SV" },
  { code: "403014009", nome: "BORMIO", provincia: "SO" },
  { code: "403018019", nome: "BORNASCO", provincia: "PV" },
  { code: "403017022", nome: "BORNO", provincia: "BS" },
  { code: "420095016", nome: "BORONEDDU", provincia: "OR" },
  { code: "420091011", nome: "BORORE", provincia: "NU" },
  { code: "413069007", nome: "BORRELLO", provincia: "CH" },
  { code: "401096006", nome: "BORRIANA", provincia: "BI" },
  { code: "405026004", nome: "BORSO DEL GRAPPA", provincia: "TV" },
  { code: "420091012", nome: "BORTIGALI", provincia: "NU" },
  { code: "420090014", nome: "BORTIGIADAS", provincia: "SS" },
  { code: "420090015", nome: "BORUTTA", provincia: "SS" },
  { code: "407010005", nome: "BORZONASCA", provincia: "GE" },
  { code: "420091013", nome: "BOSA", provincia: "NU" },
  { code: "405029007", nome: "BOSARO", provincia: "RO" },
  { code: "405023010", nome: "BOSCHI SANT\'ANNA", provincia: "VR" },
  { code: "405023011", nome: "BOSCO CHIESANUOVA", provincia: "VR" },
  { code: "401006021", nome: "BOSCO MARENGO", provincia: "AL" },
  { code: "401001033", nome: "BOSCONERO", provincia: "TO" },
  { code: "415063008", nome: "BOSCOREALE", provincia: "NA" },
  { code: "415063009", nome: "BOSCOTRECASE", provincia: "NA" },
  { code: "401004026", nome: "BOSIA", provincia: "CN" },
  { code: "401006022", nome: "BOSIO", provincia: "AL" },
  { code: "403097009", nome: "BOSISIO PARINI", provincia: "LC" },
  { code: "403018020", nome: "BOSNASCO", provincia: "PV" },
  { code: "403016033", nome: "BOSSICO", provincia: "BG" },
  { code: "401004027", nome: "BOSSOLASCO", provincia: "CN" },
  { code: "418079012", nome: "BOTRICELLO", provincia: "CZ" },
  { code: "416075009", nome: "BOTRUGNO", provincia: "LE" },
  { code: "403016034", nome: "BOTTANUCO", provincia: "BG" },
  { code: "403017023", nome: "BOTTICINO", provincia: "BS" },
  { code: "420090016", nome: "BOTTIDDA", provincia: "SS" },
  { code: "418080013", nome: "BOVA MARINA", provincia: "RC" },
  { code: "418080011", nome: "BOVA", provincia: "RC" },
  { code: "418080012", nome: "BOVALINO", provincia: "RC" },
  { code: "403017024", nome: "BOVEGNO", provincia: "BS" },
  { code: "401004028", nome: "BOVES", provincia: "CN" },
  { code: "403017025", nome: "BOVEZZO", provincia: "BS" },
  { code: "412060014", nome: "BOVILLE ERNICA", provincia: "FR" },
  { code: "416071007", nome: "BOVINO", provincia: "FG" },
  { code: "403108010", nome: "BOVISIO-MASCIAGO", provincia: "MB" },
  { code: "405028014", nome: "BOVOLENTA", provincia: "PD" },
  { code: "405023012", nome: "BOVOLONE", provincia: "VR" },
  { code: "401006023", nome: "BOZZOLE", provincia: "AL" },
  { code: "403020007", nome: "BOZZOLO", provincia: "MN" },
  { code: "401004029", nome: "BRA", provincia: "CN" },
  { code: "403016035", nome: "BRACCA", provincia: "BG" },
  { code: "412058013", nome: "BRACCIANO", provincia: "RM" },
  { code: "415065016", nome: "BRACIGLIANO", provincia: "SA" },
  { code: "404021009", nome: "BRAIES", provincia: "BZ" },
  { code: "403018021", nome: "BRALLO DI PREGOLA", provincia: "PV" },
  { code: "418080014", nome: "BRANCALEONE", provincia: "RC" },
  { code: "403017026", nome: "BRANDICO", provincia: "BS" },
  { code: "401001034", nome: "BRANDIZZO", provincia: "TO" },
  { code: "403016036", nome: "BRANZI", provincia: "BG" },
  { code: "403017027", nome: "BRAONE", provincia: "BS" },
  { code: "403012017", nome: "BREBBIA", provincia: "VA" },
  { code: "405026005", nome: "BREDA DI PIAVE", provincia: "TV" },
  { code: "405024014", nome: "BREGANZE", provincia: "VI" },
  { code: "403013028", nome: "BREGNANO", provincia: "CO" },
  { code: "403016038", nome: "BREMBATE DI SOPRA", provincia: "BG" },
  { code: "403016037", nome: "BREMBATE", provincia: "BG" },
  { code: "403098006", nome: "BREMBIO", provincia: "LO" },
  { code: "403018022", nome: "BREME", provincia: "PV" },
  { code: "405024015", nome: "BRENDOLA", provincia: "VI" },
  { code: "403013029", nome: "BRENNA", provincia: "CO" },
  { code: "404021010", nome: "BRENNERO", provincia: "BZ" },
  { code: "403017028", nome: "BRENO", provincia: "BS" },
  { code: "403012019", nome: "BRENTA", provincia: "VA" },
  { code: "405023013", nome: "BRENTINO BELLUNO", provincia: "VR" },
  { code: "404022025", nome: "BRENTONICO", provincia: "TN" },
  { code: "405023914", nome: "BRENZONE SUL GARDA", provincia: "VR" },
  { code: "408035006", nome: "BRESCELLO", provincia: "RE" },
  { code: "403017029", nome: "BRESCIA", provincia: "BS" },
  { code: "404022026", nome: "BRESIMO", provincia: "TN" },
  { code: "403018023", nome: "BRESSANA BOTTARONE", provincia: "PV" },
  { code: "404021011", nome: "BRESSANONE", provincia: "BZ" },
  { code: "405024016", nome: "BRESSANVIDO", provincia: "VI" },
  { code: "403015032", nome: "BRESSO", provincia: "MI" },
  { code: "403012020", nome: "BREZZO DI BEDERO", provincia: "VA" },
  { code: "401004030", nome: "BRIAGLIA", provincia: "CN" },
  { code: "418102003", nome: "BRIATICO", provincia: "VV" },
  { code: "401001035", nome: "BRICHERASIO", provincia: "TO" },
  { code: "403013030", nome: "BRIENNO", provincia: "CO" },
  { code: "417076013", nome: "BRIENZA", provincia: "PZ" },
  { code: "401004031", nome: "BRIGA ALTA", provincia: "CN" },
  { code: "401003026", nome: "BRIGA NOVARESE", provincia: "NO" },
  { code: "403016040", nome: "BRIGNANO GERA D\'ADDA", provincia: "BG" },
  { code: "401006024", nome: "BRIGNANO-FRASCATA", provincia: "AL" },
  { code: "417076014", nome: "BRINDISI DI MONTAGNA", provincia: "PZ" },
  { code: "416074001", nome: "BRINDISI", provincia: "BR" },
  { code: "403012021", nome: "BRINZIO", provincia: "VA" },
  { code: "401003027", nome: "BRIONA", provincia: "NO" },
  { code: "403017030", nome: "BRIONE", provincia: "BS" },
  { code: "403108011", nome: "BRIOSCO", provincia: "MB" },
  { code: "408039004", nome: "BRISIGHELLA", provincia: "RA" },
  { code: "403012022", nome: "BRISSAGO-VALTRAVAGLIA", provincia: "VA" },
  { code: "402007011", nome: "BRISSOGNE", provincia: "AO" },
  { code: "413068004", nome: "BRITTOLI", provincia: "PE" },
  { code: "403097010", nome: "BRIVIO", provincia: "LC" },
  { code: "412060015", nome: "BROCCOSTELLA", provincia: "FR" },
  { code: "405024017", nome: "BROGLIANO", provincia: "VI" },
  { code: "418102004", nome: "BROGNATURO", provincia: "VV" },
  { code: "419083007", nome: "BROLO", provincia: "ME" },
  { code: "401004032", nome: "BRONDELLO", provincia: "CN" },
  { code: "403018024", nome: "BRONI", provincia: "PV" },
  { code: "419087009", nome: "BRONTE", provincia: "CT" },
  { code: "404021012", nome: "BRONZOLO", provincia: "BZ" },
  { code: "401004033", nome: "BROSSASCO", provincia: "CN" },
  { code: "401001036", nome: "BROSSO", provincia: "TO" },
  { code: "401103013", nome: "BROVELLO-CARPUGNINO", provincia: "VB" },
  { code: "401001037", nome: "BROZOLO", provincia: "TO" },
  { code: "403108012", nome: "BRUGHERIO", provincia: "MB" },
  { code: "405028015", nome: "BRUGINE", provincia: "PD" },
  { code: "407011007", nome: "BRUGNATO", provincia: "SP" },
  { code: "406093007", nome: "BRUGNERA", provincia: "PN" },
  { code: "401001038", nome: "BRUINO", provincia: "TO" },
  { code: "403016041", nome: "BRUMANO", provincia: "BG" },
  { code: "403013032", nome: "BRUNATE", provincia: "CO" },
  { code: "403012023", nome: "BRUNELLO", provincia: "VA" },
  { code: "404021013", nome: "BRUNICO", provincia: "BZ" },
  { code: "401005010", nome: "BRUNO", provincia: "AT" },
  { code: "403016042", nome: "BRUSAPORTO", provincia: "BG" },
  { code: "401001039", nome: "BRUSASCO", provincia: "TO" },
  { code: "415063010", nome: "BRUSCIANO", provincia: "NA" },
  { code: "403012024", nome: "BRUSIMPIANO", provincia: "VA" },
  { code: "401096007", nome: "BRUSNENGO", provincia: "BI" },
  { code: "402007012", nome: "BRUSSON", provincia: "AO" },
  { code: "401001040", nome: "BRUZOLO", provincia: "TO" },
  { code: "418080015", nome: "BRUZZANO ZEFFIRIO", provincia: "RC" },
  { code: "403015035", nome: "BUBBIANO", provincia: "MI" },
  { code: "401005011", nome: "BUBBIO", provincia: "AT" },
  { code: "419089003", nome: "BUCCHERI", provincia: "SR" },
  { code: "413069008", nome: "BUCCHIANICO", provincia: "CH" },
  { code: "415062010", nome: "BUCCIANO", provincia: "BN" },
  { code: "403015036", nome: "BUCCINASCO", provincia: "MI" },
  { code: "415065017", nome: "BUCCINO", provincia: "SA" },
  { code: "409051005", nome: "BUCINE", provincia: "AR" },
  { code: "420090017", nome: "BUDDUSO\'", provincia: "SS" },
  { code: "406093008", nome: "BUDOIA", provincia: "PN" },
  { code: "420091014", nome: "BUDONI", provincia: "NU" },
  { code: "408037008", nome: "BUDRIO", provincia: "BO" },
  { code: "420092007", nome: "BUGGERRU", provincia: "CA" },
  { code: "409047003", nome: "BUGGIANO", provincia: "PT" },
  { code: "403014010", nome: "BUGLIO IN MONTE", provincia: "SO" },
  { code: "413066012", nome: "BUGNARA", provincia: "AQ" },
  { code: "403012025", nome: "BUGUGGIATE", provincia: "VA" },
  { code: "406030013", nome: "BUJA", provincia: "UD" },
  { code: "403097011", nome: "BULCIAGO", provincia: "LC" },
  { code: "403013034", nome: "BULGAROGRASSO", provincia: "CO" },
  { code: "420090018", nome: "BULTEI", provincia: "SS" },
  { code: "420090019", nome: "BULZI", provincia: "SS" },
  { code: "415065018", nome: "BUONABITACOLO", provincia: "SA" },
  { code: "415062011", nome: "BUONALBERGO", provincia: "BN" },
  { code: "409052003", nome: "BUONCONVENTO", provincia: "SI" },
  { code: "418078020", nome: "BUONVICINO", provincia: "CS" },
  { code: "403108013", nome: "BURAGO DI MOLGORA", provincia: "MB" },
  { code: "420092008", nome: "BURCEI", provincia: "CA" },
  { code: "419084005", nome: "BURGIO", provincia: "AG" },
  { code: "420090020", nome: "BURGOS", provincia: "SS" },
  { code: "401001041", nome: "BURIASCO", provincia: "TO" },
  { code: "401001042", nome: "BUROLO", provincia: "TO" },
  { code: "401002021", nome: "BURONZO", provincia: "VC" },
  { code: "420095017", nome: "BUSACHI", provincia: "OR" },
  { code: "407010006", nome: "BUSALLA", provincia: "GE" },
  { code: "401001043", nome: "BUSANO", provincia: "TO" },
  { code: "401004034", nome: "BUSCA", provincia: "CN" },
  { code: "403015038", nome: "BUSCATE", provincia: "MI" },
  { code: "419089004", nome: "BUSCEMI", provincia: "SR" },
  { code: "419081002", nome: "BUSETO PALIZZOLO", provincia: "TP" },
  { code: "403108051", nome: "BUSNAGO", provincia: "MB" },
  { code: "403015040", nome: "BUSSERO", provincia: "MI" },
  { code: "408034007", nome: "BUSSETO", provincia: "PR" },
  { code: "413068005", nome: "BUSSI SUL TIRINO", provincia: "PE" },
  { code: "414070005", nome: "BUSSO", provincia: "CB" },
  { code: "405023015", nome: "BUSSOLENGO", provincia: "VR" },
  { code: "401001044", nome: "BUSSOLENO", provincia: "TO" },
  { code: "403012026", nome: "BUSTO ARSIZIO", provincia: "VA" },
  { code: "403015041", nome: "BUSTO GAROLFO", provincia: "MI" },
  { code: "419085003", nome: "BUTERA", provincia: "CL" },
  { code: "409050002", nome: "BUTI", provincia: "PI" },
  { code: "405023016", nome: "BUTTAPIETRA", provincia: "VR" },
  { code: "401001045", nome: "BUTTIGLIERA ALTA", provincia: "TO" },
  { code: "401005012", nome: "BUTTIGLIERA D\'ASTI", provincia: "AT" },
  { code: "406030014", nome: "BUTTRIO", provincia: "UD" },
  { code: "401006025", nome: "CABELLA LIGURE", provincia: "AL" },
  { code: "403013035", nome: "CABIATE", provincia: "CO" },
  { code: "420095018", nome: "CABRAS", provincia: "OR" },
  { code: "419082014", nome: "CACCAMO", provincia: "PA" },
  { code: "418101002", nome: "CACCURI", provincia: "KR" },
  { code: "403012027", nome: "CADEGLIANO-VICONAGO", provincia: "VA" },
  { code: "408035008", nome: "CADELBOSCO DI SOPRA", provincia: "RE" },
  { code: "408033007", nome: "CADEO", provincia: "PC" },
  { code: "404022929", nome: "CADERZONE TERME", provincia: "TN" },
  { code: "405028016", nome: "CADONEGHE", provincia: "PD" },
  { code: "403013036", nome: "CADORAGO", provincia: "CO" },
  { code: "403012143", nome: "CADREZZATE CON OSMATE", provincia: "VA" },
  { code: "405026006", nome: "CAERANO DI SAN MARCO", provincia: "TV" },
  { code: "401001046", nome: "CAFASSE", provincia: "TO" },
  { code: "415065019", nome: "CAGGIANO", provincia: "SA" },
  { code: "411141007", nome: "CAGLI", provincia: "PU" },
  { code: "420092009", nome: "CAGLIARI", provincia: "CA" },
  { code: "403013037", nome: "CAGLIO", provincia: "CO" },
  { code: "413066013", nome: "CAGNANO AMITERNO", provincia: "AQ" },
  { code: "416071008", nome: "CAGNANO VARANO", provincia: "FG" },
  { code: "415061008", nome: "CAIANELLO", provincia: "CE" },
  { code: "415061009", nome: "CAIAZZO", provincia: "CE" },
  { code: "404021014", nome: "CAINES", provincia: "BZ" },
  { code: "403017031", nome: "CAINO", provincia: "BS" },
  { code: "403014011", nome: "CAIOLO", provincia: "SO" },
  { code: "415064013", nome: "CAIRANO", provincia: "AV" },
  { code: "403012029", nome: "CAIRATE", provincia: "VA" },
  { code: "407009015", nome: "CAIRO MONTENOTTE", provincia: "SV" },
  { code: "415063011", nome: "CAIVANO", provincia: "NA" },
  { code: "415064014", nome: "CALABRITTO", provincia: "AV" },
  { code: "405025008", nome: "CALALZO DI CADORE", provincia: "BL" },
  { code: "401005013", nome: "CALAMANDRANA", provincia: "AT" },
  { code: "419084006", nome: "CALAMONACI", provincia: "AG" },
  { code: "420090021", nome: "CALANGIANUS", provincia: "SS" },
  { code: "418080016", nome: "CALANNA", provincia: "RC" },
  { code: "401103014", nome: "CALASCA-CASTIGLIONE", provincia: "VB" },
  { code: "419086005", nome: "CALASCIBETTA", provincia: "EN" },
  { code: "413066014", nome: "CALASCIO", provincia: "AQ" },
  { code: "420092010", nome: "CALASETTA", provincia: "CA" },
  { code: "419087010", nome: "CALATABIANO", provincia: "CT" },
  { code: "419081903", nome: "CALATAFIMI SEGESTA", provincia: "TP" },
  { code: "412056010", nome: "CALCATA", provincia: "VT" },
  { code: "404022032", nome: "CALCERANICA AL LAGO", provincia: "TN" },
  { code: "409050003", nome: "CALCI", provincia: "PI" },
  { code: "417077004", nome: "CALCIANO", provincia: "MT" },
  { code: "409050004", nome: "CALCINAIA", provincia: "PI" },
  { code: "403016043", nome: "CALCINATE", provincia: "BG" },
  { code: "403017032", nome: "CALCINATO", provincia: "BS" },
  { code: "403016044", nome: "CALCIO", provincia: "BG" },
  { code: "403097012", nome: "CALCO", provincia: "LC" },
  { code: "404021015", nome: "CALDARO SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "411043006", nome: "CALDAROLA", provincia: "MC" },
  { code: "408037009", nome: "CALDERARA DI RENO", provincia: "BO" },
  { code: "404022033", nome: "CALDES", provincia: "TN" },
  { code: "405023017", nome: "CALDIERO", provincia: "VR" },
  { code: "405024018", nome: "CALDOGNO", provincia: "VI" },
  { code: "404022034", nome: "CALDONAZZO", provincia: "TN" },
  { code: "408033008", nome: "CALENDASCO", provincia: "PC" },
  { code: "409048005", nome: "CALENZANO", provincia: "FI" },
  { code: "408034008", nome: "CALESTANO", provincia: "PR" },
  { code: "407011008", nome: "CALICE AL CORNOVIGLIO", provincia: "SP" },
  { code: "407009016", nome: "CALICE LIGURE", provincia: "SV" },
  { code: "416075010", nome: "CALIMERA", provincia: "LE" },
  { code: "415064015", nome: "CALITRI", provincia: "AV" },
  { code: "407009017", nome: "CALIZZANO", provincia: "SV" },
  { code: "401096008", nome: "CALLABIANA", provincia: "BI" },
  { code: "401005914", nome: "CALLIANO MONFERRATO", provincia: "AT" },
  { code: "404022035", nome: "CALLIANO", provincia: "TN" },
  { code: "403097013", nome: "CALOLZIOCORTE", provincia: "LC" },
  { code: "418078021", nome: "CALOPEZZATI", provincia: "CS" },
  { code: "401005015", nome: "CALOSSO", provincia: "AT" },
  { code: "418078022", nome: "CALOVETO", provincia: "CS" },
  { code: "419084007", nome: "CALTABELLOTTA", provincia: "AG" },
  { code: "419087011", nome: "CALTAGIRONE", provincia: "CT" },
  { code: "419085004", nome: "CALTANISSETTA", provincia: "CL" },
  { code: "419082015", nome: "CALTAVUTURO", provincia: "PA" },
  { code: "401003030", nome: "CALTIGNAGA", provincia: "NO" },
  { code: "405029008", nome: "CALTO", provincia: "RO" },
  { code: "405024019", nome: "CALTRANO", provincia: "VI" },
  { code: "403016046", nome: "CALUSCO D\'ADDA", provincia: "BG" },
  { code: "401001047", nome: "CALUSO", provincia: "TO" },
  { code: "403017033", nome: "CALVAGESE DELLA RIVIERA", provincia: "BS" },
  { code: "415065020", nome: "CALVANICO", provincia: "SA" },
  { code: "403019009", nome: "CALVATONE", provincia: "CR" },
  { code: "417076015", nome: "CALVELLO", provincia: "PZ" },
  { code: "405024020", nome: "CALVENE", provincia: "VI" },
  { code: "403016047", nome: "CALVENZANO", provincia: "BG" },
  { code: "417076016", nome: "CALVERA", provincia: "PZ" },
  { code: "410055008", nome: "CALVI DELL\'UMBRIA", provincia: "TR" },
  { code: "415061010", nome: "CALVI RISORTA", provincia: "CE" },
  { code: "415062012", nome: "CALVI", provincia: "BN" },
  { code: "403018025", nome: "CALVIGNANO", provincia: "PV" },
  { code: "403015042", nome: "CALVIGNASCO", provincia: "MI" },
  { code: "403017034", nome: "CALVISANO", provincia: "BS" },
  { code: "415063012", nome: "CALVIZZANO", provincia: "NA" },
  { code: "401006026", nome: "CAMAGNA MONFERRATO", provincia: "AL" },
  { code: "409046005", nome: "CAMAIORE", provincia: "LU" },
  { code: "401096009", nome: "CAMANDONA", provincia: "BI" },
  { code: "419084008", nome: "CAMASTRA", provincia: "AG" },
  { code: "403015044", nome: "CAMBIAGO", provincia: "MI" },
  { code: "401001048", nome: "CAMBIANO", provincia: "TO" },
  { code: "401103015", nome: "CAMBIASCA", provincia: "VB" },
  { code: "401096010", nome: "CAMBURZANO", provincia: "BI" },
  { code: "401004035", nome: "CAMERANA", provincia: "CN" },
  { code: "401005016", nome: "CAMERANO CASASCO", provincia: "AT" },
  { code: "411042006", nome: "CAMERANO", provincia: "AN" },
  { code: "403016048", nome: "CAMERATA CORNELLO", provincia: "BG" },
  { code: "412058014", nome: "CAMERATA NUOVA", provincia: "RM" },
  { code: "411042007", nome: "CAMERATA PICENA", provincia: "AN" },
  { code: "401003032", nome: "CAMERI", provincia: "NO" },
  { code: "411043007", nome: "CAMERINO", provincia: "MC" },
  { code: "415065021", nome: "CAMEROTA", provincia: "SA" },
  { code: "415061011", nome: "CAMIGLIANO", provincia: "CE" },
  { code: "418080017", nome: "CAMINI", provincia: "RC" },
  { code: "406030015", nome: "CAMINO AL TAGLIAMENTO", provincia: "UD" },
  { code: "401006027", nome: "CAMINO", provincia: "AL" },
  { code: "405024021", nome: "CAMISANO VICENTINO", provincia: "VI" },
  { code: "403019010", nome: "CAMISANO", provincia: "CR" },
  { code: "419084009", nome: "CAMMARATA", provincia: "AG" },
  { code: "407010007", nome: "CAMOGLI", provincia: "GE" },
  { code: "405027002", nome: "CAMPAGNA LUPIA", provincia: "VE" },
  { code: "415065022", nome: "CAMPAGNA", provincia: "SA" },
  { code: "412058015", nome: "CAMPAGNANO DI ROMA", provincia: "RM" },
  { code: "409053002", nome: "CAMPAGNATICO", provincia: "GR" },
  { code: "403019011", nome: "CAMPAGNOLA CREMASCA", provincia: "CR" },
  { code: "408035009", nome: "CAMPAGNOLA EMILIA", provincia: "RE" },
  { code: "418078023", nome: "CAMPANA", provincia: "CS" },
  { code: "403108014", nome: "CAMPARADA", provincia: "MB" },
  { code: "408035010", nome: "CAMPEGINE", provincia: "RE" },
  { code: "410054005", nome: "CAMPELLO SUL CLITUNNO", provincia: "PG" },
  { code: "401002025", nome: "CAMPERTOGNO", provincia: "VC" },
  { code: "409048006", nome: "CAMPI BISENZIO", provincia: "FI" },
  { code: "416075011", nome: "CAMPI SALENTINA", provincia: "LE" },
  { code: "401096086", nome: "CAMPIGLIA CERVO", provincia: "BI" },
  { code: "405024022", nome: "CAMPIGLIA DEI BERICI", provincia: "VI" },
  { code: "409049002", nome: "CAMPIGLIA MARITTIMA", provincia: "LI" },
  { code: "401001049", nome: "CAMPIGLIONE FENILE", provincia: "TO" },
  { code: "403013040", nome: "CAMPIONE D\'ITALIA", provincia: "CO" },
  { code: "404022036", nome: "CAMPITELLO DI FASSA", provincia: "TN" },
  { code: "413067008", nome: "CAMPLI", provincia: "TE" },
  { code: "418080018", nome: "CAMPO CALABRO", provincia: "RC" },
  { code: "413066015", nome: "CAMPO DI GIOVE", provincia: "AQ" },
  { code: "404021016", nome: "CAMPO DI TRENS", provincia: "BZ" },
  { code: "407010008", nome: "CAMPO LIGURE", provincia: "GE" },
  { code: "409049003", nome: "CAMPO NELL\'ELBA", provincia: "LI" },
  { code: "405028020", nome: "CAMPO SAN MARTINO", provincia: "PD" },
  { code: "404021017", nome: "CAMPO TURES", provincia: "BZ" },
  { code: "414070006", nome: "CAMPOBASSO", provincia: "CB" },
  { code: "419084010", nome: "CAMPOBELLO DI LICATA", provincia: "AG" },
  { code: "419081004", nome: "CAMPOBELLO DI MAZARA", provincia: "TP" },
  { code: "414070007", nome: "CAMPOCHIARO", provincia: "CB" },
  { code: "405028017", nome: "CAMPODARSEGO", provincia: "PD" },
  { code: "404022037", nome: "CAMPODENNO", provincia: "TN" },
  { code: "412059003", nome: "CAMPODIMELE", provincia: "LT" },
  { code: "414070008", nome: "CAMPODIPIETRA", provincia: "CB" },
  { code: "403014012", nome: "CAMPODOLCINO", provincia: "SO" },
  { code: "405028018", nome: "CAMPODORO", provincia: "PD" },
  { code: "419082016", nome: "CAMPOFELICE DI FITALIA", provincia: "PA" },
  { code: "419082017", nome: "CAMPOFELICE DI ROCCELLA", provincia: "PA" },
  { code: "411109004", nome: "CAMPOFILONE", provincia: "FM" },
  { code: "419082018", nome: "CAMPOFIORITO", provincia: "PA" },
  { code: "406030016", nome: "CAMPOFORMIDO", provincia: "UD" },
  { code: "419085005", nome: "CAMPOFRANCO", provincia: "CL" },
  { code: "408036003", nome: "CAMPOGALLIANO", provincia: "MO" },
  { code: "415062013", nome: "CAMPOLATTARO", provincia: "BN" },
  { code: "412060016", nome: "CAMPOLI APPENNINO", provincia: "FR" },
  { code: "415062014", nome: "CAMPOLI DEL MONTE TABURNO", provincia: "BN" },
  { code: "414070009", nome: "CAMPOLIETO", provincia: "CB" },
  { code: "405027003", nome: "CAMPOLONGO MAGGIORE", provincia: "VE" },
  { code: "406030138", nome: "CAMPOLONGO TAPOGLIANO", provincia: "UD" },
  { code: "417076017", nome: "CAMPOMAGGIORE", provincia: "PZ" },
  { code: "414070010", nome: "CAMPOMARINO", provincia: "CB" },
  { code: "407010009", nome: "CAMPOMORONE", provincia: "GE" },
  { code: "405027004", nome: "CAMPONOGARA", provincia: "VE" },
  { code: "415065023", nome: "CAMPORA", provincia: "SA" },
  { code: "419082019", nome: "CAMPOREALE", provincia: "PA" },
  { code: "409046006", nome: "CAMPORGIANO", provincia: "LU" },
  { code: "407008011", nome: "CAMPOROSSO", provincia: "IM" },
  { code: "411043008", nome: "CAMPOROTONDO DI FIASTRONE", provincia: "MC" },
  { code: "419087012", nome: "CAMPOROTONDO ETNEO", provincia: "CT" },
  { code: "405028019", nome: "CAMPOSAMPIERO", provincia: "PD" },
  { code: "415063013", nome: "CAMPOSANO", provincia: "NA" },
  { code: "408036004", nome: "CAMPOSANTO", provincia: "MO" },
  { code: "403018926", nome: "CAMPOSPINOSO ALBAREDO", provincia: "PV" },
  { code: "413066016", nome: "CAMPOTOSTO", provincia: "AQ" },
  { code: "408037010", nome: "CAMUGNANO", provincia: "BO" },
  { code: "404022038", nome: "CANAL SAN BOVO", provincia: "TN" },
  { code: "405025023", nome: "CANALE D\'AGORDO", provincia: "BL" },
  { code: "412058016", nome: "CANALE MONTERANO", provincia: "RM" },
  { code: "401004037", nome: "CANALE", provincia: "CN" },
  { code: "405029009", nome: "CANARO", provincia: "RO" },
  { code: "404022039", nome: "CANAZEI", provincia: "TN" },
  { code: "417076018", nome: "CANCELLARA", provincia: "PZ" },
  { code: "415061012", nome: "CANCELLO ED ARNONE", provincia: "CE" },
  { code: "405029010", nome: "CANDA", provincia: "RO" },
  { code: "416071009", nome: "CANDELA", provincia: "FG" },
  { code: "401096012", nome: "CANDELO", provincia: "BI" },
  { code: "401001050", nome: "CANDIA CANAVESE", provincia: "TO" },
  { code: "403018027", nome: "CANDIA LOMELLINA", provincia: "PV" },
  { code: "405028021", nome: "CANDIANA", provincia: "PD" },
  { code: "415064016", nome: "CANDIDA", provincia: "AV" },
  { code: "418080019", nome: "CANDIDONI", provincia: "RC" },
  { code: "401001051", nome: "CANDIOLO", provincia: "TO" },
  { code: "403015046", nome: "CANEGRATE", provincia: "MI" },
  { code: "401005017", nome: "CANELLI", provincia: "AT" },
  { code: "412056011", nome: "CANEPINA", provincia: "VT" },
  { code: "406093009", nome: "CANEVA", provincia: "PN" },
  { code: "419084011", nome: "CANICATTI\'", provincia: "AG" },
  { code: "419089005", nome: "CANICATTINI BAGNI", provincia: "SR" },
  { code: "412056012", nome: "CANINO", provincia: "VT" },
  { code: "401001052", nome: "CANISCHIO", provincia: "TO" },
  { code: "413066017", nome: "CANISTRO", provincia: "AQ" },
  { code: "418078024", nome: "CANNA", provincia: "CS" },
  { code: "415065024", nome: "CANNALONGA", provincia: "SA" },
  { code: "410054006", nome: "CANNARA", provincia: "PG" },
  { code: "401103016", nome: "CANNERO RIVIERA", provincia: "VB" },
  { code: "403018029", nome: "CANNETO PAVESE", provincia: "PV" },
  { code: "403020008", nome: "CANNETO SULL\'OGLIO", provincia: "MN" },
  { code: "401103017", nome: "CANNOBIO", provincia: "VB" },
  { code: "416075012", nome: "CANNOLE", provincia: "LE" },
  { code: "418080020", nome: "CANOLO", provincia: "RC" },
  { code: "403016049", nome: "CANONICA D\'ADDA", provincia: "BG" },
  { code: "416110004", nome: "CANOSA DI PUGLIA", provincia: "BT" },
  { code: "413069010", nome: "CANOSA SANNITA", provincia: "CH" },
  { code: "401004038", nome: "CANOSIO", provincia: "CN" },
  { code: "408035502", nome: "CANOSSA", provincia: "RE" },
  { code: "413066018", nome: "CANSANO", provincia: "AQ" },
  { code: "409100001", nome: "CANTAGALLO", provincia: "PO" },
  { code: "412057009", nome: "CANTALICE", provincia: "RI" },
  { code: "401001053", nome: "CANTALUPA", provincia: "TO" },
  { code: "412057010", nome: "CANTALUPO IN SABINA", provincia: "RI" },
  { code: "401006028", nome: "CANTALUPO LIGURE", provincia: "AL" },
  { code: "414094005", nome: "CANTALUPO NEL SANNIO", provincia: "IS" },
  { code: "401005018", nome: "CANTARANA", provincia: "AT" },
  { code: "403012030", nome: "CANTELLO", provincia: "VA" },
  { code: "412058017", nome: "CANTERANO", provincia: "RM" },
  { code: "411141008", nome: "CANTIANO", provincia: "PU" },
  { code: "401001054", nome: "CANTOIRA", provincia: "TO" },
  { code: "403013041", nome: "CANTU\'", provincia: "CO" },
  { code: "413067009", nome: "CANZANO", provincia: "TE" },
  { code: "403013042", nome: "CANZO", provincia: "CO" },
  { code: "405027005", nome: "CAORLE", provincia: "VE" },
  { code: "408033010", nome: "CAORSO", provincia: "PC" },
  { code: "415065925", nome: "CAPACCIO PAESTUM", provincia: "SA" },
  { code: "419082020", nome: "CAPACI", provincia: "PA" },
  { code: "409053003", nome: "CAPALBIO", provincia: "GR" },
  { code: "409050005", nome: "CAPANNOLI", provincia: "PI" },
  { code: "409046007", nome: "CAPANNORI", provincia: "LU" },
  { code: "412058018", nome: "CAPENA", provincia: "RM" },
  { code: "403019012", nome: "CAPERGNANICA", provincia: "CR" },
  { code: "413066019", nome: "CAPESTRANO", provincia: "AQ" },
  { code: "403013043", nome: "CAPIAGO INTIMIANO", provincia: "CO" },
  { code: "418102005", nome: "CAPISTRANO", provincia: "VV" },
  { code: "413066020", nome: "CAPISTRELLO", provincia: "AQ" },
  { code: "413066021", nome: "CAPITIGNANO", provincia: "AQ" },
  { code: "419083008", nome: "CAPIZZI", provincia: "ME" },
  { code: "403016050", nome: "CAPIZZONE", provincia: "BG" },
  { code: "419083009", nome: "CAPO D\'ORLANDO", provincia: "ME" },
  { code: "403017035", nome: "CAPO DI PONTE", provincia: "BS" },
  { code: "412056013", nome: "CAPODIMONTE", provincia: "VT" },
  { code: "415061013", nome: "CAPODRISE", provincia: "CE" },
  { code: "409049004", nome: "CAPOLIVERI", provincia: "LI" },
  { code: "409051006", nome: "CAPOLONA", provincia: "AR" },
  { code: "403108052", nome: "CAPONAGO", provincia: "MB" },
  { code: "413066022", nome: "CAPORCIANO", provincia: "AQ" },
  { code: "415064017", nome: "CAPOSELE", provincia: "AV" },
  { code: "420092011", nome: "CAPOTERRA", provincia: "CA" },
  { code: "403017036", nome: "CAPOVALLE", provincia: "BS" },
  { code: "413066023", nome: "CAPPADOCIA", provincia: "AQ" },
  { code: "403019013", nome: "CAPPELLA CANTONE", provincia: "CR" },
  { code: "403019014", nome: "CAPPELLA DE\' PICENARDI", provincia: "CR" },
  { code: "405026007", nome: "CAPPELLA MAGGIORE", provincia: "TV" },
  { code: "413068006", nome: "CAPPELLE SUL TAVO", provincia: "PE" },
  { code: "414094006", nome: "CAPRACOTTA", provincia: "IS" },
  { code: "409048008", nome: "CAPRAIA E LIMITE", provincia: "FI" },
  { code: "409049005", nome: "CAPRAIA ISOLA", provincia: "LI" },
  { code: "403019015", nome: "CAPRALBA", provincia: "CR" },
  { code: "412058019", nome: "CAPRANICA PRENESTINA", provincia: "RM" },
  { code: "412056014", nome: "CAPRANICA", provincia: "VT" },
  { code: "416075013", nome: "CAPRARICA DI LECCE", provincia: "LE" },
  { code: "412056015", nome: "CAPRAROLA", provincia: "VT" },
  { code: "401004039", nome: "CAPRAUNA", provincia: "CN" },
  { code: "409051007", nome: "CAPRESE MICHELANGELO", provincia: "AR" },
  { code: "401103018", nome: "CAPREZZO", provincia: "VB" },
  { code: "419083010", nome: "CAPRI LEONE", provincia: "ME" },
  { code: "415063014", nome: "CAPRI", provincia: "NA" },
  { code: "404022040", nome: "CAPRIANA", provincia: "TN" },
  { code: "403017037", nome: "CAPRIANO DEL COLLE", provincia: "BS" },
  { code: "401006029", nome: "CAPRIATA D\'ORBA", provincia: "AL" },
  { code: "403016051", nome: "CAPRIATE SAN GERVASIO", provincia: "BG" },
  { code: "415061014", nome: "CAPRIATI A VOLTURNO", provincia: "CE" },
  { code: "401001055", nome: "CAPRIE", provincia: "TO" },
  { code: "415064018", nome: "CAPRIGLIA IRPINA", provincia: "AV" },
  { code: "401005019", nome: "CAPRIGLIO", provincia: "AT" },
  { code: "401096013", nome: "CAPRILE", provincia: "BI" },
  { code: "403016052", nome: "CAPRINO BERGAMASCO", provincia: "BG" },
  { code: "405023018", nome: "CAPRINO VERONESE", provincia: "VR" },
  { code: "403017038", nome: "CAPRIOLO", provincia: "BS" },
  { code: "406031001", nome: "CAPRIVA DEL FRIULI", provincia: "GO" },
  { code: "415061015", nome: "CAPUA", provincia: "CE" },
  { code: "416072014", nome: "CAPURSO", provincia: "BA" },
  { code: "418080021", nome: "CARAFFA DEL BIANCO", provincia: "RC" },
  { code: "418079017", nome: "CARAFFA DI CATANZARO", provincia: "CZ" },
  { code: "401004040", nome: "CARAGLIO", provincia: "CN" },
  { code: "401004041", nome: "CARAMAGNA PIEMONTE", provincia: "CN" },
  { code: "413068007", nome: "CARAMANICO TERME", provincia: "PE" },
  { code: "413066024", nome: "CARAPELLE CALVISIO", provincia: "AQ" },
  { code: "416071010", nome: "CARAPELLE", provincia: "FG" },
  { code: "407010010", nome: "CARASCO", provincia: "GE" },
  { code: "411044010", nome: "CARASSAI", provincia: "AP" },
  { code: "403108015", nome: "CARATE BRIANZA", provincia: "MB" },
  { code: "403013044", nome: "CARATE URIO", provincia: "CO" },
  { code: "403016053", nome: "CARAVAGGIO", provincia: "BG" },
  { code: "403012031", nome: "CARAVATE", provincia: "VA" },
  { code: "401001056", nome: "CARAVINO", provincia: "TO" },
  { code: "407008012", nome: "CARAVONICA", provincia: "IM" },
  { code: "412056016", nome: "CARBOGNANO", provincia: "VT" },
  { code: "403018030", nome: "CARBONARA AL TICINO", provincia: "PV" },
  { code: "415063015", nome: "CARBONARA DI NOLA", provincia: "NA" },
  { code: "401006030", nome: "CARBONARA SCRIVIA", provincia: "AL" },
  { code: "403013045", nome: "CARBONATE", provincia: "CO" },
  { code: "417076019", nome: "CARBONE", provincia: "PZ" },
  { code: "405026008", nome: "CARBONERA", provincia: "TV" },
  { code: "420092012", nome: "CARBONIA", provincia: "CA" },
  { code: "407009018", nome: "CARCARE", provincia: "SV" },
  { code: "401002029", nome: "CARCOFORO", provincia: "VC" },
  { code: "403012032", nome: "CARDANO AL CAMPO", provincia: "VA" },
  { code: "401004042", nome: "CARDE\'", provincia: "CN" },
  { code: "420091103", nome: "CARDEDU", provincia: "NU" },
  { code: "418080022", nome: "CARDETO", provincia: "RC" },
  { code: "418079018", nome: "CARDINALE", provincia: "CZ" },
  { code: "415063016", nome: "CARDITO", provincia: "NA" },
  { code: "409046008", nome: "CAREGGINE", provincia: "LU" },
  { code: "401001057", nome: "CAREMA", provincia: "TO" },
  { code: "403097014", nome: "CARENNO", provincia: "LC" },
  { code: "401006031", nome: "CARENTINO", provincia: "AL" },
  { code: "418080023", nome: "CARERI", provincia: "RC" },
  { code: "401002030", nome: "CARESANA", provincia: "VC" },
  { code: "401002031", nome: "CARESANABLOT", provincia: "VC" },
  { code: "401006032", nome: "CAREZZANO", provincia: "AL" },
  { code: "418101003", nome: "CARFIZZI", provincia: "KR" },
  { code: "420090022", nome: "CARGEGHE", provincia: "SS" },
  { code: "418078025", nome: "CARIATI", provincia: "CS" },
  { code: "415064019", nome: "CARIFE", provincia: "AV" },
  { code: "401001058", nome: "CARIGNANO", provincia: "TO" },
  { code: "403013046", nome: "CARIMATE", provincia: "CO" },
  { code: "415061016", nome: "CARINARO", provincia: "CE" },
  { code: "419082021", nome: "CARINI", provincia: "PA" },
  { code: "415061017", nome: "CARINOLA", provincia: "CE" },
  { code: "401002032", nome: "CARISIO", provincia: "VC" },
  { code: "404022042", nome: "CARISOLO", provincia: "TN" },
  { code: "416071011", nome: "CARLANTINO", provincia: "FG" },
  { code: "403013047", nome: "CARLAZZO", provincia: "CO" },
  { code: "419089006", nome: "CARLENTINI", provincia: "SR" },
  { code: "406030018", nome: "CARLINO", provincia: "UD" },
  { code: "420092013", nome: "CARLOFORTE", provincia: "CA" },
  { code: "418079020", nome: "CARLOPOLI", provincia: "CZ" },
  { code: "401001059", nome: "CARMAGNOLA", provincia: "TO" },
  { code: "416075014", nome: "CARMIANO", provincia: "LE" },
  { code: "405028023", nome: "CARMIGNANO DI BRENTA", provincia: "PD" },
  { code: "409100002", nome: "CARMIGNANO", provincia: "PO" },
  { code: "403012033", nome: "CARNAGO", provincia: "VA" },
  { code: "403108016", nome: "CARNATE", provincia: "MB" },
  { code: "403016055", nome: "CAROBBIO DEGLI ANGELI", provincia: "BG" },
  { code: "418078026", nome: "CAROLEI", provincia: "CS" },
  { code: "403016056", nome: "CARONA", provincia: "BG" },
  { code: "419083011", nome: "CARONIA", provincia: "ME" },
  { code: "403012034", nome: "CARONNO PERTUSELLA", provincia: "VA" },
  { code: "403012035", nome: "CARONNO VARESINO", provincia: "VA" },
  { code: "416073002", nome: "CAROSINO", provincia: "TA" },
  { code: "416074002", nome: "CAROVIGNO", provincia: "BR" },
  { code: "414094007", nome: "CAROVILLI", provincia: "IS" },
  { code: "408033011", nome: "CARPANETO PIACENTINO", provincia: "PC" },
  { code: "418078027", nome: "CARPANZANO", provincia: "CS" },
  { code: "411141009", nome: "CARPEGNA", provincia: "PU" },
  { code: "403017039", nome: "CARPENEDOLO", provincia: "BS" },
  { code: "401006033", nome: "CARPENETO", provincia: "AL" },
  { code: "408036005", nome: "CARPI", provincia: "MO" },
  { code: "403015050", nome: "CARPIANO", provincia: "MI" },
  { code: "416075015", nome: "CARPIGNANO SALENTINO", provincia: "LE" },
  { code: "401003036", nome: "CARPIGNANO SESIA", provincia: "NO" },
  { code: "408035011", nome: "CARPINETI", provincia: "RE" },
  { code: "413068008", nome: "CARPINETO DELLA NORA", provincia: "PE" },
  { code: "412058020", nome: "CARPINETO ROMANO", provincia: "RM" },
  { code: "413069011", nome: "CARPINETO SINELLO", provincia: "CH" },
  { code: "416071012", nome: "CARPINO", provincia: "FG" },
  { code: "414094008", nome: "CARPINONE", provincia: "IS" },
  { code: "409045003", nome: "CARRARA", provincia: "MS" },
  { code: "405024024", nome: "CARRE\'", provincia: "VI" },
  { code: "401006034", nome: "CARREGA LIGURE", provincia: "AL" },
  { code: "407011009", nome: "CARRO", provincia: "SP" },
  { code: "407011010", nome: "CARRODANO", provincia: "SP" },
  { code: "401006035", nome: "CARROSIO", provincia: "AL" },
  { code: "401004043", nome: "CARRU\'", provincia: "CN" },
  { code: "413066025", nome: "CARSOLI", provincia: "AQ" },
  { code: "405024025", nome: "CARTIGLIANO", provincia: "VI" },
  { code: "401004044", nome: "CARTIGNANO", provincia: "CN" },
  { code: "411141010", nome: "CARTOCETO", provincia: "PU" },
  { code: "401006036", nome: "CARTOSIO", provincia: "AL" },
  { code: "405028026", nome: "CARTURA", provincia: "PD" },
  { code: "403015051", nome: "CARUGATE", provincia: "MI" },
  { code: "403013048", nome: "CARUGO", provincia: "CO" },
  { code: "413069012", nome: "CARUNCHIO", provincia: "CH" },
  { code: "403016057", nome: "CARVICO", provincia: "BG" },
  { code: "404022043", nome: "CARZANO", provincia: "TN" },
  { code: "418101004", nome: "CASABONA", provincia: "KR" },
  { code: "414070011", nome: "CASACALENDA", provincia: "CB" },
  { code: "413069013", nome: "CASACANDITELLA", provincia: "CH" },
  { code: "415061018", nome: "CASAGIOVE", provincia: "CE" },
  { code: "401006037", nome: "CASAL CERMELLI", provincia: "AL" },
  { code: "415061019", nome: "CASAL DI PRINCIPE", provincia: "CE" },
  { code: "415065028", nome: "CASAL VELINO", provincia: "SA" },
  { code: "413069014", nome: "CASALANGUIDA", provincia: "CH" },
  { code: "412060017", nome: "CASALATTICO", provincia: "FR" },
  { code: "401003037", nome: "CASALBELTRAME", provincia: "NO" },
  { code: "413069015", nome: "CASALBORDINO", provincia: "CH" },
  { code: "415064020", nome: "CASALBORE", provincia: "AV" },
  { code: "401001060", nome: "CASALBORGONE", provincia: "TO" },
  { code: "415065026", nome: "CASALBUONO", provincia: "SA" },
  { code: "403019016", nome: "CASALBUTTANO ED UNITI", provincia: "CR" },
  { code: "414070012", nome: "CASALCIPRANO", provincia: "CB" },
  { code: "415062015", nome: "CASALDUNI", provincia: "BN" },
  { code: "401103019", nome: "CASALE CORTE CERRO", provincia: "VB" },
  { code: "403019017", nome: "CASALE CREMASCO-VIDOLASCO", provincia: "CR" },
  { code: "405028027", nome: "CASALE DI SCODOSIA", provincia: "PD" },
  { code: "403012036", nome: "CASALE LITTA", provincia: "VA" },
  { code: "409050006", nome: "CASALE MARITTIMO", provincia: "PI" },
  { code: "401006039", nome: "CASALE MONFERRATO", provincia: "AL" },
  { code: "405026009", nome: "CASALE SUL SILE", provincia: "TV" },
  { code: "408037011", nome: "CASALECCHIO DI RENO", provincia: "BO" },
  { code: "401006038", nome: "CASALEGGIO BOIRO", provincia: "AL" },
  { code: "401003039", nome: "CASALEGGIO NOVARA", provincia: "NO" },
  { code: "405023019", nome: "CASALEONE", provincia: "VR" },
  { code: "403019018", nome: "CASALETTO CEREDANO", provincia: "CR" },
  { code: "403019019", nome: "CASALETTO DI SOPRA", provincia: "CR" },
  { code: "403098008", nome: "CASALETTO LODIGIANO", provincia: "LO" },
  { code: "415065027", nome: "CASALETTO SPARTANO", provincia: "SA" },
  { code: "403019020", nome: "CASALETTO VAPRIO", provincia: "CR" },
  { code: "408037012", nome: "CASALFIUMANESE", provincia: "BO" },
  { code: "408035012", nome: "CASALGRANDE", provincia: "RE" },
  { code: "401004045", nome: "CASALGRASSO", provincia: "CN" },
  { code: "418078156", nome: "CASALI DEL MANCO", provincia: "CS" },
  { code: "413069016", nome: "CASALINCONTRADA", provincia: "CH" },
  { code: "401003040", nome: "CASALINO", provincia: "NO" },
  { code: "403019021", nome: "CASALMAGGIORE", provincia: "CR" },
  { code: "403098009", nome: "CASALMAIOCCO", provincia: "LO" },
  { code: "403019022", nome: "CASALMORANO", provincia: "CR" },
  { code: "403020010", nome: "CASALMORO", provincia: "MN" },
  { code: "401006040", nome: "CASALNOCETO", provincia: "AL" },
  { code: "415063017", nome: "CASALNUOVO DI NAPOLI", provincia: "NA" },
  { code: "416071013", nome: "CASALNUOVO MONTEROTARO", provincia: "FG" },
  { code: "403020011", nome: "CASALOLDO", provincia: "MN" },
  { code: "403098010", nome: "CASALPUSTERLENGO", provincia: "LO" },
  { code: "403020012", nome: "CASALROMANO", provincia: "MN" },
  { code: "405028028", nome: "CASALSERUGO", provincia: "PD" },
  { code: "415061020", nome: "CASALUCE", provincia: "CE" },
  { code: "416071014", nome: "CASALVECCHIO DI PUGLIA", provincia: "FG" },
  { code: "419083012", nome: "CASALVECCHIO SICULO", provincia: "ME" },
  { code: "412060018", nome: "CASALVIERI", provincia: "FR" },
  { code: "401003041", nome: "CASALVOLONE", provincia: "NO" },
  { code: "403012037", nome: "CASALZUIGNO", provincia: "VA" },
  { code: "415063018", nome: "CASAMARCIANO", provincia: "NA" },
  { code: "416072015", nome: "CASAMASSIMA", provincia: "BA" },
  { code: "415063019", nome: "CASAMICCIOLA TERME", provincia: "NA" },
  { code: "415063020", nome: "CASANDRINO", provincia: "NA" },
  { code: "401002033", nome: "CASANOVA ELVO", provincia: "VC" },
  { code: "407009019", nome: "CASANOVA LERRONE", provincia: "SV" },
  { code: "403018031", nome: "CASANOVA LONATI", provincia: "PV" },
  { code: "412058021", nome: "CASAPE", provincia: "RM" },
  { code: "415061103", nome: "CASAPESENNA", provincia: "CE" },
  { code: "401096014", nome: "CASAPINTA", provincia: "BI" },
  { code: "412057011", nome: "CASAPROTA", provincia: "RI" },
  { code: "415061021", nome: "CASAPULLA", provincia: "CE" },
  { code: "416075016", nome: "CASARANO", provincia: "LE" },
  { code: "403097015", nome: "CASARGO", provincia: "LC" },
  { code: "403015055", nome: "CASARILE", provincia: "MI" },
  { code: "406093010", nome: "CASARSA DELLA DELIZIA", provincia: "PN" },
  { code: "407010011", nome: "CASARZA LIGURE", provincia: "GE" },
  { code: "401006041", nome: "CASASCO", provincia: "AL" },
  { code: "403097016", nome: "CASATENOVO", provincia: "LC" },
  { code: "403018032", nome: "CASATISMA", provincia: "PV" },
  { code: "415063021", nome: "CASAVATORE", provincia: "NA" },
  { code: "403016058", nome: "CASAZZA", provincia: "BG" },
  { code: "410054007", nome: "CASCIA", provincia: "PG" },
  { code: "403012038", nome: "CASCIAGO", provincia: "VA" },
  { code: "409050040", nome: "CASCIANA TERME LARI", provincia: "PI" },
  { code: "409050008", nome: "CASCINA", provincia: "PI" },
  { code: "401001061", nome: "CASCINETTE D\'IVREA", provincia: "TO" },
  { code: "403018033", nome: "CASEI GEROLA", provincia: "PV" },
  { code: "401001062", nome: "CASELETTE", provincia: "TO" },
  { code: "407010012", nome: "CASELLA", provincia: "GE" },
  { code: "415065029", nome: "CASELLE IN PITTARI", provincia: "SA" },
  { code: "403098011", nome: "CASELLE LANDI", provincia: "LO" },
  { code: "403098012", nome: "CASELLE LURANI", provincia: "LO" },
  { code: "401001063", nome: "CASELLE TORINESE", provincia: "TO" },
  { code: "415061022", nome: "CASERTA", provincia: "CE" },
  { code: "405026010", nome: "CASIER", provincia: "TV" },
  { code: "418080024", nome: "CASIGNANA", provincia: "RC" },
  { code: "408035013", nome: "CASINA", provincia: "RE" },
  { code: "403016059", nome: "CASIRATE D\'ADDA", provincia: "BG" },
  { code: "403013052", nome: "CASLINO D\'ERBA", provincia: "CO" },
  { code: "403013053", nome: "CASNATE CON BERNATE", provincia: "CO" },
  { code: "403016060", nome: "CASNIGO", provincia: "BG" },
  { code: "415063022", nome: "CASOLA DI NAPOLI", provincia: "NA" },
  { code: "409045004", nome: "CASOLA IN LUNIGIANA", provincia: "MS" },
  { code: "408039005", nome: "CASOLA VALSENIO", provincia: "RA" },
  { code: "409052004", nome: "CASOLE D\'ELSA", provincia: "SI" },
  { code: "413069017", nome: "CASOLI", provincia: "CH" },
  { code: "403018034", nome: "CASORATE PRIMO", provincia: "PV" },
  { code: "403012039", nome: "CASORATE SEMPIONE", provincia: "VA" },
  { code: "403015058", nome: "CASOREZZO", provincia: "MI" },
  { code: "415063023", nome: "CASORIA", provincia: "NA" },
  { code: "401005920", nome: "CASORZO MONFERRATO", provincia: "AT" },
  { code: "412057012", nome: "CASPERIA", provincia: "RI" },
  { code: "403014013", nome: "CASPOGGIO", provincia: "SO" },
  { code: "406030019", nome: "CASSACCO", provincia: "UD" },
  { code: "403097017", nome: "CASSAGO BRIANZA", provincia: "LC" },
  { code: "418078029", nome: "CASSANO ALL\'IONIO", provincia: "CS" },
  { code: "403015059", nome: "CASSANO D\'ADDA", provincia: "MI" },
  { code: "416072016", nome: "CASSANO DELLE MURGE", provincia: "BA" },
  { code: "415064021", nome: "CASSANO IRPINO", provincia: "AV" },
  { code: "403012040", nome: "CASSANO MAGNAGO", provincia: "VA" },
  { code: "401006191", nome: "CASSANO SPINOLA", provincia: "AL" },
  { code: "403012041", nome: "CASSANO VALCUVIA", provincia: "VA" },
  { code: "419089007", nome: "CASSARO", provincia: "SR" },
  { code: "403016061", nome: "CASSIGLIO", provincia: "BG" },
  { code: "403015060", nome: "CASSINA DE\' PECCHI", provincia: "MI" },
  { code: "403013055", nome: "CASSINA RIZZARDI", provincia: "CO" },
  { code: "403097018", nome: "CASSINA VALSASSINA", provincia: "LC" },
  { code: "401005021", nome: "CASSINASCO", provincia: "AT" },
  { code: "401006043", nome: "CASSINE", provincia: "AL" },
  { code: "401006044", nome: "CASSINELLE", provincia: "AL" },
  { code: "403015061", nome: "CASSINETTA DI LUGAGNANO", provincia: "MI" },
  { code: "412060019", nome: "CASSINO", provincia: "FR" },
  { code: "405024026", nome: "CASSOLA", provincia: "VI" },
  { code: "403018035", nome: "CASSOLNOVO", provincia: "PV" },
  { code: "405023020", nome: "CASTAGNARO", provincia: "VR" },
  { code: "409049006", nome: "CASTAGNETO CARDUCCI", provincia: "LI" },
  { code: "401001064", nome: "CASTAGNETO PO", provincia: "TO" },
  { code: "401004046", nome: "CASTAGNITO", provincia: "CN" },
  { code: "401005022", nome: "CASTAGNOLE DELLE LANZE", provincia: "AT" },
  { code: "401005023", nome: "CASTAGNOLE MONFERRATO", provincia: "AT" },
  { code: "401001065", nome: "CASTAGNOLE PIEMONTE", provincia: "TO" },
  { code: "403018036", nome: "CASTANA", provincia: "PV" },
  { code: "403015062", nome: "CASTANO PRIMO", provincia: "MI" },
  { code: "403018037", nome: "CASTEGGIO", provincia: "PV" },
  { code: "403017040", nome: "CASTEGNATO", provincia: "BS" },
  { code: "405024027", nome: "CASTEGNERO", provincia: "VI" },
  { code: "415064022", nome: "CASTEL BARONIA", provincia: "AV" },
  { code: "401005024", nome: "CASTEL BOGLIONE", provincia: "AT" },
  { code: "408039006", nome: "CASTEL BOLOGNESE", provincia: "RA" },
  { code: "415061023", nome: "CASTEL CAMPAGNANO", provincia: "CE" },
  { code: "413067010", nome: "CASTEL CASTAGNA", provincia: "TE" },
  { code: "404022045", nome: "CASTEL CONDINO", provincia: "TN" },
  { code: "408037013", nome: "CASTEL D\'AIANO", provincia: "BO" },
  { code: "403020014", nome: "CASTEL D\'ARIO", provincia: "MN" },
  { code: "405023021", nome: "CASTEL D\'AZZANO", provincia: "VR" },
  { code: "414094009", nome: "CASTEL DEL GIUDICE", provincia: "IS" },
  { code: "413066026", nome: "CASTEL DEL MONTE", provincia: "AQ" },
  { code: "409053004", nome: "CASTEL DEL PIANO", provincia: "GR" },
  { code: "408037014", nome: "CASTEL DEL RIO", provincia: "BO" },
  { code: "408037015", nome: "CASTEL DI CASIO", provincia: "BO" },
  { code: "413066027", nome: "CASTEL DI IERI", provincia: "AQ" },
  { code: "419087013", nome: "CASTEL DI IUDICA", provincia: "CT" },
  { code: "411044011", nome: "CASTEL DI LAMA", provincia: "AP" },
  { code: "419083013", nome: "CASTEL DI LUCIO", provincia: "ME" },
  { code: "413066028", nome: "CASTEL DI SANGRO", provincia: "AQ" },
  { code: "415061024", nome: "CASTEL DI SASSO", provincia: "CE" },
  { code: "412057013", nome: "CASTEL DI TORA", provincia: "RI" },
  { code: "409051008", nome: "CASTEL FOCOGNANO", provincia: "AR" },
  { code: "413069018", nome: "CASTEL FRENTANO", provincia: "CH" },
  { code: "403019024", nome: "CASTEL GABBIANO", provincia: "CR" },
  { code: "412058022", nome: "CASTEL GANDOLFO", provincia: "RM" },
  { code: "410055009", nome: "CASTEL GIORGIO", provincia: "TR" },
  { code: "403020015", nome: "CASTEL GOFFREDO", provincia: "MN" },
  { code: "408037016", nome: "CASTEL GUELFO DI BOLOGNA", provincia: "BO" },
  { code: "404022240", nome: "CASTEL IVANO", provincia: "TN" },
  { code: "412058023", nome: "CASTEL MADAMA", provincia: "RM" },
  { code: "408037019", nome: "CASTEL MAGGIORE", provincia: "BO" },
  { code: "403017042", nome: "CASTEL MELLA", provincia: "BS" },
  { code: "415061026", nome: "CASTEL MORRONE", provincia: "CE" },
  { code: "410054008", nome: "CASTEL RITALDI", provincia: "PG" },
  { code: "401005032", nome: "CASTEL ROCCHERO", provincia: "AT" },
  { code: "403016063", nome: "CASTEL ROZZONE", provincia: "BG" },
  { code: "415065034", nome: "CASTEL SAN GIORGIO", provincia: "SA" },
  { code: "408033013", nome: "CASTEL SAN GIOVANNI", provincia: "PC" },
  { code: "415065035", nome: "CASTEL SAN LORENZO", provincia: "SA" },
  { code: "409051010", nome: "CASTEL SAN NICCOLO\'", provincia: "AR" },
  { code: "412058025", nome: "CASTEL SAN PIETRO ROMANO", provincia: "RM" },
  { code: "408037020", nome: "CASTEL SAN PIETRO TERME", provincia: "BO" },
  { code: "414094012", nome: "CASTEL SAN VINCENZO", provincia: "IS" },
  { code: "412057015", nome: "CASTEL SANT\'ANGELO", provincia: "RI" },
  { code: "412056017", nome: "CASTEL SANT\'ELIA", provincia: "VT" },
  { code: "410055010", nome: "CASTEL VISCARDO", provincia: "TR" },
  { code: "407008015", nome: "CASTEL VITTORIO", provincia: "IM" },
  { code: "415061027", nome: "CASTEL VOLTURNO", provincia: "CE" },
  { code: "405028029", nome: "CASTELBALDO", provincia: "PD" },
  { code: "403020013", nome: "CASTELBELFORTE", provincia: "MN" },
  { code: "411042008", nome: "CASTELBELLINO", provincia: "AN" },
  { code: "404021018", nome: "CASTELBELLO CIARDES", provincia: "BZ" },
  { code: "407009020", nome: "CASTELBIANCO", provincia: "SV" },
  { code: "414070013", nome: "CASTELBOTTACCIO", provincia: "CB" },
  { code: "419082022", nome: "CASTELBUONO", provincia: "PA" },
  { code: "415065030", nome: "CASTELCIVITA", provincia: "SA" },
  { code: "403017041", nome: "CASTELCOVATI", provincia: "BS" },
  { code: "405026011", nome: "CASTELCUCCO", provincia: "TV" },
  { code: "419082023", nome: "CASTELDACCIA", provincia: "PA" },
  { code: "408099021", nome: "CASTELDELCI", provincia: "RN" },
  { code: "401004047", nome: "CASTELDELFINO", provincia: "CN" },
  { code: "403019023", nome: "CASTELDIDONE", provincia: "CR" },
  { code: "411042010", nome: "CASTELFIDARDO", provincia: "AN" },
  { code: "409048010", nome: "CASTELFIORENTINO", provincia: "FI" },
  { code: "412059004", nome: "CASTELFORTE", provincia: "LT" },
  { code: "415064023", nome: "CASTELFRANCI", provincia: "AV" },
  { code: "409050009", nome: "CASTELFRANCO DI SOTTO", provincia: "PI" },
  { code: "408036006", nome: "CASTELFRANCO EMILIA", provincia: "MO" },
  { code: "415062016", nome: "CASTELFRANCO IN MISCANO", provincia: "BN" },
  { code: "409051040", nome: "CASTELFRANCO PIANDISCO\'", provincia: "AR" },
  { code: "405026012", nome: "CASTELFRANCO VENETO", provincia: "TV" },
  { code: "403098062", nome: "CASTELGERUNDO", provincia: "LO" },
  { code: "405024028", nome: "CASTELGOMBERTO", provincia: "VI" },
  { code: "417076021", nome: "CASTELGRANDE", provincia: "PZ" },
  { code: "405029011", nome: "CASTELGUGLIELMO", provincia: "RO" },
  { code: "413069019", nome: "CASTELGUIDONE", provincia: "CH" },
  { code: "401005025", nome: "CASTELL\'ALFERO", provincia: "AT" },
  { code: "408033012", nome: "CASTELL\'ARQUATO", provincia: "PC" },
  { code: "409053005", nome: "CASTELL\'AZZARA", provincia: "GR" },
  { code: "419083014", nome: "CASTELL\'UMBERTO", provincia: "ME" },
  { code: "415065031", nome: "CASTELLABATE", provincia: "SA" },
  { code: "413066029", nome: "CASTELLAFIUME", provincia: "AQ" },
  { code: "413067011", nome: "CASTELLALTO", provincia: "TE" },
  { code: "419081005", nome: "CASTELLAMMARE DEL GOLFO", provincia: "TP" },
  { code: "415063024", nome: "CASTELLAMMARE DI STABIA", provincia: "NA" },
  { code: "401001066", nome: "CASTELLAMONTE", provincia: "TO" },
  { code: "416072017", nome: "CASTELLANA GROTTE", provincia: "BA" },
  { code: "419082024", nome: "CASTELLANA SICULA", provincia: "PA" },
  { code: "416073003", nome: "CASTELLANETA", provincia: "TA" },
  { code: "401006945", nome: "CASTELLANIA COPPI", provincia: "AL" },
  { code: "403012042", nome: "CASTELLANZA", provincia: "VA" },
  { code: "401006046", nome: "CASTELLAR GUIDOBONO", provincia: "AL" },
  { code: "408035014", nome: "CASTELLARANO", provincia: "RE" },
  { code: "407008014", nome: "CASTELLARO", provincia: "IM" },
  { code: "401006047", nome: "CASTELLAZZO BORMIDA", provincia: "AL" },
  { code: "401003042", nome: "CASTELLAZZO NOVARESE", provincia: "NO" },
  { code: "411042011", nome: "CASTELLEONE DI SUASA", provincia: "AN" },
  { code: "403019025", nome: "CASTELLEONE", provincia: "CR" },
  { code: "401005026", nome: "CASTELLERO", provincia: "AT" },
  { code: "401096015", nome: "CASTELLETTO CERVO", provincia: "BI" },
  { code: "401006048", nome: "CASTELLETTO D\'ERRO", provincia: "AL" },
  { code: "401006049", nome: "CASTELLETTO D\'ORBA", provincia: "AL" },
  { code: "403018038", nome: "CASTELLETTO DI BRANDUZZO", provincia: "PV" },
  { code: "401006050", nome: "CASTELLETTO MERLI", provincia: "AL" },
  { code: "401005027", nome: "CASTELLETTO MOLINA", provincia: "AT" },
  { code: "401006051", nome: "CASTELLETTO MONFERRATO", provincia: "AL" },
  { code: "401003043", nome: "CASTELLETTO SOPRA TICINO", provincia: "NO" },
  { code: "401004049", nome: "CASTELLETTO STURA", provincia: "CN" },
  { code: "401004050", nome: "CASTELLETTO UZZONE", provincia: "CN" },
  { code: "403016062", nome: "CASTELLI CALEPIO", provincia: "BG" },
  { code: "413067012", nome: "CASTELLI", provincia: "TE" },
  { code: "409052005", nome: "CASTELLINA IN CHIANTI", provincia: "SI" },
  { code: "409050010", nome: "CASTELLINA MARITTIMA", provincia: "PI" },
  { code: "401004951", nome: "CASTELLINALDO D\'ALBA", provincia: "CN" },
  { code: "414070014", nome: "CASTELLINO DEL BIFERNO", provincia: "CB" },
  { code: "401004052", nome: "CASTELLINO TANARO", provincia: "CN" },
  { code: "412060020", nome: "CASTELLIRI", provincia: "FR" },
  { code: "403012043", nome: "CASTELLO CABIAGLIO", provincia: "VA" },
  { code: "403018039", nome: "CASTELLO D\'AGOGNA", provincia: "PV" },
  { code: "408037017", nome: "CASTELLO D\'ARGILE", provincia: "BO" },
  { code: "415061025", nome: "CASTELLO DEL MATESE", provincia: "CE" },
  { code: "403014014", nome: "CASTELLO DELL\'ACQUA", provincia: "SO" },
  { code: "401005028", nome: "CASTELLO DI ANNONE", provincia: "AT" },
  { code: "403097019", nome: "CASTELLO DI BRIANZA", provincia: "LC" },
  { code: "415063025", nome: "CASTELLO DI CISTERNA", provincia: "NA" },
  { code: "405026013", nome: "CASTELLO DI GODEGO", provincia: "TV" },
  { code: "404022048", nome: "CASTELLO TESINO", provincia: "TN" },
  { code: "404022047", nome: "CASTELLO-MOLINA DI FIEMME", provincia: "TN" },
  { code: "403020016", nome: "CASTELLUCCHIO", provincia: "MN" },
  { code: "416071015", nome: "CASTELLUCCIO DE\' SAURI", provincia: "FG" },
  { code: "417076022", nome: "CASTELLUCCIO INFERIORE", provincia: "PZ" },
  { code: "417076023", nome: "CASTELLUCCIO SUPERIORE", provincia: "PZ" },
  { code: "416071016", nome: "CASTELLUCCIO VALMAGGIORE", provincia: "FG" },
  { code: "401004053", nome: "CASTELMAGNO", provincia: "CN" },
  { code: "403013058", nome: "CASTELMARTE", provincia: "CO" },
  { code: "405029012", nome: "CASTELMASSA", provincia: "RO" },
  { code: "414070015", nome: "CASTELMAURO", provincia: "CB" },
  { code: "417076024", nome: "CASTELMEZZANO", provincia: "PZ" },
  { code: "419083015", nome: "CASTELMOLA", provincia: "ME" },
  { code: "403018040", nome: "CASTELNOVETTO", provincia: "PV" },
  { code: "405029013", nome: "CASTELNOVO BARIANO", provincia: "RO" },
  { code: "406093011", nome: "CASTELNOVO DEL FRIULI", provincia: "PN" },
  { code: "408035015", nome: "CASTELNOVO DI SOTTO", provincia: "RE" },
  { code: "408035016", nome: "CASTELNOVO NE\' MONTI", provincia: "RE" },
  { code: "401005029", nome: "CASTELNUOVO BELBO", provincia: "AT" },
  { code: "409052006", nome: "CASTELNUOVO BERARDENGA", provincia: "SI" },
  { code: "403098013", nome: "CASTELNUOVO BOCCA D\'ADDA", provincia: "LO" },
  { code: "401006052", nome: "CASTELNUOVO BORMIDA", provincia: "AL" },
  { code: "403013059", nome: "CASTELNUOVO BOZZENTE", provincia: "CO" },
  { code: "401005030", nome: "CASTELNUOVO CALCEA", provincia: "AT" },
  { code: "415065032", nome: "CASTELNUOVO CILENTO", provincia: "SA" },
  { code: "405023520", nome: "CASTELNUOVO DEL GARDA", provincia: "VR" },
  { code: "416071017", nome: "CASTELNUOVO DELLA DAUNIA", provincia: "FG" },
  { code: "401004054", nome: "CASTELNUOVO DI CEVA", provincia: "CN" },
  { code: "415065033", nome: "CASTELNUOVO DI CONZA", provincia: "SA" },
  { code: "412057014", nome: "CASTELNUOVO DI FARFA", provincia: "RI" },
  { code: "409046009", nome: "CASTELNUOVO DI GARFAGNANA", provincia: "LU" },
  { code: "412058024", nome: "CASTELNUOVO DI PORTO", provincia: "RM" },
  { code: "409050011", nome: "CASTELNUOVO DI VAL DI CECINA", provincia: "PI" },
  { code: "401005031", nome: "CASTELNUOVO DON BOSCO", provincia: "AT" },
  { code: "407011011", nome: "CASTELNUOVO MAGRA", provincia: "SP" },
  { code: "401001067", nome: "CASTELNUOVO NIGRA", provincia: "TO" },
  { code: "412060021", nome: "CASTELNUOVO PARANO", provincia: "FR" },
  { code: "408036007", nome: "CASTELNUOVO RANGONE", provincia: "MO" },
  { code: "401006053", nome: "CASTELNUOVO SCRIVIA", provincia: "AL" },
  { code: "404022049", nome: "CASTELNUOVO", provincia: "TN" },
  { code: "415062017", nome: "CASTELPAGANO", provincia: "BN" },
  { code: "414094010", nome: "CASTELPETROSO", provincia: "IS" },
  { code: "414094011", nome: "CASTELPIZZUTO", provincia: "IS" },
  { code: "411042012", nome: "CASTELPLANIO", provincia: "AN" },
  { code: "415062018", nome: "CASTELPOTO", provincia: "BN" },
  { code: "411043009", nome: "CASTELRAIMONDO", provincia: "MC" },
  { code: "404021019", nome: "CASTELROTTO", provincia: "BZ" },
  { code: "411043010", nome: "CASTELSANTANGELO SUL NERA", provincia: "MC" },
  { code: "417076025", nome: "CASTELSARACENO", provincia: "PZ" },
  { code: "420090023", nome: "CASTELSARDO", provincia: "SS" },
  { code: "403012044", nome: "CASTELSEPRIO", provincia: "VA" },
  { code: "418101005", nome: "CASTELSILANO", provincia: "KR" },
  { code: "401006054", nome: "CASTELSPINA", provincia: "AL" },
  { code: "419084012", nome: "CASTELTERMINI", provincia: "AG" },
  { code: "403012045", nome: "CASTELVECCANA", provincia: "VA" },
  { code: "413066030", nome: "CASTELVECCHIO CALVISIO", provincia: "AQ" },
  { code: "407009021", nome: "CASTELVECCHIO DI ROCCA BARBENA", provincia: "SV" },
  { code: "413066031", nome: "CASTELVECCHIO SUBEQUO", provincia: "AQ" },
  { code: "415062019", nome: "CASTELVENERE", provincia: "BN" },
  { code: "403019026", nome: "CASTELVERDE", provincia: "CR" },
  { code: "414094013", nome: "CASTELVERRINO", provincia: "IS" },
  { code: "415062020", nome: "CASTELVETERE IN VAL FORTORE", provincia: "BN" },
  { code: "415064024", nome: "CASTELVETERE SUL CALORE", provincia: "AV" },
  { code: "419081006", nome: "CASTELVETRANO", provincia: "TP" },
  { code: "408036008", nome: "CASTELVETRO DI MODENA", provincia: "MO" },
  { code: "408033014", nome: "CASTELVETRO PIACENTINO", provincia: "PC" },
  { code: "403019027", nome: "CASTELVISCONTI", provincia: "CR" },
  { code: "408037021", nome: "CASTENASO", provincia: "BO" },
  { code: "403017043", nome: "CASTENEDOLO", provincia: "BS" },
  { code: "420092106", nome: "CASTIADAS", provincia: "CA" },
  { code: "409051011", nome: "CASTIGLION FIBOCCHI", provincia: "AR" },
  { code: "409051012", nome: "CASTIGLION FIORENTINO", provincia: "AR" },
  { code: "413068009", nome: "CASTIGLIONE A CASAURIA", provincia: "PE" },
  { code: "407010013", nome: "CASTIGLIONE CHIAVARESE", provincia: "GE" },
  { code: "418078030", nome: "CASTIGLIONE COSENTINO", provincia: "CS" },
  { code: "403098014", nome: "CASTIGLIONE D\'ADDA", provincia: "LO" },
  { code: "409052007", nome: "CASTIGLIONE D\'ORCIA", provincia: "SI" },
  { code: "408037022", nome: "CASTIGLIONE DEI PEPOLI", provincia: "BO" },
  { code: "415065036", nome: "CASTIGLIONE DEL GENOVESI", provincia: "SA" },
  { code: "410054009", nome: "CASTIGLIONE DEL LAGO", provincia: "PG" },
  { code: "409053006", nome: "CASTIGLIONE DELLA PESCAIA", provincia: "GR" },
  { code: "403020017", nome: "CASTIGLIONE DELLE STIVIERE", provincia: "MN" },
  { code: "409046010", nome: "CASTIGLIONE DI GARFAGNANA", provincia: "LU" },
  { code: "419087014", nome: "CASTIGLIONE DI SICILIA", provincia: "CT" },
  { code: "401004055", nome: "CASTIGLIONE FALLETTO", provincia: "CN" },
  { code: "412056018", nome: "CASTIGLIONE IN TEVERINA", provincia: "VT" },
  { code: "413069020", nome: "CASTIGLIONE MESSER MARINO", provincia: "CH" },
  { code: "413067013", nome: "CASTIGLIONE MESSER RAIMONDO", provincia: "TE" },
  { code: "403012046", nome: "CASTIGLIONE OLONA", provincia: "VA" },
  { code: "401004056", nome: "CASTIGLIONE TINELLA", provincia: "CN" },
  { code: "401001068", nome: "CASTIGLIONE TORINESE", provincia: "TO" },
  { code: "411044012", nome: "CASTIGNANO", provincia: "AP" },
  { code: "413067014", nome: "CASTILENTI", provincia: "TE" },
  { code: "401004057", nome: "CASTINO", provincia: "CN" },
  { code: "403014015", nome: "CASTIONE ANDEVENNO", provincia: "SO" },
  { code: "403016064", nome: "CASTIONE DELLA PRESOLANA", provincia: "BG" },
  { code: "406030020", nome: "CASTIONS DI STRADA", provincia: "UD" },
  { code: "403098015", nome: "CASTIRAGA VIDARDO", provincia: "LO" },
  { code: "403017044", nome: "CASTO", provincia: "BS" },
  { code: "411044013", nome: "CASTORANO", provincia: "AP" },
  { code: "403017045", nome: "CASTREZZATO", provincia: "BS" },
  { code: "416075017", nome: "CASTRI DI LECCE", provincia: "LE" },
  { code: "416075018", nome: "CASTRIGNANO DE\' GRECI", provincia: "LE" },
  { code: "416075019", nome: "CASTRIGNANO DEL CAPO", provincia: "LE" },
  { code: "412060023", nome: "CASTRO DEI VOLSCI", provincia: "FR" },
  { code: "403016065", nome: "CASTRO", provincia: "BG" },
  { code: "416075096", nome: "CASTRO", provincia: "LE" },
  { code: "408140005", nome: "CASTROCARO TERME E TERRA DEL SOLE", provincia: "FC" },
  { code: "412060022", nome: "CASTROCIELO", provincia: "FR" },
  { code: "419084013", nome: "CASTROFILIPPO", provincia: "AG" },
  { code: "418078031", nome: "CASTROLIBERO", provincia: "CS" },
  { code: "403012047", nome: "CASTRONNO", provincia: "VA" },
  { code: "419082025", nome: "CASTRONOVO DI SICILIA", provincia: "PA" },
  { code: "417076026", nome: "CASTRONUOVO DI SANT\'ANDREA", provincia: "PZ" },
  { code: "414070016", nome: "CASTROPIGNANO", provincia: "CB" },
  { code: "419083016", nome: "CASTROREALE", provincia: "ME" },
  { code: "418078032", nome: "CASTROREGIO", provincia: "CS" },
  { code: "418078033", nome: "CASTROVILLARI", provincia: "CS" },
  { code: "419087015", nome: "CATANIA", provincia: "CT" },
  { code: "418079023", nome: "CATANZARO", provincia: "CZ" },
  { code: "419086006", nome: "CATENANUOVA", provincia: "EN" },
  { code: "413068010", nome: "CATIGNANO", provincia: "PE" },
  { code: "419084014", nome: "CATTOLICA ERACLEA", provincia: "AG" },
  { code: "408099002", nome: "CATTOLICA", provincia: "RN" },
  { code: "418080025", nome: "CAULONIA", provincia: "RC" },
  { code: "415062021", nome: "CAUTANO", provincia: "BN" },
  { code: "415065037", nome: "CAVA DE\' TIRRENI", provincia: "SA" },
  { code: "403018041", nome: "CAVA MANARA", provincia: "PV" },
  { code: "401096016", nome: "CAVAGLIA\'", provincia: "BI" },
  { code: "401003044", nome: "CAVAGLIETTO", provincia: "NO" },
  { code: "401003045", nome: "CAVAGLIO D\'AGOGNA", provincia: "NO" },
  { code: "401001069", nome: "CAVAGNOLO", provincia: "TO" },
  { code: "405023023", nome: "CAVAION VERONESE", provincia: "VR" },
  { code: "404022050", nome: "CAVALESE", provincia: "TN" },
  { code: "401004058", nome: "CAVALLERLEONE", provincia: "CN" },
  { code: "401004059", nome: "CAVALLERMAGGIORE", provincia: "CN" },
  { code: "416075020", nome: "CAVALLINO", provincia: "LE" },
  { code: "405027044", nome: "CAVALLINO-TREPORTI", provincia: "VE" },
  { code: "401003047", nome: "CAVALLIRIO", provincia: "NO" },
  { code: "404022051", nome: "CAVARENO", provincia: "TN" },
  { code: "403013062", nome: "CAVARGNA", provincia: "CO" },
  { code: "403012048", nome: "CAVARIA CON PREMEZZO", provincia: "VA" },
  { code: "405027006", nome: "CAVARZERE", provincia: "VE" },
  { code: "405026014", nome: "CAVASO DEL TOMBA", provincia: "TV" },
  { code: "406093012", nome: "CAVASSO NUOVO", provincia: "PN" },
  { code: "401006055", nome: "CAVATORE", provincia: "AL" },
  { code: "406030021", nome: "CAVAZZO CARNICO", provincia: "UD" },
  { code: "412058026", nome: "CAVE", provincia: "RM" },
  { code: "404022052", nome: "CAVEDAGO", provincia: "TN" },
  { code: "404022053", nome: "CAVEDINE", provincia: "TN" },
  { code: "403098017", nome: "CAVENAGO D\'ADDA", provincia: "LO" },
  { code: "403108017", nome: "CAVENAGO DI BRIANZA", provincia: "MB" },
  { code: "403016066", nome: "CAVERNAGO", provincia: "BG" },
  { code: "408036009", nome: "CAVEZZO", provincia: "MO" },
  { code: "404022054", nome: "CAVIZZANA", provincia: "TN" },
  { code: "401001070", nome: "CAVOUR", provincia: "TO" },
  { code: "408035017", nome: "CAVRIAGO", provincia: "RE" },
  { code: "403020018", nome: "CAVRIANA", provincia: "MN" },
  { code: "409051013", nome: "CAVRIGLIA", provincia: "AR" },
  { code: "403012049", nome: "CAZZAGO BRABBIA", provincia: "VA" },
  { code: "403017046", nome: "CAZZAGO SAN MARTINO", provincia: "BS" },
  { code: "405023024", nome: "CAZZANO DI TRAMIGNA", provincia: "VR" },
  { code: "403016067", nome: "CAZZANO SANT\'ANDREA", provincia: "BG" },
  { code: "412060024", nome: "CECCANO", provincia: "FR" },
  { code: "403018042", nome: "CECIMA", provincia: "PV" },
  { code: "409049007", nome: "CECINA", provincia: "LI" },
  { code: "403017047", nome: "CEDEGOLO", provincia: "BS" },
  { code: "403014016", nome: "CEDRASCO", provincia: "SO" },
  { code: "419082026", nome: "CEFALA\' DIANA", provincia: "PA" },
  { code: "419082027", nome: "CEFALU\'", provincia: "PA" },
  { code: "405027007", nome: "CEGGIA", provincia: "VE" },
  { code: "416074003", nome: "CEGLIE MESSAPICA", provincia: "BR" },
  { code: "413066032", nome: "CELANO", provincia: "AQ" },
  { code: "413069021", nome: "CELENZA SUL TRIGNO", provincia: "CH" },
  { code: "416071018", nome: "CELENZA VALFORTORE", provincia: "FG" },
  { code: "418078034", nome: "CELICO", provincia: "CS" },
  { code: "403019028", nome: "CELLA DATI", provincia: "CR" },
  { code: "401006056", nome: "CELLA MONTE", provincia: "AL" },
  { code: "416072018", nome: "CELLAMARE", provincia: "BA" },
  { code: "418078035", nome: "CELLARA", provincia: "CS" },
  { code: "401005033", nome: "CELLARENGO", provincia: "AT" },
  { code: "403017048", nome: "CELLATICA", provincia: "BS" },
  { code: "415065038", nome: "CELLE DI BULGHERIA", provincia: "SA" },
  { code: "401004060", nome: "CELLE DI MACRA", provincia: "CN" },
  { code: "416071019", nome: "CELLE DI SAN VITO", provincia: "FG" },
  { code: "401005034", nome: "CELLE ENOMONDO", provincia: "AT" },
  { code: "407009022", nome: "CELLE LIGURE", provincia: "SV" },
  { code: "412056019", nome: "CELLENO", provincia: "VT" },
  { code: "412056020", nome: "CELLERE", provincia: "VT" },
  { code: "413067015", nome: "CELLINO ATTANASIO", provincia: "TE" },
  { code: "416074004", nome: "CELLINO SAN MARCO", provincia: "BR" },
  { code: "401002171", nome: "CELLIO CON BREIA", provincia: "VC" },
  { code: "415061102", nome: "CELLOLE", provincia: "CE" },
  { code: "404022241", nome: "CEMBRA LISIGNAGO", provincia: "TN" },
  { code: "418079024", nome: "CENADI", provincia: "CZ" },
  { code: "403016068", nome: "CENATE SOPRA", provincia: "BG" },
  { code: "403016069", nome: "CENATE SOTTO", provincia: "BG" },
  { code: "405025010", nome: "CENCENIGHE AGORDINO", provincia: "BL" },
  { code: "403016070", nome: "CENE", provincia: "BG" },
  { code: "405029014", nome: "CENESELLI", provincia: "RO" },
  { code: "407009023", nome: "CENGIO", provincia: "SV" },
  { code: "401004061", nome: "CENTALLO", provincia: "CN" },
  { code: "408038004", nome: "CENTO", provincia: "FE" },
  { code: "415065039", nome: "CENTOLA", provincia: "SA" },
  { code: "418079025", nome: "CENTRACHE", provincia: "CZ" },
  { code: "403013254", nome: "CENTRO VALLE INTELVI", provincia: "CO" },
  { code: "419086007", nome: "CENTURIPE", provincia: "EN" },
  { code: "413068011", nome: "CEPAGATTI", provincia: "PE" },
  { code: "415062022", nome: "CEPPALONI", provincia: "BN" },
  { code: "401103021", nome: "CEPPO MORELLI", provincia: "VB" },
  { code: "412060025", nome: "CEPRANO", provincia: "FR" },
  { code: "419086008", nome: "CERAMI", provincia: "EN" },
  { code: "407010014", nome: "CERANESI", provincia: "GE" },
  { code: "403013063", nome: "CERANO D\'INTELVI", provincia: "CO" },
  { code: "401003049", nome: "CERANO", provincia: "NO" },
  { code: "403018043", nome: "CERANOVA", provincia: "PV" },
  { code: "415065040", nome: "CERASO", provincia: "SA" },
  { code: "414070017", nome: "CERCEMAGGIORE", provincia: "CB" },
  { code: "401001071", nome: "CERCENASCO", provincia: "TO" },
  { code: "414070018", nome: "CERCEPICCOLA", provincia: "CB" },
  { code: "418078036", nome: "CERCHIARA DI CALABRIA", provincia: "CS" },
  { code: "413066033", nome: "CERCHIO", provincia: "AQ" },
  { code: "403014017", nome: "CERCINO", provincia: "SO" },
  { code: "406030022", nome: "CERCIVENTO", provincia: "UD" },
  { code: "415063026", nome: "CERCOLA", provincia: "NA" },
  { code: "419082028", nome: "CERDA", provincia: "PA" },
  { code: "405023025", nome: "CEREA", provincia: "VR" },
  { code: "405029015", nome: "CEREGNANO", provincia: "RO" },
  { code: "418101006", nome: "CERENZIA", provincia: "KR" },
  { code: "401001072", nome: "CERES", provincia: "TO" },
  { code: "403020019", nome: "CERESARA", provincia: "MN" },
  { code: "401006057", nome: "CERESETO", provincia: "AL" },
  { code: "401004062", nome: "CERESOLE ALBA", provincia: "CN" },
  { code: "401001073", nome: "CERESOLE REALE", provincia: "TO" },
  { code: "403016071", nome: "CERETE", provincia: "BG" },
  { code: "403018044", nome: "CERETTO LOMELLINA", provincia: "PV" },
  { code: "403018045", nome: "CERGNAGO", provincia: "PV" },
  { code: "407009024", nome: "CERIALE", provincia: "SV" },
  { code: "407008016", nome: "CERIANA", provincia: "IM" },
  { code: "403108018", nome: "CERIANO LAGHETTO", provincia: "MB" },
  { code: "408033015", nome: "CERIGNALE", provincia: "PC" },
  { code: "416071020", nome: "CERIGNOLA", provincia: "FG" },
  { code: "418078037", nome: "CERISANO", provincia: "CS" },
  { code: "403013064", nome: "CERMENATE", provincia: "CO" },
  { code: "404021020", nome: "CERMES", provincia: "BZ" },
  { code: "413067016", nome: "CERMIGNANO", provincia: "TE" },
  { code: "403013065", nome: "CERNOBBIO", provincia: "CO" },
  { code: "403097020", nome: "CERNUSCO LOMBARDONE", provincia: "LC" },
  { code: "403015070", nome: "CERNUSCO SUL NAVIGLIO", provincia: "MI" },
  { code: "401005035", nome: "CERRETO D\'ASTI", provincia: "AT" },
  { code: "411042013", nome: "CERRETO D\'ESI", provincia: "AN" },
  { code: "410054010", nome: "CERRETO DI SPOLETO", provincia: "PG" },
  { code: "401006058", nome: "CERRETO GRUE", provincia: "AL" },
  { code: "409048011", nome: "CERRETO GUIDI", provincia: "FI" },
  { code: "412058027", nome: "CERRETO LAZIALE", provincia: "RM" },
  { code: "415062023", nome: "CERRETO SANNITA", provincia: "BN" },
  { code: "401004063", nome: "CERRETTO LANGHE", provincia: "CN" },
  { code: "401006059", nome: "CERRINA MONFERRATO", provincia: "AL" },
  { code: "401096018", nome: "CERRIONE", provincia: "BI" },
  { code: "403015071", nome: "CERRO AL LAMBRO", provincia: "MI" },
  { code: "414094014", nome: "CERRO AL VOLTURNO", provincia: "IS" },
  { code: "403015072", nome: "CERRO MAGGIORE", provincia: "MI" },
  { code: "401005036", nome: "CERRO TANARO", provincia: "AT" },
  { code: "405023026", nome: "CERRO VERONESE", provincia: "VR" },
  { code: "417076027", nome: "CERSOSIMO", provincia: "PZ" },
  { code: "409048012", nome: "CERTALDO", provincia: "FI" },
  { code: "403018046", nome: "CERTOSA DI PAVIA", provincia: "PV" },
  { code: "418079027", nome: "CERVA", provincia: "CZ" },
  { code: "412058028", nome: "CERVARA DI ROMA", provincia: "RM" },
  { code: "405028030", nome: "CERVARESE SANTA CROCE", provincia: "PD" },
  { code: "412060026", nome: "CERVARO", provincia: "FR" },
  { code: "401004064", nome: "CERVASCA", provincia: "CN" },
  { code: "401002041", nome: "CERVATTO", provincia: "VC" },
  { code: "403017049", nome: "CERVENO", provincia: "BS" },
  { code: "401004065", nome: "CERVERE", provincia: "CN" },
  { code: "403018047", nome: "CERVESINA", provincia: "PV" },
  { code: "412058029", nome: "CERVETERI", provincia: "RM" },
  { code: "408039007", nome: "CERVIA", provincia: "RA" },
  { code: "418078038", nome: "CERVICATI", provincia: "CS" },
  { code: "403098018", nome: "CERVIGNANO D\'ADDA", provincia: "LO" },
  { code: "406030023", nome: "CERVIGNANO DEL FRIULI", provincia: "UD" },
  { code: "415064025", nome: "CERVINARA", provincia: "AV" },
  { code: "415061028", nome: "CERVINO", provincia: "CE" },
  { code: "407008017", nome: "CERVO", provincia: "IM" },
  { code: "418078039", nome: "CERZETO", provincia: "CS" },
  { code: "415061029", nome: "CESA", provincia: "CE" },
  { code: "403097021", nome: "CESANA BRIANZA", provincia: "LC" },
  { code: "401001074", nome: "CESANA TORINESE", provincia: "TO" },
  { code: "403015074", nome: "CESANO BOSCONE", provincia: "MI" },
  { code: "403108019", nome: "CESANO MADERNO", provincia: "MB" },
  { code: "401103022", nome: "CESARA", provincia: "VB" },
  { code: "419083017", nome: "CESARO\'", provincia: "ME" },
  { code: "403015076", nome: "CESATE", provincia: "MI" },
  { code: "408140007", nome: "CESENA", provincia: "FC" },
  { code: "408140008", nome: "CESENATICO", provincia: "FC" },
  { code: "415064026", nome: "CESINALI", provincia: "AV" },
  { code: "407008018", nome: "CESIO", provincia: "IM" },
  { code: "405025011", nome: "CESIOMAGGIORE", provincia: "BL" },
  { code: "405026015", nome: "CESSALTO", provincia: "TV" },
  { code: "418102006", nome: "CESSANITI", provincia: "VV" },
  { code: "411043011", nome: "CESSAPALOMBO", provincia: "MC" },
  { code: "401005037", nome: "CESSOLE", provincia: "AT" },
  { code: "415065041", nome: "CETARA", provincia: "SA" },
  { code: "403017050", nome: "CETO", provincia: "BS" },
  { code: "409052008", nome: "CETONA", provincia: "SI" },
  { code: "418078040", nome: "CETRARO", provincia: "CS" },
  { code: "401004066", nome: "CEVA", provincia: "CN" },
  { code: "403017051", nome: "CEVO", provincia: "BS" },
  { code: "402007013", nome: "CHALLAND-SAINT-ANSELME", provincia: "AO" },
  { code: "402007014", nome: "CHALLAND-SAINT-VICTOR", provincia: "AO" },
  { code: "402007015", nome: "CHAMBAVE", provincia: "AO" },
  { code: "402007016", nome: "CHAMOIS", provincia: "AO" },
  { code: "402007017", nome: "CHAMPDEPRAZ", provincia: "AO" },
  { code: "402007018", nome: "CHAMPORCHER", provincia: "AO" },
  { code: "402007019", nome: "CHARVENSOD", provincia: "AO" },
  { code: "402007020", nome: "CHATILLON", provincia: "AO" },
  { code: "401004067", nome: "CHERASCO", provincia: "CN" },
  { code: "420090024", nome: "CHEREMULE", provincia: "SS" },
  { code: "401001075", nome: "CHIALAMBERTO", provincia: "TO" },
  { code: "405024029", nome: "CHIAMPO", provincia: "VI" },
  { code: "415064027", nome: "CHIANCHE", provincia: "AV" },
  { code: "409052009", nome: "CHIANCIANO TERME", provincia: "SI" },
  { code: "409050012", nome: "CHIANNI", provincia: "PI" },
  { code: "401001076", nome: "CHIANOCCO", provincia: "TO" },
  { code: "419088002", nome: "CHIARAMONTE GULFI", provincia: "RG" },
  { code: "420090025", nome: "CHIARAMONTI", provincia: "SS" },
  { code: "405026016", nome: "CHIARANO", provincia: "TV" },
  { code: "418079029", nome: "CHIARAVALLE CENTRALE", provincia: "CZ" },
  { code: "411042014", nome: "CHIARAVALLE", provincia: "AN" },
  { code: "403017052", nome: "CHIARI", provincia: "BS" },
  { code: "417076028", nome: "CHIAROMONTE", provincia: "PZ" },
  { code: "414094015", nome: "CHIAUCI", provincia: "IS" },
  { code: "407010015", nome: "CHIAVARI", provincia: "GE" },
  { code: "403014018", nome: "CHIAVENNA", provincia: "SO" },
  { code: "401001077", nome: "CHIAVERANO", provincia: "TO" },
  { code: "404021021", nome: "CHIENES", provincia: "BZ" },
  { code: "401001078", nome: "CHIERI", provincia: "TO" },
  { code: "405025012", nome: "CHIES D\'ALPAGO", provincia: "BL" },
  { code: "403014019", nome: "CHIESA IN VALMALENCO", provincia: "SO" },
  { code: "401001079", nome: "CHIESANUOVA", provincia: "TO" },
  { code: "409047022", nome: "CHIESINA UZZANESE", provincia: "PT" },
  { code: "413069022", nome: "CHIETI", provincia: "CH" },
  { code: "416071021", nome: "CHIEUTI", provincia: "FG" },
  { code: "403019029", nome: "CHIEVE", provincia: "CR" },
  { code: "403016072", nome: "CHIGNOLO D\'ISOLA", provincia: "BG" },
  { code: "403018048", nome: "CHIGNOLO PO", provincia: "PV" },
  { code: "405027008", nome: "CHIOGGIA", provincia: "VE" },
  { code: "401001080", nome: "CHIOMONTE", provincia: "TO" },
  { code: "406093013", nome: "CHIONS", provincia: "PN" },
  { code: "406030024", nome: "CHIOPRIS VISCONE", provincia: "UD" },
  { code: "409051014", nome: "CHITIGNANO", provincia: "AR" },
  { code: "403016073", nome: "CHIUDUNO", provincia: "BG" },
  { code: "405024030", nome: "CHIUPPANO", provincia: "VI" },
  { code: "403014020", nome: "CHIURO", provincia: "SO" },
  { code: "401004068", nome: "CHIUSA DI PESIO", provincia: "CN" },
  { code: "401001081", nome: "CHIUSA DI SAN MICHELE", provincia: "TO" },
  { code: "419082029", nome: "CHIUSA SCLAFANI", provincia: "PA" },
  { code: "404021022", nome: "CHIUSA", provincia: "BZ" },
  { code: "406030025", nome: "CHIUSAFORTE", provincia: "UD" },
  { code: "407008019", nome: "CHIUSANICO", provincia: "IM" },
  { code: "401005038", nome: "CHIUSANO D\'ASTI", provincia: "AT" },
  { code: "415064028", nome: "CHIUSANO DI SAN DOMENICO", provincia: "AV" },
  { code: "407008020", nome: "CHIUSAVECCHIA", provincia: "IM" },
  { code: "409052010", nome: "CHIUSDINO", provincia: "SI" },
  { code: "409051015", nome: "CHIUSI DELLA VERNA", provincia: "AR" },
  { code: "409052011", nome: "CHIUSI", provincia: "SI" },
  { code: "401001082", nome: "CHIVASSO", provincia: "TO" },
  { code: "412058118", nome: "CIAMPINO", provincia: "RM" },
  { code: "419084015", nome: "CIANCIANA", provincia: "AG" },
  { code: "405025013", nome: "CIBIANA DI CADORE", provincia: "BL" },
  { code: "407010016", nome: "CICAGNA", provincia: "GE" },
  { code: "418079030", nome: "CICALA", provincia: "CZ" },
  { code: "415063027", nome: "CICCIANO", provincia: "NA" },
  { code: "415065042", nome: "CICERALE", provincia: "SA" },
  { code: "412058030", nome: "CICILIANO", provincia: "RM" },
  { code: "403019030", nome: "CICOGNOLO", provincia: "CR" },
  { code: "401001083", nome: "CICONIO", provincia: "TO" },
  { code: "401002042", nome: "CIGLIANO", provincia: "VC" },
  { code: "401004069", nome: "CIGLIE\'", provincia: "CN" },
  { code: "403018049", nome: "CIGOGNOLA", provincia: "PV" },
  { code: "403017053", nome: "CIGOLE", provincia: "BS" },
  { code: "403018050", nome: "CILAVEGNA", provincia: "PV" },
  { code: "405026017", nome: "CIMADOLMO", provincia: "TV" },
  { code: "403017054", nome: "CIMBERGO", provincia: "BS" },
  { code: "418080026", nome: "CIMINA\'", provincia: "RC" },
  { code: "419082030", nome: "CIMINNA", provincia: "PA" },
  { code: "415063028", nome: "CIMITILE", provincia: "NA" },
  { code: "406093014", nome: "CIMOLAIS", provincia: "PN" },
  { code: "404022058", nome: "CIMONE", provincia: "TN" },
  { code: "401005039", nome: "CINAGLIO", provincia: "AT" },
  { code: "412058031", nome: "CINETO ROMANO", provincia: "RM" },
  { code: "403019031", nome: "CINGIA DE\' BOTTI", provincia: "CR" },
  { code: "411043012", nome: "CINGOLI", provincia: "MC" },
  { code: "409053007", nome: "CINIGIANO", provincia: "GR" },
  { code: "403015077", nome: "CINISELLO BALSAMO", provincia: "MI" },
  { code: "419082031", nome: "CINISI", provincia: "PA" },
  { code: "403014021", nome: "CINO", provincia: "SO" },
  { code: "418080027", nome: "CINQUEFRONDI", provincia: "RC" },
  { code: "401001084", nome: "CINTANO", provincia: "TO" },
  { code: "404022059", nome: "CINTE TESINO", provincia: "TN" },
  { code: "405027009", nome: "CINTO CAOMAGGIORE", provincia: "VE" },
  { code: "405028031", nome: "CINTO EUGANEO", provincia: "PD" },
  { code: "401001085", nome: "CINZANO", provincia: "TO" },
  { code: "415061030", nome: "CIORLANO", provincia: "CE" },
  { code: "407008021", nome: "CIPRESSA", provincia: "IM" },
  { code: "415062024", nome: "CIRCELLO", provincia: "BN" },
  { code: "401001086", nome: "CIRIE\'", provincia: "TO" },
  { code: "417077005", nome: "CIRIGLIANO", provincia: "MT" },
  { code: "403013068", nome: "CIRIMIDO", provincia: "CO" },
  { code: "418101008", nome: "CIRO\' MARINA", provincia: "KR" },
  { code: "418101007", nome: "CIRO\'", provincia: "KR" },
  { code: "404022060", nome: "CIS", provincia: "TN" },
  { code: "403016074", nome: "CISANO BERGAMASCO", provincia: "BG" },
  { code: "407009025", nome: "CISANO SUL NEVA", provincia: "SV" },
  { code: "403016075", nome: "CISERANO", provincia: "BG" },
  { code: "403012050", nome: "CISLAGO", provincia: "VA" },
  { code: "403015078", nome: "CISLIANO", provincia: "MI" },
  { code: "405026018", nome: "CISON DI VALMARINO", provincia: "TV" },
  { code: "401004070", nome: "CISSONE", provincia: "CN" },
  { code: "401005040", nome: "CISTERNA D\'ASTI", provincia: "AT" },
  { code: "412059005", nome: "CISTERNA DI LATINA", provincia: "LT" },
  { code: "416074005", nome: "CISTERNINO", provincia: "BR" },
  { code: "410054011", nome: "CITERNA", provincia: "PG" },
  { code: "410054012", nome: "CITTA\' DELLA PIEVE", provincia: "PG" },
  { code: "410054013", nome: "CITTA\' DI CASTELLO", provincia: "PG" },
  { code: "413068012", nome: "CITTA\' SANT\'ANGELO", provincia: "PE" },
  { code: "405028032", nome: "CITTADELLA", provincia: "PD" },
  { code: "412057016", nome: "CITTADUCALE", provincia: "RI" },
  { code: "418080028", nome: "CITTANOVA", provincia: "RC" },
  { code: "412057017", nome: "CITTAREALE", provincia: "RI" },
  { code: "403012051", nome: "CITTIGLIO", provincia: "VA" },
  { code: "403097022", nome: "CIVATE", provincia: "LC" },
  { code: "407008022", nome: "CIVEZZA", provincia: "IM" },
  { code: "404022061", nome: "CIVEZZANO", provincia: "TN" },
  { code: "401002043", nome: "CIVIASCO", provincia: "VC" },
  { code: "406030026", nome: "CIVIDALE DEL FRIULI", provincia: "UD" },
  { code: "403016076", nome: "CIVIDATE AL PIANO", provincia: "BG" },
  { code: "403017055", nome: "CIVIDATE CAMUNO", provincia: "BS" },
  { code: "412056021", nome: "CIVITA CASTELLANA", provincia: "VT" },
  { code: "413066034", nome: "CIVITA D\'ANTINO", provincia: "AQ" },
  { code: "418078041", nome: "CIVITA", provincia: "CS" },
  { code: "414070019", nome: "CIVITACAMPOMARANO", provincia: "CB" },
  { code: "413069023", nome: "CIVITALUPARELLA", provincia: "CH" },
  { code: "414094016", nome: "CIVITANOVA DEL SANNIO", provincia: "IS" },
  { code: "411043013", nome: "CIVITANOVA MARCHE", provincia: "MC" },
  { code: "413068013", nome: "CIVITAQUANA", provincia: "PE" },
  { code: "412058032", nome: "CIVITAVECCHIA", provincia: "RM" },
  { code: "413066035", nome: "CIVITELLA ALFEDENA", provincia: "AQ" },
  { code: "413068014", nome: "CIVITELLA CASANOVA", provincia: "PE" },
  { code: "412056022", nome: "CIVITELLA D\'AGLIANO", provincia: "VT" },
  { code: "413067017", nome: "CIVITELLA DEL TRONTO", provincia: "TE" },
  { code: "408140009", nome: "CIVITELLA DI ROMAGNA", provincia: "FC" },
  { code: "409051016", nome: "CIVITELLA IN VAL DI CHIANA", provincia: "AR" },
  { code: "413069024", nome: "CIVITELLA MESSER RAIMONDO", provincia: "CH" },
  { code: "409053008", nome: "CIVITELLA PAGANICO", provincia: "GR" },
  { code: "413066036", nome: "CIVITELLA ROVETO", provincia: "AQ" },
  { code: "412058033", nome: "CIVITELLA SAN PAOLO", provincia: "RM" },
  { code: "403014022", nome: "CIVO", provincia: "SO" },
  { code: "403013071", nome: "CLAINO CON OSTENO", provincia: "CO" },
  { code: "406093015", nome: "CLAUT", provincia: "PN" },
  { code: "406093016", nome: "CLAUZETTO", provincia: "PN" },
  { code: "401004071", nome: "CLAVESANA", provincia: "CN" },
  { code: "401001087", nome: "CLAVIERE", provincia: "TO" },
  { code: "404022062", nome: "CLES", provincia: "TN" },
  { code: "418078042", nome: "CLETO", provincia: "CS" },
  { code: "403012052", nome: "CLIVIO", provincia: "VA" },
  { code: "403016077", nome: "CLUSONE", provincia: "BG" },
  { code: "401001088", nome: "COASSOLO TORINESE", provincia: "TO" },
  { code: "401001089", nome: "COAZZE", provincia: "TO" },
  { code: "401005041", nome: "COAZZOLO", provincia: "AT" },
  { code: "403017056", nome: "COCCAGLIO", provincia: "BS" },
  { code: "401005042", nome: "COCCONATO", provincia: "AT" },
  { code: "403012053", nome: "COCQUIO-TREVISAGO", provincia: "VA" },
  { code: "413066037", nome: "COCULLO", provincia: "AQ" },
  { code: "405028033", nome: "CODEVIGO", provincia: "PD" },
  { code: "403018051", nome: "CODEVILLA", provincia: "PV" },
  { code: "408038005", nome: "CODIGORO", provincia: "FE" },
  { code: "405026019", nome: "CODOGNE\'", provincia: "TV" },
  { code: "403098019", nome: "CODOGNO", provincia: "LO" },
  { code: "406030027", nome: "CODROIPO", provincia: "UD" },
  { code: "420090026", nome: "CODRONGIANOS", provincia: "SS" },
  { code: "401096019", nome: "COGGIOLA", provincia: "BI" },
  { code: "403108020", nome: "COGLIATE", provincia: "MB" },
  { code: "402007021", nome: "COGNE", provincia: "AO" },
  { code: "407010017", nome: "COGOLETO", provincia: "GE" },
  { code: "405024032", nome: "COGOLLO DEL CENGIO", provincia: "VI" },
  { code: "407010018", nome: "COGORNO", provincia: "GE" },
  { code: "401003051", nome: "COLAZZA", provincia: "NO" },
  { code: "405024126", nome: "COLCERESA", provincia: "VI" },
  { code: "403016078", nome: "COLERE", provincia: "BG" },
  { code: "412060027", nome: "COLFELICE", provincia: "FR" },
  { code: "408033016", nome: "COLI", provincia: "PC" },
  { code: "403097023", nome: "COLICO", provincia: "LC" },
  { code: "412057018", nome: "COLLALTO SABINO", provincia: "RI" },
  { code: "413066038", nome: "COLLARMELE", provincia: "AQ" },
  { code: "410054014", nome: "COLLAZZONE", provincia: "PG" },
  { code: "403097024", nome: "COLLE BRIANZA", provincia: "LC" },
  { code: "414070020", nome: "COLLE D\'ANCHISE", provincia: "CB" },
  { code: "412057019", nome: "COLLE DI TORA", provincia: "RI" },
  { code: "409052012", nome: "COLLE DI VAL D\'ELSA", provincia: "SI" },
  { code: "412060029", nome: "COLLE SAN MAGNO", provincia: "FR" },
  { code: "415062025", nome: "COLLE SANNITA", provincia: "BN" },
  { code: "405025014", nome: "COLLE SANTA LUCIA", provincia: "BL" },
  { code: "405026020", nome: "COLLE UMBERTO", provincia: "TV" },
  { code: "403017057", nome: "COLLEBEATO", provincia: "BS" },
  { code: "408034009", nome: "COLLECCHIO", provincia: "PR" },
  { code: "413068015", nome: "COLLECORVINO", provincia: "PE" },
  { code: "413067018", nome: "COLLEDARA", provincia: "TE" },
  { code: "413069025", nome: "COLLEDIMACINE", provincia: "CH" },
  { code: "413069026", nome: "COLLEDIMEZZO", provincia: "CH" },
  { code: "412058034", nome: "COLLEFERRO", provincia: "RM" },
  { code: "412057020", nome: "COLLEGIOVE", provincia: "RI" },
  { code: "401001090", nome: "COLLEGNO", provincia: "TO" },
  { code: "413066039", nome: "COLLELONGO", provincia: "AQ" },
  { code: "412060028", nome: "COLLEPARDO", provincia: "FR" },
  { code: "416075021", nome: "COLLEPASSO", provincia: "LE" },
  { code: "413066040", nome: "COLLEPIETRO", provincia: "AQ" },
  { code: "401001091", nome: "COLLERETTO CASTELNUOVO", provincia: "TO" },
  { code: "401001092", nome: "COLLERETTO GIACOSA", provincia: "TO" },
  { code: "409049008", nome: "COLLESALVETTI", provincia: "LI" },
  { code: "419082032", nome: "COLLESANO", provincia: "PA" },
  { code: "414070021", nome: "COLLETORTO", provincia: "CB" },
  { code: "412057021", nome: "COLLEVECCHIO", provincia: "RI" },
  { code: "414094017", nome: "COLLI A VOLTURNO", provincia: "IS" },
  { code: "411141069", nome: "COLLI AL METAURO", provincia: "PU" },
  { code: "411044014", nome: "COLLI DEL TRONTO", provincia: "AP" },
  { code: "412057022", nome: "COLLI SUL VELINO", provincia: "RI" },
  { code: "403018193", nome: "COLLI VERDI", provincia: "PV" },
  { code: "415065043", nome: "COLLIANO", provincia: "SA" },
  { code: "420092014", nome: "COLLINAS", provincia: "CA" },
  { code: "403017058", nome: "COLLIO", provincia: "BS" },
  { code: "401002045", nome: "COLLOBIANO", provincia: "VC" },
  { code: "406030028", nome: "COLLOREDO DI MONTE ALBANO", provincia: "UD" },
  { code: "411043014", nome: "COLMURANO", provincia: "MC" },
  { code: "417077006", nome: "COLOBRARO", provincia: "MT" },
  { code: "405023027", nome: "COLOGNA VENETA", provincia: "VR" },
  { code: "403017059", nome: "COLOGNE", provincia: "BS" },
  { code: "403016079", nome: "COLOGNO AL SERIO", provincia: "BG" },
  { code: "403015081", nome: "COLOGNO MONZESE", provincia: "MI" },
  { code: "405023028", nome: "COLOGNOLA AI COLLI", provincia: "VR" },
  { code: "412058035", nome: "COLONNA", provincia: "RM" },
  { code: "413067019", nome: "COLONNELLA", provincia: "TE" },
  { code: "403013074", nome: "COLONNO", provincia: "CO" },
  { code: "403014023", nome: "COLORINA", provincia: "SO" },
  { code: "408034010", nome: "COLORNO", provincia: "PR" },
  { code: "418078043", nome: "COLOSIMI", provincia: "CS" },
  { code: "403015082", nome: "COLTURANO", provincia: "MI" },
  { code: "403013251", nome: "COLVERDE", provincia: "CO" },
  { code: "403016080", nome: "COLZATE", provincia: "BG" },
  { code: "403012054", nome: "COMABBIO", provincia: "VA" },
  { code: "408038006", nome: "COMACCHIO", provincia: "FE" },
  { code: "404022228", nome: "COMANO TERME", provincia: "TN" },
  { code: "409045005", nome: "COMANO", provincia: "MS" },
  { code: "403098020", nome: "COMAZZO", provincia: "LO" },
  { code: "406030029", nome: "COMEGLIANS", provincia: "UD" },
  { code: "405025015", nome: "COMELICO SUPERIORE", provincia: "BL" },
  { code: "403012055", nome: "COMERIO", provincia: "VA" },
  { code: "403017060", nome: "COMEZZANO-CIZZAGO", provincia: "BS" },
  { code: "401003052", nome: "COMIGNAGO", provincia: "NO" },
  { code: "419088003", nome: "COMISO", provincia: "RG" },
  { code: "419084016", nome: "COMITINI", provincia: "AG" },
  { code: "415063029", nome: "COMIZIANO", provincia: "NA" },
  { code: "403020020", nome: "COMMESSAGGIO", provincia: "MN" },
  { code: "404022064", nome: "COMMEZZADURA", provincia: "TN" },
  { code: "403013075", nome: "COMO", provincia: "CO" },
  { code: "408034011", nome: "COMPIANO", provincia: "PR" },
  { code: "403016081", nome: "COMUN NUOVO", provincia: "BG" },
  { code: "411044015", nome: "COMUNANZA", provincia: "AP" },
  { code: "405027010", nome: "CONA", provincia: "VE" },
  { code: "414094018", nome: "CONCA CASALE", provincia: "IS" },
  { code: "415065044", nome: "CONCA DEI MARINI", provincia: "SA" },
  { code: "415061031", nome: "CONCA DELLA CAMPANIA", provincia: "CE" },
  { code: "405023029", nome: "CONCAMARISE", provincia: "VR" },
  { code: "412057023", nome: "CONCERVIANO", provincia: "RI" },
  { code: "403017061", nome: "CONCESIO", provincia: "BS" },
  { code: "405027011", nome: "CONCORDIA SAGITTARIA", provincia: "VE" },
  { code: "408036010", nome: "CONCORDIA SULLA SECCHIA", provincia: "MO" },
  { code: "403108021", nome: "CONCOREZZO", provincia: "MB" },
  { code: "418080029", nome: "CONDOFURI", provincia: "RC" },
  { code: "401001093", nome: "CONDOVE", provincia: "TO" },
  { code: "419083018", nome: "CONDRO\'", provincia: "ME" },
  { code: "405026021", nome: "CONEGLIANO", provincia: "TV" },
  { code: "403018052", nome: "CONFIENZA", provincia: "PV" },
  { code: "412057024", nome: "CONFIGNI", provincia: "RI" },
  { code: "418079033", nome: "CONFLENTI", provincia: "CZ" },
  { code: "401006060", nome: "CONIOLO", provincia: "AL" },
  { code: "408039008", nome: "CONSELICE", provincia: "RA" },
  { code: "405028034", nome: "CONSELVE", provincia: "PD" },
  { code: "404022242", nome: "CONTA\'", provincia: "TN" },
  { code: "419082033", nome: "CONTESSA ENTELLINA", provincia: "PA" },
  { code: "412057025", nome: "CONTIGLIANO", provincia: "RI" },
  { code: "415064029", nome: "CONTRADA", provincia: "AV" },
  { code: "413067020", nome: "CONTROGUERRA", provincia: "TE" },
  { code: "415065045", nome: "CONTRONE", provincia: "SA" },
  { code: "415065046", nome: "CONTURSI", provincia: "SA" },
  { code: "416072019", nome: "CONVERSANO", provincia: "BA" },
  { code: "415064030", nome: "CONZA DELLA CAMPANIA", provincia: "AV" },
  { code: "401006061", nome: "CONZANO", provincia: "AL" },
  { code: "416075022", nome: "COPERTINO", provincia: "LE" },
  { code: "403018053", nome: "COPIANO", provincia: "PV" },
  { code: "408038007", nome: "COPPARO", provincia: "FE" },
  { code: "403018054", nome: "CORANA", provincia: "PV" },
  { code: "416072020", nome: "CORATO", provincia: "BA" },
  { code: "415065047", nome: "CORBARA", provincia: "SA" },
  { code: "403015085", nome: "CORBETTA", provincia: "MI" },
  { code: "405029017", nome: "CORBOLA", provincia: "RO" },
  { code: "412056023", nome: "CORCHIANO", provincia: "VT" },
  { code: "410054015", nome: "CORCIANO", provincia: "PG" },
  { code: "406093017", nome: "CORDENONS", provincia: "PN" },
  { code: "405026022", nome: "CORDIGNANO", provincia: "TV" },
  { code: "406093018", nome: "CORDOVADO", provincia: "PN" },
  { code: "409046011", nome: "COREGLIA ANTELMINELLI", provincia: "LU" },
  { code: "407010019", nome: "COREGLIA LIGURE", provincia: "GE" },
  { code: "412060030", nome: "CORENO AUSONIO", provincia: "FR" },
  { code: "413066041", nome: "CORFINIO", provincia: "AQ" },
  { code: "412059006", nome: "CORI", provincia: "LT" },
  { code: "408099003", nome: "CORIANO", provincia: "RN" },
  { code: "416075023", nome: "CORIGLIANO D\'OTRANTO", provincia: "LE" },
  { code: "418078157", nome: "CORIGLIANO-ROSSANO", provincia: "CS" },
  { code: "411042015", nome: "CORINALDO", provincia: "AN" },
  { code: "401001094", nome: "CORIO", provincia: "TO" },
  { code: "419082034", nome: "CORLEONE", provincia: "PA" },
  { code: "415065048", nome: "CORLETO MONFORTE", provincia: "SA" },
  { code: "417076029", nome: "CORLETO PERTICARA", provincia: "PZ" },
  { code: "403015086", nome: "CORMANO", provincia: "MI" },
  { code: "406031002", nome: "CORMONS", provincia: "GO" },
  { code: "403016082", nome: "CORNA IMAGNA", provincia: "BG" },
  { code: "403016249", nome: "CORNALBA", provincia: "BG" },
  { code: "403018191", nome: "CORNALE E BASTIDA", provincia: "PV" },
  { code: "403015087", nome: "CORNAREDO", provincia: "MI" },
  { code: "403108053", nome: "CORNATE D\'ADDA", provincia: "MB" },
  { code: "404021023", nome: "CORNEDO ALL\'ISARCO", provincia: "BZ" },
  { code: "405024034", nome: "CORNEDO VICENTINO", provincia: "VI" },
  { code: "403098021", nome: "CORNEGLIANO LAUDENSE", provincia: "LO" },
  { code: "401004072", nome: "CORNELIANO D\'ALBA", provincia: "CN" },
  { code: "408034012", nome: "CORNIGLIO", provincia: "PR" },
  { code: "406030030", nome: "CORNO DI ROSAZZO", provincia: "UD" },
  { code: "403098022", nome: "CORNO GIOVINE", provincia: "LO" },
  { code: "403098023", nome: "CORNOVECCHIO", provincia: "LO" },
  { code: "405026023", nome: "CORNUDA", provincia: "TV" },
  { code: "408035020", nome: "CORREGGIO", provincia: "RE" },
  { code: "403108022", nome: "CORREZZANA", provincia: "MB" },
  { code: "405028035", nome: "CORREZZOLA", provincia: "PD" },
  { code: "403013077", nome: "CORRIDO", provincia: "CO" },
  { code: "411043015", nome: "CORRIDONIA", provincia: "MC" },
  { code: "413067021", nome: "CORROPOLI", provincia: "TE" },
  { code: "416075024", nome: "CORSANO", provincia: "LE" },
  { code: "403015093", nome: "CORSICO", provincia: "MI" },
  { code: "401005044", nome: "CORSIONE", provincia: "AT" },
  { code: "404021024", nome: "CORTACCIA SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "418079034", nome: "CORTALE", provincia: "CZ" },
  { code: "401005045", nome: "CORTANDONE", provincia: "AT" },
  { code: "401005046", nome: "CORTANZE", provincia: "AT" },
  { code: "401005047", nome: "CORTAZZONE", provincia: "AT" },
  { code: "408033017", nome: "CORTE BRUGNATELLA", provincia: "PC" },
  { code: "403019032", nome: "CORTE DE\' CORTESI CON CIGNONE", provincia: "CR" },
  { code: "403019033", nome: "CORTE DE\' FRATI", provincia: "CR" },
  { code: "403017062", nome: "CORTE FRANCA", provincia: "BS" },
  { code: "403098024", nome: "CORTE PALASIO", provincia: "LO" },
  { code: "408033018", nome: "CORTEMAGGIORE", provincia: "PC" },
  { code: "401004073", nome: "CORTEMILIA", provincia: "CN" },
  { code: "403017063", nome: "CORTENO GOLGI", provincia: "BS" },
  { code: "403097025", nome: "CORTENOVA", provincia: "LC" },
  { code: "403016083", nome: "CORTENUOVA", provincia: "BG" },
  { code: "403018192", nome: "CORTEOLONA E GENZONE", provincia: "PV" },
  { code: "401005048", nome: "CORTIGLIONE", provincia: "AT" },
  { code: "405025016", nome: "CORTINA D\'AMPEZZO", provincia: "BL" },
  { code: "404021025", nome: "CORTINA SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "413067022", nome: "CORTINO", provincia: "TE" },
  { code: "409051017", nome: "CORTONA", provincia: "AR" },
  { code: "404021026", nome: "CORVARA IN BADIA", provincia: "BZ" },
  { code: "413068016", nome: "CORVARA", provincia: "PE" },
  { code: "403018057", nome: "CORVINO SAN QUIRICO", provincia: "PV" },
  { code: "403017064", nome: "CORZANO", provincia: "BS" },
  { code: "406030031", nome: "COSEANO", provincia: "UD" },
  { code: "418078045", nome: "COSENZA", provincia: "CS" },
  { code: "407008023", nome: "COSIO D\'ARROSCIA", provincia: "IM" },
  { code: "403014024", nome: "COSIO VALTELLINO", provincia: "SO" },
  { code: "418080030", nome: "COSOLETO", provincia: "RC" },
  { code: "401004074", nome: "COSSANO BELBO", provincia: "CN" },
  { code: "401001095", nome: "COSSANO CANAVESE", provincia: "TO" },
  { code: "401096020", nome: "COSSATO", provincia: "BI" },
  { code: "407009026", nome: "COSSERIA", provincia: "SV" },
  { code: "411044016", nome: "COSSIGNANO", provincia: "AP" },
  { code: "401103023", nome: "COSSOGNO", provincia: "VB" },
  { code: "420090027", nome: "COSSOINE", provincia: "SS" },
  { code: "401005049", nome: "COSSOMBRATO", provincia: "AT" },
  { code: "403018058", nome: "COSTA DE\' NOBILI", provincia: "PV" },
  { code: "403016084", nome: "COSTA DI MEZZATE", provincia: "BG" },
  { code: "405029018", nome: "COSTA DI ROVIGO", provincia: "RO" },
  { code: "403097026", nome: "COSTA MASNAGA", provincia: "LC" },
  { code: "403016247", nome: "COSTA SERINA", provincia: "BG" },
  { code: "403016085", nome: "COSTA VALLE IMAGNA", provincia: "BG" },
  { code: "401006062", nome: "COSTA VESCOVATO", provincia: "AL" },
  { code: "403016086", nome: "COSTA VOLPINO", provincia: "BG" },
  { code: "405024035", nome: "COSTABISSARA", provincia: "VI" },
  { code: "410054016", nome: "COSTACCIARO", provincia: "PG" },
  { code: "401002047", nome: "COSTANZANA", provincia: "VC" },
  { code: "407008024", nome: "COSTARAINERA", provincia: "IM" },
  { code: "405023930", nome: "COSTERMANO SUL GARDA", provincia: "VR" },
  { code: "401005050", nome: "COSTIGLIOLE D\'ASTI", provincia: "AT" },
  { code: "401004075", nome: "COSTIGLIOLE SALUZZO", provincia: "CN" },
  { code: "408039009", nome: "COTIGNOLA", provincia: "RA" },
  { code: "418101009", nome: "COTRONEI", provincia: "KR" },
  { code: "412057026", nome: "COTTANELLO", provincia: "RI" },
  { code: "402007022", nome: "COURMAYEUR", provincia: "AO" },
  { code: "403016087", nome: "COVO", provincia: "BG" },
  { code: "403018059", nome: "COZZO", provincia: "PV" },
  { code: "417077007", nome: "CRACO", provincia: "MT" },
  { code: "403097027", nome: "CRANDOLA VALSASSINA", provincia: "LC" },
  { code: "401002048", nome: "CRAVAGLIANA", provincia: "VC" },
  { code: "401004076", nome: "CRAVANZANA", provincia: "CN" },
  { code: "401103024", nome: "CRAVEGGIA", provincia: "VB" },
  { code: "405024036", nome: "CREAZZO", provincia: "VI" },
  { code: "413069027", nome: "CRECCHIO", provincia: "CH" },
  { code: "403016088", nome: "CREDARO", provincia: "BG" },
  { code: "403019034", nome: "CREDERA RUBBIANO", provincia: "CR" },
  { code: "403019035", nome: "CREMA", provincia: "CR" },
  { code: "403097028", nome: "CREMELLA", provincia: "LC" },
  { code: "403012056", nome: "CREMENAGA", provincia: "VA" },
  { code: "403097029", nome: "CREMENO", provincia: "LC" },
  { code: "403013083", nome: "CREMIA", provincia: "CO" },
  { code: "401006063", nome: "CREMOLINO", provincia: "AL" },
  { code: "403019036", nome: "CREMONA", provincia: "CR" },
  { code: "403019037", nome: "CREMOSANO", provincia: "CR" },
  { code: "401002049", nome: "CRESCENTINO", provincia: "VC" },
  { code: "405024037", nome: "CRESPADORO", provincia: "VI" },
  { code: "403098025", nome: "CRESPIATICA", provincia: "LO" },
  { code: "409050041", nome: "CRESPINA LORENZANA", provincia: "PI" },
  { code: "405029019", nome: "CRESPINO", provincia: "RO" },
  { code: "401003055", nome: "CRESSA", provincia: "NO" },
  { code: "401096021", nome: "CREVACUORE", provincia: "BI" },
  { code: "408037024", nome: "CREVALCORE", provincia: "BO" },
  { code: "401103025", nome: "CREVOLADOSSOLA", provincia: "VB" },
  { code: "415063030", nome: "CRISPANO", provincia: "NA" },
  { code: "416073004", nome: "CRISPIANO", provincia: "TA" },
  { code: "401004077", nome: "CRISSOLO", provincia: "CN" },
  { code: "407010020", nome: "CROCEFIESCHI", provincia: "GE" },
  { code: "405026025", nome: "CROCETTA DEL MONTELLO", provincia: "TV" },
  { code: "401103026", nome: "CRODO", provincia: "VB" },
  { code: "413067023", nome: "CROGNALETO", provincia: "TE" },
  { code: "418078046", nome: "CROPALATI", provincia: "CS" },
  { code: "418079036", nome: "CROPANI", provincia: "CZ" },
  { code: "418078047", nome: "CROSIA", provincia: "CS" },
  { code: "403012057", nome: "CROSIO DELLA VALLE", provincia: "VA" },
  { code: "418101010", nome: "CROTONE", provincia: "KR" },
  { code: "403019038", nome: "CROTTA D\'ADDA", provincia: "CR" },
  { code: "401002052", nome: "CROVA", provincia: "VC" },
  { code: "404022068", nome: "CROVIANA", provincia: "TN" },
  { code: "418101011", nome: "CRUCOLI", provincia: "KR" },
  { code: "403012058", nome: "CUASSO AL MONTE", provincia: "VA" },
  { code: "415065049", nome: "CUCCARO VETERE", provincia: "SA" },
  { code: "403013084", nome: "CUCCIAGO", provincia: "CO" },
  { code: "401001096", nome: "CUCEGLIO", provincia: "TO" },
  { code: "403015096", nome: "CUGGIONO", provincia: "MI" },
  { code: "403012059", nome: "CUGLIATE-FABIASCO", provincia: "VA" },
  { code: "420095019", nome: "CUGLIERI", provincia: "OR" },
  { code: "413068017", nome: "CUGNOLI", provincia: "PE" },
  { code: "401001097", nome: "CUMIANA", provincia: "TO" },
  { code: "403019039", nome: "CUMIGNANO SUL NAVIGLIO", provincia: "CR" },
  { code: "403012060", nome: "CUNARDO", provincia: "VA" },
  { code: "401004078", nome: "CUNEO", provincia: "CN" },
  { code: "401005051", nome: "CUNICO", provincia: "AT" },
  { code: "401001098", nome: "CUORGNE\'", provincia: "TO" },
  { code: "413069028", nome: "CUPELLO", provincia: "CH" },
  { code: "411044017", nome: "CUPRA MARITTIMA", provincia: "AP" },
  { code: "411042016", nome: "CUPRAMONTANA", provincia: "AN" },
  { code: "403018060", nome: "CURA CARPIGNANO", provincia: "PV" },
  { code: "420095077", nome: "CURCURIS", provincia: "OR" },
  { code: "401003058", nome: "CUREGGIO", provincia: "NO" },
  { code: "403012061", nome: "CURIGLIA CON MONTEVIASCO", provincia: "VA" },
  { code: "418079039", nome: "CURINGA", provincia: "CZ" },
  { code: "401096023", nome: "CURINO", provincia: "BI" },
  { code: "403016089", nome: "CURNO", provincia: "BG" },
  { code: "404021027", nome: "CURON VENOSTA", provincia: "BZ" },
  { code: "416075025", nome: "CURSI", provincia: "LE" },
  { code: "405028036", nome: "CURTAROLO", provincia: "PD" },
  { code: "403020021", nome: "CURTATONE", provincia: "MN" },
  { code: "415061032", nome: "CURTI", provincia: "CE" },
  { code: "403015097", nome: "CUSAGO", provincia: "MI" },
  { code: "403015098", nome: "CUSANO MILANINO", provincia: "MI" },
  { code: "415062026", nome: "CUSANO MUTRI", provincia: "BN" },
  { code: "403013085", nome: "CUSINO", provincia: "CO" },
  { code: "403016090", nome: "CUSIO", provincia: "BG" },
  { code: "419081007", nome: "CUSTONACI", provincia: "TP" },
  { code: "418101012", nome: "CUTRO", provincia: "KR" },
  { code: "416075026", nome: "CUTROFIANO", provincia: "LE" },
  { code: "403012062", nome: "CUVEGLIO", provincia: "VA" },
  { code: "403012063", nome: "CUVIO", provincia: "VA" },
  { code: "403015099", nome: "DAIRAGO", provincia: "MI" },
  { code: "403016091", nome: "DALMINE", provincia: "BG" },
  { code: "404022071", nome: "DAMBEL", provincia: "TN" },
  { code: "405025017", nome: "DANTA DI CADORE", provincia: "BL" },
  { code: "403017065", nome: "DARFO BOARIO TERME", provincia: "BS" },
  { code: "418102007", nome: "DASA\'", provincia: "VV" },
  { code: "407010021", nome: "DAVAGNA", provincia: "GE" },
  { code: "403012064", nome: "DAVERIO", provincia: "VA" },
  { code: "418079042", nome: "DAVOLI", provincia: "CZ" },
  { code: "403014025", nome: "DAZIO", provincia: "SO" },
  { code: "420092015", nome: "DECIMOMANNU", provincia: "CA" },
  { code: "420092016", nome: "DECIMOPUTZU", provincia: "CA" },
  { code: "418079043", nome: "DECOLLATURA", provincia: "CZ" },
  { code: "407009027", nome: "DEGO", provincia: "SV" },
  { code: "407011012", nome: "DEIVA MARINA", provincia: "SP" },
  { code: "403014026", nome: "DELEBIO", provincia: "SO" },
  { code: "419085006", nome: "DELIA", provincia: "CL" },
  { code: "418080031", nome: "DELIANUOVA", provincia: "RC" },
  { code: "416071022", nome: "DELICETO", provincia: "FG" },
  { code: "403017066", nome: "DELLO", provincia: "BS" },
  { code: "401004079", nome: "DEMONTE", provincia: "CN" },
  { code: "401006065", nome: "DENICE", provincia: "AL" },
  { code: "404022074", nome: "DENNO", provincia: "TN" },
  { code: "401006066", nome: "DERNICE", provincia: "AL" },
  { code: "403019040", nome: "DEROVERE", provincia: "CR" },
  { code: "410054017", nome: "DERUTA", provincia: "PG" },
  { code: "403097030", nome: "DERVIO", provincia: "LC" },
  { code: "401002054", nome: "DESANA", provincia: "VC" },
  { code: "403017067", nome: "DESENZANO DEL GARDA", provincia: "BS" },
  { code: "403108023", nome: "DESIO", provincia: "MB" },
  { code: "420091016", nome: "DESULO", provincia: "NU" },
  { code: "418078048", nome: "DIAMANTE", provincia: "CS" },
  { code: "407008025", nome: "DIANO ARENTINO", provincia: "IM" },
  { code: "407008026", nome: "DIANO CASTELLO", provincia: "IM" },
  { code: "401004080", nome: "DIANO D\'ALBA", provincia: "CN" },
  { code: "407008027", nome: "DIANO MARINA", provincia: "IM" },
  { code: "407008028", nome: "DIANO SAN PIETRO", provincia: "IM" },
  { code: "409048013", nome: "DICOMANO", provincia: "FI" },
  { code: "406030032", nome: "DIGNANO", provincia: "UD" },
  { code: "404022233", nome: "DIMARO FOLGARIDA", provincia: "TN" },
  { code: "418102008", nome: "DINAMI", provincia: "VV" },
  { code: "418078049", nome: "DIPIGNANO", provincia: "CS" },
  { code: "416075027", nome: "DISO", provincia: "LE" },
  { code: "401003060", nome: "DIVIGNANO", provincia: "NO" },
  { code: "403013087", nome: "DIZZASCO", provincia: "CO" },
  { code: "404021028", nome: "DOBBIACO", provincia: "BZ" },
  { code: "406031003", nome: "DOBERDO\' DEL LAGO", provincia: "GO" },
  { code: "401004081", nome: "DOGLIANI", provincia: "CN" },
  { code: "413069029", nome: "DOGLIOLA", provincia: "CH" },
  { code: "406030033", nome: "DOGNA", provincia: "UD" },
  { code: "405023031", nome: "DOLCE\'", provincia: "VR" },
  { code: "407008029", nome: "DOLCEACQUA", provincia: "IM" },
  { code: "407008030", nome: "DOLCEDO", provincia: "IM" },
  { code: "406031004", nome: "DOLEGNA DEL COLLIO", provincia: "GO" },
  { code: "420092017", nome: "DOLIANOVA", provincia: "CA" },
  { code: "405027012", nome: "DOLO", provincia: "VE" },
  { code: "403097031", nome: "DOLZAGO", provincia: "LC" },
  { code: "418078050", nome: "DOMANICO", provincia: "CS" },
  { code: "403013089", nome: "DOMASO", provincia: "CO" },
  { code: "405025018", nome: "DOMEGGE DI CADORE", provincia: "BL" },
  { code: "415064031", nome: "DOMICELLA", provincia: "AV" },
  { code: "401103028", nome: "DOMODOSSOLA", provincia: "VB" },
  { code: "420092018", nome: "DOMUS DE MARIA", provincia: "CA" },
  { code: "420092019", nome: "DOMUSNOVAS", provincia: "CA" },
  { code: "401096024", nome: "DONATO", provincia: "BI" },
  { code: "403013090", nome: "DONGO", provincia: "CO" },
  { code: "402007023", nome: "DONNAS", provincia: "AO" },
  { code: "420092020", nome: "DONORI", provincia: "CA" },
  { code: "420091017", nome: "DORGALI", provincia: "NU" },
  { code: "403097032", nome: "DORIO", provincia: "LC" },
  { code: "401003062", nome: "DORMELLETTO", provincia: "NO" },
  { code: "403018061", nome: "DORNO", provincia: "PV" },
  { code: "401096025", nome: "DORZANO", provincia: "BI" },
  { code: "403020022", nome: "DOSOLO", provincia: "MN" },
  { code: "403016092", nome: "DOSSENA", provincia: "BG" },
  { code: "403013092", nome: "DOSSO DEL LIRO", provincia: "CO" },
  { code: "402007024", nome: "DOUES", provincia: "AO" },
  { code: "408140011", nome: "DOVADOLA", provincia: "FC" },
  { code: "403019041", nome: "DOVERA", provincia: "CR" },
  { code: "408037025", nome: "DOZZA", provincia: "BO" },
  { code: "415061033", nome: "DRAGONI", provincia: "CE" },
  { code: "418102009", nome: "DRAPIA", provincia: "VV" },
  { code: "404022078", nome: "DRENA", provincia: "TN" },
  { code: "406030034", nome: "DRENCHIA", provincia: "UD" },
  { code: "403015101", nome: "DRESANO", provincia: "MI" },
  { code: "404022079", nome: "DRO", provincia: "TN" },
  { code: "401004082", nome: "DRONERO", provincia: "CN" },
  { code: "401001099", nome: "DRUENTO", provincia: "TO" },
  { code: "401103029", nome: "DRUOGNO", provincia: "VB" },
  { code: "420091018", nome: "DUALCHI", provincia: "NU" },
  { code: "403014027", nome: "DUBINO", provincia: "SO" },
  { code: "405028106", nome: "DUE CARRARE", provincia: "PD" },
  { code: "405024038", nome: "DUEVILLE", provincia: "VI" },
  { code: "415062027", nome: "DUGENTA", provincia: "BN" },
  { code: "406032001", nome: "DUINO AURISINA", provincia: "TS" },
  { code: "403012065", nome: "DUMENZA", provincia: "VA" },
  { code: "403012066", nome: "DUNO", provincia: "VA" },
  { code: "415062028", nome: "DURAZZANO", provincia: "BN" },
  { code: "414070022", nome: "DURONIA", provincia: "CB" },
  { code: "401005052", nome: "DUSINO SAN MICHELE", provincia: "AT" },
  { code: "415065050", nome: "EBOLI", provincia: "SA" },
  { code: "403017068", nome: "EDOLO", provincia: "BS" },
  { code: "404021029", nome: "EGNA", provincia: "BZ" },
  { code: "413068018", nome: "ELICE", provincia: "PE" },
  { code: "420091019", nome: "ELINI", provincia: "NU" },
  { code: "403097033", nome: "ELLO", provincia: "LC" },
  { code: "420092108", nome: "ELMAS", provincia: "CA" },
  { code: "401004083", nome: "ELVA", provincia: "CN" },
  { code: "402007025", nome: "EMARESE", provincia: "AO" },
  { code: "409048014", nome: "EMPOLI", provincia: "FI" },
  { code: "403016093", nome: "ENDINE GAIANO", provincia: "BG" },
  { code: "405024039", nome: "ENEGO", provincia: "VI" },
  { code: "406030035", nome: "ENEMONZO", provincia: "UD" },
  { code: "419086009", nome: "ENNA", provincia: "EN" },
  { code: "401004084", nome: "ENTRACQUE", provincia: "CN" },
  { code: "403016094", nome: "ENTRATICO", provincia: "BG" },
  { code: "401004085", nome: "ENVIE", provincia: "CN" },
  { code: "417076030", nome: "EPISCOPIA", provincia: "PZ" },
  { code: "405027013", nome: "ERACLEA", provincia: "VE" },
  { code: "403013095", nome: "ERBA", provincia: "CO" },
  { code: "405023032", nome: "ERBE\'", provincia: "VR" },
  { code: "405023033", nome: "ERBEZZO", provincia: "VR" },
  { code: "403017069", nome: "ERBUSCO", provincia: "BS" },
  { code: "416074006", nome: "ERCHIE", provincia: "BR" },
  { code: "415063064", nome: "ERCOLANO", provincia: "NA" },
  { code: "419081008", nome: "ERICE", provincia: "TP" },
  { code: "407009028", nome: "ERLI", provincia: "SV" },
  { code: "406093019", nome: "ERTO E CASSO", provincia: "PN" },
  { code: "420090088", nome: "ERULA", provincia: "SS" },
  { code: "403097034", nome: "ERVE", provincia: "LC" },
  { code: "411043016", nome: "ESANATOGLIA", provincia: "MC" },
  { code: "420091020", nome: "ESCALAPLANO", provincia: "NU" },
  { code: "420091021", nome: "ESCOLCA", provincia: "NU" },
  { code: "403017070", nome: "ESINE", provincia: "BS" },
  { code: "403097035", nome: "ESINO LARIO", provincia: "LC" },
  { code: "412060031", nome: "ESPERIA", provincia: "FR" },
  { code: "420090028", nome: "ESPORLATU", provincia: "SS" },
  { code: "405028037", nome: "ESTE", provincia: "PD" },
  { code: "420091022", nome: "ESTERZILI", provincia: "NU" },
  { code: "402007026", nome: "ETROUBLES", provincia: "AO" },
  { code: "403013097", nome: "EUPILIO", provincia: "CO" },
  { code: "401001100", nome: "EXILLES", provincia: "TO" },
  { code: "401006067", nome: "FABBRICA CURONE", provincia: "AL" },
  { code: "409046036", nome: "FABBRICHE DI VERGEMOLI", provincia: "LU" },
  { code: "408035021", nome: "FABBRICO", provincia: "RE" },
  { code: "411042017", nome: "FABRIANO", provincia: "AN" },
  { code: "412056024", nome: "FABRICA DI ROMA", provincia: "VT" },
  { code: "418102010", nome: "FABRIZIA", provincia: "VV" },
  { code: "410055011", nome: "FABRO", provincia: "TR" },
  { code: "406030036", nome: "FAEDIS", provincia: "UD" },
  { code: "403014028", nome: "FAEDO VALTELLINO", provincia: "SO" },
  { code: "408039010", nome: "FAENZA", provincia: "RA" },
  { code: "416071023", nome: "FAETO", provincia: "FG" },
  { code: "406030037", nome: "FAGAGNA", provincia: "UD" },
  { code: "403013098", nome: "FAGGETO LARIO", provincia: "CO" },
  { code: "416073005", nome: "FAGGIANO", provincia: "TA" },
  { code: "413066042", nome: "FAGNANO ALTO", provincia: "AQ" },
  { code: "418078051", nome: "FAGNANO CASTELLO", provincia: "CS" },
  { code: "403012067", nome: "FAGNANO OLONA", provincia: "VA" },
  { code: "404022081", nome: "FAI DELLA PAGANELLA", provincia: "TN" },
  { code: "415062029", nome: "FAICCHIO", provincia: "BN" },
  { code: "405025019", nome: "FALCADE", provincia: "BL" },
  { code: "415061101", nome: "FALCIANO DEL MASSICO", provincia: "CE" },
  { code: "418078052", nome: "FALCONARA ALBANESE", provincia: "CS" },
  { code: "411042018", nome: "FALCONARA MARITTIMA", provincia: "AN" },
  { code: "419083019", nome: "FALCONE", provincia: "ME" },
  { code: "412056025", nome: "FALERIA", provincia: "VT" },
  { code: "418079047", nome: "FALERNA", provincia: "CZ" },
  { code: "411109005", nome: "FALERONE", provincia: "FM" },
  { code: "413069104", nome: "FALLO", provincia: "CH" },
  { code: "403013099", nome: "FALOPPIO", provincia: "CO" },
  { code: "412060032", nome: "FALVATERRA", provincia: "FR" },
  { code: "404021030", nome: "FALZES", provincia: "BZ" },
  { code: "408036011", nome: "FANANO", provincia: "MO" },
  { code: "406093020", nome: "FANNA", provincia: "PN" },
  { code: "413067024", nome: "FANO ADRIANO", provincia: "TE" },
  { code: "411141013", nome: "FANO", provincia: "PU" },
  { code: "413069030", nome: "FARA FILIORUM PETRI", provincia: "CH" },
  { code: "403016096", nome: "FARA GERA D\'ADDA", provincia: "BG" },
  { code: "412057027", nome: "FARA IN SABINA", provincia: "RI" },
  { code: "401003065", nome: "FARA NOVARESE", provincia: "NO" },
  { code: "403016097", nome: "FARA OLIVANA CON SOLA", provincia: "BG" },
  { code: "413069031", nome: "FARA SAN MARTINO", provincia: "CH" },
  { code: "405024040", nome: "FARA VICENTINO", provincia: "VI" },
  { code: "417076031", nome: "FARDELLA", provincia: "PZ" },
  { code: "401004086", nome: "FARIGLIANO", provincia: "CN" },
  { code: "413068019", nome: "FARINDOLA", provincia: "PE" },
  { code: "408033019", nome: "FARINI", provincia: "PC" },
  { code: "412056026", nome: "FARNESE", provincia: "VT" },
  { code: "406031005", nome: "FARRA D\'ISONZO", provincia: "GO" },
  { code: "405026026", nome: "FARRA DI SOLIGO", provincia: "TV" },
  { code: "416074007", nome: "FASANO", provincia: "BR" },
  { code: "407010022", nome: "FASCIA", provincia: "GE" },
  { code: "409050014", nome: "FAUGLIA", provincia: "PI" },
  { code: "401004087", nome: "FAULE", provincia: "CN" },
  { code: "407010023", nome: "FAVALE DI MALVARO", provincia: "GE" },
  { code: "419084017", nome: "FAVARA", provincia: "AG" },
  { code: "419081009", nome: "FAVIGNANA", provincia: "TP" },
  { code: "401001101", nome: "FAVRIA", provincia: "TO" },
  { code: "401004088", nome: "FEISOGLIO", provincia: "CN" },
  { code: "401001102", nome: "FELETTO", provincia: "TO" },
  { code: "408034013", nome: "FELINO", provincia: "PR" },
  { code: "415065051", nome: "FELITTO", provincia: "SA" },
  { code: "401006068", nome: "FELIZZANO", provincia: "AL" },
  { code: "405025021", nome: "FELTRE", provincia: "BL" },
  { code: "403013100", nome: "FENEGRO\'", provincia: "CO" },
  { code: "401001103", nome: "FENESTRELLE", provincia: "TO" },
  { code: "402007027", nome: "FENIS", provincia: "AO" },
  { code: "410055012", nome: "FERENTILLO", provincia: "TR" },
  { code: "412060033", nome: "FERENTINO", provincia: "FR" },
  { code: "419089008", nome: "FERLA", provincia: "SR" },
  { code: "411141014", nome: "FERMIGNANO", provincia: "PU" },
  { code: "411109006", nome: "FERMO", provincia: "FM" },
  { code: "403012068", nome: "FERNO", provincia: "VA" },
  { code: "418079048", nome: "FEROLETO ANTICO", provincia: "CZ" },
  { code: "418080032", nome: "FEROLETO DELLA CHIESA", provincia: "RC" },
  { code: "417077008", nome: "FERRANDINA", provincia: "MT" },
  { code: "405023034", nome: "FERRARA DI MONTE BALDO", provincia: "VR" },
  { code: "408038008", nome: "FERRARA", provincia: "FE" },
  { code: "414070023", nome: "FERRAZZANO", provincia: "CB" },
  { code: "403012069", nome: "FERRERA DI VARESE", provincia: "VA" },
  { code: "403018062", nome: "FERRERA ERBOGNONE", provincia: "PV" },
  { code: "401005053", nome: "FERRERE", provincia: "AT" },
  { code: "408033020", nome: "FERRIERE", provincia: "PC" },
  { code: "418080033", nome: "FERRUZZANO", provincia: "RC" },
  { code: "412057028", nome: "FIAMIGNANO", provincia: "RI" },
  { code: "412058036", nome: "FIANO ROMANO", provincia: "RM" },
  { code: "401001104", nome: "FIANO", provincia: "TO" },
  { code: "411043017", nome: "FIASTRA", provincia: "MC" },
  { code: "404022083", nome: "FIAVE\'", provincia: "TN" },
  { code: "419082035", nome: "FICARAZZI", provincia: "PA" },
  { code: "405029021", nome: "FICAROLO", provincia: "RO" },
  { code: "419083020", nome: "FICARRA", provincia: "ME" },
  { code: "410055013", nome: "FICULLE", provincia: "TR" },
  { code: "408034014", nome: "FIDENZA", provincia: "PR" },
  { code: "404021031", nome: "FIE\' ALLO SCILIAR", provincia: "BZ" },
  { code: "404022085", nome: "FIEROZZO", provincia: "TN" },
  { code: "403019043", nome: "FIESCO", provincia: "CR" },
  { code: "409048015", nome: "FIESOLE", provincia: "FI" },
  { code: "403017071", nome: "FIESSE", provincia: "BS" },
  { code: "405027014", nome: "FIESSO D\'ARTICO", provincia: "VE" },
  { code: "405029022", nome: "FIESSO UMBERTIANO", provincia: "RO" },
  { code: "403013101", nome: "FIGINO SERENZA", provincia: "CO" },
  { code: "409048052", nome: "FIGLINE E INCISA VALDARNO", provincia: "FI" },
  { code: "418078053", nome: "FIGLINE VEGLIATURO", provincia: "CS" },
  { code: "412058037", nome: "FILACCIANO", provincia: "RM" },
  { code: "418102011", nome: "FILADELFIA", provincia: "VV" },
  { code: "403016098", nome: "FILAGO", provincia: "BG" },
  { code: "418102012", nome: "FILANDARI", provincia: "VV" },
  { code: "409045006", nome: "FILATTIERA", provincia: "MS" },
  { code: "412060034", nome: "FILETTINO", provincia: "FR" },
  { code: "413069032", nome: "FILETTO", provincia: "CH" },
  { code: "417076032", nome: "FILIANO", provincia: "PZ" },
  { code: "403018063", nome: "FILIGHERA", provincia: "PV" },
  { code: "414094019", nome: "FILIGNANO", provincia: "IS" },
  { code: "418102013", nome: "FILOGASO", provincia: "VV" },
  { code: "411042019", nome: "FILOTTRANO", provincia: "AN" },
  { code: "408036012", nome: "FINALE EMILIA", provincia: "MO" },
  { code: "407009029", nome: "FINALE LIGURE", provincia: "SV" },
  { code: "403016099", nome: "FINO DEL MONTE", provincia: "BG" },
  { code: "403013102", nome: "FINO MORNASCO", provincia: "CO" },
  { code: "403016100", nome: "FIORANO AL SERIO", provincia: "BG" },
  { code: "401001105", nome: "FIORANO CANAVESE", provincia: "TO" },
  { code: "408036013", nome: "FIORANO MODENESE", provincia: "MO" },
  { code: "408033021", nome: "FIORENZUOLA D\'ARDA", provincia: "PC" },
  { code: "409048017", nome: "FIRENZE", provincia: "FI" },
  { code: "409048018", nome: "FIRENZUOLA", provincia: "FI" },
  { code: "418078054", nome: "FIRMO", provincia: "CS" },
  { code: "408038027", nome: "FISCAGLIA", provincia: "FE" },
  { code: "415065052", nome: "FISCIANO", provincia: "SA" },
  { code: "412060035", nome: "FIUGGI", provincia: "FR" },
  { code: "408036014", nome: "FIUMALBO", provincia: "MO" },
  { code: "418080034", nome: "FIUMARA", provincia: "RC" },
  { code: "406093021", nome: "FIUME VENETO", provincia: "PN" },
  { code: "419083021", nome: "FIUMEDINISI", provincia: "ME" },
  { code: "418078055", nome: "FIUMEFREDDO BRUZIO", provincia: "CS" },
  { code: "419087016", nome: "FIUMEFREDDO DI SICILIA", provincia: "CT" },
  { code: "406030190", nome: "FIUMICELLO VILLA VICENTINA", provincia: "UD" },
  { code: "412058120", nome: "FIUMICINO", provincia: "RM" },
  { code: "411043019", nome: "FIUMINATA", provincia: "MC" },
  { code: "409045007", nome: "FIVIZZANO", provincia: "MS" },
  { code: "406030039", nome: "FLAIBANO", provincia: "UD" },
  { code: "403017072", nome: "FLERO", provincia: "BS" },
  { code: "419083022", nome: "FLORESTA", provincia: "ME" },
  { code: "419089009", nome: "FLORIDIA", provincia: "SR" },
  { code: "420090029", nome: "FLORINAS", provincia: "SS" },
  { code: "415064032", nome: "FLUMERI", provincia: "AV" },
  { code: "420092021", nome: "FLUMINIMAGGIORE", provincia: "CA" },
  { code: "420091023", nome: "FLUSSIO", provincia: "NU" },
  { code: "401002057", nome: "FOBELLO", provincia: "VC" },
  { code: "416071024", nome: "FOGGIA", provincia: "FG" },
  { code: "415062030", nome: "FOGLIANISE", provincia: "BN" },
  { code: "406031006", nome: "FOGLIANO REDIPUGLIA", provincia: "GO" },
  { code: "401001106", nome: "FOGLIZZO", provincia: "TO" },
  { code: "409051018", nome: "FOIANO DELLA CHIANA", provincia: "AR" },
  { code: "415062031", nome: "FOIANO DI VAL FORTORE", provincia: "BN" },
  { code: "404022087", nome: "FOLGARIA", provincia: "TN" },
  { code: "411044020", nome: "FOLIGNANO", provincia: "AP" },
  { code: "410054018", nome: "FOLIGNO", provincia: "PG" },
  { code: "405026027", nome: "FOLLINA", provincia: "TV" },
  { code: "407011013", nome: "FOLLO", provincia: "SP" },
  { code: "409053009", nome: "FOLLONICA", provincia: "GR" },
  { code: "403098026", nome: "FOMBIO", provincia: "LO" },
  { code: "419083023", nome: "FONDACHELLI-FANTINA", provincia: "ME" },
  { code: "412059007", nome: "FONDI", provincia: "LT" },
  { code: "420091024", nome: "FONNI", provincia: "NU" },
  { code: "402007028", nome: "FONTAINEMORE", provincia: "AO" },
  { code: "412060036", nome: "FONTANA LIRI", provincia: "FR" },
  { code: "406093022", nome: "FONTANAFREDDA", provincia: "PN" },
  { code: "415064033", nome: "FONTANAROSA", provincia: "AV" },
  { code: "408037026", nome: "FONTANELICE", provincia: "BO" },
  { code: "403016101", nome: "FONTANELLA", provincia: "BG" },
  { code: "408034015", nome: "FONTANELLATO", provincia: "PR" },
  { code: "405026028", nome: "FONTANELLE", provincia: "TV" },
  { code: "401003066", nome: "FONTANETO D\'AGOGNA", provincia: "NO" },
  { code: "401002058", nome: "FONTANETTO PO", provincia: "VC" },
  { code: "407010024", nome: "FONTANIGORDA", provincia: "GE" },
  { code: "401005054", nome: "FONTANILE", provincia: "AT" },
  { code: "405028038", nome: "FONTANIVA", provincia: "PD" },
  { code: "412058122", nome: "FONTE NUOVA", provincia: "RM" },
  { code: "405026029", nome: "FONTE", provincia: "TV" },
  { code: "413066043", nome: "FONTECCHIO", provincia: "AQ" },
  { code: "412060037", nome: "FONTECHIARI", provincia: "FR" },
  { code: "415061034", nome: "FONTEGRECA", provincia: "CE" },
  { code: "403016102", nome: "FONTENO", provincia: "BG" },
  { code: "408034016", nome: "FONTEVIVO", provincia: "PR" },
  { code: "405025022", nome: "FONZASO", provincia: "BL" },
  { code: "403016103", nome: "FOPPOLO", provincia: "BG" },
  { code: "412057029", nome: "FORANO", provincia: "RI" },
  { code: "411044021", nome: "FORCE", provincia: "AP" },
  { code: "415062032", nome: "FORCHIA", provincia: "BN" },
  { code: "403014029", nome: "FORCOLA", provincia: "SO" },
  { code: "420095020", nome: "FORDONGIANUS", provincia: "OR" },
  { code: "417076033", nome: "FORENZA", provincia: "PZ" },
  { code: "403016104", nome: "FORESTO SPARSO", provincia: "BG" },
  { code: "406030137", nome: "FORGARIA NEL FRIULI", provincia: "UD" },
  { code: "415064034", nome: "FORINO", provincia: "AV" },
  { code: "415063031", nome: "FORIO", provincia: "NA" },
  { code: "414094020", nome: "FORLI\' DEL SANNIO", provincia: "IS" },
  { code: "408140012", nome: "FORLI\'", provincia: "FC" },
  { code: "408140013", nome: "FORLIMPOPOLI", provincia: "FC" },
  { code: "401103031", nome: "FORMAZZA", provincia: "VB" },
  { code: "412058038", nome: "FORMELLO", provincia: "RM" },
  { code: "412059008", nome: "FORMIA", provincia: "LT" },
  { code: "415061035", nome: "FORMICOLA", provincia: "CE" },
  { code: "403019044", nome: "FORMIGARA", provincia: "CR" },
  { code: "408036015", nome: "FORMIGINE", provincia: "MO" },
  { code: "401002059", nome: "FORMIGLIANA", provincia: "VC" },
  { code: "404022089", nome: "FORNACE", provincia: "TN" },
  { code: "414094021", nome: "FORNELLI", provincia: "IS" },
  { code: "406030040", nome: "FORNI AVOLTRI", provincia: "UD" },
  { code: "406030041", nome: "FORNI DI SOPRA", provincia: "UD" },
  { code: "406030042", nome: "FORNI DI SOTTO", provincia: "UD" },
  { code: "401001107", nome: "FORNO CANAVESE", provincia: "TO" },
  { code: "408034017", nome: "FORNOVO DI TARO", provincia: "PR" },
  { code: "403016105", nome: "FORNOVO SAN GIOVANNI", provincia: "BG" },
  { code: "409046013", nome: "FORTE DEI MARMI", provincia: "LU" },
  { code: "404021032", nome: "FORTEZZA", provincia: "BZ" },
  { code: "403018064", nome: "FORTUNAGO", provincia: "PV" },
  { code: "419083024", nome: "FORZA D\'AGRO\'", provincia: "ME" },
  { code: "409046014", nome: "FOSCIANDORA", provincia: "LU" },
  { code: "409045008", nome: "FOSDINOVO", provincia: "MS" },
  { code: "413066044", nome: "FOSSA", provincia: "AQ" },
  { code: "413069033", nome: "FOSSACESIA", provincia: "CH" },
  { code: "405027015", nome: "FOSSALTA DI PIAVE", provincia: "VE" },
  { code: "405027016", nome: "FOSSALTA DI PORTOGRUARO", provincia: "VE" },
  { code: "414070024", nome: "FOSSALTO", provincia: "CB" },
  { code: "401004089", nome: "FOSSANO", provincia: "CN" },
  { code: "410054019", nome: "FOSSATO DI VICO", provincia: "PG" },
  { code: "418079052", nome: "FOSSATO SERRALTA", provincia: "CZ" },
  { code: "405027017", nome: "FOSSO\'", provincia: "VE" },
  { code: "411141015", nome: "FOSSOMBRONE", provincia: "PU" },
  { code: "405024041", nome: "FOZA", provincia: "VI" },
  { code: "401004090", nome: "FRABOSA SOPRANA", provincia: "CN" },
  { code: "401004091", nome: "FRABOSA SOTTANA", provincia: "CN" },
  { code: "401006069", nome: "FRACONALTO", provincia: "AL" },
  { code: "416073006", nome: "FRAGAGNANO", provincia: "TA" },
  { code: "415062033", nome: "FRAGNETO L\'ABATE", provincia: "BN" },
  { code: "415062034", nome: "FRAGNETO MONFORTE", provincia: "BN" },
  { code: "413069034", nome: "FRAINE", provincia: "CH" },
  { code: "407011014", nome: "FRAMURA", provincia: "SP" },
  { code: "413069035", nome: "FRANCAVILLA AL MARE", provincia: "CH" },
  { code: "418102014", nome: "FRANCAVILLA ANGITOLA", provincia: "VV" },
  { code: "401006070", nome: "FRANCAVILLA BISIO", provincia: "AL" },
  { code: "411109007", nome: "FRANCAVILLA D\'ETE", provincia: "FM" },
  { code: "419083025", nome: "FRANCAVILLA DI SICILIA", provincia: "ME" },
  { code: "416074008", nome: "FRANCAVILLA FONTANA", provincia: "BR" },
  { code: "417076034", nome: "FRANCAVILLA IN SINNI", provincia: "PZ" },
  { code: "418078056", nome: "FRANCAVILLA MARITTIMA", provincia: "CS" },
  { code: "418102015", nome: "FRANCICA", provincia: "VV" },
  { code: "419089010", nome: "FRANCOFONTE", provincia: "SR" },
  { code: "415061036", nome: "FRANCOLISE", provincia: "CE" },
  { code: "401006071", nome: "FRASCARO", provincia: "AL" },
  { code: "403018065", nome: "FRASCAROLO", provincia: "PV" },
  { code: "412058039", nome: "FRASCATI", provincia: "RM" },
  { code: "418078057", nome: "FRASCINETO", provincia: "CS" },
  { code: "404022090", nome: "FRASSILONGO", provincia: "TN" },
  { code: "405029023", nome: "FRASSINELLE POLESINE", provincia: "RO" },
  { code: "401006072", nome: "FRASSINELLO MONFERRATO", provincia: "AL" },
  { code: "401006073", nome: "FRASSINETO PO", provincia: "AL" },
  { code: "401001108", nome: "FRASSINETTO", provincia: "TO" },
  { code: "401004092", nome: "FRASSINO", provincia: "CN" },
  { code: "408036016", nome: "FRASSINORO", provincia: "MO" },
  { code: "412057030", nome: "FRASSO SABINO", provincia: "RI" },
  { code: "415062035", nome: "FRASSO TELESINO", provincia: "BN" },
  { code: "405029024", nome: "FRATTA POLESINE", provincia: "RO" },
  { code: "410054020", nome: "FRATTA TODINA", provincia: "PG" },
  { code: "415063032", nome: "FRATTAMAGGIORE", provincia: "NA" },
  { code: "415063033", nome: "FRATTAMINORE", provincia: "NA" },
  { code: "411141016", nome: "FRATTE ROSA", provincia: "PU" },
  { code: "419083026", nome: "FRAZZANO\'", provincia: "ME" },
  { code: "405026030", nome: "FREGONA", provincia: "TV" },
  { code: "413069036", nome: "FRESAGRANDINARIA", provincia: "CH" },
  { code: "401006074", nome: "FRESONARA", provincia: "AL" },
  { code: "415064035", nome: "FRIGENTO", provincia: "AV" },
  { code: "415061037", nome: "FRIGNANO", provincia: "CE" },
  { code: "401005055", nome: "FRINCO", provincia: "AT" },
  { code: "413069037", nome: "FRISA", provincia: "CH" },
  { code: "406093024", nome: "FRISANCO", provincia: "PN" },
  { code: "401001109", nome: "FRONT", provincia: "TO" },
  { code: "411141017", nome: "FRONTINO", provincia: "PU" },
  { code: "411141018", nome: "FRONTONE", provincia: "PU" },
  { code: "412060038", nome: "FROSINONE", provincia: "FR" },
  { code: "414094022", nome: "FROSOLONE", provincia: "IS" },
  { code: "401001110", nome: "FROSSASCO", provincia: "TO" },
  { code: "401006075", nome: "FRUGAROLO", provincia: "AL" },
  { code: "401006976", nome: "FUBINE MONFERRATO", provincia: "AL" },
  { code: "409048019", nome: "FUCECCHIO", provincia: "FI" },
  { code: "403016106", nome: "FUIPIANO VALLE IMAGNA", provincia: "BG" },
  { code: "405023035", nome: "FUMANE", provincia: "VR" },
  { code: "412060039", nome: "FUMONE", provincia: "FR" },
  { code: "404021033", nome: "FUNES", provincia: "BZ" },
  { code: "419083027", nome: "FURCI SICULO", provincia: "ME" },
  { code: "413069038", nome: "FURCI", provincia: "CH" },
  { code: "419083028", nome: "FURNARI", provincia: "ME" },
  { code: "415065053", nome: "FURORE", provincia: "SA" },
  { code: "420092022", nome: "FURTEI", provincia: "CA" },
  { code: "418078058", nome: "FUSCALDO", provincia: "CS" },
  { code: "408039011", nome: "FUSIGNANO", provincia: "RA" },
  { code: "403014030", nome: "FUSINE", provincia: "SO" },
  { code: "415065054", nome: "FUTANI", provincia: "SA" },
  { code: "403019045", nome: "GABBIONETA BINANUOVA", provincia: "CR" },
  { code: "401006077", nome: "GABIANO", provincia: "AL" },
  { code: "411141019", nome: "GABICCE MARE", provincia: "PU" },
  { code: "402007029", nome: "GABY", provincia: "AO" },
  { code: "403019046", nome: "GADESCO PIEVE DELMONA", provincia: "CR" },
  { code: "420091025", nome: "GADONI", provincia: "NU" },
  { code: "412059009", nome: "GAETA", provincia: "LT" },
  { code: "419083029", nome: "GAGGI", provincia: "ME" },
  { code: "403015103", nome: "GAGGIANO", provincia: "MI" },
  { code: "408037027", nome: "GAGGIO MONTANO", provincia: "BO" },
  { code: "401096026", nome: "GAGLIANICO", provincia: "BI" },
  { code: "413066045", nome: "GAGLIANO ATERNO", provincia: "AQ" },
  { code: "419086010", nome: "GAGLIANO CASTELFERRATO", provincia: "EN" },
  { code: "416075028", nome: "GAGLIANO DEL CAPO", provincia: "LE" },
  { code: "418079055", nome: "GAGLIATO", provincia: "CZ" },
  { code: "411043020", nome: "GAGLIOLE", provincia: "MC" },
  { code: "405026031", nome: "GAIARINE", provincia: "TV" },
  { code: "405029025", nome: "GAIBA", provincia: "RO" },
  { code: "401004093", nome: "GAIOLA", provincia: "CN" },
  { code: "409052013", nome: "GAIOLE IN CHIANTI", provincia: "SI" },
  { code: "420091026", nome: "GAIRO", provincia: "NU" },
  { code: "404021034", nome: "GAIS", provincia: "BZ" },
  { code: "419083030", nome: "GALATI MAMERTINO", provincia: "ME" },
  { code: "416075029", nome: "GALATINA", provincia: "LE" },
  { code: "416075030", nome: "GALATONE", provincia: "LE" },
  { code: "418080035", nome: "GALATRO", provincia: "RC" },
  { code: "403097036", nome: "GALBIATE", provincia: "LC" },
  { code: "408140014", nome: "GALEATA", provincia: "FC" },
  { code: "403098027", nome: "GALGAGNANO", provincia: "LO" },
  { code: "403012070", nome: "GALLARATE", provincia: "VA" },
  { code: "412056027", nome: "GALLESE", provincia: "VT" },
  { code: "403012071", nome: "GALLIATE LOMBARDO", provincia: "VA" },
  { code: "401003068", nome: "GALLIATE", provincia: "NO" },
  { code: "403018066", nome: "GALLIAVOLA", provincia: "PV" },
  { code: "412058040", nome: "GALLICANO NEL LAZIO", provincia: "RM" },
  { code: "409046015", nome: "GALLICANO", provincia: "LU" },
  { code: "417076035", nome: "GALLICCHIO", provincia: "PZ" },
  { code: "405028039", nome: "GALLIERA VENETA", provincia: "PD" },
  { code: "408037028", nome: "GALLIERA", provincia: "BO" },
  { code: "412060040", nome: "GALLINARO", provincia: "FR" },
  { code: "405024042", nome: "GALLIO", provincia: "VI" },
  { code: "416075031", nome: "GALLIPOLI", provincia: "LE" },
  { code: "415061038", nome: "GALLO MATESE", provincia: "CE" },
  { code: "419083031", nome: "GALLODORO", provincia: "ME" },
  { code: "415061039", nome: "GALLUCCIO", provincia: "CE" },
  { code: "420091027", nome: "GALTELLI\'", provincia: "NU" },
  { code: "405028040", nome: "GALZIGNANO TERME", provincia: "PD" },
  { code: "401006078", nome: "GAMALERO", provincia: "AL" },
  { code: "403017073", nome: "GAMBARA", provincia: "BS" },
  { code: "403018067", nome: "GAMBARANA", provincia: "PV" },
  { code: "401004094", nome: "GAMBASCA", provincia: "CN" },
  { code: "409048020", nome: "GAMBASSI TERME", provincia: "FI" },
  { code: "414070025", nome: "GAMBATESA", provincia: "CB" },
  { code: "405024043", nome: "GAMBELLARA", provincia: "VI" },
  { code: "413069039", nome: "GAMBERALE", provincia: "CH" },
  { code: "408140015", nome: "GAMBETTOLA", provincia: "FC" },
  { code: "403018068", nome: "GAMBOLO\'", provincia: "PV" },
  { code: "403016107", nome: "GANDELLINO", provincia: "BG" },
  { code: "403016108", nome: "GANDINO", provincia: "BG" },
  { code: "403016109", nome: "GANDOSSO", provincia: "BG" },
  { code: "419082036", nome: "GANGI", provincia: "PA" },
  { code: "417077009", nome: "GARAGUSO", provincia: "MT" },
  { code: "401003069", nome: "GARBAGNA NOVARESE", provincia: "NO" },
  { code: "401006079", nome: "GARBAGNA", provincia: "AL" },
  { code: "403015105", nome: "GARBAGNATE MILANESE", provincia: "MI" },
  { code: "403097037", nome: "GARBAGNATE MONASTERO", provincia: "LC" },
  { code: "405023036", nome: "GARDA", provincia: "VR" },
  { code: "403017074", nome: "GARDONE RIVIERA", provincia: "BS" },
  { code: "403017075", nome: "GARDONE VAL TROMPIA", provincia: "BS" },
  { code: "401004095", nome: "GARESSIO", provincia: "CN" },
  { code: "401003070", nome: "GARGALLO", provincia: "NO" },
  { code: "404021035", nome: "GARGAZZONE", provincia: "BZ" },
  { code: "403017076", nome: "GARGNANO", provincia: "BS" },
  { code: "403018069", nome: "GARLASCO", provincia: "PV" },
  { code: "403097038", nome: "GARLATE", provincia: "LC" },
  { code: "407009030", nome: "GARLENDA", provincia: "SV" },
  { code: "404022991", nome: "GARNIGA TERME", provincia: "TN" },
  { code: "403013106", nome: "GARZENO", provincia: "CO" },
  { code: "401001111", nome: "GARZIGLIANA", provincia: "TO" },
  { code: "418079056", nome: "GASPERINA", provincia: "CZ" },
  { code: "401001112", nome: "GASSINO TORINESE", provincia: "TO" },
  { code: "408035022", nome: "GATTATICO", provincia: "RE" },
  { code: "408140016", nome: "GATTEO", provincia: "FC" },
  { code: "401003166", nome: "GATTICO-VERUNO", provincia: "NO" },
  { code: "401002061", nome: "GATTINARA", provincia: "VC" },
  { code: "403017077", nome: "GAVARDO", provincia: "BS" },
  { code: "405029026", nome: "GAVELLO", provincia: "RO" },
  { code: "403016110", nome: "GAVERINA TERME", provincia: "BG" },
  { code: "401006081", nome: "GAVI", provincia: "AL" },
  { code: "412058041", nome: "GAVIGNANO", provincia: "RM" },
  { code: "403012072", nome: "GAVIRATE", provincia: "VA" },
  { code: "420091028", nome: "GAVOI", provincia: "NU" },
  { code: "409053010", nome: "GAVORRANO", provincia: "GR" },
  { code: "403020024", nome: "GAZOLDO DEGLI IPPOLITI", provincia: "MN" },
  { code: "403012073", nome: "GAZZADA SCHIANNO", provincia: "VA" },
  { code: "403016111", nome: "GAZZANIGA", provincia: "BG" },
  { code: "405023037", nome: "GAZZO VERONESE", provincia: "VR" },
  { code: "405028041", nome: "GAZZO", provincia: "PD" },
  { code: "408033022", nome: "GAZZOLA", provincia: "PC" },
  { code: "403020025", nome: "GAZZUOLO", provincia: "MN" },
  { code: "419085007", nome: "GELA", provincia: "CL" },
  { code: "408099004", nome: "GEMMANO", provincia: "RN" },
  { code: "406030043", nome: "GEMONA DEL FRIULI", provincia: "UD" },
  { code: "403012074", nome: "GEMONIO", provincia: "VA" },
  { code: "412058042", nome: "GENAZZANO", provincia: "RM" },
  { code: "411042020", nome: "GENGA", provincia: "AN" },
  { code: "403019047", nome: "GENIVOLTA", provincia: "CR" },
  { code: "401004096", nome: "GENOLA", provincia: "CN" },
  { code: "420091029", nome: "GENONI", provincia: "NU" },
  { code: "407010025", nome: "GENOVA", provincia: "GE" },
  { code: "420092023", nome: "GENURI", provincia: "CA" },
  { code: "417076036", nome: "GENZANO DI LUCANIA", provincia: "PZ" },
  { code: "412058043", nome: "GENZANO DI ROMA", provincia: "RM" },
  { code: "403013107", nome: "GERA LARIO", provincia: "CO" },
  { code: "418080036", nome: "GERACE", provincia: "RC" },
  { code: "419082037", nome: "GERACI SICULO", provincia: "PA" },
  { code: "412058044", nome: "GERANO", provincia: "RM" },
  { code: "403018071", nome: "GERENZAGO", provincia: "PV" },
  { code: "403012075", nome: "GERENZANO", provincia: "VA" },
  { code: "420091030", nome: "GERGEI", provincia: "NU" },
  { code: "401001113", nome: "GERMAGNANO", provincia: "TO" },
  { code: "401103032", nome: "GERMAGNO", provincia: "VB" },
  { code: "403012076", nome: "GERMIGNAGA", provincia: "VA" },
  { code: "418102016", nome: "GEROCARNE", provincia: "VV" },
  { code: "403014031", nome: "GEROLA ALTA", provincia: "SO" },
  { code: "403019048", nome: "GERRE DE\' CAPRIOLI", provincia: "CR" },
  { code: "420092024", nome: "GESICO", provincia: "CA" },
  { code: "403015106", nome: "GESSATE", provincia: "MI" },
  { code: "413069040", nome: "GESSOPALENA", provincia: "CH" },
  { code: "420092025", nome: "GESTURI", provincia: "CA" },
  { code: "415064036", nome: "GESUALDO", provincia: "AV" },
  { code: "403017078", nome: "GHEDI", provincia: "BS" },
  { code: "401003073", nome: "GHEMME", provincia: "NO" },
  { code: "401103033", nome: "GHIFFA", provincia: "VB" },
  { code: "420095021", nome: "GHILARZA", provincia: "OR" },
  { code: "403016113", nome: "GHISALBA", provincia: "BG" },
  { code: "401002062", nome: "GHISLARENGO", provincia: "VC" },
  { code: "405029027", nome: "GIACCIANO CON BARUCHELLA", provincia: "RO" },
  { code: "401001114", nome: "GIAGLIONE", provincia: "TO" },
  { code: "403017079", nome: "GIANICO", provincia: "BS" },
  { code: "410054021", nome: "GIANO DELL\'UMBRIA", provincia: "PG" },
  { code: "415061040", nome: "GIANO VETUSTO", provincia: "CE" },
  { code: "419082038", nome: "GIARDINELLO", provincia: "PA" },
  { code: "419083032", nome: "GIARDINI-NAXOS", provincia: "ME" },
  { code: "401006082", nome: "GIAROLE", provincia: "AL" },
  { code: "419088004", nome: "GIARRATANA", provincia: "RG" },
  { code: "419087017", nome: "GIARRE", provincia: "CT" },
  { code: "420090030", nome: "GIAVE", provincia: "SS" },
  { code: "401001115", nome: "GIAVENO", provincia: "TO" },
  { code: "405026032", nome: "GIAVERA DEL MONTELLO", provincia: "TV" },
  { code: "420092026", nome: "GIBA", provincia: "CA" },
  { code: "419081010", nome: "GIBELLINA", provincia: "TP" },
  { code: "401096027", nome: "GIFFLENGA", provincia: "BI" },
  { code: "418080037", nome: "GIFFONE", provincia: "RC" },
  { code: "415065055", nome: "GIFFONI SEI CASALI", provincia: "SA" },
  { code: "415065056", nome: "GIFFONI VALLE PIANA", provincia: "SA" },
  { code: "401103034", nome: "GIGNESE", provincia: "VB" },
  { code: "402007030", nome: "GIGNOD", provincia: "AO" },
  { code: "414070026", nome: "GILDONE", provincia: "CB" },
  { code: "418079058", nome: "GIMIGLIANO", provincia: "CZ" },
  { code: "415062036", nome: "GINESTRA DEGLI SCHIAVONI", provincia: "BN" },
  { code: "417076099", nome: "GINESTRA", provincia: "PZ" },
  { code: "416073007", nome: "GINOSA", provincia: "TA" },
  { code: "415065057", nome: "GIOI", provincia: "SA" },
  { code: "413066046", nome: "GIOIA DEI MARSI", provincia: "AQ" },
  { code: "416072021", nome: "GIOIA DEL COLLE", provincia: "BA" },
  { code: "415061041", nome: "GIOIA SANNITICA", provincia: "CE" },
  { code: "418080038", nome: "GIOIA TAURO", provincia: "RC" },
  { code: "418080039", nome: "GIOIOSA IONICA", provincia: "RC" },
  { code: "419083033", nome: "GIOIOSA MAREA", provincia: "ME" },
  { code: "410055014", nome: "GIOVE", provincia: "TR" },
  { code: "416072022", nome: "GIOVINAZZO", provincia: "BA" },
  { code: "404022092", nome: "GIOVO", provincia: "TN" },
  { code: "420091031", nome: "GIRASOLE", provincia: "NU" },
  { code: "418079059", nome: "GIRIFALCO", provincia: "CZ" },
  { code: "413069041", nome: "GISSI", provincia: "CH" },
  { code: "416075032", nome: "GIUGGIANELLO", provincia: "LE" },
  { code: "415063034", nome: "GIUGLIANO IN CAMPANIA", provincia: "NA" },
  { code: "419082039", nome: "GIULIANA", provincia: "PA" },
  { code: "412060041", nome: "GIULIANO DI ROMA", provincia: "FR" },
  { code: "413069042", nome: "GIULIANO TEATINO", provincia: "CH" },
  { code: "413067025", nome: "GIULIANOVA", provincia: "TE" },
  { code: "415065058", nome: "GIUNGANO", provincia: "SA" },
  { code: "416075033", nome: "GIURDIGNANO", provincia: "LE" },
  { code: "403018072", nome: "GIUSSAGO", provincia: "PV" },
  { code: "403108024", nome: "GIUSSANO", provincia: "MB" },
  { code: "407009031", nome: "GIUSTENICE", provincia: "SV" },
  { code: "404022093", nome: "GIUSTINO", provincia: "TN" },
  { code: "407009032", nome: "GIUSVALLA", provincia: "SV" },
  { code: "401001116", nome: "GIVOLETTO", provincia: "TO" },
  { code: "418079060", nome: "GIZZERIA", provincia: "CZ" },
  { code: "404021036", nome: "GLORENZA", provincia: "BZ" },
  { code: "405026033", nome: "GODEGA DI SANT\'URBANO", provincia: "TV" },
  { code: "403018973", nome: "GODIASCO SALICE TERME", provincia: "PV" },
  { code: "419082040", nome: "GODRANO", provincia: "PA" },
  { code: "403020026", nome: "GOITO", provincia: "MN" },
  { code: "403012077", nome: "GOLASECCA", provincia: "VA" },
  { code: "403018074", nome: "GOLFERENZO", provincia: "PV" },
  { code: "420090083", nome: "GOLFO ARANCI", provincia: "SS" },
  { code: "403019049", nome: "GOMBITO", provincia: "CR" },
  { code: "406030044", nome: "GONARS", provincia: "UD" },
  { code: "420092027", nome: "GONI", provincia: "CA" },
  { code: "420092028", nome: "GONNESA", provincia: "CA" },
  { code: "420095022", nome: "GONNOSCODINA", provincia: "OR" },
  { code: "420092029", nome: "GONNOSFANADIGA", provincia: "CA" },
  { code: "420095023", nome: "GONNOSNO\'", provincia: "OR" },
  { code: "420095024", nome: "GONNOSTRAMATZA", provincia: "OR" },
  { code: "403020027", nome: "GONZAGA", provincia: "MN" },
  { code: "403014032", nome: "GORDONA", provincia: "SO" },
  { code: "412058045", nome: "GORGA", provincia: "RM" },
  { code: "405026034", nome: "GORGO AL MONTICANO", provincia: "TV" },
  { code: "417077010", nome: "GORGOGLIONE", provincia: "MT" },
  { code: "403015108", nome: "GORGONZOLA", provincia: "MI" },
  { code: "413066047", nome: "GORIANO SICOLI", provincia: "AQ" },
  { code: "406031007", nome: "GORIZIA", provincia: "GO" },
  { code: "403012078", nome: "GORLA MAGGIORE", provincia: "VA" },
  { code: "403012079", nome: "GORLA MINORE", provincia: "VA" },
  { code: "403016114", nome: "GORLAGO", provincia: "BG" },
  { code: "403016115", nome: "GORLE", provincia: "BG" },
  { code: "403012080", nome: "GORNATE-OLONA", provincia: "VA" },
  { code: "403016116", nome: "GORNO", provincia: "BG" },
  { code: "408038025", nome: "GORO", provincia: "FE" },
  { code: "407010026", nome: "GORRETO", provincia: "GE" },
  { code: "401004097", nome: "GORZEGNO", provincia: "CN" },
  { code: "405025025", nome: "GOSALDO", provincia: "BL" },
  { code: "408033023", nome: "GOSSOLENGO", provincia: "PC" },
  { code: "401004098", nome: "GOTTASECCA", provincia: "CN" },
  { code: "403017080", nome: "GOTTOLENGO", provincia: "BS" },
  { code: "401004099", nome: "GOVONE", provincia: "CN" },
  { code: "401003076", nome: "GOZZANO", provincia: "NO" },
  { code: "411141020", nome: "GRADARA", provincia: "PU" },
  { code: "406031008", nome: "GRADISCA D\'ISONZO", provincia: "GO" },
  { code: "406031009", nome: "GRADO", provincia: "GO" },
  { code: "412056028", nome: "GRADOLI", provincia: "VT" },
  { code: "403098028", nome: "GRAFFIGNANA", provincia: "LO" },
  { code: "412056029", nome: "GRAFFIGNANO", provincia: "VT" },
  { code: "401096028", nome: "GRAGLIA", provincia: "BI" },
  { code: "408033024", nome: "GRAGNANO TREBBIENSE", provincia: "PC" },
  { code: "415063035", nome: "GRAGNANO", provincia: "NA" },
  { code: "419087018", nome: "GRAMMICHELE", provincia: "CT" },
  { code: "401005956", nome: "GRANA MONFERRATO", provincia: "AT" },
  { code: "408037030", nome: "GRANAROLO DELL\'EMILIA", provincia: "BO" },
  { code: "403013110", nome: "GRANDATE", provincia: "CO" },
  { code: "403013111", nome: "GRANDOLA ED UNITI", provincia: "CO" },
  { code: "419083034", nome: "GRANITI", provincia: "ME" },
  { code: "401003077", nome: "GRANOZZO CON MONTICELLO", provincia: "NO" },
  { code: "403012081", nome: "GRANTOLA", provincia: "VA" },
  { code: "405028042", nome: "GRANTORTO", provincia: "PD" },
  { code: "405028043", nome: "GRANZE", provincia: "PD" },
  { code: "417077011", nome: "GRASSANO", provincia: "MT" },
  { code: "403016117", nome: "GRASSOBBIO", provincia: "BG" },
  { code: "419082041", nome: "GRATTERI", provincia: "PA" },
  { code: "403013249", nome: "GRAVEDONA ED UNITI", provincia: "CO" },
  { code: "403018075", nome: "GRAVELLONA LOMELLINA", provincia: "PV" },
  { code: "401103035", nome: "GRAVELLONA TOCE", provincia: "VB" },
  { code: "401001117", nome: "GRAVERE", provincia: "TO" },
  { code: "419087019", nome: "GRAVINA DI CATANIA", provincia: "CT" },
  { code: "416072023", nome: "GRAVINA IN PUGLIA", provincia: "BA" },
  { code: "415061042", nome: "GRAZZANISE", provincia: "CE" },
  { code: "401005057", nome: "GRAZZANO BADOGLIO", provincia: "AT" },
  { code: "412057031", nome: "GRECCIO", provincia: "RI" },
  { code: "415064037", nome: "GRECI", provincia: "AV" },
  { code: "401002065", nome: "GREGGIO", provincia: "VC" },
  { code: "401006083", nome: "GREMIASCO", provincia: "AL" },
  { code: "402007031", nome: "GRESSAN", provincia: "AO" },
  { code: "402007032", nome: "GRESSONEY-LA-TRINITE\'", provincia: "AO" },
  { code: "402007033", nome: "GRESSONEY-SAINT-JEAN", provincia: "AO" },
  { code: "409048021", nome: "GREVE IN CHIANTI", provincia: "FI" },
  { code: "403015110", nome: "GREZZAGO", provincia: "MI" },
  { code: "405023038", nome: "GREZZANA", provincia: "VR" },
  { code: "403013113", nome: "GRIANTE", provincia: "CO" },
  { code: "415061043", nome: "GRICIGNANO DI AVERSA", provincia: "CE" },
  { code: "401003079", nome: "GRIGNASCO", provincia: "NO" },
  { code: "404022095", nome: "GRIGNO", provincia: "TN" },
  { code: "406030045", nome: "GRIMACCO", provincia: "UD" },
  { code: "418078059", nome: "GRIMALDI", provincia: "CS" },
  { code: "401004100", nome: "GRINZANE CAVOUR", provincia: "CN" },
  { code: "405024046", nome: "GRISIGNANO DI ZOCCO", provincia: "VI" },
  { code: "418078060", nome: "GRISOLIA", provincia: "CS" },
  { code: "408037031", nome: "GRIZZANA MORANDI", provincia: "BO" },
  { code: "401006084", nome: "GROGNARDO", provincia: "AL" },
  { code: "403016118", nome: "GROMO", provincia: "BG" },
  { code: "401006085", nome: "GRONDONA", provincia: "AL" },
  { code: "403016119", nome: "GRONE", provincia: "BG" },
  { code: "403019050", nome: "GRONTARDO", provincia: "CR" },
  { code: "403018076", nome: "GROPELLO CAIROLI", provincia: "PV" },
  { code: "408033025", nome: "GROPPARELLO", provincia: "PC" },
  { code: "401001118", nome: "GROSCAVALLO", provincia: "TO" },
  { code: "403014033", nome: "GROSIO", provincia: "SO" },
  { code: "403014034", nome: "GROSOTTO", provincia: "SO" },
  { code: "409053011", nome: "GROSSETO", provincia: "GR" },
  { code: "401001119", nome: "GROSSO", provincia: "TO" },
  { code: "412058046", nome: "GROTTAFERRATA", provincia: "RM" },
  { code: "416073008", nome: "GROTTAGLIE", provincia: "TA" },
  { code: "415064038", nome: "GROTTAMINARDA", provincia: "AV" },
  { code: "411044023", nome: "GROTTAMMARE", provincia: "AP" },
  { code: "411109008", nome: "GROTTAZZOLINA", provincia: "FM" },
  { code: "412056030", nome: "GROTTE DI CASTRO", provincia: "VT" },
  { code: "419084018", nome: "GROTTE", provincia: "AG" },
  { code: "418080040", nome: "GROTTERIA", provincia: "RC" },
  { code: "417077012", nome: "GROTTOLE", provincia: "MT" },
  { code: "415064039", nome: "GROTTOLELLA", provincia: "AV" },
  { code: "405027018", nome: "GRUARO", provincia: "VE" },
  { code: "401001120", nome: "GRUGLIASCO", provincia: "TO" },
  { code: "403019051", nome: "GRUMELLO CREMONESE ED UNITI", provincia: "CR" },
  { code: "403016120", nome: "GRUMELLO DEL MONTE", provincia: "BG" },
  { code: "417076037", nome: "GRUMENTO NOVA", provincia: "PZ" },
  { code: "416072024", nome: "GRUMO APPULA", provincia: "BA" },
  { code: "415063036", nome: "GRUMO NEVANO", provincia: "NA" },
  { code: "405024047", nome: "GRUMOLO DELLE ABBADESSE", provincia: "VI" },
  { code: "416075034", nome: "GUAGNANO", provincia: "LE" },
  { code: "410054022", nome: "GUALDO CATTANEO", provincia: "PG" },
  { code: "410054023", nome: "GUALDO TADINO", provincia: "PG" },
  { code: "411043021", nome: "GUALDO", provincia: "MC" },
  { code: "419083035", nome: "GUALTIERI SICAMINO\'", provincia: "ME" },
  { code: "408035023", nome: "GUALTIERI", provincia: "RE" },
  { code: "420092030", nome: "GUAMAGGIORE", provincia: "CA" },
  { code: "403013114", nome: "GUANZATE", provincia: "CO" },
  { code: "412060042", nome: "GUARCINO", provincia: "FR" },
  { code: "405029028", nome: "GUARDA VENETA", provincia: "RO" },
  { code: "401002066", nome: "GUARDABOSONE", provincia: "VC" },
  { code: "403098029", nome: "GUARDAMIGLIO", provincia: "LO" },
  { code: "418079061", nome: "GUARDAVALLE", provincia: "CZ" },
  { code: "410055015", nome: "GUARDEA", provincia: "TR" },
  { code: "415064040", nome: "GUARDIA LOMBARDI", provincia: "AV" },
  { code: "417076038", nome: "GUARDIA PERTICARA", provincia: "PZ" },
  { code: "418078061", nome: "GUARDIA PIEMONTESE", provincia: "CS" },
  { code: "415062037", nome: "GUARDIA SANFRAMONDI", provincia: "BN" },
  { code: "413069043", nome: "GUARDIAGRELE", provincia: "CH" },
  { code: "414070027", nome: "GUARDIALFIERA", provincia: "CB" },
  { code: "414070028", nome: "GUARDIAREGIA", provincia: "CB" },
  { code: "409050015", nome: "GUARDISTALLO", provincia: "PI" },
  { code: "401004101", nome: "GUARENE", provincia: "CN" },
  { code: "420092031", nome: "GUASILA", provincia: "CA" },
  { code: "408035024", nome: "GUASTALLA", provincia: "RE" },
  { code: "401006086", nome: "GUAZZORA", provincia: "AL" },
  { code: "410054024", nome: "GUBBIO", provincia: "PG" },
  { code: "403015112", nome: "GUDO VISCONTI", provincia: "MI" },
  { code: "414070029", nome: "GUGLIONESI", provincia: "CB" },
  { code: "403020028", nome: "GUIDIZZOLO", provincia: "MN" },
  { code: "412058047", nome: "GUIDONIA MONTECELIO", provincia: "RM" },
  { code: "408036017", nome: "GUIGLIA", provincia: "MO" },
  { code: "413069044", nome: "GUILMI", provincia: "CH" },
  { code: "401103036", nome: "GURRO", provincia: "VB" },
  { code: "420092032", nome: "GUSPINI", provincia: "CA" },
  { code: "403017081", nome: "GUSSAGO", provincia: "BS" },
  { code: "403019052", nome: "GUSSOLA", provincia: "CR" },
  { code: "402007034", nome: "HONE", provincia: "AO" },
  { code: "403017082", nome: "IDRO", provincia: "BS" },
  { code: "420092033", nome: "IGLESIAS", provincia: "CA" },
  { code: "401004102", nome: "IGLIANO", provincia: "CN" },
  { code: "420091032", nome: "ILBONO", provincia: "NU" },
  { code: "405023039", nome: "ILLASI", provincia: "VR" },
  { code: "420090031", nome: "ILLORAI", provincia: "SS" },
  { code: "403097039", nome: "IMBERSAGO", provincia: "LC" },
  { code: "404022097", nome: "IMER", provincia: "TN" },
  { code: "408037032", nome: "IMOLA", provincia: "BO" },
  { code: "407008031", nome: "IMPERIA", provincia: "IM" },
  { code: "409048022", nome: "IMPRUNETA", provincia: "FI" },
  { code: "403012082", nome: "INARZO", provincia: "VA" },
  { code: "401005058", nome: "INCISA SCAPACCINO", provincia: "AT" },
  { code: "403017083", nome: "INCUDINE", provincia: "BS" },
  { code: "403012083", nome: "INDUNO OLONA", provincia: "VA" },
  { code: "401001121", nome: "INGRIA", provincia: "TO" },
  { code: "401103037", nome: "INTRAGNA", provincia: "VB" },
  { code: "403097040", nome: "INTROBIO", provincia: "LC" },
  { code: "402007035", nome: "INTROD", provincia: "AO" },
  { code: "413066048", nome: "INTRODACQUA", provincia: "AQ" },
  { code: "403013118", nome: "INVERIGO", provincia: "CO" },
  { code: "403018077", nome: "INVERNO E MONTELEONE", provincia: "PV" },
  { code: "401001122", nome: "INVERSO PINASCA", provincia: "TO" },
  { code: "403015113", nome: "INVERUNO", provincia: "MI" },
  { code: "401003082", nome: "INVORIO", provincia: "NO" },
  { code: "403015114", nome: "INZAGO", provincia: "MI" },
  { code: "418102017", nome: "IONADI", provincia: "VV" },
  { code: "420091033", nome: "IRGOLI", provincia: "NU" },
  { code: "403017084", nome: "IRMA", provincia: "BS" },
  { code: "417077013", nome: "IRSINA", provincia: "MT" },
  { code: "401004103", nome: "ISASCA", provincia: "CN" },
  { code: "418079063", nome: "ISCA SULLO IONIO", provincia: "CZ" },
  { code: "412056031", nome: "ISCHIA DI CASTRO", provincia: "VT" },
  { code: "415063037", nome: "ISCHIA", provincia: "NA" },
  { code: "416071025", nome: "ISCHITELLA", provincia: "FG" },
  { code: "403017085", nome: "ISEO", provincia: "BS" },
  { code: "404022098", nome: "ISERA", provincia: "TN" },
  { code: "414094023", nome: "ISERNIA", provincia: "IS" },
  { code: "420092114", nome: "ISILI", provincia: "CA" },
  { code: "419082042", nome: "ISNELLO", provincia: "PA" },
  { code: "401005059", nome: "ISOLA D\'ASTI", provincia: "AT" },
  { code: "407010027", nome: "ISOLA DEL CANTONE", provincia: "GE" },
  { code: "409053012", nome: "ISOLA DEL GIGLIO", provincia: "GR" },
  { code: "413067026", nome: "ISOLA DEL GRAN SASSO D\'ITALIA", provincia: "TE" },
  { code: "412060043", nome: "ISOLA DEL LIRI", provincia: "FR" },
  { code: "411141021", nome: "ISOLA DEL PIANO", provincia: "PU" },
  { code: "405023040", nome: "ISOLA DELLA SCALA", provincia: "VR" },
  { code: "419082043", nome: "ISOLA DELLE FEMMINE", provincia: "PA" },
  { code: "418101013", nome: "ISOLA DI CAPO RIZZUTO", provincia: "KR" },
  { code: "403016121", nome: "ISOLA DI FONDRA", provincia: "BG" },
  { code: "403019053", nome: "ISOLA DOVARESE", provincia: "CR" },
  { code: "405023041", nome: "ISOLA RIZZA", provincia: "VR" },
  { code: "401006087", nome: "ISOLA SANT\'ANTONIO", provincia: "AL" },
  { code: "405024048", nome: "ISOLA VICENTINA", provincia: "VI" },
  { code: "401001123", nome: "ISOLABELLA", provincia: "TO" },
  { code: "407008032", nome: "ISOLABONA", provincia: "IM" },
  { code: "416071026", nome: "ISOLE TREMITI", provincia: "FG" },
  { code: "403017086", nome: "ISORELLA", provincia: "BS" },
  { code: "415065059", nome: "ISPANI", provincia: "SA" },
  { code: "419088005", nome: "ISPICA", provincia: "RG" },
  { code: "403012084", nome: "ISPRA", provincia: "VA" },
  { code: "401001124", nome: "ISSIGLIO", provincia: "TO" },
  { code: "402007036", nome: "ISSIME", provincia: "AO" },
  { code: "403016122", nome: "ISSO", provincia: "BG" },
  { code: "402007037", nome: "ISSOGNE", provincia: "AO" },
  { code: "405026035", nome: "ISTRANA", provincia: "TV" },
  { code: "419083036", nome: "ITALA", provincia: "ME" },
  { code: "412059010", nome: "ITRI", provincia: "LT" },
  { code: "420090032", nome: "ITTIREDDU", provincia: "SS" },
  { code: "420090033", nome: "ITTIRI", provincia: "SS" },
  { code: "401001125", nome: "IVREA", provincia: "TO" },
  { code: "403019054", nome: "IZANO", provincia: "CR" },
  { code: "418079065", nome: "JACURSO", provincia: "CZ" },
  { code: "414070030", nome: "JELSI", provincia: "CB" },
  { code: "412058048", nome: "JENNE", provincia: "RM" },
  { code: "403012085", nome: "JERAGO CON ORAGO", provincia: "VA" },
  { code: "420091035", nome: "JERZU", provincia: "NU" },
  { code: "411042021", nome: "JESI", provincia: "AN" },
  { code: "405027019", nome: "JESOLO", provincia: "VE" },
  { code: "408038010", nome: "JOLANDA DI SAVOIA", provincia: "FE" },
  { code: "419084019", nome: "JOPPOLO GIANCAXIO", provincia: "AG" },
  { code: "418102018", nome: "JOPPOLO", provincia: "VV" },
  { code: "402007038", nome: "JOVENCAN", provincia: "AO" },
  { code: "413066049", nome: "L\'AQUILA", provincia: "AQ" },
  { code: "401001126", nome: "LA CASSA", provincia: "TO" },
  { code: "401001127", nome: "LA LOGGIA", provincia: "TO" },
  { code: "420090035", nome: "LA MADDALENA", provincia: "SS" },
  { code: "402007039", nome: "LA MAGDELEINE", provincia: "AO" },
  { code: "401004105", nome: "LA MORRA", provincia: "CN" },
  { code: "402007040", nome: "LA SALLE", provincia: "AO" },
  { code: "407011015", nome: "LA SPEZIA", provincia: "SP" },
  { code: "402007041", nome: "LA THUILE", provincia: "AO" },
  { code: "405025027", nome: "LA VALLE AGORDINA", provincia: "BL" },
  { code: "404021117", nome: "LA VALLE", provincia: "BZ" },
  { code: "403097092", nome: "LA VALLETTA BRIANZA", provincia: "LC" },
  { code: "412058049", nome: "LABICO", provincia: "RM" },
  { code: "412057032", nome: "LABRO", provincia: "RI" },
  { code: "403015115", nome: "LACCHIARELLA", provincia: "MI" },
  { code: "415063038", nome: "LACCO AMENO", provincia: "NA" },
  { code: "415064041", nome: "LACEDONIA", provincia: "AV" },
  { code: "404021037", nome: "LACES", provincia: "BZ" },
  { code: "420091036", nome: "LACONI", provincia: "NU" },
  { code: "412058116", nome: "LADISPOLI", provincia: "RM" },
  { code: "420090034", nome: "LAERRU", provincia: "SS" },
  { code: "418080041", nome: "LAGANADI", provincia: "RC" },
  { code: "405024049", nome: "LAGHI", provincia: "VI" },
  { code: "403013119", nome: "LAGLIO", provincia: "CO" },
  { code: "401004104", nome: "LAGNASCO", provincia: "CN" },
  { code: "418078062", nome: "LAGO", provincia: "CS" },
  { code: "417076039", nome: "LAGONEGRO", provincia: "PZ" },
  { code: "408038011", nome: "LAGOSANTO", provincia: "FE" },
  { code: "404021038", nome: "LAGUNDO", provincia: "BZ" },
  { code: "407009033", nome: "LAIGUEGLIA", provincia: "SV" },
  { code: "403015116", nome: "LAINATE", provincia: "MI" },
  { code: "418078063", nome: "LAINO BORGO", provincia: "CS" },
  { code: "418078064", nome: "LAINO CASTELLO", provincia: "CS" },
  { code: "403013120", nome: "LAINO", provincia: "CO" },
  { code: "404021039", nome: "LAION", provincia: "BZ" },
  { code: "404021040", nome: "LAIVES", provincia: "BZ" },
  { code: "409050016", nome: "LAJATICO", provincia: "PI" },
  { code: "403016123", nome: "LALLIO", provincia: "BG" },
  { code: "413069045", nome: "LAMA DEI PELIGNI", provincia: "CH" },
  { code: "408036018", nome: "LAMA MOCOGNO", provincia: "MO" },
  { code: "403013121", nome: "LAMBRUGO", provincia: "CO" },
  { code: "418079160", nome: "LAMEZIA TERME", provincia: "CZ" },
  { code: "405025026", nome: "LAMON", provincia: "BL" },
  { code: "419084020", nome: "LAMPEDUSA E LINOSA", provincia: "AG" },
  { code: "409047005", nome: "LAMPORECCHIO", provincia: "PT" },
  { code: "401002067", nome: "LAMPORO", provincia: "VC" },
  { code: "404021041", nome: "LANA", provincia: "BZ" },
  { code: "413069046", nome: "LANCIANO", provincia: "CH" },
  { code: "401003083", nome: "LANDIONA", provincia: "NO" },
  { code: "403018078", nome: "LANDRIANO", provincia: "PV" },
  { code: "408034018", nome: "LANGHIRANO", provincia: "PR" },
  { code: "403018079", nome: "LANGOSCO", provincia: "PV" },
  { code: "420091037", nome: "LANUSEI", provincia: "NU" },
  { code: "412058050", nome: "LANUVIO", provincia: "RM" },
  { code: "403014036", nome: "LANZADA", provincia: "SO" },
  { code: "401001128", nome: "LANZO TORINESE", provincia: "TO" },
  { code: "411109009", nome: "LAPEDONA", provincia: "FM" },
  { code: "415064042", nome: "LAPIO", provincia: "AV" },
  { code: "418078065", nome: "LAPPANO", provincia: "CS" },
  { code: "409047006", nome: "LARCIANO", provincia: "PT" },
  { code: "403018080", nome: "LARDIRAGO", provincia: "PV" },
  { code: "412058115", nome: "LARIANO", provincia: "RM" },
  { code: "414070031", nome: "LARINO", provincia: "CB" },
  { code: "420092034", nome: "LAS PLASSAS", provincia: "CA" },
  { code: "404021042", nome: "LASA", provincia: "BZ" },
  { code: "419082044", nome: "LASCARI", provincia: "PA" },
  { code: "403013123", nome: "LASNIGO", provincia: "CO" },
  { code: "405024050", nome: "LASTEBASSE", provincia: "VI" },
  { code: "409048024", nome: "LASTRA A SIGNA", provincia: "FI" },
  { code: "412056032", nome: "LATERA", provincia: "VT" },
  { code: "409051042", nome: "LATERINA PERGINE VALDARNO", provincia: "AR" },
  { code: "416073009", nome: "LATERZA", provincia: "TA" },
  { code: "416074009", nome: "LATIANO", provincia: "BR" },
  { code: "412059011", nome: "LATINA", provincia: "LT" },
  { code: "406030046", nome: "LATISANA", provincia: "UD" },
  { code: "417076040", nome: "LATRONICO", provincia: "PZ" },
  { code: "418078066", nome: "LATTARICO", provincia: "CS" },
  { code: "406030047", nome: "LAUCO", provincia: "UD" },
  { code: "415065060", nome: "LAUREANA CILENTO", provincia: "SA" },
  { code: "418080042", nome: "LAUREANA DI BORRELLO", provincia: "RC" },
  { code: "404021043", nome: "LAUREGNO", provincia: "BZ" },
  { code: "417076041", nome: "LAURENZANA", provincia: "PZ" },
  { code: "417076042", nome: "LAURIA", provincia: "PZ" },
  { code: "401001129", nome: "LAURIANO", provincia: "TO" },
  { code: "415065061", nome: "LAURINO", provincia: "SA" },
  { code: "415065062", nome: "LAURITO", provincia: "SA" },
  { code: "415064043", nome: "LAURO", provincia: "AV" },
  { code: "407010028", nome: "LAVAGNA", provincia: "GE" },
  { code: "405023042", nome: "LAVAGNO", provincia: "VR" },
  { code: "404022102", nome: "LAVARONE", provincia: "TN" },
  { code: "417076043", nome: "LAVELLO", provincia: "PZ" },
  { code: "403012086", nome: "LAVENA-PONTE TRESA", provincia: "VA" },
  { code: "403012087", nome: "LAVENO-MOMBELLO", provincia: "VA" },
  { code: "403017087", nome: "LAVENONE", provincia: "BS" },
  { code: "415065063", nome: "LAVIANO", provincia: "SA" },
  { code: "404022103", nome: "LAVIS", provincia: "TN" },
  { code: "405023043", nome: "LAZISE", provincia: "VR" },
  { code: "403108025", nome: "LAZZATE", provincia: "MB" },
  { code: "413066050", nome: "LECCE NEI MARSI", provincia: "AQ" },
  { code: "416075035", nome: "LECCE", provincia: "LE" },
  { code: "403097042", nome: "LECCO", provincia: "LC" },
  { code: "404022229", nome: "LEDRO", provincia: "TN" },
  { code: "403016124", nome: "LEFFE", provincia: "BG" },
  { code: "403012088", nome: "LEGGIUNO", provincia: "VA" },
  { code: "405023044", nome: "LEGNAGO", provincia: "VR" },
  { code: "403015118", nome: "LEGNANO", provincia: "MI" },
  { code: "405028044", nome: "LEGNARO", provincia: "PD" },
  { code: "420091038", nome: "LEI", provincia: "NU" },
  { code: "401001130", nome: "LEINI", provincia: "TO" },
  { code: "407010029", nome: "LEIVI", provincia: "GE" },
  { code: "401001131", nome: "LEMIE", provincia: "TO" },
  { code: "405029029", nome: "LENDINARA", provincia: "RO" },
  { code: "419083037", nome: "LENI", provincia: "ME" },
  { code: "403016125", nome: "LENNA", provincia: "BG" },
  { code: "403017088", nome: "LENO", provincia: "BS" },
  { code: "412059012", nome: "LENOLA", provincia: "LT" },
  { code: "401002068", nome: "LENTA", provincia: "VC" },
  { code: "403108054", nome: "LENTATE SUL SEVESO", provincia: "MB" },
  { code: "413069047", nome: "LENTELLA", provincia: "CH" },
  { code: "419089011", nome: "LENTINI", provincia: "SR" },
  { code: "412057033", nome: "LEONESSA", provincia: "RI" },
  { code: "419086011", nome: "LEONFORTE", provincia: "EN" },
  { code: "416073010", nome: "LEPORANO", provincia: "TA" },
  { code: "416075036", nome: "LEQUILE", provincia: "LE" },
  { code: "401004106", nome: "LEQUIO BERRIA", provincia: "CN" },
  { code: "401004107", nome: "LEQUIO TANARO", provincia: "CN" },
  { code: "419082045", nome: "LERCARA FRIDDI", provincia: "PA" },
  { code: "407011016", nome: "LERICI", provincia: "SP" },
  { code: "401006088", nome: "LERMA", provincia: "AL" },
  { code: "401003084", nome: "LESA", provincia: "NO" },
  { code: "401004108", nome: "LESEGNO", provincia: "CN" },
  { code: "408034019", nome: "LESIGNANO DE\' BAGNI", provincia: "PR" },
  { code: "416071027", nome: "LESINA", provincia: "FG" },
  { code: "403108026", nome: "LESMO", provincia: "MB" },
  { code: "401001132", nome: "LESSOLO", provincia: "TO" },
  { code: "401096085", nome: "LESSONA", provincia: "BI" },
  { code: "406030048", nome: "LESTIZZA", provincia: "UD" },
  { code: "415061044", nome: "LETINO", provincia: "CE" },
  { code: "419083038", nome: "LETOJANNI", provincia: "ME" },
  { code: "415063039", nome: "LETTERE", provincia: "NA" },
  { code: "413068020", nome: "LETTOMANOPPELLO", provincia: "PE" },
  { code: "413069048", nome: "LETTOPALENA", provincia: "CH" },
  { code: "407011017", nome: "LEVANTO", provincia: "SP" },
  { code: "403016126", nome: "LEVATE", provincia: "BG" },
  { code: "416075037", nome: "LEVERANO", provincia: "LE" },
  { code: "401004109", nome: "LEVICE", provincia: "CN" },
  { code: "404022104", nome: "LEVICO TERME", provincia: "TN" },
  { code: "401001133", nome: "LEVONE", provincia: "TO" },
  { code: "403013126", nome: "LEZZENO", provincia: "CO" },
  { code: "415061045", nome: "LIBERI", provincia: "CE" },
  { code: "419083039", nome: "LIBRIZZI", provincia: "ME" },
  { code: "419084021", nome: "LICATA", provincia: "AG" },
  { code: "409045009", nome: "LICCIANA NARDI", provincia: "MS" },
  { code: "412058051", nome: "LICENZA", provincia: "RM" },
  { code: "419087020", nome: "LICODIA EUBEA", provincia: "CT" },
  { code: "403097043", nome: "LIERNA", provincia: "LC" },
  { code: "401002070", nome: "LIGNANA", provincia: "VC" },
  { code: "406030049", nome: "LIGNANO-SABBIADORO", provincia: "UD" },
  { code: "402007042", nome: "LILLIANES", provincia: "AO" },
  { code: "405025029", nome: "LIMANA", provincia: "BL" },
  { code: "415062038", nome: "LIMATOLA", provincia: "BN" },
  { code: "418102019", nome: "LIMBADI", provincia: "VV" },
  { code: "403108027", nome: "LIMBIATE", provincia: "MB" },
  { code: "405028045", nome: "LIMENA", provincia: "PD" },
  { code: "403013128", nome: "LIMIDO COMASCO", provincia: "CO" },
  { code: "419083040", nome: "LIMINA", provincia: "ME" },
  { code: "401004110", nome: "LIMONE PIEMONTE", provincia: "CN" },
  { code: "403017089", nome: "LIMONE SUL GARDA", provincia: "BS" },
  { code: "414070032", nome: "LIMOSANO", provincia: "CB" },
  { code: "403018081", nome: "LINAROLO", provincia: "PV" },
  { code: "419087021", nome: "LINGUAGLOSSA", provincia: "CT" },
  { code: "415064044", nome: "LIONI", provincia: "AV" },
  { code: "419083041", nome: "LIPARI", provincia: "ME" },
  { code: "403013129", nome: "LIPOMO", provincia: "CO" },
  { code: "403018082", nome: "LIRIO", provincia: "PV" },
  { code: "403015122", nome: "LISCATE", provincia: "MI" },
  { code: "413069049", nome: "LISCIA", provincia: "CH" },
  { code: "410054025", nome: "LISCIANO NICCONE", provincia: "PG" },
  { code: "401004111", nome: "LISIO", provincia: "CN" },
  { code: "403108028", nome: "LISSONE", provincia: "MB" },
  { code: "415063040", nome: "LIVERI", provincia: "NA" },
  { code: "403014037", nome: "LIVIGNO", provincia: "SO" },
  { code: "405025030", nome: "LIVINALLONGO DEL COL DI LANA", provincia: "BL" },
  { code: "403013130", nome: "LIVO", provincia: "CO" },
  { code: "404022106", nome: "LIVO", provincia: "TN" },
  { code: "401002071", nome: "LIVORNO FERRARIS", provincia: "VC" },
  { code: "409049009", nome: "LIVORNO", provincia: "LI" },
  { code: "403098030", nome: "LIVRAGA", provincia: "LO" },
  { code: "416075038", nome: "LIZZANELLO", provincia: "LE" },
  { code: "408037033", nome: "LIZZANO IN BELVEDERE", provincia: "BO" },
  { code: "416073011", nome: "LIZZANO", provincia: "TA" },
  { code: "407009034", nome: "LOANO", provincia: "SV" },
  { code: "401005060", nome: "LOAZZOLO", provincia: "AT" },
  { code: "401001134", nome: "LOCANA", provincia: "TO" },
  { code: "403015125", nome: "LOCATE DI TRIULZI", provincia: "MI" },
  { code: "403013131", nome: "LOCATE VARESINO", provincia: "CO" },
  { code: "403016127", nome: "LOCATELLO", provincia: "BG" },
  { code: "420091039", nome: "LOCERI", provincia: "NU" },
  { code: "416072025", nome: "LOCOROTONDO", provincia: "BA" },
  { code: "418080043", nome: "LOCRI", provincia: "RC" },
  { code: "420091040", nome: "LOCULI", provincia: "NU" },
  { code: "420091041", nome: "LODE\'", provincia: "NU" },
  { code: "403098032", nome: "LODI VECCHIO", provincia: "LO" },
  { code: "403098031", nome: "LODI", provincia: "LO" },
  { code: "420091104", nome: "LODINE", provincia: "NU" },
  { code: "403017090", nome: "LODRINO", provincia: "BS" },
  { code: "403017091", nome: "LOGRATO", provincia: "BS" },
  { code: "408037034", nome: "LOIANO", provincia: "BO" },
  { code: "420090084", nome: "LOIRI PORTO SAN PAOLO", provincia: "SS" },
  { code: "403097044", nome: "LOMAGNA", provincia: "LC" },
  { code: "403013133", nome: "LOMAZZO", provincia: "CO" },
  { code: "401001135", nome: "LOMBARDORE", provincia: "TO" },
  { code: "401001136", nome: "LOMBRIASCO", provincia: "TO" },
  { code: "403018083", nome: "LOMELLO", provincia: "PV" },
  { code: "404022108", nome: "LONA-LASES", provincia: "TN" },
  { code: "403012089", nome: "LONATE CEPPINO", provincia: "VA" },
  { code: "403012090", nome: "LONATE POZZOLO", provincia: "VA" },
  { code: "403017992", nome: "LONATO DEL GARDA", provincia: "BS" },
  { code: "409048025", nome: "LONDA", provincia: "FI" },
  { code: "414094024", nome: "LONGANO", provincia: "IS" },
  { code: "405024051", nome: "LONGARE", provincia: "VI" },
  { code: "405025071", nome: "LONGARONE", provincia: "BL" },
  { code: "403017093", nome: "LONGHENA", provincia: "BS" },
  { code: "419083042", nome: "LONGI", provincia: "ME" },
  { code: "408140018", nome: "LONGIANO", provincia: "FC" },
  { code: "418078067", nome: "LONGOBARDI", provincia: "CS" },
  { code: "418078068", nome: "LONGOBUCCO", provincia: "CS" },
  { code: "403013134", nome: "LONGONE AL SEGRINO", provincia: "CO" },
  { code: "412057034", nome: "LONGONE SABINO", provincia: "RI" },
  { code: "405024052", nome: "LONIGO", provincia: "VI" },
  { code: "401001137", nome: "LORANZE\'", provincia: "TO" },
  { code: "405028046", nome: "LOREGGIA", provincia: "PD" },
  { code: "401103038", nome: "LOREGLIA", provincia: "VB" },
  { code: "405025032", nome: "LORENZAGO DI CADORE", provincia: "BL" },
  { code: "405029030", nome: "LOREO", provincia: "RO" },
  { code: "413068021", nome: "LORETO APRUTINO", provincia: "PE" },
  { code: "411042022", nome: "LORETO", provincia: "AN" },
  { code: "405026036", nome: "LORIA", provincia: "TV" },
  { code: "409051020", nome: "LORO CIUFFENNA", provincia: "AR" },
  { code: "411043022", nome: "LORO PICENO", provincia: "MC" },
  { code: "407010030", nome: "LORSICA", provincia: "GE" },
  { code: "403017094", nome: "LOSINE", provincia: "BS" },
  { code: "420091042", nome: "LOTZORAI", provincia: "NU" },
  { code: "403016128", nome: "LOVERE", provincia: "BG" },
  { code: "403014038", nome: "LOVERO", provincia: "SO" },
  { code: "403017095", nome: "LOZIO", provincia: "BS" },
  { code: "403012091", nome: "LOZZA", provincia: "VA" },
  { code: "405028047", nome: "LOZZO ATESTINO", provincia: "PD" },
  { code: "405025033", nome: "LOZZO DI CADORE", provincia: "BL" },
  { code: "401002072", nome: "LOZZOLO", provincia: "VC" },
  { code: "401006193", nome: "LU E CUCCARO MONFERRATO", provincia: "AL" },
  { code: "412056033", nome: "LUBRIANO", provincia: "VT" },
  { code: "419084022", nome: "LUCCA SICULA", provincia: "AG" },
  { code: "409046017", nome: "LUCCA", provincia: "LU" },
  { code: "416071028", nome: "LUCERA", provincia: "FG" },
  { code: "409051021", nome: "LUCIGNANO", provincia: "AR" },
  { code: "407008033", nome: "LUCINASCO", provincia: "IM" },
  { code: "414070033", nome: "LUCITO", provincia: "CB" },
  { code: "413066051", nome: "LUCO DEI MARSI", provincia: "AQ" },
  { code: "413066052", nome: "LUCOLI", provincia: "AQ" },
  { code: "408033026", nome: "LUGAGNANO VAL D\'ARDA", provincia: "PC" },
  { code: "410055016", nome: "LUGNANO IN TEVERINA", provincia: "TR" },
  { code: "405024053", nome: "LUGO DI VICENZA", provincia: "VI" },
  { code: "408039012", nome: "LUGO", provincia: "RA" },
  { code: "403012092", nome: "LUINO", provincia: "VA" },
  { code: "403013135", nome: "LUISAGO", provincia: "CO" },
  { code: "420091043", nome: "LULA", provincia: "NU" },
  { code: "407010031", nome: "LUMARZO", provincia: "GE" },
  { code: "403017096", nome: "LUMEZZANE", provincia: "BS" },
  { code: "420092035", nome: "LUNAMATRONA", provincia: "CA" },
  { code: "411141022", nome: "LUNANO", provincia: "PU" },
  { code: "403018084", nome: "LUNGAVILLA", provincia: "PV" },
  { code: "418078069", nome: "LUNGRO", provincia: "CS" },
  { code: "407011920", nome: "LUNI", provincia: "SP" },
  { code: "415064045", nome: "LUOGOSANO", provincia: "AV" },
  { code: "420090036", nome: "LUOGOSANTO", provincia: "SS" },
  { code: "414070034", nome: "LUPARA", provincia: "CB" },
  { code: "403013136", nome: "LURAGO D\'ERBA", provincia: "CO" },
  { code: "403013137", nome: "LURAGO MARINONE", provincia: "CO" },
  { code: "403016129", nome: "LURANO", provincia: "BG" },
  { code: "420090037", nome: "LURAS", provincia: "SS" },
  { code: "403013138", nome: "LURATE CACCIVIO", provincia: "CO" },
  { code: "415061046", nome: "LUSCIANO", provincia: "CE" },
  { code: "401001139", nome: "LUSERNA SAN GIOVANNI", provincia: "TO" },
  { code: "404022109", nome: "LUSERNA", provincia: "TN" },
  { code: "401001140", nome: "LUSERNETTA", provincia: "TO" },
  { code: "406030051", nome: "LUSEVERA", provincia: "UD" },
  { code: "405029031", nome: "LUSIA", provincia: "RO" },
  { code: "405024127", nome: "LUSIANA CONCO", provincia: "VI" },
  { code: "401001141", nome: "LUSIGLIE\'", provincia: "TO" },
  { code: "404021044", nome: "LUSON", provincia: "BZ" },
  { code: "415065064", nome: "LUSTRA", provincia: "SA" },
  { code: "403012093", nome: "LUVINATE", provincia: "VA" },
  { code: "403016130", nome: "LUZZANA", provincia: "BG" },
  { code: "408035026", nome: "LUZZARA", provincia: "RE" },
  { code: "418078070", nome: "LUZZI", provincia: "CS" },
  { code: "403012142", nome: "MACCAGNO CON PINO E VEDDASCA", provincia: "VA" },
  { code: "403098033", nome: "MACCASTORNA", provincia: "LO" },
  { code: "414094025", nome: "MACCHIA D\'ISERNIA", provincia: "IS" },
  { code: "414070035", nome: "MACCHIA VALFORTORE", provincia: "CB" },
  { code: "414094026", nome: "MACCHIAGODENA", provincia: "IS" },
  { code: "401001142", nome: "MACELLO", provincia: "TO" },
  { code: "415061047", nome: "MACERATA CAMPANIA", provincia: "CE" },
  { code: "411141023", nome: "MACERATA FELTRIA", provincia: "PU" },
  { code: "411043023", nome: "MACERATA", provincia: "MC" },
  { code: "403108029", nome: "MACHERIO", provincia: "MB" },
  { code: "403017097", nome: "MACLODIO", provincia: "BS" },
  { code: "420091044", nome: "MACOMER", provincia: "NU" },
  { code: "401004112", nome: "MACRA", provincia: "CN" },
  { code: "401103039", nome: "MACUGNAGA", provincia: "VB" },
  { code: "415061048", nome: "MADDALONI", provincia: "CE" },
  { code: "403014035", nome: "MADESIMO", provincia: "SO" },
  { code: "403019055", nome: "MADIGNANO", provincia: "CR" },
  { code: "403016131", nome: "MADONE", provincia: "BG" },
  { code: "401103040", nome: "MADONNA DEL SASSO", provincia: "VB" },
  { code: "404022243", nome: "MADRUZZO", provincia: "TN" },
  { code: "412059013", nome: "MAENZA", provincia: "LT" },
  { code: "414070036", nome: "MAFALDA", provincia: "CB" },
  { code: "403017098", nome: "MAGASA", provincia: "BS" },
  { code: "403015130", nome: "MAGENTA", provincia: "MI" },
  { code: "401003088", nome: "MAGGIORA", provincia: "NO" },
  { code: "403018085", nome: "MAGHERNO", provincia: "PV" },
  { code: "410054026", nome: "MAGIONE", provincia: "PG" },
  { code: "418079068", nome: "MAGISANO", provincia: "CZ" },
  { code: "401004113", nome: "MAGLIANO ALFIERI", provincia: "CN" },
  { code: "401004114", nome: "MAGLIANO ALPI", provincia: "CN" },
  { code: "413066053", nome: "MAGLIANO DE\' MARSI", provincia: "AQ" },
  { code: "411109010", nome: "MAGLIANO DI TENNA", provincia: "FM" },
  { code: "409053013", nome: "MAGLIANO IN TOSCANA", provincia: "GR" },
  { code: "412058052", nome: "MAGLIANO ROMANO", provincia: "RM" },
  { code: "412057035", nome: "MAGLIANO SABINA", provincia: "RI" },
  { code: "415065065", nome: "MAGLIANO VETERE", provincia: "SA" },
  { code: "416075039", nome: "MAGLIE", provincia: "LE" },
  { code: "407009035", nome: "MAGLIOLO", provincia: "SV" },
  { code: "401001143", nome: "MAGLIONE", provincia: "TO" },
  { code: "403020029", nome: "MAGNACAVALLO", provincia: "MN" },
  { code: "403015131", nome: "MAGNAGO", provincia: "MI" },
  { code: "406030052", nome: "MAGNANO IN RIVIERA", provincia: "UD" },
  { code: "401096030", nome: "MAGNANO", provincia: "BI" },
  { code: "420091045", nome: "MAGOMADAS", provincia: "NU" },
  { code: "404021045", nome: "MAGRE\' SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "403013139", nome: "MAGREGLIO", provincia: "CO" },
  { code: "418079069", nome: "MAIDA", provincia: "CZ" },
  { code: "418078071", nome: "MAIERA\'", provincia: "CS" },
  { code: "418102020", nome: "MAIERATO", provincia: "VV" },
  { code: "411042023", nome: "MAIOLATI SPONTINI", provincia: "AN" },
  { code: "408099022", nome: "MAIOLO", provincia: "RN" },
  { code: "415065066", nome: "MAIORI", provincia: "SA" },
  { code: "403098034", nome: "MAIRAGO", provincia: "LO" },
  { code: "403017099", nome: "MAIRANO", provincia: "BS" },
  { code: "407011018", nome: "MAISSANA", provincia: "SP" },
  { code: "406030053", nome: "MAJANO", provincia: "UD" },
  { code: "403019056", nome: "MALAGNINO", provincia: "CR" },
  { code: "408037035", nome: "MALALBERGO", provincia: "BO" },
  { code: "406030054", nome: "MALBORGHETTO-VALBRUNA", provincia: "UD" },
  { code: "405023045", nome: "MALCESINE", provincia: "VR" },
  { code: "404022110", nome: "MALE\'", provincia: "TN" },
  { code: "403017100", nome: "MALEGNO", provincia: "BS" },
  { code: "403098035", nome: "MALEO", provincia: "LO" },
  { code: "401103041", nome: "MALESCO", provincia: "VB" },
  { code: "419087022", nome: "MALETTO", provincia: "CT" },
  { code: "419083043", nome: "MALFA", provincia: "ME" },
  { code: "403097045", nome: "MALGRATE", provincia: "LC" },
  { code: "418078072", nome: "MALITO", provincia: "CS" },
  { code: "407009036", nome: "MALLARE", provincia: "SV" },
  { code: "404021046", nome: "MALLES VENOSTA", provincia: "BZ" },
  { code: "403012096", nome: "MALNATE", provincia: "VA" },
  { code: "405024055", nome: "MALO", provincia: "VI" },
  { code: "403017101", nome: "MALONNO", provincia: "BS" },
  { code: "411044027", nome: "MALTIGNANO", provincia: "AP" },
  { code: "419083044", nome: "MALVAGNA", provincia: "ME" },
  { code: "401006090", nome: "MALVICINO", provincia: "AL" },
  { code: "418078073", nome: "MALVITO", provincia: "CS" },
  { code: "418080044", nome: "MAMMOLA", provincia: "RC" },
  { code: "420091046", nome: "MAMOIADA", provincia: "NU" },
  { code: "409053014", nome: "MANCIANO", provincia: "GR" },
  { code: "419083045", nome: "MANDANICI", provincia: "ME" },
  { code: "420092036", nome: "MANDAS", provincia: "CA" },
  { code: "418078074", nome: "MANDATORICCIO", provincia: "CS" },
  { code: "412058053", nome: "MANDELA", provincia: "RM" },
  { code: "403097046", nome: "MANDELLO DEL LARIO", provincia: "LC" },
  { code: "401003090", nome: "MANDELLO VITTA", provincia: "NO" },
  { code: "416073012", nome: "MANDURIA", provincia: "TA" },
  { code: "403017102", nome: "MANERBA DEL GARDA", provincia: "BS" },
  { code: "403017103", nome: "MANERBIO", provincia: "BS" },
  { code: "416071029", nome: "MANFREDONIA", provincia: "FG" },
  { code: "401004115", nome: "MANGO", provincia: "CN" },
  { code: "418078075", nome: "MANGONE", provincia: "CS" },
  { code: "419087057", nome: "MANIACE", provincia: "CT" },
  { code: "406093025", nome: "MANIAGO", provincia: "PN" },
  { code: "415064046", nome: "MANOCALZATI", provincia: "AV" },
  { code: "413068022", nome: "MANOPPELLO", provincia: "PE" },
  { code: "405026037", nome: "MANSUE\'", provincia: "TV" },
  { code: "401004116", nome: "MANTA", provincia: "CN" },
  { code: "403014039", nome: "MANTELLO", provincia: "SO" },
  { code: "403020030", nome: "MANTOVA", provincia: "MN" },
  { code: "406030055", nome: "MANZANO", provincia: "UD" },
  { code: "412058054", nome: "MANZIANA", provincia: "RM" },
  { code: "403016132", nome: "MAPELLO", provincia: "BG" },
  { code: "401001316", nome: "MAPPANO", provincia: "TO" },
  { code: "420090038", nome: "MARA", provincia: "SS" },
  { code: "420092037", nome: "MARACALAGONIS", provincia: "CA" },
  { code: "408036019", nome: "MARANELLO", provincia: "MO" },
  { code: "415063041", nome: "MARANO DI NAPOLI", provincia: "NA" },
  { code: "405023046", nome: "MARANO DI VALPOLICELLA", provincia: "VR" },
  { code: "412058055", nome: "MARANO EQUO", provincia: "RM" },
  { code: "406030056", nome: "MARANO LAGUNARE", provincia: "UD" },
  { code: "418078076", nome: "MARANO MARCHESATO", provincia: "CS" },
  { code: "418078077", nome: "MARANO PRINCIPATO", provincia: "CS" },
  { code: "408036020", nome: "MARANO SUL PANARO", provincia: "MO" },
  { code: "401003091", nome: "MARANO TICINO", provincia: "NO" },
  { code: "405024056", nome: "MARANO VICENTINO", provincia: "VI" },
  { code: "401005061", nome: "MARANZANA", provincia: "AT" },
  { code: "417076044", nome: "MARATEA", provincia: "PZ" },
  { code: "403015134", nome: "MARCALLO CON CASONE", provincia: "MI" },
  { code: "403020031", nome: "MARCARIA", provincia: "MN" },
  { code: "418079071", nome: "MARCEDUSA", provincia: "CZ" },
  { code: "412058056", nome: "MARCELLINA", provincia: "RM" },
  { code: "418079072", nome: "MARCELLINARA", provincia: "CZ" },
  { code: "412057036", nome: "MARCETELLI", provincia: "RI" },
  { code: "403017104", nome: "MARCHENO", provincia: "BS" },
  { code: "403012097", nome: "MARCHIROLO", provincia: "VA" },
  { code: "409049011", nome: "MARCIANA MARINA", provincia: "LI" },
  { code: "409049010", nome: "MARCIANA", provincia: "LI" },
  { code: "415061049", nome: "MARCIANISE", provincia: "CE" },
  { code: "409051022", nome: "MARCIANO DELLA CHIANA", provincia: "AR" },
  { code: "403018086", nome: "MARCIGNAGO", provincia: "PV" },
  { code: "405027020", nome: "MARCON", provincia: "VE" },
  { code: "404021047", nome: "MAREBBE", provincia: "BZ" },
  { code: "401004117", nome: "MARENE", provincia: "CN" },
  { code: "405026038", nome: "MARENO DI PIAVE", provincia: "TV" },
  { code: "401001144", nome: "MARENTINO", provincia: "TO" },
  { code: "401005062", nome: "MARETTO", provincia: "AT" },
  { code: "401004118", nome: "MARGARITA", provincia: "CN" },
  { code: "416110005", nome: "MARGHERITA DI SAVOIA", provincia: "BT" },
  { code: "403097047", nome: "MARGNO", provincia: "LC" },
  { code: "403020032", nome: "MARIANA MANTOVANA", provincia: "MN" },
  { code: "403013143", nome: "MARIANO COMENSE", provincia: "CO" },
  { code: "406031010", nome: "MARIANO DEL FRIULI", provincia: "GO" },
  { code: "419085008", nome: "MARIANOPOLI", provincia: "CL" },
  { code: "415063042", nome: "MARIGLIANELLA", provincia: "NA" },
  { code: "415063043", nome: "MARIGLIANO", provincia: "NA" },
  { code: "418080045", nome: "MARINA DI GIOIOSA IONICA", provincia: "RC" },
  { code: "419082046", nome: "MARINEO", provincia: "PA" },
  { code: "412058057", nome: "MARINO", provincia: "RM" },
  { code: "404021048", nome: "MARLENGO", provincia: "BZ" },
  { code: "409047007", nome: "MARLIANA", provincia: "PT" },
  { code: "403017105", nome: "MARMENTINO", provincia: "BS" },
  { code: "403020033", nome: "MARMIROLO", provincia: "MN" },
  { code: "401004119", nome: "MARMORA", provincia: "CN" },
  { code: "403012098", nome: "MARNATE", provincia: "VA" },
  { code: "403017106", nome: "MARONE", provincia: "BS" },
  { code: "418080046", nome: "MAROPATI", provincia: "RC" },
  { code: "405024057", nome: "MAROSTICA", provincia: "VI" },
  { code: "409048026", nome: "MARRADI", provincia: "FI" },
  { code: "420095025", nome: "MARRUBIU", provincia: "OR" },
  { code: "401004120", nome: "MARSAGLIA", provincia: "CN" },
  { code: "419081011", nome: "MARSALA", provincia: "TP" },
  { code: "410054027", nome: "MARSCIANO", provincia: "PG" },
  { code: "417076045", nome: "MARSICO NUOVO", provincia: "PZ" },
  { code: "417076046", nome: "MARSICOVETERE", provincia: "PZ" },
  { code: "412056034", nome: "MARTA", provincia: "VT" },
  { code: "416075040", nome: "MARTANO", provincia: "LE" },
  { code: "405027021", nome: "MARTELLAGO", provincia: "VE" },
  { code: "404021049", nome: "MARTELLO", provincia: "BZ" },
  { code: "406030057", nome: "MARTIGNACCO", provincia: "UD" },
  { code: "403019057", nome: "MARTIGNANA DI PO", provincia: "CR" },
  { code: "416075041", nome: "MARTIGNANO", provincia: "LE" },
  { code: "416073013", nome: "MARTINA FRANCA", provincia: "TA" },
  { code: "403016133", nome: "MARTINENGO", provincia: "BG" },
  { code: "401004121", nome: "MARTINIANA PO", provincia: "CN" },
  { code: "413067047", nome: "MARTINSICURO", provincia: "TE" },
  { code: "418079074", nome: "MARTIRANO LOMBARDO", provincia: "CZ" },
  { code: "418079073", nome: "MARTIRANO", provincia: "CZ" },
  { code: "420090039", nome: "MARTIS", provincia: "SS" },
  { code: "418080047", nome: "MARTONE", provincia: "RC" },
  { code: "403098036", nome: "MARUDO", provincia: "LO" },
  { code: "416073014", nome: "MARUGGIO", provincia: "TA" },
  { code: "408037036", nome: "MARZABOTTO", provincia: "BO" },
  { code: "415061050", nome: "MARZANO APPIO", provincia: "CE" },
  { code: "415064047", nome: "MARZANO DI NOLA", provincia: "AV" },
  { code: "403018087", nome: "MARZANO", provincia: "PV" },
  { code: "418078078", nome: "MARZI", provincia: "CS" },
  { code: "403012099", nome: "MARZIO", provincia: "VA" },
  { code: "420092103", nome: "MASAINAS", provincia: "CA" },
  { code: "403015136", nome: "MASATE", provincia: "MI" },
  { code: "419087023", nome: "MASCALI", provincia: "CT" },
  { code: "419087024", nome: "MASCALUCIA", provincia: "CT" },
  { code: "417076047", nome: "MASCHITO", provincia: "PZ" },
  { code: "403012100", nome: "MASCIAGO PRIMO", provincia: "VA" },
  { code: "405026039", nome: "MASER", provincia: "TV" },
  { code: "405028048", nome: "MASERA\' DI PADOVA", provincia: "PD" },
  { code: "401103042", nome: "MASERA", provincia: "VB" },
  { code: "405026040", nome: "MASERADA SUL PIAVE", provincia: "TV" },
  { code: "408038012", nome: "MASI TORELLO", provincia: "FE" },
  { code: "405028049", nome: "MASI", provincia: "PD" },
  { code: "401006091", nome: "MASIO", provincia: "AL" },
  { code: "403013144", nome: "MASLIANICO", provincia: "CO" },
  { code: "407010032", nome: "MASONE", provincia: "GE" },
  { code: "413066054", nome: "MASSA D\'ALBE", provincia: "AQ" },
  { code: "415063092", nome: "MASSA DI SOMMA", provincia: "NA" },
  { code: "409047008", nome: "MASSA E COZZILE", provincia: "PT" },
  { code: "411109011", nome: "MASSA FERMANA", provincia: "FM" },
  { code: "408039013", nome: "MASSA LOMBARDA", provincia: "RA" },
  { code: "415063044", nome: "MASSA LUBRENSE", provincia: "NA" },
  { code: "409053015", nome: "MASSA MARITTIMA", provincia: "GR" },
  { code: "410054028", nome: "MASSA MARTANA", provincia: "PG" },
  { code: "409045010", nome: "MASSA", provincia: "MS" },
  { code: "416073015", nome: "MASSAFRA", provincia: "TA" },
  { code: "403098037", nome: "MASSALENGO", provincia: "LO" },
  { code: "405028050", nome: "MASSANZAGO", provincia: "PD" },
  { code: "409046018", nome: "MASSAROSA", provincia: "LU" },
  { code: "401096031", nome: "MASSAZZA", provincia: "BI" },
  { code: "401001145", nome: "MASSELLO", provincia: "TO" },
  { code: "401096032", nome: "MASSERANO", provincia: "BI" },
  { code: "411044029", nome: "MASSIGNANO", provincia: "AP" },
  { code: "404022112", nome: "MASSIMENO", provincia: "TN" },
  { code: "407009037", nome: "MASSIMINO", provincia: "SV" },
  { code: "401003093", nome: "MASSINO VISCONTI", provincia: "NO" },
  { code: "401103043", nome: "MASSIOLA", provincia: "VB" },
  { code: "420095026", nome: "MASULLAS", provincia: "OR" },
  { code: "411043024", nome: "MATELICA", provincia: "MC" },
  { code: "417077014", nome: "MATERA", provincia: "MT" },
  { code: "401001146", nome: "MATHI", provincia: "TO" },
  { code: "416075042", nome: "MATINO", provincia: "LE" },
  { code: "414070037", nome: "MATRICE", provincia: "CB" },
  { code: "401001147", nome: "MATTIE", provincia: "TO" },
  { code: "416071031", nome: "MATTINATA", provincia: "FG" },
  { code: "419081012", nome: "MAZARA DEL VALLO", provincia: "TP" },
  { code: "412058058", nome: "MAZZANO ROMANO", provincia: "RM" },
  { code: "403017107", nome: "MAZZANO", provincia: "BS" },
  { code: "419085009", nome: "MAZZARINO", provincia: "CL" },
  { code: "419083046", nome: "MAZZARRA\' SANT\'ANDREA", provincia: "ME" },
  { code: "419087056", nome: "MAZZARRONE", provincia: "CT" },
  { code: "401001148", nome: "MAZZE\'", provincia: "TO" },
  { code: "404022113", nome: "MAZZIN", provincia: "TN" },
  { code: "403014040", nome: "MAZZO DI VALTELLINA", provincia: "SO" },
  { code: "401001149", nome: "MEANA DI SUSA", provincia: "TO" },
  { code: "420091047", nome: "MEANA SARDO", provincia: "NU" },
  { code: "403108030", nome: "MEDA", provincia: "MB" },
  { code: "403018088", nome: "MEDE", provincia: "PV" },
  { code: "406031011", nome: "MEDEA", provincia: "GO" },
  { code: "408034020", nome: "MEDESANO", provincia: "PR" },
  { code: "408037037", nome: "MEDICINA", provincia: "BO" },
  { code: "403015139", nome: "MEDIGLIA", provincia: "MI" },
  { code: "403016250", nome: "MEDOLAGO", provincia: "BG" },
  { code: "403020034", nome: "MEDOLE", provincia: "MN" },
  { code: "408036021", nome: "MEDOLLA", provincia: "MO" },
  { code: "405026041", nome: "MEDUNA DI LIVENZA", provincia: "TV" },
  { code: "406093026", nome: "MEDUNO", provincia: "PN" },
  { code: "405028052", nome: "MEGLIADINO SAN VITALE", provincia: "PD" },
  { code: "401003095", nome: "MEINA", provincia: "NO" },
  { code: "405029032", nome: "MELARA", provincia: "RO" },
  { code: "401006092", nome: "MELAZZO", provincia: "AL" },
  { code: "408140019", nome: "MELDOLA", provincia: "FC" },
  { code: "407010033", nome: "MELE", provincia: "GE" },
  { code: "403015140", nome: "MELEGNANO", provincia: "MI" },
  { code: "416075043", nome: "MELENDUGNO", provincia: "LE" },
  { code: "403098038", nome: "MELETI", provincia: "LO" },
  { code: "417076048", nome: "MELFI", provincia: "PZ" },
  { code: "418080048", nome: "MELICUCCA\'", provincia: "RC" },
  { code: "418080049", nome: "MELICUCCO", provincia: "RC" },
  { code: "419089012", nome: "MELILLI", provincia: "SR" },
  { code: "418101014", nome: "MELISSA", provincia: "KR" },
  { code: "416075044", nome: "MELISSANO", provincia: "LE" },
  { code: "415063045", nome: "MELITO DI NAPOLI", provincia: "NA" },
  { code: "418080050", nome: "MELITO DI PORTO SALVO", provincia: "RC" },
  { code: "415064048", nome: "MELITO IRPINO", provincia: "AV" },
  { code: "415062039", nome: "MELIZZANO", provincia: "BN" },
  { code: "401004122", nome: "MELLE", provincia: "CN" },
  { code: "403014041", nome: "MELLO", provincia: "SO" },
  { code: "416075045", nome: "MELPIGNANO", provincia: "LE" },
  { code: "404021050", nome: "MELTINA", provincia: "BZ" },
  { code: "403015142", nome: "MELZO", provincia: "MI" },
  { code: "403013145", nome: "MENAGGIO", provincia: "CO" },
  { code: "403018089", nome: "MENCONICO", provincia: "PV" },
  { code: "407008034", nome: "MENDATICA", provincia: "IM" },
  { code: "418078079", nome: "MENDICINO", provincia: "CS" },
  { code: "419084023", nome: "MENFI", provincia: "AG" },
  { code: "412058059", nome: "MENTANA", provincia: "RM" },
  { code: "405027022", nome: "MEOLO", provincia: "VE" },
  { code: "401006093", nome: "MERANA", provincia: "AL" },
  { code: "404021051", nome: "MERANO", provincia: "BZ" },
  { code: "403097048", nome: "MERATE", provincia: "LC" },
  { code: "403012101", nome: "MERCALLO", provincia: "VA" },
  { code: "411141025", nome: "MERCATELLO SUL METAURO", provincia: "PU" },
  { code: "411141026", nome: "MERCATINO CONCA", provincia: "PU" },
  { code: "415065067", nome: "MERCATO SAN SEVERINO", provincia: "SA" },
  { code: "408140020", nome: "MERCATO SARACENO", provincia: "FC" },
  { code: "401001150", nome: "MERCENASCO", provincia: "TO" },
  { code: "415064049", nome: "MERCOGLIANO", provincia: "AV" },
  { code: "406030058", nome: "MERETO DI TOMBA", provincia: "UD" },
  { code: "411042024", nome: "MERGO", provincia: "AN" },
  { code: "401103044", nome: "MERGOZZO", provincia: "VB" },
  { code: "419083047", nome: "MERI\'", provincia: "ME" },
  { code: "405028053", nome: "MERLARA", provincia: "PD" },
  { code: "403098039", nome: "MERLINO", provincia: "LO" },
  { code: "403013147", nome: "MERONE", provincia: "CO" },
  { code: "416074010", nome: "MESAGNE", provincia: "BR" },
  { code: "403014043", nome: "MESE", provincia: "SO" },
  { code: "403012102", nome: "MESENZANA", provincia: "VA" },
  { code: "403015144", nome: "MESERO", provincia: "MI" },
  { code: "408038014", nome: "MESOLA", provincia: "FE" },
  { code: "418101015", nome: "MESORACA", provincia: "KR" },
  { code: "419083048", nome: "MESSINA", provincia: "ME" },
  { code: "405028054", nome: "MESTRINO", provincia: "PD" },
  { code: "415063046", nome: "META", provincia: "NA" },
  { code: "403108031", nome: "MEZZAGO", provincia: "MB" },
  { code: "403018090", nome: "MEZZANA BIGLI", provincia: "PV" },
  { code: "401096033", nome: "MEZZANA MORTIGLIENGO", provincia: "BI" },
  { code: "403018091", nome: "MEZZANA RABATTONE", provincia: "PV" },
  { code: "404022114", nome: "MEZZANA", provincia: "TN" },
  { code: "405023047", nome: "MEZZANE DI SOTTO", provincia: "VR" },
  { code: "407010034", nome: "MEZZANEGO", provincia: "GE" },
  { code: "403018092", nome: "MEZZANINO", provincia: "PV" },
  { code: "404022115", nome: "MEZZANO", provincia: "TN" },
  { code: "401001152", nome: "MEZZENILE", provincia: "TO" },
  { code: "404022116", nome: "MEZZOCORONA", provincia: "TN" },
  { code: "419082047", nome: "MEZZOJUSO", provincia: "PA" },
  { code: "403016134", nome: "MEZZOLDO", provincia: "BG" },
  { code: "404022117", nome: "MEZZOLOMBARDO", provincia: "TN" },
  { code: "401003097", nome: "MEZZOMERICO", provincia: "NO" },
  { code: "401096034", nome: "MIAGLIANO", provincia: "BI" },
  { code: "405026042", nome: "MIANE", provincia: "TV" },
  { code: "401003098", nome: "MIASINO", provincia: "NO" },
  { code: "401103045", nome: "MIAZZINA", provincia: "VB" },
  { code: "412057037", nome: "MICIGLIANO", provincia: "RI" },
  { code: "416075046", nome: "MIGGIANO", provincia: "LE" },
  { code: "413069050", nome: "MIGLIANICO", provincia: "CH" },
  { code: "418079077", nome: "MIGLIERINA", provincia: "CZ" },
  { code: "417077015", nome: "MIGLIONICO", provincia: "MT" },
  { code: "407010035", nome: "MIGNANEGO", provincia: "GE" },
  { code: "415061051", nome: "MIGNANO MONTE LUNGO", provincia: "CE" },
  { code: "403015146", nome: "MILANO", provincia: "MI" },
  { code: "419083049", nome: "MILAZZO", provincia: "ME" },
  { code: "419085010", nome: "MILENA", provincia: "CL" },
  { code: "418102021", nome: "MILETO", provincia: "VV" },
  { code: "420095027", nome: "MILIS", provincia: "OR" },
  { code: "419087025", nome: "MILITELLO IN VAL DI CATANIA", provincia: "CT" },
  { code: "419083050", nome: "MILITELLO ROSMARINO", provincia: "ME" },
  { code: "407009038", nome: "MILLESIMO", provincia: "SV" },
  { code: "419087026", nome: "MILO", provincia: "CT" },
  { code: "403017108", nome: "MILZANO", provincia: "BS" },
  { code: "419087027", nome: "MINEO", provincia: "CT" },
  { code: "405023048", nome: "MINERBE", provincia: "VR" },
  { code: "408037038", nome: "MINERBIO", provincia: "BO" },
  { code: "416075047", nome: "MINERVINO DI LECCE", provincia: "LE" },
  { code: "416110006", nome: "MINERVINO MURGE", provincia: "BT" },
  { code: "415065068", nome: "MINORI", provincia: "SA" },
  { code: "412059014", nome: "MINTURNO", provincia: "LT" },
  { code: "409046019", nome: "MINUCCIANO", provincia: "LU" },
  { code: "407009039", nome: "MIOGLIA", provincia: "SV" },
  { code: "405027023", nome: "MIRA", provincia: "VE" },
  { code: "415064050", nome: "MIRABELLA ECLANO", provincia: "AV" },
  { code: "419087028", nome: "MIRABELLA IMBACCARI", provincia: "CT" },
  { code: "401006094", nome: "MIRABELLO MONFERRATO", provincia: "AL" },
  { code: "414070038", nome: "MIRABELLO SANNITICO", provincia: "CB" },
  { code: "403018093", nome: "MIRADOLO TERME", provincia: "PV" },
  { code: "414094027", nome: "MIRANDA", provincia: "IS" },
  { code: "408036022", nome: "MIRANDOLA", provincia: "MO" },
  { code: "405027024", nome: "MIRANO", provincia: "VE" },
  { code: "419083051", nome: "MIRTO", provincia: "ME" },
  { code: "408099005", nome: "MISANO ADRIATICO", provincia: "RN" },
  { code: "403016135", nome: "MISANO DI GERA D\'ADDA", provincia: "BG" },
  { code: "419081025", nome: "MISILISCEMI", provincia: "TP" },
  { code: "419082048", nome: "MISILMERI", provincia: "PA" },
  { code: "403108032", nome: "MISINTO", provincia: "MB" },
  { code: "403097049", nome: "MISSAGLIA", provincia: "LC" },
  { code: "417076049", nome: "MISSANELLO", provincia: "PZ" },
  { code: "419087029", nome: "MISTERBIANCO", provincia: "CT" },
  { code: "419083052", nome: "MISTRETTA", provincia: "ME" },
  { code: "401005063", nome: "MOASCA", provincia: "AT" },
  { code: "407010036", nome: "MOCONESI", provincia: "GE" },
  { code: "408036023", nome: "MODENA", provincia: "MO" },
  { code: "419088006", nome: "MODICA", provincia: "RG" },
  { code: "408140022", nome: "MODIGLIANA", provincia: "FC" },
  { code: "420091048", nome: "MODOLO", provincia: "NU" },
  { code: "416072027", nome: "MODUGNO", provincia: "BA" },
  { code: "404022118", nome: "MOENA", provincia: "TN" },
  { code: "406030059", nome: "MOGGIO UDINESE", provincia: "UD" },
  { code: "403097050", nome: "MOGGIO", provincia: "LC" },
  { code: "403020035", nome: "MOGLIA", provincia: "MN" },
  { code: "405026043", nome: "MOGLIANO VENETO", provincia: "TV" },
  { code: "411043025", nome: "MOGLIANO", provincia: "MC" },
  { code: "420095028", nome: "MOGORELLA", provincia: "OR" },
  { code: "420095029", nome: "MOGORO", provincia: "OR" },
  { code: "415062040", nome: "MOIANO", provincia: "BN" },
  { code: "406030060", nome: "MOIMACCO", provincia: "UD" },
  { code: "419083053", nome: "MOIO ALCANTARA", provincia: "ME" },
  { code: "403016136", nome: "MOIO DE\' CALVI", provincia: "BG" },
  { code: "415065069", nome: "MOIO DELLA CIVITELLA", provincia: "SA" },
  { code: "401004123", nome: "MOIOLA", provincia: "CN" },
  { code: "416072028", nome: "MOLA DI BARI", provincia: "BA" },
  { code: "401006095", nome: "MOLARE", provincia: "AL" },
  { code: "409046020", nome: "MOLAZZANA", provincia: "LU" },
  { code: "416072029", nome: "MOLFETTA", provincia: "BA" },
  { code: "413066055", nome: "MOLINA ATERNO", provincia: "AQ" },
  { code: "415062041", nome: "MOLINARA", provincia: "BN" },
  { code: "408037039", nome: "MOLINELLA", provincia: "BO" },
  { code: "407008035", nome: "MOLINI DI TRIORA", provincia: "IM" },
  { code: "401006096", nome: "MOLINO DEI TORTI", provincia: "AL" },
  { code: "414070039", nome: "MOLISE", provincia: "CB" },
  { code: "417076050", nome: "MOLITERNO", provincia: "PZ" },
  { code: "401002078", nome: "MOLLIA", provincia: "VC" },
  { code: "418080051", nome: "MOLOCHIO", provincia: "RC" },
  { code: "403097051", nome: "MOLTENO", provincia: "LC" },
  { code: "403013152", nome: "MOLTRASIO", provincia: "CO" },
  { code: "404022120", nome: "MOLVENO", provincia: "TN" },
  { code: "401005064", nome: "MOMBALDONE", provincia: "AT" },
  { code: "401004124", nome: "MOMBARCARO", provincia: "CN" },
  { code: "411141027", nome: "MOMBAROCCIO", provincia: "PU" },
  { code: "401005065", nome: "MOMBARUZZO", provincia: "AT" },
  { code: "401004125", nome: "MOMBASIGLIO", provincia: "CN" },
  { code: "401001153", nome: "MOMBELLO DI TORINO", provincia: "TO" },
  { code: "401006097", nome: "MOMBELLO MONFERRATO", provincia: "AL" },
  { code: "401005066", nome: "MOMBERCELLI", provincia: "AT" },
  { code: "401003100", nome: "MOMO", provincia: "NO" },
  { code: "401001154", nome: "MOMPANTERO", provincia: "TO" },
  { code: "412057038", nome: "MOMPEO", provincia: "RI" },
  { code: "401006098", nome: "MOMPERONE", provincia: "AL" },
  { code: "414070040", nome: "MONACILIONI", provincia: "CB" },
  { code: "401005067", nome: "MONALE", provincia: "AT" },
  { code: "418080052", nome: "MONASTERACE", provincia: "RC" },
  { code: "401005068", nome: "MONASTERO BORMIDA", provincia: "AT" },
  { code: "401001155", nome: "MONASTERO DI LANZO", provincia: "TO" },
  { code: "401004126", nome: "MONASTERO DI VASCO", provincia: "CN" },
  { code: "401004127", nome: "MONASTEROLO CASOTTO", provincia: "CN" },
  { code: "403016137", nome: "MONASTEROLO DEL CASTELLO", provincia: "BG" },
  { code: "401004128", nome: "MONASTEROLO DI SAVIGLIANO", provincia: "CN" },
  { code: "405026044", nome: "MONASTIER DI TREVISO", provincia: "TV" },
  { code: "420092038", nome: "MONASTIR", provincia: "CA" },
  { code: "401001156", nome: "MONCALIERI", provincia: "TO" },
  { code: "401005069", nome: "MONCALVO", provincia: "AT" },
  { code: "401001157", nome: "MONCENISIO", provincia: "TO" },
  { code: "401006099", nome: "MONCESTINO", provincia: "AL" },
  { code: "401004129", nome: "MONCHIERO", provincia: "CN" },
  { code: "408034022", nome: "MONCHIO DELLE CORTI", provincia: "PR" },
  { code: "401002079", nome: "MONCRIVELLO", provincia: "VC" },
  { code: "401005070", nome: "MONCUCCO TORINESE", provincia: "AT" },
  { code: "408099006", nome: "MONDAINO", provincia: "RN" },
  { code: "411141028", nome: "MONDAVIO", provincia: "PU" },
  { code: "411141029", nome: "MONDOLFO", provincia: "PU" },
  { code: "401004130", nome: "MONDOVI\'", provincia: "CN" },
  { code: "415061052", nome: "MONDRAGONE", provincia: "CE" },
  { code: "407010037", nome: "MONEGLIA", provincia: "GE" },
  { code: "401004131", nome: "MONESIGLIO", provincia: "CN" },
  { code: "406031012", nome: "MONFALCONE", provincia: "GO" },
  { code: "401004132", nome: "MONFORTE D\'ALBA", provincia: "CN" },
  { code: "419083054", nome: "MONFORTE SAN GIORGIO", provincia: "ME" },
  { code: "405026045", nome: "MONFUMO", provincia: "TV" },
  { code: "401005071", nome: "MONGARDINO", provincia: "AT" },
  { code: "408037040", nome: "MONGHIDORO", provincia: "BO" },
  { code: "418102022", nome: "MONGIANA", provincia: "VV" },
  { code: "401006100", nome: "MONGIARDINO LIGURE", provincia: "AL" },
  { code: "419083055", nome: "MONGIUFFI MELIA", provincia: "ME" },
  { code: "401096035", nome: "MONGRANDO", provincia: "BI" },
  { code: "418078080", nome: "MONGRASSANO", provincia: "CS" },
  { code: "404021952", nome: "MONGUELFO-TESIDO", provincia: "BZ" },
  { code: "403013153", nome: "MONGUZZO", provincia: "CO" },
  { code: "403017109", nome: "MONIGA DEL GARDA", provincia: "BS" },
  { code: "401006101", nome: "MONLEALE", provincia: "AL" },
  { code: "403017110", nome: "MONNO", provincia: "BS" },
  { code: "416072030", nome: "MONOPOLI", provincia: "BA" },
  { code: "419082049", nome: "MONREALE", provincia: "PA" },
  { code: "406032002", nome: "MONRUPINO", provincia: "TS" },
  { code: "411109012", nome: "MONSAMPIETRO MORICO", provincia: "FM" },
  { code: "411044031", nome: "MONSAMPOLO DEL TRONTO", provincia: "AP" },
  { code: "411042025", nome: "MONSANO", provincia: "AN" },
  { code: "405028055", nome: "MONSELICE", provincia: "PD" },
  { code: "420092109", nome: "MONSERRATO", provincia: "CA" },
  { code: "409047009", nome: "MONSUMMANO TERME", provincia: "PT" },
  { code: "401004133", nome: "MONTA\'", provincia: "CN" },
  { code: "401005072", nome: "MONTABONE", provincia: "AT" },
  { code: "401006102", nome: "MONTACUTO", provincia: "AL" },
  { code: "401005073", nome: "MONTAFIA", provincia: "AT" },
  { code: "414070041", nome: "MONTAGANO", provincia: "CB" },
  { code: "403014044", nome: "MONTAGNA IN VALTELLINA", provincia: "SO" },
  { code: "404021953", nome: "MONTAGNA SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "405028056", nome: "MONTAGNANA", provincia: "PD" },
  { code: "419083056", nome: "MONTAGNAREALE", provincia: "ME" },
  { code: "415064051", nome: "MONTAGUTO", provincia: "AV" },
  { code: "409048027", nome: "MONTAIONE", provincia: "FI" },
  { code: "419083057", nome: "MONTALBANO ELICONA", provincia: "ME" },
  { code: "417077016", nome: "MONTALBANO JONICO", provincia: "MT" },
  { code: "409052037", nome: "MONTALCINO", provincia: "SI" },
  { code: "401006103", nome: "MONTALDEO", provincia: "AL" },
  { code: "401006104", nome: "MONTALDO BORMIDA", provincia: "AL" },
  { code: "401004134", nome: "MONTALDO DI MONDOVI\'", provincia: "CN" },
  { code: "401004135", nome: "MONTALDO ROERO", provincia: "CN" },
  { code: "401005074", nome: "MONTALDO SCARAMPI", provincia: "AT" },
  { code: "401001158", nome: "MONTALDO TORINESE", provincia: "TO" },
  { code: "409047010", nome: "MONTALE", provincia: "PT" },
  { code: "401001159", nome: "MONTALENGHE", provincia: "TO" },
  { code: "419084024", nome: "MONTALLEGRO", provincia: "AG" },
  { code: "407008068", nome: "MONTALTO CARPASIO", provincia: "IM" },
  { code: "411044032", nome: "MONTALTO DELLE MARCHE", provincia: "AP" },
  { code: "412056035", nome: "MONTALTO DI CASTRO", provincia: "VT" },
  { code: "401001160", nome: "MONTALTO DORA", provincia: "TO" },
  { code: "403018094", nome: "MONTALTO PAVESE", provincia: "PV" },
  { code: "418078081", nome: "MONTALTO UFFUGO", provincia: "CS" },
  { code: "401001161", nome: "MONTANARO", provincia: "TO" },
  { code: "403098040", nome: "MONTANASO LOMBARDO", provincia: "LO" },
  { code: "401004136", nome: "MONTANERA", provincia: "CN" },
  { code: "415065070", nome: "MONTANO ANTILIA", provincia: "SA" },
  { code: "403013154", nome: "MONTANO LUCINO", provincia: "CO" },
  { code: "411109013", nome: "MONTAPPONE", provincia: "FM" },
  { code: "414094028", nome: "MONTAQUILA", provincia: "IS" },
  { code: "412057039", nome: "MONTASOLA", provincia: "RI" },
  { code: "418079080", nome: "MONTAURO", provincia: "CZ" },
  { code: "413069051", nome: "MONTAZZOLI", provincia: "CH" },
  { code: "409053016", nome: "MONTE ARGENTARIO", provincia: "GR" },
  { code: "410054029", nome: "MONTE CASTELLO DI VIBIO", provincia: "PG" },
  { code: "411043027", nome: "MONTE CAVALLO", provincia: "MC" },
  { code: "411141031", nome: "MONTE CERIGNONE", provincia: "PU" },
  { code: "412058060", nome: "MONTE COMPATRI", provincia: "RM" },
  { code: "403019058", nome: "MONTE CREMASCO", provincia: "CR" },
  { code: "405024063", nome: "MONTE DI MALO", provincia: "VI" },
  { code: "415063047", nome: "MONTE DI PROCIDA", provincia: "NA" },
  { code: "411109016", nome: "MONTE GIBERTO", provincia: "FM" },
  { code: "411141935", nome: "MONTE GRIMANO TERME", provincia: "PU" },
  { code: "403017111", nome: "MONTE ISOLA", provincia: "BS" },
  { code: "403097052", nome: "MONTE MARENZO", provincia: "LC" },
  { code: "412058064", nome: "MONTE PORZIO CATONE", provincia: "RM" },
  { code: "411141038", nome: "MONTE PORZIO", provincia: "PU" },
  { code: "411109021", nome: "MONTE RINALDO", provincia: "FM" },
  { code: "411042029", nome: "MONTE ROBERTO", provincia: "AN" },
  { code: "412056037", nome: "MONTE ROMANO", provincia: "VT" },
  { code: "412059015", nome: "MONTE SAN BIAGIO", provincia: "LT" },
  { code: "415065075", nome: "MONTE SAN GIACOMO", provincia: "SA" },
  { code: "412060044", nome: "MONTE SAN GIOVANNI CAMPANO", provincia: "FR" },
  { code: "412057043", nome: "MONTE SAN GIOVANNI IN SABINA", provincia: "RI" },
  { code: "411043031", nome: "MONTE SAN GIUSTO", provincia: "MC" },
  { code: "411043032", nome: "MONTE SAN MARTINO", provincia: "MC" },
  { code: "411109023", nome: "MONTE SAN PIETRANGELI", provincia: "FM" },
  { code: "408037042", nome: "MONTE SAN PIETRO", provincia: "BO" },
  { code: "409051025", nome: "MONTE SAN SAVINO", provincia: "AR" },
  { code: "411042030", nome: "MONTE SAN VITO", provincia: "AN" },
  { code: "416071033", nome: "MONTE SANT\'ANGELO", provincia: "FG" },
  { code: "410054032", nome: "MONTE SANTA MARIA TIBERINA", provincia: "PG" },
  { code: "411109024", nome: "MONTE URANO", provincia: "FM" },
  { code: "411109025", nome: "MONTE VIDON COMBATTE", provincia: "FM" },
  { code: "411109026", nome: "MONTE VIDON CORRADO", provincia: "FM" },
  { code: "403018095", nome: "MONTEBELLO DELLA BATTAGLIA", provincia: "PV" },
  { code: "413068023", nome: "MONTEBELLO DI BERTONA", provincia: "PE" },
  { code: "418080053", nome: "MONTEBELLO IONICO", provincia: "RC" },
  { code: "413069009", nome: "MONTEBELLO SUL SANGRO", provincia: "CH" },
  { code: "405024060", nome: "MONTEBELLO VICENTINO", provincia: "VI" },
  { code: "405026046", nome: "MONTEBELLUNA", provincia: "TV" },
  { code: "407010038", nome: "MONTEBRUNO", provincia: "GE" },
  { code: "412057040", nome: "MONTEBUONO", provincia: "RI" },
  { code: "411141030", nome: "MONTECALVO IN FOGLIA", provincia: "PU" },
  { code: "415064052", nome: "MONTECALVO IRPINO", provincia: "AV" },
  { code: "403018096", nome: "MONTECALVO VERSIGGIA", provincia: "PV" },
  { code: "409046021", nome: "MONTECARLO", provincia: "LU" },
  { code: "411042026", nome: "MONTECAROTTO", provincia: "AN" },
  { code: "411043026", nome: "MONTECASSIANO", provincia: "MC" },
  { code: "401006105", nome: "MONTECASTELLO", provincia: "AL" },
  { code: "410055017", nome: "MONTECASTRILLI", provincia: "TR" },
  { code: "409050019", nome: "MONTECATINI VAL DI CECINA", provincia: "PI" },
  { code: "409047011", nome: "MONTECATINI-TERME", provincia: "PT" },
  { code: "405023049", nome: "MONTECCHIA DI CROSARA", provincia: "VR" },
  { code: "408035027", nome: "MONTECCHIO EMILIA", provincia: "RE" },
  { code: "405024061", nome: "MONTECCHIO MAGGIORE", provincia: "VI" },
  { code: "405024062", nome: "MONTECCHIO PRECALCINO", provincia: "VI" },
  { code: "410055018", nome: "MONTECCHIO", provincia: "TR" },
  { code: "401006106", nome: "MONTECHIARO D\'ACQUI", provincia: "AL" },
  { code: "401005075", nome: "MONTECHIARO D\'ASTI", provincia: "AT" },
  { code: "408034023", nome: "MONTECHIARUGOLO", provincia: "PR" },
  { code: "414070042", nome: "MONTECILFONE", provincia: "CB" },
  { code: "411099030", nome: "MONTECOPIOLO", provincia: "RN" },
  { code: "415065071", nome: "MONTECORICE", provincia: "SA" },
  { code: "415065072", nome: "MONTECORVINO PUGLIANO", provincia: "SA" },
  { code: "415065073", nome: "MONTECORVINO ROVELLA", provincia: "SA" },
  { code: "411043028", nome: "MONTECOSARO", provincia: "MC" },
  { code: "401103046", nome: "MONTECRESTESE", provincia: "VB" },
  { code: "408036024", nome: "MONTECRETO", provincia: "MO" },
  { code: "411044034", nome: "MONTEDINOVE", provincia: "AP" },
  { code: "419085011", nome: "MONTEDORO", provincia: "CL" },
  { code: "415064053", nome: "MONTEFALCIONE", provincia: "AV" },
  { code: "410054030", nome: "MONTEFALCO", provincia: "PG" },
  { code: "411109014", nome: "MONTEFALCONE APPENNINO", provincia: "FM" },
  { code: "415062042", nome: "MONTEFALCONE DI VAL FORTORE", provincia: "BN" },
  { code: "414070043", nome: "MONTEFALCONE NEL SANNIO", provincia: "CB" },
  { code: "411043029", nome: "MONTEFANO", provincia: "MC" },
  { code: "411141034", nome: "MONTEFELCINO", provincia: "PU" },
  { code: "413069052", nome: "MONTEFERRANTE", provincia: "CH" },
  { code: "412056036", nome: "MONTEFIASCONE", provincia: "VT" },
  { code: "413067027", nome: "MONTEFINO", provincia: "TE" },
  { code: "408099008", nome: "MONTEFIORE CONCA", provincia: "RN" },
  { code: "411044036", nome: "MONTEFIORE DELL\'ASO", provincia: "AP" },
  { code: "408036025", nome: "MONTEFIORINO", provincia: "MO" },
  { code: "412058061", nome: "MONTEFLAVIO", provincia: "RM" },
  { code: "415065074", nome: "MONTEFORTE CILENTO", provincia: "SA" },
  { code: "405023050", nome: "MONTEFORTE D\'ALPONE", provincia: "VR" },
  { code: "415064054", nome: "MONTEFORTE IRPINO", provincia: "AV" },
  { code: "411109015", nome: "MONTEFORTINO", provincia: "FM" },
  { code: "410055019", nome: "MONTEFRANCO", provincia: "TR" },
  { code: "415064055", nome: "MONTEFREDANE", provincia: "AV" },
  { code: "415064056", nome: "MONTEFUSCO", provincia: "AV" },
  { code: "410055020", nome: "MONTEGABBIONE", provincia: "TR" },
  { code: "405024064", nome: "MONTEGALDA", provincia: "VI" },
  { code: "405024065", nome: "MONTEGALDELLA", provincia: "VI" },
  { code: "411044038", nome: "MONTEGALLO", provincia: "AP" },
  { code: "401006107", nome: "MONTEGIOCO", provincia: "AL" },
  { code: "418078082", nome: "MONTEGIORDANO", provincia: "CS" },
  { code: "411109017", nome: "MONTEGIORGIO", provincia: "FM" },
  { code: "411109018", nome: "MONTEGRANARO", provincia: "FM" },
  { code: "408099009", nome: "MONTEGRIDOLFO", provincia: "RN" },
  { code: "403012103", nome: "MONTEGRINO - VALTRAVAGLIA", provincia: "VA" },
  { code: "401005076", nome: "MONTEGROSSO D\'ASTI", provincia: "AT" },
  { code: "407008037", nome: "MONTEGROSSO PIAN LATTE", provincia: "IM" },
  { code: "405028057", nome: "MONTEGROTTO TERME", provincia: "PD" },
  { code: "416073016", nome: "MONTEIASI", provincia: "TA" },
  { code: "411141036", nome: "MONTELABBATE", provincia: "PU" },
  { code: "412058062", nome: "MONTELANICO", provincia: "RM" },
  { code: "413069053", nome: "MONTELAPIANO", provincia: "CH" },
  { code: "410055021", nome: "MONTELEONE D\'ORVIETO", provincia: "TR" },
  { code: "411109019", nome: "MONTELEONE DI FERMO", provincia: "FM" },
  { code: "416071032", nome: "MONTELEONE DI PUGLIA", provincia: "FG" },
  { code: "410054031", nome: "MONTELEONE DI SPOLETO", provincia: "PG" },
  { code: "420090040", nome: "MONTELEONE ROCCA DORIA", provincia: "SS" },
  { code: "412057041", nome: "MONTELEONE SABINO", provincia: "RI" },
  { code: "419082050", nome: "MONTELEPRE", provincia: "PA" },
  { code: "412058063", nome: "MONTELIBRETTI", provincia: "RM" },
  { code: "415064057", nome: "MONTELLA", provincia: "AV" },
  { code: "403016139", nome: "MONTELLO", provincia: "BG" },
  { code: "414070044", nome: "MONTELONGO", provincia: "CB" },
  { code: "411109020", nome: "MONTELPARO", provincia: "FM" },
  { code: "401004137", nome: "MONTELUPO ALBESE", provincia: "CN" },
  { code: "409048028", nome: "MONTELUPO FIORENTINO", provincia: "FI" },
  { code: "411043030", nome: "MONTELUPONE", provincia: "MC" },
  { code: "419082051", nome: "MONTEMAGGIORE BELSITO", provincia: "PA" },
  { code: "401005977", nome: "MONTEMAGNO MONFERRATO", provincia: "AT" },
  { code: "401004138", nome: "MONTEMALE DI CUNEO", provincia: "CN" },
  { code: "415064058", nome: "MONTEMARANO", provincia: "AV" },
  { code: "411042027", nome: "MONTEMARCIANO", provincia: "AN" },
  { code: "401006108", nome: "MONTEMARZINO", provincia: "AL" },
  { code: "416073017", nome: "MONTEMESOLA", provincia: "TA" },
  { code: "403013155", nome: "MONTEMEZZO", provincia: "CO" },
  { code: "409051023", nome: "MONTEMIGNAIO", provincia: "AR" },
  { code: "415064059", nome: "MONTEMILETTO", provincia: "AV" },
  { code: "417076051", nome: "MONTEMILONE", provincia: "PZ" },
  { code: "414070045", nome: "MONTEMITRO", provincia: "CB" },
  { code: "411044044", nome: "MONTEMONACO", provincia: "AP" },
  { code: "409100003", nome: "MONTEMURLO", provincia: "PO" },
  { code: "417076052", nome: "MONTEMURRO", provincia: "PZ" },
  { code: "406030061", nome: "MONTENARS", provincia: "UD" },
  { code: "414070046", nome: "MONTENERO DI BISACCIA", provincia: "CB" },
  { code: "412057042", nome: "MONTENERO SABINO", provincia: "RI" },
  { code: "414094029", nome: "MONTENERO VAL COCCHIARA", provincia: "IS" },
  { code: "413069054", nome: "MONTENERODOMO", provincia: "CH" },
  { code: "413069055", nome: "MONTEODORISIO", provincia: "CH" },
  { code: "418079081", nome: "MONTEPAONE", provincia: "CZ" },
  { code: "416073018", nome: "MONTEPARANO", provincia: "TA" },
  { code: "411044045", nome: "MONTEPRANDONE", provincia: "AP" },
  { code: "409052015", nome: "MONTEPULCIANO", provincia: "SI" },
  { code: "409051024", nome: "MONTERCHI", provincia: "AR" },
  { code: "406093027", nome: "MONTEREALE VALCELLINA", provincia: "PN" },
  { code: "413066056", nome: "MONTEREALE", provincia: "AQ" },
  { code: "408037041", nome: "MONTERENZIO", provincia: "BO" },
  { code: "409052016", nome: "MONTERIGGIONI", provincia: "SI" },
  { code: "414094030", nome: "MONTERODUNI", provincia: "IS" },
  { code: "409052017", nome: "MONTERONI D\'ARBIA", provincia: "SI" },
  { code: "416075048", nome: "MONTERONI DI LECCE", provincia: "LE" },
  { code: "412056038", nome: "MONTEROSI", provincia: "VT" },
  { code: "407011019", nome: "MONTEROSSO AL MARE", provincia: "SP" },
  { code: "419088007", nome: "MONTEROSSO ALMO", provincia: "RG" },
  { code: "418102023", nome: "MONTEROSSO CALABRO", provincia: "VV" },
  { code: "401004139", nome: "MONTEROSSO GRANA", provincia: "CN" },
  { code: "409053027", nome: "MONTEROTONDO MARITTIMO", provincia: "GR" },
  { code: "412058065", nome: "MONTEROTONDO", provincia: "RM" },
  { code: "411109022", nome: "MONTERUBBIANO", provincia: "FM" },
  { code: "416075049", nome: "MONTESANO SALENTINO", provincia: "LE" },
  { code: "415065076", nome: "MONTESANO SULLA MARCELLANA", provincia: "SA" },
  { code: "415062043", nome: "MONTESARCHIO", provincia: "BN" },
  { code: "417077017", nome: "MONTESCAGLIOSO", provincia: "MT" },
  { code: "403018097", nome: "MONTESCANO", provincia: "PV" },
  { code: "401103047", nome: "MONTESCHENO", provincia: "VB" },
  { code: "409050020", nome: "MONTESCUDAIO", provincia: "PI" },
  { code: "408099029", nome: "MONTESCUDO-MONTE COLOMBO", provincia: "RN" },
  { code: "408036026", nome: "MONTESE", provincia: "MO" },
  { code: "403018098", nome: "MONTESEGALE", provincia: "PV" },
  { code: "413068024", nome: "MONTESILVANO", provincia: "PE" },
  { code: "409048030", nome: "MONTESPERTOLI", provincia: "FI" },
  { code: "401001162", nome: "MONTEU DA PO", provincia: "TO" },
  { code: "401004140", nome: "MONTEU ROERO", provincia: "CN" },
  { code: "419084025", nome: "MONTEVAGO", provincia: "AG" },
  { code: "409051026", nome: "MONTEVARCHI", provincia: "AR" },
  { code: "403097053", nome: "MONTEVECCHIA", provincia: "LC" },
  { code: "415064060", nome: "MONTEVERDE", provincia: "AV" },
  { code: "409050021", nome: "MONTEVERDI MARITTIMO", provincia: "PI" },
  { code: "405024066", nome: "MONTEVIALE", provincia: "VI" },
  { code: "401004141", nome: "MONTEZEMOLO", provincia: "CN" },
  { code: "420090041", nome: "MONTI", provincia: "SS" },
  { code: "408140028", nome: "MONTIANO", provincia: "FC" },
  { code: "403017112", nome: "MONTICELLI BRUSATI", provincia: "BS" },
  { code: "408033027", nome: "MONTICELLI D\'ONGINA", provincia: "PC" },
  { code: "403018099", nome: "MONTICELLI PAVESE", provincia: "PV" },
  { code: "403097054", nome: "MONTICELLO BRIANZA", provincia: "LC" },
  { code: "405024067", nome: "MONTICELLO CONTE OTTO", provincia: "VI" },
  { code: "401004142", nome: "MONTICELLO D\'ALBA", provincia: "CN" },
  { code: "403017113", nome: "MONTICHIARI", provincia: "BS" },
  { code: "409052018", nome: "MONTICIANO", provincia: "SI" },
  { code: "409053017", nome: "MONTIERI", provincia: "GR" },
  { code: "401005516", nome: "MONTIGLIO MONFERRATO", provincia: "AT" },
  { code: "409045011", nome: "MONTIGNOSO", provincia: "MS" },
  { code: "403017114", nome: "MONTIRONE", provincia: "BS" },
  { code: "402007043", nome: "MONTJOVET", provincia: "AO" },
  { code: "403019059", nome: "MONTODINE", provincia: "CR" },
  { code: "407010039", nome: "MONTOGGIO", provincia: "GE" },
  { code: "410054033", nome: "MONTONE", provincia: "PG" },
  { code: "412057044", nome: "MONTOPOLI DI SABINA", provincia: "RI" },
  { code: "409050022", nome: "MONTOPOLI IN VAL D\'ARNO", provincia: "PI" },
  { code: "403013157", nome: "MONTORFANO", provincia: "CO" },
  { code: "413067028", nome: "MONTORIO AL VOMANO", provincia: "TE" },
  { code: "414070047", nome: "MONTORIO NEI FRENTANI", provincia: "CB" },
  { code: "412058066", nome: "MONTORIO ROMANO", provincia: "RM" },
  { code: "415064121", nome: "MONTORO", provincia: "AV" },
  { code: "405024068", nome: "MONTORSO VICENTINO", provincia: "VI" },
  { code: "411109027", nome: "MONTOTTONE", provincia: "FM" },
  { code: "420091049", nome: "MONTRESTA", provincia: "NU" },
  { code: "403018100", nome: "MONTU\' BECCARIA", provincia: "PV" },
  { code: "403012104", nome: "MONVALLE", provincia: "VA" },
  { code: "403108033", nome: "MONZA", provincia: "MB" },
  { code: "403020036", nome: "MONZAMBANO", provincia: "MN" },
  { code: "408037044", nome: "MONZUNO", provincia: "BO" },
  { code: "418078083", nome: "MORANO CALABRO", provincia: "CS" },
  { code: "401006109", nome: "MORANO SUL PO", provincia: "AL" },
  { code: "401005122", nome: "MORANSENGO-TONENGO", provincia: "AT" },
  { code: "406031013", nome: "MORARO", provincia: "GO" },
  { code: "403012105", nome: "MORAZZONE", provincia: "VA" },
  { code: "403014045", nome: "MORBEGNO", provincia: "SO" },
  { code: "401006110", nome: "MORBELLO", provincia: "AL" },
  { code: "416075050", nome: "MORCIANO DI LEUCA", provincia: "LE" },
  { code: "408099011", nome: "MORCIANO DI ROMAGNA", provincia: "RN" },
  { code: "415062044", nome: "MORCONE", provincia: "BN" },
  { code: "408037045", nome: "MORDANO", provincia: "BO" },
  { code: "403016140", nome: "MORENGO", provincia: "BG" },
  { code: "420090042", nome: "MORES", provincia: "SS" },
  { code: "411109028", nome: "MORESCO", provincia: "FM" },
  { code: "401004143", nome: "MORETTA", provincia: "CN" },
  { code: "408033028", nome: "MORFASSO", provincia: "PC" },
  { code: "405026047", nome: "MORGANO", provincia: "TV" },
  { code: "402007044", nome: "MORGEX", provincia: "AO" },
  { code: "420095030", nome: "MORGONGIORI", provincia: "OR" },
  { code: "404022123", nome: "MORI", provincia: "TN" },
  { code: "405026048", nome: "MORIAGO DELLA BATTAGLIA", provincia: "TV" },
  { code: "412058067", nome: "MORICONE", provincia: "RM" },
  { code: "415065077", nome: "MORIGERATI", provincia: "SA" },
  { code: "403015150", nome: "MORIMONDO", provincia: "MI" },
  { code: "413066057", nome: "MORINO", provincia: "AQ" },
  { code: "401001163", nome: "MORIONDO TORINESE", provincia: "TO" },
  { code: "412058068", nome: "MORLUPO", provincia: "RM" },
  { code: "418078084", nome: "MORMANNO", provincia: "CS" },
  { code: "403012106", nome: "MORNAGO", provincia: "VA" },
  { code: "401006111", nome: "MORNESE", provincia: "AL" },
  { code: "403016141", nome: "MORNICO AL SERIO", provincia: "BG" },
  { code: "403018101", nome: "MORNICO LOSANA", provincia: "PV" },
  { code: "412060045", nome: "MOROLO", provincia: "FR" },
  { code: "401004144", nome: "MOROZZO", provincia: "CN" },
  { code: "415064063", nome: "MORRA DE SANCTIS", provincia: "AV" },
  { code: "411042031", nome: "MORRO D\'ALBA", provincia: "AN" },
  { code: "413067029", nome: "MORRO D\'ORO", provincia: "TE" },
  { code: "412057045", nome: "MORRO REATINO", provincia: "RI" },
  { code: "414070048", nome: "MORRONE DEL SANNIO", provincia: "CB" },
  { code: "411043033", nome: "MORROVALLE", provincia: "MC" },
  { code: "406093028", nome: "MORSANO AL TAGLIAMENTO", provincia: "PN" },
  { code: "401006112", nome: "MORSASCO", provincia: "AL" },
  { code: "403018102", nome: "MORTARA", provincia: "PV" },
  { code: "406030062", nome: "MORTEGLIANO", provincia: "UD" },
  { code: "403097055", nome: "MORTERONE", provincia: "LC" },
  { code: "406030063", nome: "MORUZZO", provincia: "UD" },
  { code: "403019060", nome: "MOSCAZZANO", provincia: "CR" },
  { code: "415064064", nome: "MOSCHIANO", provincia: "AV" },
  { code: "413067030", nome: "MOSCIANO SANT\'ANGELO", provincia: "TE" },
  { code: "413068025", nome: "MOSCUFO", provincia: "PE" },
  { code: "404021054", nome: "MOSO IN PASSIRIA", provincia: "BZ" },
  { code: "406031014", nome: "MOSSA", provincia: "GO" },
  { code: "401096501", nome: "MOSSO", provincia: "BI" },
  { code: "403019061", nome: "MOTTA BALUFFI", provincia: "CR" },
  { code: "419083058", nome: "MOTTA CAMASTRA", provincia: "ME" },
  { code: "419083059", nome: "MOTTA D\'AFFERMO", provincia: "ME" },
  { code: "401002082", nome: "MOTTA DEI CONTI", provincia: "VC" },
  { code: "405026049", nome: "MOTTA DI LIVENZA", provincia: "TV" },
  { code: "416071034", nome: "MOTTA MONTECORVINO", provincia: "FG" },
  { code: "418080054", nome: "MOTTA SAN GIOVANNI", provincia: "RC" },
  { code: "419087030", nome: "MOTTA SANT\'ANASTASIA", provincia: "CT" },
  { code: "418079083", nome: "MOTTA SANTA LUCIA", provincia: "CZ" },
  { code: "403015151", nome: "MOTTA VISCONTI", provincia: "MI" },
  { code: "418078085", nome: "MOTTAFOLLONE", provincia: "CS" },
  { code: "401096037", nome: "MOTTALCIATA", provincia: "BI" },
  { code: "403020037", nome: "MOTTEGGIANA", provincia: "MN" },
  { code: "416073019", nome: "MOTTOLA", provincia: "TA" },
  { code: "413069056", nome: "MOZZAGROGNA", provincia: "CH" },
  { code: "403016142", nome: "MOZZANICA", provincia: "BG" },
  { code: "403013159", nome: "MOZZATE", provincia: "CO" },
  { code: "405023051", nome: "MOZZECANE", provincia: "VR" },
  { code: "403016143", nome: "MOZZO", provincia: "BG" },
  { code: "411043034", nome: "MUCCIA", provincia: "MC" },
  { code: "406032003", nome: "MUGGIA", provincia: "TS" },
  { code: "403108034", nome: "MUGGIO\'", provincia: "MB" },
  { code: "415064065", nome: "MUGNANO DEL CARDINALE", provincia: "AV" },
  { code: "415063048", nome: "MUGNANO DI NAPOLI", provincia: "NA" },
  { code: "403098041", nome: "MULAZZANO", provincia: "LO" },
  { code: "409045012", nome: "MULAZZO", provincia: "MS" },
  { code: "403017115", nome: "MURA", provincia: "BS" },
  { code: "420092039", nome: "MURAVERA", provincia: "CA" },
  { code: "401004145", nome: "MURAZZANO", provincia: "CN" },
  { code: "401004146", nome: "MURELLO", provincia: "CN" },
  { code: "407009040", nome: "MURIALDO", provincia: "SV" },
  { code: "401006113", nome: "MURISENGO", provincia: "AL" },
  { code: "409052019", nome: "MURLO", provincia: "SI" },
  { code: "416075051", nome: "MURO LECCESE", provincia: "LE" },
  { code: "417076053", nome: "MURO LUCANO", provincia: "PZ" },
  { code: "420090043", nome: "MUROS", provincia: "SS" },
  { code: "403017116", nome: "MUSCOLINE", provincia: "BS" },
  { code: "420092040", nome: "MUSEI", provincia: "CA" },
  { code: "405027025", nome: "MUSILE DI PIAVE", provincia: "VE" },
  { code: "403013160", nome: "MUSSO", provincia: "CO" },
  { code: "405024070", nome: "MUSSOLENTE", provincia: "VI" },
  { code: "419085012", nome: "MUSSOMELI", provincia: "CL" },
  { code: "406030064", nome: "MUZZANA DEL TURGNANO", provincia: "UD" },
  { code: "401096038", nome: "MUZZANO", provincia: "BI" },
  { code: "404022124", nome: "NAGO-TORBOLE", provincia: "TN" },
  { code: "404021055", nome: "NALLES", provincia: "BZ" },
  { code: "405024071", nome: "NANTO", provincia: "VI" },
  { code: "415063049", nome: "NAPOLI", provincia: "NA" },
  { code: "420095031", nome: "NARBOLIA", provincia: "OR" },
  { code: "420092041", nome: "NARCAO", provincia: "CA" },
  { code: "416075052", nome: "NARDO\'", provincia: "LE" },
  { code: "418102024", nome: "NARDODIPACE", provincia: "VV" },
  { code: "410055022", nome: "NARNI", provincia: "TR" },
  { code: "419084026", nome: "NARO", provincia: "AG" },
  { code: "401004147", nome: "NARZOLE", provincia: "CN" },
  { code: "407009041", nome: "NASINO", provincia: "SV" },
  { code: "419083060", nome: "NASO", provincia: "ME" },
  { code: "404021056", nome: "NATURNO", provincia: "BZ" },
  { code: "403017117", nome: "NAVE", provincia: "BS" },
  { code: "413066058", nome: "NAVELLI", provincia: "AQ" },
  { code: "404021057", nome: "NAZ SCIAVES", provincia: "BZ" },
  { code: "412058069", nome: "NAZZANO", provincia: "RM" },
  { code: "407010040", nome: "NE", provincia: "GE" },
  { code: "401003103", nome: "NEBBIUNO", provincia: "NO" },
  { code: "405023952", nome: "NEGRAR DI VALPOLICELLA", provincia: "VR" },
  { code: "407010041", nome: "NEIRONE", provincia: "GE" },
  { code: "401004148", nome: "NEIVE", provincia: "CN" },
  { code: "403016144", nome: "NEMBRO", provincia: "BG" },
  { code: "412058070", nome: "NEMI", provincia: "RM" },
  { code: "417076054", nome: "NEMOLI", provincia: "PZ" },
  { code: "420095032", nome: "NEONELI", provincia: "OR" },
  { code: "412056039", nome: "NEPI", provincia: "VT" },
  { code: "413067031", nome: "NERETO", provincia: "TE" },
  { code: "412058071", nome: "NEROLA", provincia: "RM" },
  { code: "405026050", nome: "NERVESA DELLA BATTAGLIA", provincia: "TV" },
  { code: "403015154", nome: "NERVIANO", provincia: "MI" },
  { code: "412057046", nome: "NESPOLO", provincia: "RI" },
  { code: "403013161", nome: "NESSO", provincia: "CO" },
  { code: "401096039", nome: "NETRO", provincia: "BI" },
  { code: "412058072", nome: "NETTUNO", provincia: "RM" },
  { code: "408034024", nome: "NEVIANO DEGLI ARDUINI", provincia: "PR" },
  { code: "416075053", nome: "NEVIANO", provincia: "LE" },
  { code: "401004149", nome: "NEVIGLIE", provincia: "CN" },
  { code: "403017118", nome: "NIARDO", provincia: "BS" },
  { code: "401003104", nome: "NIBBIOLA", provincia: "NO" },
  { code: "403097056", nome: "NIBIONNO", provincia: "LC" },
  { code: "401001164", nome: "NICHELINO", provincia: "TO" },
  { code: "419087031", nome: "NICOLOSI", provincia: "CT" },
  { code: "403018103", nome: "NICORVO", provincia: "PV" },
  { code: "419086012", nome: "NICOSIA", provincia: "EN" },
  { code: "418102025", nome: "NICOTERA", provincia: "VV" },
  { code: "401004150", nome: "NIELLA BELBO", provincia: "CN" },
  { code: "401004151", nome: "NIELLA TANARO", provincia: "CN" },
  { code: "406030065", nome: "NIMIS", provincia: "UD" },
  { code: "419085013", nome: "NISCEMI", provincia: "CL" },
  { code: "419086013", nome: "NISSORIA", provincia: "EN" },
  { code: "419083061", nome: "NIZZA DI SICILIA", provincia: "ME" },
  { code: "401005080", nome: "NIZZA MONFERRATO", provincia: "AT" },
  { code: "405027026", nome: "NOALE", provincia: "VE" },
  { code: "401001165", nome: "NOASCA", provincia: "TO" },
  { code: "418078086", nome: "NOCARA", provincia: "CS" },
  { code: "413068026", nome: "NOCCIANO", provincia: "PE" },
  { code: "415065078", nome: "NOCERA INFERIORE", provincia: "SA" },
  { code: "415065079", nome: "NOCERA SUPERIORE", provincia: "SA" },
  { code: "418079087", nome: "NOCERA TERINESE", provincia: "CZ" },
  { code: "410054034", nome: "NOCERA UMBRA", provincia: "PG" },
  { code: "408034025", nome: "NOCETO", provincia: "PR" },
  { code: "416072031", nome: "NOCI", provincia: "BA" },
  { code: "416075054", nome: "NOCIGLIA", provincia: "LE" },
  { code: "417076055", nome: "NOEPOLI", provincia: "PZ" },
  { code: "405023053", nome: "NOGARA", provincia: "VR" },
  { code: "404022127", nome: "NOGAREDO", provincia: "TN" },
  { code: "405023054", nome: "NOGAROLE ROCCA", provincia: "VR" },
  { code: "405024072", nome: "NOGAROLE VICENTINO", provincia: "VI" },
  { code: "416072032", nome: "NOICATTARO", provincia: "BA" },
  { code: "415063050", nome: "NOLA", provincia: "NA" },
  { code: "401001166", nome: "NOLE", provincia: "TO" },
  { code: "407009042", nome: "NOLI", provincia: "SV" },
  { code: "401001167", nome: "NOMAGLIO", provincia: "TO" },
  { code: "404022128", nome: "NOMI", provincia: "TN" },
  { code: "408036027", nome: "NONANTOLA", provincia: "MO" },
  { code: "401001168", nome: "NONE", provincia: "TO" },
  { code: "401103048", nome: "NONIO", provincia: "VB" },
  { code: "420091050", nome: "NORAGUGUME", provincia: "NU" },
  { code: "420095033", nome: "NORBELLO", provincia: "OR" },
  { code: "410054035", nome: "NORCIA", provincia: "PG" },
  { code: "412059016", nome: "NORMA", provincia: "LT" },
  { code: "403015155", nome: "NOSATE", provincia: "MI" },
  { code: "413067032", nome: "NOTARESCO", provincia: "TE" },
  { code: "419089013", nome: "NOTO", provincia: "SR" },
  { code: "404021058", nome: "NOVA LEVANTE", provincia: "BZ" },
  { code: "403108035", nome: "NOVA MILANESE", provincia: "MB" },
  { code: "404021059", nome: "NOVA PONENTE", provincia: "BZ" },
  { code: "417077018", nome: "NOVA SIRI", provincia: "MT" },
  { code: "408099023", nome: "NOVAFELTRIA", provincia: "RN" },
  { code: "404022129", nome: "NOVALEDO", provincia: "TN" },
  { code: "401001169", nome: "NOVALESA", provincia: "TO" },
  { code: "419083062", nome: "NOVARA DI SICILIA", provincia: "ME" },
  { code: "401003106", nome: "NOVARA", provincia: "NO" },
  { code: "403014046", nome: "NOVATE MEZZOLA", provincia: "SO" },
  { code: "403015157", nome: "NOVATE MILANESE", provincia: "MI" },
  { code: "405024073", nome: "NOVE", provincia: "VI" },
  { code: "403013163", nome: "NOVEDRATE", provincia: "CO" },
  { code: "404022253", nome: "NOVELLA", provincia: "TN" },
  { code: "408035028", nome: "NOVELLARA", provincia: "RE" },
  { code: "401004152", nome: "NOVELLO", provincia: "CN" },
  { code: "405027027", nome: "NOVENTA DI PIAVE", provincia: "VE" },
  { code: "405028058", nome: "NOVENTA PADOVANA", provincia: "PD" },
  { code: "405024074", nome: "NOVENTA VICENTINA", provincia: "VI" },
  { code: "408036028", nome: "NOVI DI MODENA", provincia: "MO" },
  { code: "401006114", nome: "NOVI LIGURE", provincia: "AL" },
  { code: "415065080", nome: "NOVI VELIA", provincia: "SA" },
  { code: "403015158", nome: "NOVIGLIO", provincia: "MI" },
  { code: "416075055", nome: "NOVOLI", provincia: "LE" },
  { code: "401004153", nome: "NUCETTO", provincia: "CN" },
  { code: "420090044", nome: "NUGHEDU DI SAN NICOLO\'", provincia: "SS" },
  { code: "420095034", nome: "NUGHEDU SANTA VITTORIA", provincia: "OR" },
  { code: "420090045", nome: "NULE", provincia: "SS" },
  { code: "420090046", nome: "NULVI", provincia: "SS" },
  { code: "411042032", nome: "NUMANA", provincia: "AN" },
  { code: "420091051", nome: "NUORO", provincia: "NU" },
  { code: "420095035", nome: "NURACHI", provincia: "OR" },
  { code: "420091052", nome: "NURAGUS", provincia: "NU" },
  { code: "420091053", nome: "NURALLAO", provincia: "NU" },
  { code: "420092042", nome: "NURAMINIS", provincia: "CA" },
  { code: "420095036", nome: "NURECI", provincia: "OR" },
  { code: "420092117", nome: "NURRI", provincia: "CA" },
  { code: "402007045", nome: "NUS", provincia: "AO" },
  { code: "415064066", nome: "NUSCO", provincia: "AV" },
  { code: "403017119", nome: "NUVOLENTO", provincia: "BS" },
  { code: "403017120", nome: "NUVOLERA", provincia: "BS" },
  { code: "420092043", nome: "NUXIS", provincia: "CA" },
  { code: "401096040", nome: "OCCHIEPPO INFERIORE", provincia: "BI" },
  { code: "401096041", nome: "OCCHIEPPO SUPERIORE", provincia: "BI" },
  { code: "405029033", nome: "OCCHIOBELLO", provincia: "RO" },
  { code: "401006115", nome: "OCCIMIANO", provincia: "AL" },
  { code: "413066059", nome: "OCRE", provincia: "AQ" },
  { code: "401006116", nome: "ODALENGO GRANDE", provincia: "AL" },
  { code: "401006117", nome: "ODALENGO PICCOLO", provincia: "AL" },
  { code: "405026051", nome: "ODERZO", provincia: "TV" },
  { code: "403017121", nome: "ODOLO", provincia: "BS" },
  { code: "413066060", nome: "OFENA", provincia: "AQ" },
  { code: "411042033", nome: "OFFAGNA", provincia: "AN" },
  { code: "403019062", nome: "OFFANENGO", provincia: "CR" },
  { code: "411044054", nome: "OFFIDA", provincia: "AP" },
  { code: "403017122", nome: "OFFLAGA", provincia: "BS" },
  { code: "401103049", nome: "OGGEBBIO", provincia: "VB" },
  { code: "403012107", nome: "OGGIONA CON SANTO STEFANO", provincia: "VA" },
  { code: "403097057", nome: "OGGIONO", provincia: "LC" },
  { code: "401001170", nome: "OGLIANICO", provincia: "TO" },
  { code: "415065081", nome: "OGLIASTRO CILENTO", provincia: "SA" },
  { code: "420090047", nome: "OLBIA", provincia: "SS" },
  { code: "401002088", nome: "OLCENENGO", provincia: "VC" },
  { code: "401002089", nome: "OLDENICO", provincia: "VC" },
  { code: "401003109", nome: "OLEGGIO CASTELLO", provincia: "NO" },
  { code: "401003108", nome: "OLEGGIO", provincia: "NO" },
  { code: "403018104", nome: "OLEVANO DI LOMELLINA", provincia: "PV" },
  { code: "412058073", nome: "OLEVANO ROMANO", provincia: "RM" },
  { code: "415065082", nome: "OLEVANO SUL TUSCIANO", provincia: "SA" },
  { code: "403013165", nome: "OLGIATE COMASCO", provincia: "CO" },
  { code: "403097058", nome: "OLGIATE MOLGORA", provincia: "LC" },
  { code: "403012108", nome: "OLGIATE OLONA", provincia: "VA" },
  { code: "403097059", nome: "OLGINATE", provincia: "LC" },
  { code: "420091055", nome: "OLIENA", provincia: "NU" },
  { code: "403018105", nome: "OLIVA GESSI", provincia: "PV" },
  { code: "418079088", nome: "OLIVADI", provincia: "CZ" },
  { code: "419083063", nome: "OLIVERI", provincia: "ME" },
  { code: "415065083", nome: "OLIVETO CITRA", provincia: "SA" },
  { code: "403097060", nome: "OLIVETO LARIO", provincia: "LC" },
  { code: "417077019", nome: "OLIVETO LUCANO", provincia: "MT" },
  { code: "407008038", nome: "OLIVETTA SAN MICHELE", provincia: "IM" },
  { code: "401006118", nome: "OLIVOLA", provincia: "AL" },
  { code: "420095037", nome: "OLLASTRA SIMAXIS", provincia: "OR" },
  { code: "420091056", nome: "OLLOLAI", provincia: "NU" },
  { code: "402007046", nome: "OLLOMONT", provincia: "AO" },
  { code: "420090048", nome: "OLMEDO", provincia: "SS" },
  { code: "403019063", nome: "OLMENETA", provincia: "CR" },
  { code: "403016145", nome: "OLMO AL BREMBO", provincia: "BG" },
  { code: "401005081", nome: "OLMO GENTILE", provincia: "AT" },
  { code: "403016146", nome: "OLTRE IL COLLE", provincia: "BG" },
  { code: "403016147", nome: "OLTRESSENDA ALTA", provincia: "BG" },
  { code: "403013169", nome: "OLTRONA DI SAN MAMETTE", provincia: "CO" },
  { code: "420091057", nome: "OLZAI", provincia: "NU" },
  { code: "403017123", nome: "OME", provincia: "BS" },
  { code: "401103050", nome: "OMEGNA", provincia: "VB" },
  { code: "415065084", nome: "OMIGNANO", provincia: "SA" },
  { code: "420091058", nome: "ONANI", provincia: "NU" },
  { code: "412056040", nome: "ONANO", provincia: "VT" },
  { code: "401004154", nome: "ONCINO", provincia: "CN" },
  { code: "403016148", nome: "ONETA", provincia: "BG" },
  { code: "420091059", nome: "ONIFAI", provincia: "NU" },
  { code: "420091060", nome: "ONIFERI", provincia: "NU" },
  { code: "403017124", nome: "ONO SAN PIETRO", provincia: "BS" },
  { code: "403016149", nome: "ONORE", provincia: "BG" },
  { code: "407009043", nome: "ONZO", provincia: "SV" },
  { code: "403015159", nome: "OPERA", provincia: "MI" },
  { code: "413066061", nome: "OPI", provincia: "AQ" },
  { code: "405023055", nome: "OPPEANO", provincia: "VR" },
  { code: "417076056", nome: "OPPIDO LUCANO", provincia: "PZ" },
  { code: "418080055", nome: "OPPIDO MAMERTINA", provincia: "RC" },
  { code: "404021060", nome: "ORA", provincia: "BZ" },
  { code: "420091061", nome: "ORANI", provincia: "NU" },
  { code: "414070049", nome: "ORATINO", provincia: "CB" },
  { code: "401001171", nome: "ORBASSANO", provincia: "TO" },
  { code: "409053018", nome: "ORBETELLO", provincia: "GR" },
  { code: "409050023", nome: "ORCIANO PISANO", provincia: "PI" },
  { code: "407009044", nome: "ORCO FEGLINO", provincia: "SV" },
  { code: "416071063", nome: "ORDONA", provincia: "FG" },
  { code: "407010042", nome: "ORERO", provincia: "GE" },
  { code: "405024075", nome: "ORGIANO", provincia: "VI" },
  { code: "420091062", nome: "ORGOSOLO", provincia: "NU" },
  { code: "416074011", nome: "ORIA", provincia: "BR" },
  { code: "413066062", nome: "ORICOLA", provincia: "AQ" },
  { code: "403012109", nome: "ORIGGIO", provincia: "VA" },
  { code: "403012110", nome: "ORINO", provincia: "VA" },
  { code: "403016150", nome: "ORIO AL SERIO", provincia: "BG" },
  { code: "401001172", nome: "ORIO CANAVESE", provincia: "TO" },
  { code: "403098042", nome: "ORIO LITTA", provincia: "LO" },
  { code: "412056041", nome: "ORIOLO ROMANO", provincia: "VT" },
  { code: "418078087", nome: "ORIOLO", provincia: "CS" },
  { code: "420095038", nome: "ORISTANO", provincia: "OR" },
  { code: "401004155", nome: "ORMEA", provincia: "CN" },
  { code: "405026052", nome: "ORMELLE", provincia: "TV" },
  { code: "403108036", nome: "ORNAGO", provincia: "MB" },
  { code: "401103051", nome: "ORNAVASSO", provincia: "VB" },
  { code: "403016151", nome: "ORNICA", provincia: "BG" },
  { code: "420091063", nome: "OROSEI", provincia: "NU" },
  { code: "420091064", nome: "OROTELLI", provincia: "NU" },
  { code: "415065085", nome: "ORRIA", provincia: "SA" },
  { code: "420092118", nome: "ORROLI", provincia: "CA" },
  { code: "405026053", nome: "ORSAGO", provincia: "TV" },
  { code: "401006119", nome: "ORSARA BORMIDA", provincia: "AL" },
  { code: "416071035", nome: "ORSARA DI PUGLIA", provincia: "FG" },
  { code: "403013170", nome: "ORSENIGO", provincia: "CO" },
  { code: "413069057", nome: "ORSOGNA", provincia: "CH" },
  { code: "418078088", nome: "ORSOMARSO", provincia: "CS" },
  { code: "415061053", nome: "ORTA DI ATELLA", provincia: "CE" },
  { code: "416071036", nome: "ORTA NOVA", provincia: "FG" },
  { code: "401003112", nome: "ORTA SAN GIULIO", provincia: "NO" },
  { code: "420092044", nome: "ORTACESUS", provincia: "CA" },
  { code: "412056042", nome: "ORTE", provincia: "VT" },
  { code: "416075056", nome: "ORTELLE", provincia: "LE" },
  { code: "411109029", nome: "ORTEZZANO", provincia: "FM" },
  { code: "409051027", nome: "ORTIGNANO RAGGIOLO", provincia: "AR" },
  { code: "404021061", nome: "ORTISEI", provincia: "BZ" },
  { code: "413066063", nome: "ORTONA DEI MARSI", provincia: "AQ" },
  { code: "413069058", nome: "ORTONA", provincia: "CH" },
  { code: "407009045", nome: "ORTOVERO", provincia: "SV" },
  { code: "413066064", nome: "ORTUCCHIO", provincia: "AQ" },
  { code: "420091066", nome: "ORTUERI", provincia: "NU" },
  { code: "420091067", nome: "ORUNE", provincia: "NU" },
  { code: "410055023", nome: "ORVIETO", provincia: "TR" },
  { code: "412057047", nome: "ORVINIO", provincia: "RI" },
  { code: "403017125", nome: "ORZINUOVI", provincia: "BS" },
  { code: "403017126", nome: "ORZIVECCHI", provincia: "BS" },
  { code: "401001173", nome: "OSASCO", provincia: "TO" },
  { code: "401001174", nome: "OSASIO", provincia: "TO" },
  { code: "420090049", nome: "OSCHIRI", provincia: "SS" },
  { code: "420091068", nome: "OSIDDA", provincia: "NU" },
  { code: "407009046", nome: "OSIGLIA", provincia: "SV" },
  { code: "420090050", nome: "OSILO", provincia: "SS" },
  { code: "411042034", nome: "OSIMO", provincia: "AN" },
  { code: "420091069", nome: "OSINI", provincia: "NU" },
  { code: "403016152", nome: "OSIO SOPRA", provincia: "BG" },
  { code: "403016153", nome: "OSIO SOTTO", provincia: "BG" },
  { code: "403097061", nome: "OSNAGO", provincia: "LC" },
  { code: "406030066", nome: "OSOPPO", provincia: "UD" },
  { code: "407008039", nome: "OSPEDALETTI", provincia: "IM" },
  { code: "415064067", nome: "OSPEDALETTO D\'ALPINOLO", provincia: "AV" },
  { code: "405028059", nome: "OSPEDALETTO EUGANEO", provincia: "PD" },
  { code: "403098043", nome: "OSPEDALETTO LODIGIANO", provincia: "LO" },
  { code: "404022130", nome: "OSPEDALETTO", provincia: "TN" },
  { code: "405025035", nome: "OSPITALE DI CADORE", provincia: "BL" },
  { code: "403017127", nome: "OSPITALETTO BRESCIANO", provincia: "BS" },
  { code: "403098044", nome: "OSSAGO LODIGIANO", provincia: "LO" },
  { code: "404022131", nome: "OSSANA", provincia: "TN" },
  { code: "420090051", nome: "OSSI", provincia: "SS" },
  { code: "403017128", nome: "OSSIMO", provincia: "BS" },
  { code: "403015164", nome: "OSSONA", provincia: "MI" },
  { code: "401004156", nome: "OSTANA", provincia: "CN" },
  { code: "408038017", nome: "OSTELLATO", provincia: "FE" },
  { code: "403019064", nome: "OSTIANO", provincia: "CR" },
  { code: "403020038", nome: "OSTIGLIA", provincia: "MN" },
  { code: "411042036", nome: "OSTRA VETERE", provincia: "AN" },
  { code: "411042035", nome: "OSTRA", provincia: "AN" },
  { code: "416074012", nome: "OSTUNI", provincia: "BR" },
  { code: "416075057", nome: "OTRANTO", provincia: "LE" },
  { code: "410055024", nome: "OTRICOLI", provincia: "TR" },
  { code: "420091070", nome: "OTTANA", provincia: "NU" },
  { code: "415065086", nome: "OTTATI", provincia: "SA" },
  { code: "415063051", nome: "OTTAVIANO", provincia: "NA" },
  { code: "401006120", nome: "OTTIGLIO", provincia: "AL" },
  { code: "403018106", nome: "OTTOBIANO", provincia: "PV" },
  { code: "408033030", nome: "OTTONE", provincia: "PC" },
  { code: "401001175", nome: "OULX", provincia: "TO" },
  { code: "401006121", nome: "OVADA", provincia: "AL" },
  { code: "406030067", nome: "OVARO", provincia: "UD" },
  { code: "401006122", nome: "OVIGLIO", provincia: "AL" },
  { code: "413066065", nome: "OVINDOLI", provincia: "AQ" },
  { code: "420091071", nome: "OVODDA", provincia: "NU" },
  { code: "402007047", nome: "OYACE", provincia: "AO" },
  { code: "401001176", nome: "OZEGNA", provincia: "TO" },
  { code: "420090052", nome: "OZIERI", provincia: "SS" },
  { code: "408037046", nome: "OZZANO DELL\'EMILIA", provincia: "BO" },
  { code: "401006123", nome: "OZZANO MONFERRATO", provincia: "AL" },
  { code: "403015165", nome: "OZZERO", provincia: "MI" },
  { code: "420092045", nome: "PABILLONIS", provincia: "CA" },
  { code: "419083064", nome: "PACE DEL MELA", provincia: "ME" },
  { code: "419081013", nome: "PACECO", provincia: "TP" },
  { code: "413066066", nome: "PACENTRO", provincia: "AQ" },
  { code: "419089014", nome: "PACHINO", provincia: "SR" },
  { code: "410054036", nome: "PACIANO", provincia: "PG" },
  { code: "403017129", nome: "PADENGHE SUL GARDA", provincia: "BS" },
  { code: "401006124", nome: "PADERNA", provincia: "AL" },
  { code: "403097062", nome: "PADERNO D\'ADDA", provincia: "LC" },
  { code: "403015166", nome: "PADERNO DUGNANO", provincia: "MI" },
  { code: "403017130", nome: "PADERNO FRANCIACORTA", provincia: "BS" },
  { code: "403019065", nome: "PADERNO PONCHIELLI", provincia: "CR" },
  { code: "405028060", nome: "PADOVA", provincia: "PD" },
  { code: "420090053", nome: "PADRIA", provincia: "SS" },
  { code: "420090090", nome: "PADRU", provincia: "SS" },
  { code: "415065087", nome: "PADULA", provincia: "SA" },
  { code: "415062045", nome: "PADULI", provincia: "BN" },
  { code: "401004157", nome: "PAESANA", provincia: "CN" },
  { code: "405026055", nome: "PAESE", provincia: "TV" },
  { code: "415065088", nome: "PAGANI", provincia: "SA" },
  { code: "412057048", nome: "PAGANICO SABINO", provincia: "RI" },
  { code: "403016154", nome: "PAGAZZANO", provincia: "BG" },
  { code: "419083065", nome: "PAGLIARA", provincia: "ME" },
  { code: "413069059", nome: "PAGLIETA", provincia: "CH" },
  { code: "406030068", nome: "PAGNACCO", provincia: "UD" },
  { code: "401004158", nome: "PAGNO", provincia: "CN" },
  { code: "403097063", nome: "PAGNONA", provincia: "LC" },
  { code: "415064068", nome: "PAGO DEL VALLO DI LAURO", provincia: "AV" },
  { code: "415062046", nome: "PAGO VEIANO", provincia: "BN" },
  { code: "403017131", nome: "PAISCO LOVENO", provincia: "BS" },
  { code: "403017132", nome: "PAITONE", provincia: "BS" },
  { code: "403016155", nome: "PALADINA", provincia: "BG" },
  { code: "408036029", nome: "PALAGANO", provincia: "MO" },
  { code: "416073020", nome: "PALAGIANELLO", provincia: "TA" },
  { code: "416073021", nome: "PALAGIANO", provincia: "TA" },
  { code: "419087032", nome: "PALAGONIA", provincia: "CT" },
  { code: "409050024", nome: "PALAIA", provincia: "PI" },
  { code: "408034026", nome: "PALANZANO", provincia: "PR" },
  { code: "414070050", nome: "PALATA", provincia: "CB" },
  { code: "420090054", nome: "PALAU", provincia: "SS" },
  { code: "403016156", nome: "PALAZZAGO", provincia: "BG" },
  { code: "419082052", nome: "PALAZZO ADRIANO", provincia: "PA" },
  { code: "401001177", nome: "PALAZZO CANAVESE", provincia: "TO" },
  { code: "403019066", nome: "PALAZZO PIGNANO", provincia: "CR" },
  { code: "417076057", nome: "PALAZZO SAN GERVASIO", provincia: "PZ" },
  { code: "419089015", nome: "PALAZZOLO ACREIDE", provincia: "SR" },
  { code: "406030069", nome: "PALAZZOLO DELLO STELLA", provincia: "UD" },
  { code: "403017133", nome: "PALAZZOLO SULL\'OGLIO", provincia: "BS" },
  { code: "401002090", nome: "PALAZZOLO VERCELLESE", provincia: "VC" },
  { code: "409048031", nome: "PALAZZUOLO SUL SENIO", provincia: "FI" },
  { code: "413069060", nome: "PALENA", provincia: "CH" },
  { code: "418079089", nome: "PALERMITI", provincia: "CZ" },
  { code: "419082053", nome: "PALERMO", provincia: "PA" },
  { code: "412058074", nome: "PALESTRINA", provincia: "RM" },
  { code: "403018107", nome: "PALESTRO", provincia: "PV" },
  { code: "412060046", nome: "PALIANO", provincia: "FR" },
  { code: "418080056", nome: "PALIZZI", provincia: "RC" },
  { code: "418101016", nome: "PALLAGORIO", provincia: "KR" },
  { code: "401103052", nome: "PALLANZENO", provincia: "VB" },
  { code: "407009047", nome: "PALLARE", provincia: "SV" },
  { code: "415063052", nome: "PALMA CAMPANIA", provincia: "NA" },
  { code: "419084027", nome: "PALMA DI MONTECHIARO", provincia: "AG" },
  { code: "406030070", nome: "PALMANOVA", provincia: "UD" },
  { code: "416075058", nome: "PALMARIGGI", provincia: "LE" },
  { code: "420095039", nome: "PALMAS ARBOREA", provincia: "OR" },
  { code: "418080057", nome: "PALMI", provincia: "RC" },
  { code: "411044056", nome: "PALMIANO", provincia: "AP" },
  { code: "413069061", nome: "PALMOLI", provincia: "CH" },
  { code: "416072033", nome: "PALO DEL COLLE", provincia: "BA" },
  { code: "412058075", nome: "PALOMBARA SABINA", provincia: "RM" },
  { code: "413069062", nome: "PALOMBARO", provincia: "CH" },
  { code: "415065089", nome: "PALOMONTE", provincia: "SA" },
  { code: "403016157", nome: "PALOSCO", provincia: "BG" },
  { code: "404022133", nome: "PALU\' DEL FERSINA", provincia: "TN" },
  { code: "405023056", nome: "PALU\'", provincia: "VR" },
  { code: "418078089", nome: "PALUDI", provincia: "CS" },
  { code: "406030071", nome: "PALUZZA", provincia: "UD" },
  { code: "401004159", nome: "PAMPARATO", provincia: "CN" },
  { code: "401001178", nome: "PANCALIERI", provincia: "TO" },
  { code: "403018108", nome: "PANCARANA", provincia: "PV" },
  { code: "404022134", nome: "PANCHIA\'", provincia: "TN" },
  { code: "403019067", nome: "PANDINO", provincia: "CR" },
  { code: "418078090", nome: "PANETTIERI", provincia: "CS" },
  { code: "410054037", nome: "PANICALE", provincia: "PG" },
  { code: "415062047", nome: "PANNARANO", provincia: "BN" },
  { code: "416071037", nome: "PANNI", provincia: "FG" },
  { code: "419081014", nome: "PANTELLERIA", provincia: "TP" },
  { code: "403015167", nome: "PANTIGLIATE", provincia: "MI" },
  { code: "418078091", nome: "PAOLA", provincia: "CS" },
  { code: "415062048", nome: "PAOLISI", provincia: "BN" },
  { code: "418078092", nome: "PAPASIDERO", provincia: "CS" },
  { code: "405029034", nome: "PAPOZZE", provincia: "RO" },
  { code: "403015168", nome: "PARABIAGO", provincia: "MI" },
  { code: "416075059", nome: "PARABITA", provincia: "LE" },
  { code: "403017134", nome: "PARATICO", provincia: "BS" },
  { code: "404021062", nome: "PARCINES", provincia: "BZ" },
  { code: "401001179", nome: "PARELLA", provincia: "TO" },
  { code: "418078093", nome: "PARENTI", provincia: "CS" },
  { code: "415061054", nome: "PARETE", provincia: "CE" },
  { code: "401006125", nome: "PARETO", provincia: "AL" },
  { code: "418102026", nome: "PARGHELIA", provincia: "VV" },
  { code: "403097064", nome: "PARLASCO", provincia: "LC" },
  { code: "408034027", nome: "PARMA", provincia: "PR" },
  { code: "401006126", nome: "PARODI LIGURE", provincia: "AL" },
  { code: "401004160", nome: "PAROLDO", provincia: "CN" },
  { code: "415064069", nome: "PAROLISE", provincia: "AV" },
  { code: "403018109", nome: "PARONA", provincia: "PV" },
  { code: "410055025", nome: "PARRANO", provincia: "TR" },
  { code: "403016158", nome: "PARRE", provincia: "BG" },
  { code: "419081015", nome: "PARTANNA", provincia: "TP" },
  { code: "419082054", nome: "PARTINICO", provincia: "PA" },
  { code: "401003114", nome: "PARUZZARO", provincia: "NO" },
  { code: "403016159", nome: "PARZANICA", provincia: "BG" },
  { code: "406030072", nome: "PASIAN DI PRATO", provincia: "UD" },
  { code: "406093029", nome: "PASIANO DI PORDENONE", provincia: "PN" },
  { code: "403017135", nome: "PASPARDO", provincia: "BS" },
  { code: "401005082", nome: "PASSERANO MARMORITO", provincia: "AT" },
  { code: "410054038", nome: "PASSIGNANO SUL TRASIMENO", provincia: "PG" },
  { code: "403017136", nome: "PASSIRANO", provincia: "BS" },
  { code: "412060047", nome: "PASTENA", provincia: "FR" },
  { code: "415061055", nome: "PASTORANO", provincia: "CE" },
  { code: "405023057", nome: "PASTRENGO", provincia: "VR" },
  { code: "401006127", nome: "PASTURANA", provincia: "AL" },
  { code: "403097065", nome: "PASTURO", provincia: "LC" },
  { code: "418078094", nome: "PATERNO CALABRO", provincia: "CS" },
  { code: "419087033", nome: "PATERNO\'", provincia: "CT" },
  { code: "417076100", nome: "PATERNO", provincia: "PZ" },
  { code: "415064070", nome: "PATERNOPOLI", provincia: "AV" },
  { code: "412060048", nome: "PATRICA", provincia: "FR" },
  { code: "420090055", nome: "PATTADA", provincia: "SS" },
  { code: "419083066", nome: "PATTI", provincia: "ME" },
  { code: "416075060", nome: "PATU\'", provincia: "LE" },
  { code: "420095040", nome: "PAU", provincia: "OR" },
  { code: "406030073", nome: "PAULARO", provincia: "UD" },
  { code: "420092046", nome: "PAULI ARBAREI", provincia: "CA" },
  { code: "420095041", nome: "PAULILATINO", provincia: "OR" },
  { code: "403015169", nome: "PAULLO", provincia: "MI" },
  { code: "415062049", nome: "PAUPISI", provincia: "BN" },
  { code: "401001180", nome: "PAVAROLO", provincia: "TO" },
  { code: "406030074", nome: "PAVIA DI UDINE", provincia: "UD" },
  { code: "403018110", nome: "PAVIA", provincia: "PV" },
  { code: "401001181", nome: "PAVONE CANAVESE", provincia: "TO" },
  { code: "403017137", nome: "PAVONE DEL MELLA", provincia: "BS" },
  { code: "408036030", nome: "PAVULLO NEL FRIGNANO", provincia: "MO" },
  { code: "418080058", nome: "PAZZANO", provincia: "RC" },
  { code: "409050025", nome: "PECCIOLI", provincia: "PI" },
  { code: "401006128", nome: "PECETTO DI VALENZA", provincia: "AL" },
  { code: "401001183", nome: "PECETTO TORINESE", provincia: "TO" },
  { code: "419087034", nome: "PEDARA", provincia: "CT" },
  { code: "411109030", nome: "PEDASO", provincia: "FM" },
  { code: "405025036", nome: "PEDAVENA", provincia: "BL" },
  { code: "405024076", nome: "PEDEMONTE", provincia: "VI" },
  { code: "405026056", nome: "PEDEROBBA", provincia: "TV" },
  { code: "403014047", nome: "PEDESINA", provincia: "SO" },
  { code: "418078096", nome: "PEDIVIGLIANO", provincia: "CS" },
  { code: "403016160", nome: "PEDRENGO", provincia: "BG" },
  { code: "403013178", nome: "PEGLIO", provincia: "CO" },
  { code: "411141041", nome: "PEGLIO", provincia: "PU" },
  { code: "403020039", nome: "PEGOGNAGA", provincia: "MN" },
  { code: "403016161", nome: "PEIA", provincia: "BG" },
  { code: "404022136", nome: "PEIO", provincia: "TN" },
  { code: "409048032", nome: "PELAGO", provincia: "FI" },
  { code: "401003115", nome: "PELLA", provincia: "NO" },
  { code: "408034028", nome: "PELLEGRINO PARMENSE", provincia: "PR" },
  { code: "415065090", nome: "PELLEZZANO", provincia: "SA" },
  { code: "404022137", nome: "PELLIZZANO", provincia: "TN" },
  { code: "404022138", nome: "PELUGO", provincia: "TN" },
  { code: "401005083", nome: "PENANGO", provincia: "AT" },
  { code: "410055026", nome: "PENNA IN TEVERINA", provincia: "TR" },
  { code: "411043035", nome: "PENNA SAN GIOVANNI", provincia: "MC" },
  { code: "413067033", nome: "PENNA SANT\'ANDREA", provincia: "TE" },
  { code: "408099024", nome: "PENNABILLI", provincia: "RN" },
  { code: "413069063", nome: "PENNADOMO", provincia: "CH" },
  { code: "413069064", nome: "PENNAPIEDIMONTE", provincia: "CH" },
  { code: "413068027", nome: "PENNE", provincia: "PE" },
  { code: "418079092", nome: "PENTONE", provincia: "CZ" },
  { code: "413069065", nome: "PERANO", provincia: "CH" },
  { code: "405025037", nome: "PERAROLO DI CADORE", provincia: "BL" },
  { code: "404021063", nome: "PERCA", provincia: "BZ" },
  { code: "412058076", nome: "PERCILE", provincia: "RM" },
  { code: "420091072", nome: "PERDASDEFOGU", provincia: "NU" },
  { code: "420092047", nome: "PERDAXIUS", provincia: "CA" },
  { code: "415065091", nome: "PERDIFUMO", provincia: "SA" },
  { code: "413066067", nome: "PERETO", provincia: "AQ" },
  { code: "420090056", nome: "PERFUGAS", provincia: "SS" },
  { code: "404022139", nome: "PERGINE VALSUGANA", provincia: "TN" },
  { code: "411141043", nome: "PERGOLA", provincia: "PU" },
  { code: "407008040", nome: "PERINALDO", provincia: "IM" },
  { code: "415065092", nome: "PERITO", provincia: "SA" },
  { code: "403097067", nome: "PERLEDO", provincia: "LC" },
  { code: "401004161", nome: "PERLETTO", provincia: "CN" },
  { code: "401004162", nome: "PERLO", provincia: "CN" },
  { code: "402007048", nome: "PERLOZ", provincia: "AO" },
  { code: "405028061", nome: "PERNUMIA", provincia: "PD" },
  { code: "403015170", nome: "PERO", provincia: "MI" },
  { code: "401001184", nome: "PEROSA ARGENTINA", provincia: "TO" },
  { code: "401001185", nome: "PEROSA CANAVESE", provincia: "TO" },
  { code: "401001186", nome: "PERRERO", provincia: "TO" },
  { code: "403019068", nome: "PERSICO DOSIMO", provincia: "CR" },
  { code: "401002091", nome: "PERTENGO", provincia: "VC" },
  { code: "403017139", nome: "PERTICA ALTA", provincia: "BS" },
  { code: "403017140", nome: "PERTICA BASSA", provincia: "BS" },
  { code: "415065093", nome: "PERTOSA", provincia: "SA" },
  { code: "401001187", nome: "PERTUSIO", provincia: "TO" },
  { code: "410054039", nome: "PERUGIA", provincia: "PG" },
  { code: "411141044", nome: "PESARO", provincia: "PU" },
  { code: "409046022", nome: "PESCAGLIA", provincia: "LU" },
  { code: "405023058", nome: "PESCANTINA", provincia: "VR" },
  { code: "413068028", nome: "PESCARA", provincia: "PE" },
  { code: "403019069", nome: "PESCAROLO ED UNITI", provincia: "CR" },
  { code: "413066068", nome: "PESCASSEROLI", provincia: "AQ" },
  { code: "403097068", nome: "PESCATE", provincia: "LC" },
  { code: "414094031", nome: "PESCHE", provincia: "IS" },
  { code: "416071038", nome: "PESCHICI", provincia: "FG" },
  { code: "403015171", nome: "PESCHIERA BORROMEO", provincia: "MI" },
  { code: "405023059", nome: "PESCHIERA DEL GARDA", provincia: "VR" },
  { code: "409047012", nome: "PESCIA", provincia: "PT" },
  { code: "413066069", nome: "PESCINA", provincia: "AQ" },
  { code: "415062050", nome: "PESCO SANNITA", provincia: "BN" },
  { code: "413066070", nome: "PESCOCOSTANZO", provincia: "AQ" },
  { code: "414094032", nome: "PESCOLANCIANO", provincia: "IS" },
  { code: "417076058", nome: "PESCOPAGANO", provincia: "PZ" },
  { code: "414094033", nome: "PESCOPENNATARO", provincia: "IS" },
  { code: "412057049", nome: "PESCOROCCHIANO", provincia: "RI" },
  { code: "413068029", nome: "PESCOSANSONESCO", provincia: "PE" },
  { code: "412060049", nome: "PESCOSOLIDO", provincia: "FR" },
  { code: "403015172", nome: "PESSANO CON BORNAGO", provincia: "MI" },
  { code: "403019070", nome: "PESSINA CREMONESE", provincia: "CR" },
  { code: "401001188", nome: "PESSINETTO", provincia: "TO" },
  { code: "414070051", nome: "PETACCIATO", provincia: "CB" },
  { code: "418101017", nome: "PETILIA POLICASTRO", provincia: "KR" },
  { code: "415065094", nome: "PETINA", provincia: "SA" },
  { code: "419082055", nome: "PETRALIA SOPRANA", provincia: "PA" },
  { code: "419082056", nome: "PETRALIA SOTTANA", provincia: "PA" },
  { code: "412057050", nome: "PETRELLA SALTO", provincia: "RI" },
  { code: "414070052", nome: "PETRELLA TIFERNINA", provincia: "CB" },
  { code: "411141045", nome: "PETRIANO", provincia: "PU" },
  { code: "411043036", nome: "PETRIOLO", provincia: "MC" },
  { code: "411109031", nome: "PETRITOLI", provincia: "FM" },
  { code: "418079094", nome: "PETRIZZI", provincia: "CZ" },
  { code: "418079095", nome: "PETRONA\'", provincia: "CZ" },
  { code: "419081024", nome: "PETROSINO", provincia: "TP" },
  { code: "415064071", nome: "PETRURO IRPINO", provincia: "AV" },
  { code: "401003116", nome: "PETTENASCO", provincia: "NO" },
  { code: "401096042", nome: "PETTINENGO", provincia: "BI" },
  { code: "419083067", nome: "PETTINEO", provincia: "ME" },
  { code: "414094034", nome: "PETTORANELLO DEL MOLISE", provincia: "IS" },
  { code: "413066071", nome: "PETTORANO SUL GIZIO", provincia: "AQ" },
  { code: "405029035", nome: "PETTORAZZA GRIMANI", provincia: "RO" },
  { code: "401004163", nome: "PEVERAGNO", provincia: "CN" },
  { code: "401002093", nome: "PEZZANA", provincia: "VC" },
  { code: "403017141", nome: "PEZZAZE", provincia: "BS" },
  { code: "401004164", nome: "PEZZOLO VALLE UZZONE", provincia: "CN" },
  { code: "405028062", nome: "PIACENZA D\'ADIGE", provincia: "PD" },
  { code: "408033032", nome: "PIACENZA", provincia: "PC" },
  { code: "403019116", nome: "PIADENA DRIZZONA", provincia: "CR" },
  { code: "415065095", nome: "PIAGGINE", provincia: "SA" },
  { code: "403017142", nome: "PIAN CAMUNO", provincia: "BS" },
  { code: "407009048", nome: "PIANA CRIXIA", provincia: "SV" },
  { code: "419082057", nome: "PIANA DEGLI ALBANESI", provincia: "PA" },
  { code: "415061056", nome: "PIANA DI MONTE VERNA", provincia: "CE" },
  { code: "409052020", nome: "PIANCASTAGNAIO", provincia: "SI" },
  { code: "403017206", nome: "PIANCOGNO", provincia: "BS" },
  { code: "411141047", nome: "PIANDIMELETO", provincia: "PU" },
  { code: "418078097", nome: "PIANE CRATI", provincia: "CS" },
  { code: "413068030", nome: "PIANELLA", provincia: "PE" },
  { code: "403013183", nome: "PIANELLO DEL LARIO", provincia: "CO" },
  { code: "408033033", nome: "PIANELLO VAL TIDONE", provincia: "PC" },
  { code: "403019072", nome: "PIANENGO", provincia: "CR" },
  { code: "401001189", nome: "PIANEZZA", provincia: "TO" },
  { code: "405024077", nome: "PIANEZZE", provincia: "VI" },
  { code: "401004165", nome: "PIANFEI", provincia: "CN" },
  { code: "403016162", nome: "PIANICO", provincia: "BG" },
  { code: "405027028", nome: "PIANIGA", provincia: "VE" },
  { code: "415063053", nome: "PIANO DI SORRENTO", provincia: "NA" },
  { code: "418079096", nome: "PIANOPOLI", provincia: "CZ" },
  { code: "408037047", nome: "PIANORO", provincia: "BO" },
  { code: "412056043", nome: "PIANSANO", provincia: "VT" },
  { code: "403014048", nome: "PIANTEDO", provincia: "SO" },
  { code: "403016163", nome: "PIARIO", provincia: "BG" },
  { code: "401004166", nome: "PIASCO", provincia: "CN" },
  { code: "403014049", nome: "PIATEDA", provincia: "SO" },
  { code: "401096043", nome: "PIATTO", provincia: "BI" },
  { code: "409046023", nome: "PIAZZA AL SERCHIO", provincia: "LU" },
  { code: "419086014", nome: "PIAZZA ARMERINA", provincia: "EN" },
  { code: "403016164", nome: "PIAZZA BREMBANA", provincia: "BG" },
  { code: "403016165", nome: "PIAZZATORRE", provincia: "BG" },
  { code: "405028063", nome: "PIAZZOLA SUL BRENTA", provincia: "PD" },
  { code: "403016166", nome: "PIAZZOLO", provincia: "BG" },
  { code: "413068031", nome: "PICCIANO", provincia: "PE" },
  { code: "417076059", nome: "PICERNO", provincia: "PZ" },
  { code: "412060050", nome: "PICINISCO", provincia: "FR" },
  { code: "412060051", nome: "PICO", provincia: "FR" },
  { code: "401005084", nome: "PIEA", provincia: "AT" },
  { code: "401096044", nome: "PIEDICAVALLO", provincia: "BI" },
  { code: "419087035", nome: "PIEDIMONTE ETNEO", provincia: "CT" },
  { code: "415061057", nome: "PIEDIMONTE MATESE", provincia: "CE" },
  { code: "412060052", nome: "PIEDIMONTE SAN GERMANO", provincia: "FR" },
  { code: "401103053", nome: "PIEDIMULERA", provincia: "VB" },
  { code: "410054040", nome: "PIEGARO", provincia: "PG" },
  { code: "409052021", nome: "PIENZA", provincia: "SI" },
  { code: "403019073", nome: "PIERANICA", provincia: "CR" },
  { code: "403018111", nome: "PIETRA DE\' GIORGI", provincia: "PV" },
  { code: "407009049", nome: "PIETRA LIGURE", provincia: "SV" },
  { code: "401006129", nome: "PIETRA MARAZZI", provincia: "AL" },
  { code: "414094035", nome: "PIETRABBONDANTE", provincia: "IS" },
  { code: "407008041", nome: "PIETRABRUNA", provincia: "IM" },
  { code: "413067034", nome: "PIETRACAMELA", provincia: "TE" },
  { code: "414070053", nome: "PIETRACATELLA", provincia: "CB" },
  { code: "414070054", nome: "PIETRACUPA", provincia: "CB" },
  { code: "415064072", nome: "PIETRADEFUSI", provincia: "AV" },
  { code: "413069103", nome: "PIETRAFERRAZZANA", provincia: "CH" },
  { code: "418078098", nome: "PIETRAFITTA", provincia: "CS" },
  { code: "417076060", nome: "PIETRAGALLA", provincia: "PZ" },
  { code: "410054041", nome: "PIETRALUNGA", provincia: "PG" },
  { code: "415061058", nome: "PIETRAMELARA", provincia: "CE" },
  { code: "416071039", nome: "PIETRAMONTECORVINO", provincia: "FG" },
  { code: "413068032", nome: "PIETRANICO", provincia: "PE" },
  { code: "418078099", nome: "PIETRAPAOLA", provincia: "CS" },
  { code: "417076061", nome: "PIETRAPERTOSA", provincia: "PZ" },
  { code: "419086015", nome: "PIETRAPERZIA", provincia: "EN" },
  { code: "401004167", nome: "PIETRAPORZIO", provincia: "CN" },
  { code: "415062051", nome: "PIETRAROIA", provincia: "BN" },
  { code: "411141048", nome: "PIETRARUBBIA", provincia: "PU" },
  { code: "409046024", nome: "PIETRASANTA", provincia: "LU" },
  { code: "415064073", nome: "PIETRASTORNINA", provincia: "AV" },
  { code: "415061059", nome: "PIETRAVAIRANO", provincia: "CE" },
  { code: "415062052", nome: "PIETRELCINA", provincia: "BN" },
  { code: "409047013", nome: "PIEVE A NIEVOLE", provincia: "PT" },
  { code: "403018112", nome: "PIEVE ALBIGNOLA", provincia: "PV" },
  { code: "403019074", nome: "PIEVE D\'OLMI", provincia: "CR" },
  { code: "403018113", nome: "PIEVE DEL CAIRO", provincia: "PV" },
  { code: "405026096", nome: "PIEVE DEL GRAPPA", provincia: "TV" },
  { code: "404022234", nome: "PIEVE DI BONO-PREZZO", provincia: "TN" },
  { code: "405025039", nome: "PIEVE DI CADORE", provincia: "BL" },
  { code: "408037048", nome: "PIEVE DI CENTO", provincia: "BO" },
  { code: "405026057", nome: "PIEVE DI SOLIGO", provincia: "TV" },
  { code: "407008042", nome: "PIEVE DI TECO", provincia: "IM" },
  { code: "403015173", nome: "PIEVE EMANUELE", provincia: "MI" },
  { code: "403098045", nome: "PIEVE FISSIRAGA", provincia: "LO" },
  { code: "409046025", nome: "PIEVE FOSCIANA", provincia: "LU" },
  { code: "407010043", nome: "PIEVE LIGURE", provincia: "GE" },
  { code: "403018114", nome: "PIEVE PORTO MORONE", provincia: "PV" },
  { code: "403019075", nome: "PIEVE SAN GIACOMO", provincia: "CR" },
  { code: "409051030", nome: "PIEVE SANTO STEFANO", provincia: "AR" },
  { code: "404022142", nome: "PIEVE TESINO", provincia: "TN" },
  { code: "411043038", nome: "PIEVE TORINA", provincia: "MC" },
  { code: "401103054", nome: "PIEVE VERGONTE", provincia: "VB" },
  { code: "408036031", nome: "PIEVEPELAGO", provincia: "MO" },
  { code: "412060053", nome: "PIGLIO", provincia: "FR" },
  { code: "407008043", nome: "PIGNA", provincia: "IM" },
  { code: "412060054", nome: "PIGNATARO INTERAMNA", provincia: "FR" },
  { code: "415061060", nome: "PIGNATARO MAGGIORE", provincia: "CE" },
  { code: "417076062", nome: "PIGNOLA", provincia: "PZ" },
  { code: "407011021", nome: "PIGNONE", provincia: "SP" },
  { code: "403013184", nome: "PIGRA", provincia: "CO" },
  { code: "401002096", nome: "PILA", provincia: "VC" },
  { code: "420092048", nome: "PIMENTEL", provincia: "CA" },
  { code: "415063054", nome: "PIMONTE", provincia: "NA" },
  { code: "403018115", nome: "PINAROLO PO", provincia: "PV" },
  { code: "401001190", nome: "PINASCA", provincia: "TO" },
  { code: "405029036", nome: "PINCARA", provincia: "RO" },
  { code: "401001191", nome: "PINEROLO", provincia: "TO" },
  { code: "413067035", nome: "PINETO", provincia: "TE" },
  { code: "401005085", nome: "PINO D\'ASTI", provincia: "AT" },
  { code: "401001192", nome: "PINO TORINESE", provincia: "TO" },
  { code: "406093030", nome: "PINZANO AL TAGLIAMENTO", provincia: "PN" },
  { code: "404022143", nome: "PINZOLO", provincia: "TN" },
  { code: "411141049", nome: "PIOBBICO", provincia: "PU" },
  { code: "401004168", nome: "PIOBESI D\'ALBA", provincia: "CN" },
  { code: "401001193", nome: "PIOBESI TORINESE", provincia: "TO" },
  { code: "401002097", nome: "PIODE", provincia: "VC" },
  { code: "403015175", nome: "PIOLTELLO", provincia: "MI" },
  { code: "405028064", nome: "PIOMBINO DESE", provincia: "PD" },
  { code: "409049012", nome: "PIOMBINO", provincia: "LI" },
  { code: "411043039", nome: "PIORACO", provincia: "MC" },
  { code: "401001194", nome: "PIOSSASCO", provincia: "TO" },
  { code: "401005086", nome: "PIOVA\' MASSAIA", provincia: "AT" },
  { code: "405028065", nome: "PIOVE DI SACCO", provincia: "PD" },
  { code: "405024078", nome: "PIOVENE ROCCHETTE", provincia: "VI" },
  { code: "408033034", nome: "PIOZZANO", provincia: "PC" },
  { code: "401004169", nome: "PIOZZO", provincia: "CN" },
  { code: "419083068", nome: "PIRAINO", provincia: "ME" },
  { code: "409050026", nome: "PISA", provincia: "PI" },
  { code: "401003119", nome: "PISANO", provincia: "NO" },
  { code: "401001195", nome: "PISCINA", provincia: "TO" },
  { code: "420092107", nome: "PISCINAS", provincia: "CA" },
  { code: "415065096", nome: "PISCIOTTA", provincia: "SA" },
  { code: "403017143", nome: "PISOGNE", provincia: "BS" },
  { code: "412058077", nome: "PISONIANO", provincia: "RM" },
  { code: "417077020", nome: "PISTICCI", provincia: "MT" },
  { code: "409047014", nome: "PISTOIA", provincia: "PT" },
  { code: "409053019", nome: "PITIGLIANO", provincia: "GR" },
  { code: "403020041", nome: "PIUBEGA", provincia: "MN" },
  { code: "403014050", nome: "PIURO", provincia: "SO" },
  { code: "401001196", nome: "PIVERONE", provincia: "TO" },
  { code: "403018116", nome: "PIZZALE", provincia: "PV" },
  { code: "403019076", nome: "PIZZIGHETTONE", provincia: "CR" },
  { code: "418102027", nome: "PIZZO", provincia: "VV" },
  { code: "413069066", nome: "PIZZOFERRATO", provincia: "CH" },
  { code: "413066072", nome: "PIZZOLI", provincia: "AQ" },
  { code: "414094036", nome: "PIZZONE", provincia: "IS" },
  { code: "418102028", nome: "PIZZONI", provincia: "VV" },
  { code: "418080059", nome: "PLACANICA", provincia: "RC" },
  { code: "418078100", nome: "PLATACI", provincia: "CS" },
  { code: "418079099", nome: "PLATANIA", provincia: "CZ" },
  { code: "418080060", nome: "PLATI\'", provincia: "RC" },
  { code: "404021064", nome: "PLAUS", provincia: "BZ" },
  { code: "403013185", nome: "PLESIO", provincia: "CO" },
  { code: "420090057", nome: "PLOAGHE", provincia: "SS" },
  { code: "407009050", nome: "PLODIO", provincia: "SV" },
  { code: "401004170", nome: "POCAPAGLIA", provincia: "CN" },
  { code: "406030075", nome: "POCENIA", provincia: "UD" },
  { code: "409045013", nome: "PODENZANA", provincia: "MS" },
  { code: "408033035", nome: "PODENZANO", provincia: "PC" },
  { code: "412060055", nome: "POFI", provincia: "FR" },
  { code: "416075061", nome: "POGGIARDO", provincia: "LE" },
  { code: "409052022", nome: "POGGIBONSI", provincia: "SI" },
  { code: "409100004", nome: "POGGIO A CAIANO", provincia: "PO" },
  { code: "412057051", nome: "POGGIO BUSTONE", provincia: "RI" },
  { code: "412057052", nome: "POGGIO CATINO", provincia: "RI" },
  { code: "416071040", nome: "POGGIO IMPERIALE", provincia: "FG" },
  { code: "412057053", nome: "POGGIO MIRTETO", provincia: "RI" },
  { code: "412057054", nome: "POGGIO MOIANO", provincia: "RI" },
  { code: "412057055", nome: "POGGIO NATIVO", provincia: "RI" },
  { code: "413066073", nome: "POGGIO PICENZE", provincia: "AQ" },
  { code: "408038018", nome: "POGGIO RENATICO", provincia: "FE" },
  { code: "403020042", nome: "POGGIO RUSCO", provincia: "MN" },
  { code: "412057056", nome: "POGGIO SAN LORENZO", provincia: "RI" },
  { code: "411042037", nome: "POGGIO SAN MARCELLO", provincia: "AN" },
  { code: "411043040", nome: "POGGIO SAN VICINO", provincia: "MC" },
  { code: "414094037", nome: "POGGIO SANNITA", provincia: "IS" },
  { code: "408099028", nome: "POGGIO TORRIANA", provincia: "RN" },
  { code: "410054042", nome: "POGGIODOMO", provincia: "PG" },
  { code: "413069067", nome: "POGGIOFIORITO", provincia: "CH" },
  { code: "415063055", nome: "POGGIOMARINO", provincia: "NA" },
  { code: "419081016", nome: "POGGIOREALE", provincia: "TP" },
  { code: "416072034", nome: "POGGIORSINI", provincia: "BA" },
  { code: "403014051", nome: "POGGIRIDENTI", provincia: "SO" },
  { code: "403015176", nome: "POGLIANO MILANESE", provincia: "MI" },
  { code: "403013186", nome: "POGNANA LARIO", provincia: "CO" },
  { code: "403016167", nome: "POGNANO", provincia: "BG" },
  { code: "401003120", nome: "POGNO", provincia: "NO" },
  { code: "401001197", nome: "POIRINO", provincia: "TO" },
  { code: "405024079", nome: "POJANA MAGGIORE", provincia: "VI" },
  { code: "403017144", nome: "POLAVENO", provincia: "BS" },
  { code: "406093031", nome: "POLCENIGO", provincia: "PN" },
  { code: "405029037", nome: "POLESELLA", provincia: "RO" },
  { code: "408034050", nome: "POLESINE ZIBELLO", provincia: "PR" },
  { code: "412058078", nome: "POLI", provincia: "RM" },
  { code: "418102029", nome: "POLIA", provincia: "VV" },
  { code: "417077021", nome: "POLICORO", provincia: "MT" },
  { code: "416072035", nome: "POLIGNANO A MARE", provincia: "BA" },
  { code: "408036032", nome: "POLINAGO", provincia: "MO" },
  { code: "410055027", nome: "POLINO", provincia: "TR" },
  { code: "418080061", nome: "POLISTENA", provincia: "RC" },
  { code: "419082058", nome: "POLIZZI GENEROSA", provincia: "PA" },
  { code: "415065097", nome: "POLLA", provincia: "SA" },
  { code: "402007049", nome: "POLLEIN", provincia: "AO" },
  { code: "415063056", nome: "POLLENA TROCCHIA", provincia: "NA" },
  { code: "411043041", nome: "POLLENZA", provincia: "MC" },
  { code: "415065098", nome: "POLLICA", provincia: "SA" },
  { code: "419082059", nome: "POLLINA", provincia: "PA" },
  { code: "401096046", nome: "POLLONE", provincia: "BI" },
  { code: "413069068", nome: "POLLUTRI", provincia: "CH" },
  { code: "401004171", nome: "POLONGHERA", provincia: "CN" },
  { code: "403017145", nome: "POLPENAZZE", provincia: "BS" },
  { code: "405028066", nome: "POLVERARA", provincia: "PD" },
  { code: "411042038", nome: "POLVERIGI", provincia: "AN" },
  { code: "409050027", nome: "POMARANCE", provincia: "PI" },
  { code: "401001198", nome: "POMARETTO", provincia: "TO" },
  { code: "417077022", nome: "POMARICO", provincia: "MT" },
  { code: "401006131", nome: "POMARO MONFERRATO", provincia: "AL" },
  { code: "404022144", nome: "POMAROLO", provincia: "TN" },
  { code: "401003121", nome: "POMBIA", provincia: "NO" },
  { code: "412058079", nome: "POMEZIA", provincia: "RM" },
  { code: "415063057", nome: "POMIGLIANO D\'ARCO", provincia: "NA" },
  { code: "415063058", nome: "POMPEI", provincia: "NA" },
  { code: "407008044", nome: "POMPEIANA", provincia: "IM" },
  { code: "403017146", nome: "POMPIANO", provincia: "BS" },
  { code: "403020043", nome: "POMPONESCO", provincia: "MN" },
  { code: "420095042", nome: "POMPU", provincia: "OR" },
  { code: "403017147", nome: "PONCARALE", provincia: "BS" },
  { code: "401096047", nome: "PONDERANO", provincia: "BI" },
  { code: "403013187", nome: "PONNA", provincia: "CO" },
  { code: "409050028", nome: "PONSACCO", provincia: "PI" },
  { code: "405028067", nome: "PONSO", provincia: "PD" },
  { code: "401001199", nome: "PONT CANAVESE", provincia: "TO" },
  { code: "402007052", nome: "PONT-SAINT-MARTIN", provincia: "AO" },
  { code: "409048033", nome: "PONTASSIEVE", provincia: "FI" },
  { code: "402007050", nome: "PONTBOSET", provincia: "AO" },
  { code: "409047016", nome: "PONTE BUGGIANESE", provincia: "PT" },
  { code: "408033036", nome: "PONTE DELL\'OLIO", provincia: "PC" },
  { code: "403017148", nome: "PONTE DI LEGNO", provincia: "BS" },
  { code: "405026058", nome: "PONTE DI PIAVE", provincia: "TV" },
  { code: "404021065", nome: "PONTE GARDENA", provincia: "BZ" },
  { code: "403014052", nome: "PONTE IN VALTELLINA", provincia: "SO" },
  { code: "403013188", nome: "PONTE LAMBRO", provincia: "CO" },
  { code: "405025040", nome: "PONTE NELLE ALPI", provincia: "BL" },
  { code: "403018117", nome: "PONTE NIZZA", provincia: "PV" },
  { code: "403016168", nome: "PONTE NOSSA", provincia: "BG" },
  { code: "405028069", nome: "PONTE SAN NICOLO\'", provincia: "PD" },
  { code: "403016170", nome: "PONTE SAN PIETRO", provincia: "BG" },
  { code: "415062053", nome: "PONTE", provincia: "BN" },
  { code: "406030076", nome: "PONTEBBA", provincia: "UD" },
  { code: "415065099", nome: "PONTECAGNANO FAIANO", provincia: "SA" },
  { code: "405029038", nome: "PONTECCHIO POLESINE", provincia: "RO" },
  { code: "401004172", nome: "PONTECHIANALE", provincia: "CN" },
  { code: "412060056", nome: "PONTECORVO", provincia: "FR" },
  { code: "401006132", nome: "PONTECURONE", provincia: "AL" },
  { code: "407008045", nome: "PONTEDASSIO", provincia: "IM" },
  { code: "409050029", nome: "PONTEDERA", provincia: "PI" },
  { code: "415062054", nome: "PONTELANDOLFO", provincia: "BN" },
  { code: "415061061", nome: "PONTELATONE", provincia: "CE" },
  { code: "405028068", nome: "PONTELONGO", provincia: "PD" },
  { code: "408033037", nome: "PONTENURE", provincia: "PC" },
  { code: "403016169", nome: "PONTERANICA", provincia: "BG" },
  { code: "401006133", nome: "PONTESTURA", provincia: "AL" },
  { code: "403017149", nome: "PONTEVICO", provincia: "BS" },
  { code: "402007051", nome: "PONTEY", provincia: "AO" },
  { code: "403020044", nome: "PONTI SUL MINCIO", provincia: "MN" },
  { code: "401006134", nome: "PONTI", provincia: "AL" },
  { code: "403016171", nome: "PONTIDA", provincia: "BG" },
  { code: "412059017", nome: "PONTINIA", provincia: "LT" },
  { code: "407009051", nome: "PONTINVREA", provincia: "SV" },
  { code: "403016172", nome: "PONTIROLO NUOVO", provincia: "BG" },
  { code: "403017150", nome: "PONTOGLIO", provincia: "BS" },
  { code: "409045014", nome: "PONTREMOLI", provincia: "MS" },
  { code: "412059018", nome: "PONZA", provincia: "LT" },
  { code: "411109032", nome: "PONZANO DI FERMO", provincia: "FM" },
  { code: "401006135", nome: "PONZANO MONFERRATO", provincia: "AL" },
  { code: "412058080", nome: "PONZANO ROMANO", provincia: "RM" },
  { code: "405026059", nome: "PONZANO VENETO", provincia: "TV" },
  { code: "401006136", nome: "PONZONE", provincia: "AL" },
  { code: "413068933", nome: "POPOLI TERME", provincia: "PE" },
  { code: "409051031", nome: "POPPI", provincia: "AR" },
  { code: "410055028", nome: "PORANO", provincia: "TR" },
  { code: "409046026", nome: "PORCARI", provincia: "LU" },
  { code: "406093032", nome: "PORCIA", provincia: "PN" },
  { code: "406093033", nome: "PORDENONE", provincia: "PN" },
  { code: "403013189", nome: "PORLEZZA", provincia: "CO" },
  { code: "407008046", nome: "PORNASSIO", provincia: "IM" },
  { code: "406030077", nome: "PORPETTO", provincia: "UD" },
  { code: "401005087", nome: "PORTACOMARO", provincia: "AT" },
  { code: "403018118", nome: "PORTALBERA", provincia: "PV" },
  { code: "404022244", nome: "PORTE DI RENDENA", provincia: "TN" },
  { code: "401001200", nome: "PORTE", provincia: "TO" },
  { code: "415063059", nome: "PORTICI", provincia: "NA" },
  { code: "415061062", nome: "PORTICO DI CASERTA", provincia: "CE" },
  { code: "408140031", nome: "PORTICO E SAN BENEDETTO", provincia: "FC" },
  { code: "418080062", nome: "PORTIGLIOLA", provincia: "RC" },
  { code: "409049013", nome: "PORTO AZZURRO", provincia: "LI" },
  { code: "403012113", nome: "PORTO CERESIO", provincia: "VA" },
  { code: "416075097", nome: "PORTO CESAREO", provincia: "LE" },
  { code: "419084028", nome: "PORTO EMPEDOCLE", provincia: "AG" },
  { code: "403020045", nome: "PORTO MANTOVANO", provincia: "MN" },
  { code: "411043042", nome: "PORTO RECANATI", provincia: "MC" },
  { code: "411109033", nome: "PORTO SAN GIORGIO", provincia: "FM" },
  { code: "411109034", nome: "PORTO SANT\'ELPIDIO", provincia: "FM" },
  { code: "405029039", nome: "PORTO TOLLE", provincia: "RO" },
  { code: "420090058", nome: "PORTO TORRES", provincia: "SS" },
  { code: "403012114", nome: "PORTO VALTRAVAGLIA", provincia: "VA" },
  { code: "405029052", nome: "PORTO VIRO", provincia: "RO" },
  { code: "405026060", nome: "PORTOBUFFOLE\'", provincia: "TV" },
  { code: "414070055", nome: "PORTOCANNONE", provincia: "CB" },
  { code: "409049014", nome: "PORTOFERRAIO", provincia: "LI" },
  { code: "407010044", nome: "PORTOFINO", provincia: "GE" },
  { code: "405027029", nome: "PORTOGRUARO", provincia: "VE" },
  { code: "408038019", nome: "PORTOMAGGIORE", provincia: "FE" },
  { code: "419089020", nome: "PORTOPALO DI CAPO PASSERO", provincia: "SR" },
  { code: "420092049", nome: "PORTOSCUSO", provincia: "CA" },
  { code: "407011022", nome: "PORTOVENERE", provincia: "SP" },
  { code: "401096048", nome: "PORTULA", provincia: "BI" },
  { code: "420091073", nome: "POSADA", provincia: "NU" },
  { code: "405024080", nome: "POSINA", provincia: "VI" },
  { code: "415065100", nome: "POSITANO", provincia: "SA" },
  { code: "405026061", nome: "POSSAGNO", provincia: "TV" },
  { code: "412060057", nome: "POSTA FIBRENO", provincia: "FR" },
  { code: "412057057", nome: "POSTA", provincia: "RI" },
  { code: "404021066", nome: "POSTAL", provincia: "BZ" },
  { code: "403014053", nome: "POSTALESIO", provincia: "SO" },
  { code: "415065101", nome: "POSTIGLIONE", provincia: "SA" },
  { code: "401002102", nome: "POSTUA", provincia: "VC" },
  { code: "411043043", nome: "POTENZA PICENA", provincia: "MC" },
  { code: "417076063", nome: "POTENZA", provincia: "PZ" },
  { code: "405024081", nome: "POVE DEL GRAPPA", provincia: "VI" },
  { code: "405023060", nome: "POVEGLIANO VERONESE", provincia: "VR" },
  { code: "405026062", nome: "POVEGLIANO", provincia: "TV" },
  { code: "408035029", nome: "POVIGLIO", provincia: "RE" },
  { code: "406030078", nome: "POVOLETTO", provincia: "UD" },
  { code: "412057058", nome: "POZZAGLIA SABINO", provincia: "RI" },
  { code: "403019077", nome: "POZZAGLIO ED UNITI", provincia: "CR" },
  { code: "419088008", nome: "POZZALLO", provincia: "RG" },
  { code: "414094038", nome: "POZZILLI", provincia: "IS" },
  { code: "403015177", nome: "POZZO D\'ADDA", provincia: "MI" },
  { code: "401006137", nome: "POZZOL GROPPO", provincia: "AL" },
  { code: "403017151", nome: "POZZOLENGO", provincia: "BS" },
  { code: "405024082", nome: "POZZOLEONE", provincia: "VI" },
  { code: "401006138", nome: "POZZOLO FORMIGARO", provincia: "AL" },
  { code: "420090059", nome: "POZZOMAGGIORE", provincia: "SS" },
  { code: "405028070", nome: "POZZONOVO", provincia: "PD" },
  { code: "415063060", nome: "POZZUOLI", provincia: "NA" },
  { code: "406030079", nome: "POZZUOLO DEL FRIULI", provincia: "UD" },
  { code: "403015178", nome: "POZZUOLO MARTESANA", provincia: "MI" },
  { code: "403016173", nome: "PRADALUNGA", provincia: "BG" },
  { code: "406030080", nome: "PRADAMANO", provincia: "UD" },
  { code: "401004173", nome: "PRADLEVES", provincia: "CN" },
  { code: "401001201", nome: "PRAGELATO", provincia: "TO" },
  { code: "418078101", nome: "PRAIA A MARE", provincia: "CS" },
  { code: "415065102", nome: "PRAIANO", provincia: "SA" },
  { code: "403017152", nome: "PRALBOINO", provincia: "BS" },
  { code: "401001202", nome: "PRALI", provincia: "TO" },
  { code: "401001203", nome: "PRALORMO", provincia: "TO" },
  { code: "401096049", nome: "PRALUNGO", provincia: "BI" },
  { code: "405027030", nome: "PRAMAGGIORE", provincia: "VE" },
  { code: "401001204", nome: "PRAMOLLO", provincia: "TO" },
  { code: "401002104", nome: "PRAROLO", provincia: "VC" },
  { code: "401001205", nome: "PRAROSTINO", provincia: "TO" },
  { code: "401006139", nome: "PRASCO", provincia: "AL" },
  { code: "401001206", nome: "PRASCORSANO", provincia: "TO" },
  { code: "403014054", nome: "PRATA CAMPORTACCIO", provincia: "SO" },
  { code: "413066074", nome: "PRATA D\'ANSIDONIA", provincia: "AQ" },
  { code: "406093034", nome: "PRATA DI PORDENONE", provincia: "PN" },
  { code: "415064074", nome: "PRATA DI PRINCIPATO ULTRA", provincia: "AV" },
  { code: "415061063", nome: "PRATA SANNITA", provincia: "CE" },
  { code: "415061064", nome: "PRATELLA", provincia: "CE" },
  { code: "401001207", nome: "PRATIGLIONE", provincia: "TO" },
  { code: "404021067", nome: "PRATO ALLO STELVIO", provincia: "BZ" },
  { code: "406030081", nome: "PRATO CARNICO", provincia: "UD" },
  { code: "401003122", nome: "PRATO SESIA", provincia: "NO" },
  { code: "409100005", nome: "PRATO", provincia: "PO" },
  { code: "413066075", nome: "PRATOLA PELIGNA", provincia: "AQ" },
  { code: "415064075", nome: "PRATOLA SERRA", provincia: "AV" },
  { code: "409051041", nome: "PRATOVECCHIO STIA", provincia: "AR" },
  { code: "406093035", nome: "PRAVISDOMINI", provincia: "PN" },
  { code: "401096050", nome: "PRAY", provincia: "BI" },
  { code: "401004174", nome: "PRAZZO", provincia: "CN" },
  { code: "402007053", nome: "PRE\'-SAINT-DIDIER", provincia: "AO" },
  { code: "406030082", nome: "PRECENICCO", provincia: "UD" },
  { code: "410054043", nome: "PRECI", provincia: "PG" },
  { code: "404022230", nome: "PREDAIA", provincia: "TN" },
  { code: "408140032", nome: "PREDAPPIO", provincia: "FC" },
  { code: "404022147", nome: "PREDAZZO", provincia: "TN" },
  { code: "404021068", nome: "PREDOI", provincia: "BZ" },
  { code: "403016174", nome: "PREDORE", provincia: "BG" },
  { code: "401006140", nome: "PREDOSA", provincia: "AL" },
  { code: "405026063", nome: "PREGANZIOL", provincia: "TV" },
  { code: "403015179", nome: "PREGNANA MILANESE", provincia: "MI" },
  { code: "407008047", nome: "PRELA\'", provincia: "IM" },
  { code: "403097069", nome: "PREMANA", provincia: "LC" },
  { code: "406030083", nome: "PREMARIACCO", provincia: "UD" },
  { code: "401103055", nome: "PREMENO", provincia: "VB" },
  { code: "401103056", nome: "PREMIA", provincia: "VB" },
  { code: "408140033", nome: "PREMILCUORE", provincia: "FC" },
  { code: "403016175", nome: "PREMOLO", provincia: "BG" },
  { code: "401103057", nome: "PREMOSELLO-CHIOVENDA", provincia: "VB" },
  { code: "406030084", nome: "PREONE", provincia: "UD" },
  { code: "406030085", nome: "PREPOTTO", provincia: "UD" },
  { code: "403017153", nome: "PRESEGLIE", provincia: "BS" },
  { code: "415061065", nome: "PRESENZANO", provincia: "CE" },
  { code: "403016176", nome: "PRESEZZO", provincia: "BG" },
  { code: "416075098", nome: "PRESICCE-ACQUARICA", provincia: "LE" },
  { code: "405023061", nome: "PRESSANA", provincia: "VR" },
  { code: "413069069", nome: "PRETORO", provincia: "CH" },
  { code: "403017155", nome: "PREVALLE", provincia: "BS" },
  { code: "413066076", nome: "PREZZA", provincia: "AQ" },
  { code: "401004175", nome: "PRIERO", provincia: "CN" },
  { code: "415065103", nome: "PRIGNANO CILENTO", provincia: "SA" },
  { code: "408036033", nome: "PRIGNANO SULLA SECCHIA", provincia: "MO" },
  { code: "403097070", nome: "PRIMALUNA", provincia: "LC" },
  { code: "404022245", nome: "PRIMIERO SAN MARTINO DI CASTROZZA", provincia: "TN" },
  { code: "401004176", nome: "PRIOCCA", provincia: "CN" },
  { code: "401004177", nome: "PRIOLA", provincia: "CN" },
  { code: "419089021", nome: "PRIOLO GARGALLO", provincia: "SR" },
  { code: "412059019", nome: "PRIVERNO", provincia: "LT" },
  { code: "419082060", nome: "PRIZZI", provincia: "PA" },
  { code: "412056044", nome: "PROCENO", provincia: "VT" },
  { code: "415063061", nome: "PROCIDA", provincia: "NA" },
  { code: "407010045", nome: "PROPATA", provincia: "GE" },
  { code: "403013192", nome: "PROSERPIO", provincia: "CO" },
  { code: "412059020", nome: "PROSSEDI", provincia: "LT" },
  { code: "403017156", nome: "PROVAGLIO D\'ISEO", provincia: "BS" },
  { code: "403017157", nome: "PROVAGLIO VAL SABBIA", provincia: "BS" },
  { code: "404021069", nome: "PROVES", provincia: "BZ" },
  { code: "414070056", nome: "PROVVIDENTI", provincia: "CB" },
  { code: "401004178", nome: "PRUNETTO", provincia: "CN" },
  { code: "403017158", nome: "PUEGNAGO SUL GARDA", provincia: "BS" },
  { code: "415062055", nome: "PUGLIANELLO", provincia: "BN" },
  { code: "420092050", nome: "PULA", provincia: "CA" },
  { code: "406030086", nome: "PULFERO", provincia: "UD" },
  { code: "416073022", nome: "PULSANO", provincia: "TA" },
  { code: "403016177", nome: "PUMENENGO", provincia: "BG" },
  { code: "403013193", nome: "PUSIANO", provincia: "CO" },
  { code: "420090060", nome: "PUTIFIGARI", provincia: "SS" },
  { code: "416072036", nome: "PUTIGNANO", provincia: "BA" },
  { code: "415064076", nome: "QUADRELLE", provincia: "AV" },
  { code: "413069070", nome: "QUADRI", provincia: "CH" },
  { code: "401001208", nome: "QUAGLIUZZO", provincia: "TO" },
  { code: "415063062", nome: "QUALIANO", provincia: "NA" },
  { code: "401005088", nome: "QUARANTI", provincia: "AT" },
  { code: "401096087", nome: "QUAREGNA CERRETO", provincia: "BI" },
  { code: "401006141", nome: "QUARGNENTO", provincia: "AL" },
  { code: "401103058", nome: "QUARNA SOPRA", provincia: "VB" },
  { code: "401103059", nome: "QUARNA SOTTO", provincia: "VB" },
  { code: "401002107", nome: "QUARONA", provincia: "VC" },
  { code: "409047017", nome: "QUARRATA", provincia: "PT" },
  { code: "402007054", nome: "QUART", provincia: "AO" },
  { code: "405027031", nome: "QUARTO D\'ALTINO", provincia: "VE" },
  { code: "415063063", nome: "QUARTO", provincia: "NA" },
  { code: "420092051", nome: "QUARTU SANT\'ELENA", provincia: "CA" },
  { code: "420092105", nome: "QUARTUCCIU", provincia: "CA" },
  { code: "401001209", nome: "QUASSOLO", provincia: "TO" },
  { code: "401006142", nome: "QUATTORDIO", provincia: "AL" },
  { code: "408035030", nome: "QUATTRO CASTELLA", provincia: "RE" },
  { code: "407009052", nome: "QUILIANO", provincia: "SV" },
  { code: "401001210", nome: "QUINCINETTO", provincia: "TO" },
  { code: "415064077", nome: "QUINDICI", provincia: "AV" },
  { code: "403020046", nome: "QUINGENTOLE", provincia: "MN" },
  { code: "403019078", nome: "QUINTANO", provincia: "CR" },
  { code: "405026064", nome: "QUINTO DI TREVISO", provincia: "TV" },
  { code: "401002108", nome: "QUINTO VERCELLESE", provincia: "VC" },
  { code: "405024083", nome: "QUINTO VICENTINO", provincia: "VI" },
  { code: "403017159", nome: "QUINZANO D\'OGLIO", provincia: "BS" },
  { code: "403020047", nome: "QUISTELLO", provincia: "MN" },
  { code: "404022150", nome: "RABBI", provincia: "TN" },
  { code: "416075063", nome: "RACALE", provincia: "LE" },
  { code: "419084029", nome: "RACALMUTO", provincia: "AG" },
  { code: "401004179", nome: "RACCONIGI", provincia: "CN" },
  { code: "419083069", nome: "RACCUJA", provincia: "ME" },
  { code: "404021070", nome: "RACINES", provincia: "BZ" },
  { code: "409052023", nome: "RADDA IN CHIANTI", provincia: "SI" },
  { code: "419087036", nome: "RADDUSA", provincia: "CT" },
  { code: "409052024", nome: "RADICOFANI", provincia: "SI" },
  { code: "409052025", nome: "RADICONDOLI", provincia: "SI" },
  { code: "419084030", nome: "RAFFADALI", provincia: "AG" },
  { code: "419087058", nome: "RAGALNA", provincia: "CT" },
  { code: "406030087", nome: "RAGOGNA", provincia: "UD" },
  { code: "419088009", nome: "RAGUSA", provincia: "RG" },
  { code: "413066077", nome: "RAIANO", provincia: "AQ" },
  { code: "419087037", nome: "RAMACCA", provincia: "CT" },
  { code: "403012115", nome: "RANCIO VALCUVIA", provincia: "VA" },
  { code: "403012116", nome: "RANCO", provincia: "VA" },
  { code: "419087038", nome: "RANDAZZO", provincia: "CT" },
  { code: "403016178", nome: "RANICA", provincia: "BG" },
  { code: "403016179", nome: "RANZANICO", provincia: "BG" },
  { code: "407008048", nome: "RANZO", provincia: "IM" },
  { code: "411109035", nome: "RAPAGNANO", provincia: "FM" },
  { code: "407010046", nome: "RAPALLO", provincia: "GE" },
  { code: "413069071", nome: "RAPINO", provincia: "CH" },
  { code: "409052026", nome: "RAPOLANO TERME", provincia: "SI" },
  { code: "417076064", nome: "RAPOLLA", provincia: "PZ" },
  { code: "417076065", nome: "RAPONE", provincia: "PZ" },
  { code: "401002110", nome: "RASSA", provincia: "VC" },
  { code: "404021071", nome: "RASUN ANTERSELVA", provincia: "BZ" },
  { code: "403014055", nome: "RASURA", provincia: "SO" },
  { code: "419084031", nome: "RAVANUSA", provincia: "AG" },
  { code: "408036034", nome: "RAVARINO", provincia: "MO" },
  { code: "406030088", nome: "RAVASCLETTO", provincia: "UD" },
  { code: "415065104", nome: "RAVELLO", provincia: "SA" },
  { code: "408039014", nome: "RAVENNA", provincia: "RA" },
  { code: "406030089", nome: "RAVEO", provincia: "UD" },
  { code: "415061066", nome: "RAVISCANINA", provincia: "CE" },
  { code: "401103060", nome: "RE", provincia: "VB" },
  { code: "403018119", nome: "REA", provincia: "PV" },
  { code: "419084032", nome: "REALMONTE", provincia: "AG" },
  { code: "406030090", nome: "REANA DEL ROJALE", provincia: "UD" },
  { code: "401001211", nome: "REANO", provincia: "TO" },
  { code: "415061067", nome: "RECALE", provincia: "CE" },
  { code: "411043044", nome: "RECANATI", provincia: "MC" },
  { code: "407010047", nome: "RECCO", provincia: "GE" },
  { code: "401003129", nome: "RECETTO", provincia: "NO" },
  { code: "405024084", nome: "RECOARO TERME", provincia: "VI" },
  { code: "403018120", nome: "REDAVALLE", provincia: "PV" },
  { code: "403020048", nome: "REDONDESCO", provincia: "MN" },
  { code: "401005089", nome: "REFRANCORE", provincia: "AT" },
  { code: "405026065", nome: "REFRONTOLO", provincia: "TV" },
  { code: "419086016", nome: "REGALBUTO", provincia: "EN" },
  { code: "409048035", nome: "REGGELLO", provincia: "FI" },
  { code: "418080063", nome: "REGGIO CALABRIA", provincia: "RC" },
  { code: "408035033", nome: "REGGIO EMILIA", provincia: "RE" },
  { code: "408035032", nome: "REGGIOLO", provincia: "RE" },
  { code: "415062056", nome: "REINO", provincia: "BN" },
  { code: "419083070", nome: "REITANO", provincia: "ME" },
  { code: "406030091", nome: "REMANZACCO", provincia: "UD" },
  { code: "403017160", nome: "REMEDELLO", provincia: "BS" },
  { code: "403108037", nome: "RENATE", provincia: "MB" },
  { code: "418078102", nome: "RENDE", provincia: "CS" },
  { code: "404021072", nome: "RENON", provincia: "BZ" },
  { code: "405026066", nome: "RESANA", provincia: "TV" },
  { code: "403015181", nome: "RESCALDINA", provincia: "MI" },
  { code: "406030092", nome: "RESIA", provincia: "UD" },
  { code: "406030093", nome: "RESIUTTA", provincia: "UD" },
  { code: "419085014", nome: "RESUTTANO", provincia: "CL" },
  { code: "403018121", nome: "RETORBIDO", provincia: "PV" },
  { code: "401004180", nome: "REVELLO", provincia: "CN" },
  { code: "401005090", nome: "REVIGLIASCO D\'ASTI", provincia: "AT" },
  { code: "405026067", nome: "REVINE LAGO", provincia: "TV" },
  { code: "403013195", nome: "REZZAGO", provincia: "CO" },
  { code: "403017161", nome: "REZZATO", provincia: "BS" },
  { code: "407008049", nome: "REZZO", provincia: "IM" },
  { code: "407010048", nome: "REZZOAGLIO", provincia: "GE" },
  { code: "402007055", nome: "RHEMES-NOTRE-DAME", provincia: "AO" },
  { code: "402007056", nome: "RHEMES-SAINT-GEORGES", provincia: "AO" },
  { code: "403015182", nome: "RHO", provincia: "MI" },
  { code: "418080064", nome: "RIACE", provincia: "RC" },
  { code: "407009053", nome: "RIALTO", provincia: "SV" },
  { code: "412058081", nome: "RIANO", provincia: "RM" },
  { code: "415061068", nome: "RIARDO", provincia: "CE" },
  { code: "419084033", nome: "RIBERA", provincia: "AG" },
  { code: "401001212", nome: "RIBORDONE", provincia: "TO" },
  { code: "418102030", nome: "RICADI", provincia: "VV" },
  { code: "401006143", nome: "RICALDONE", provincia: "AL" },
  { code: "414070057", nome: "RICCIA", provincia: "CB" },
  { code: "408099013", nome: "RICCIONE", provincia: "RN" },
  { code: "407011023", nome: "RICCO\' DEL GOLFO DI SPEZIA", provincia: "SP" },
  { code: "403019079", nome: "RICENGO", provincia: "CR" },
  { code: "415065105", nome: "RICIGLIANO", provincia: "SA" },
  { code: "405026068", nome: "RIESE PIO X", provincia: "TV" },
  { code: "419085015", nome: "RIESI", provincia: "CL" },
  { code: "412057059", nome: "RIETI", provincia: "RI" },
  { code: "404021073", nome: "RIFIANO", provincia: "BZ" },
  { code: "401004181", nome: "RIFREDDO", provincia: "CN" },
  { code: "412058082", nome: "RIGNANO FLAMINIO", provincia: "RM" },
  { code: "416071041", nome: "RIGNANO GARGANICO", provincia: "FG" },
  { code: "409048036", nome: "RIGNANO SULL\'ARNO", provincia: "FI" },
  { code: "406030094", nome: "RIGOLATO", provincia: "UD" },
  { code: "401002113", nome: "RIMELLA", provincia: "VC" },
  { code: "408099014", nome: "RIMINI", provincia: "RN" },
  { code: "404021074", nome: "RIO DI PUSTERIA", provincia: "BZ" },
  { code: "408035034", nome: "RIO SALICETO", provincia: "RE" },
  { code: "409049021", nome: "RIO", provincia: "LI" },
  { code: "412058083", nome: "RIOFREDDO", provincia: "RM" },
  { code: "420095043", nome: "RIOLA SARDO", provincia: "OR" },
  { code: "408039015", nome: "RIOLO TERME", provincia: "RA" },
  { code: "408036035", nome: "RIOLUNATO", provincia: "MO" },
  { code: "407011024", nome: "RIOMAGGIORE", provincia: "SP" },
  { code: "417076066", nome: "RIONERO IN VULTURE", provincia: "PZ" },
  { code: "414094039", nome: "RIONERO SANNITICO", provincia: "IS" },
  { code: "413069072", nome: "RIPA TEATINA", provincia: "CH" },
  { code: "414070058", nome: "RIPABOTTONI", provincia: "CB" },
  { code: "417076067", nome: "RIPACANDIDA", provincia: "PZ" },
  { code: "414070059", nome: "RIPALIMOSANI", provincia: "CB" },
  { code: "403019080", nome: "RIPALTA ARPINA", provincia: "CR" },
  { code: "403019081", nome: "RIPALTA CREMASCA", provincia: "CR" },
  { code: "403019082", nome: "RIPALTA GUERINA", provincia: "CR" },
  { code: "409050030", nome: "RIPARBELLA", provincia: "PI" },
  { code: "411044063", nome: "RIPATRANSONE", provincia: "AP" },
  { code: "411043045", nome: "RIPE SAN GINESIO", provincia: "MC" },
  { code: "412060058", nome: "RIPI", provincia: "FR" },
  { code: "419087039", nome: "RIPOSTO", provincia: "CT" },
  { code: "401004182", nome: "RITTANA", provincia: "CN" },
  { code: "404022153", nome: "RIVA DEL GARDA", provincia: "TN" },
  { code: "408038029", nome: "RIVA DEL PO", provincia: "FE" },
  { code: "403016180", nome: "RIVA DI SOLTO", provincia: "BG" },
  { code: "407008050", nome: "RIVA LIGURE", provincia: "IM" },
  { code: "401001215", nome: "RIVA PRESSO CHIERI", provincia: "TO" },
  { code: "401001213", nome: "RIVALBA", provincia: "TO" },
  { code: "401006144", nome: "RIVALTA BORMIDA", provincia: "AL" },
  { code: "401001214", nome: "RIVALTA DI TORINO", provincia: "TO" },
  { code: "405025043", nome: "RIVAMONTE AGORDINO", provincia: "BL" },
  { code: "403018999", nome: "RIVANAZZANO TERME", provincia: "PV" },
  { code: "401001216", nome: "RIVARA", provincia: "TO" },
  { code: "401001217", nome: "RIVAROLO CANAVESE", provincia: "TO" },
  { code: "403019083", nome: "RIVAROLO DEL RE ED UNITI", provincia: "CR" },
  { code: "403020050", nome: "RIVAROLO MANTOVANO", provincia: "MN" },
  { code: "401006145", nome: "RIVARONE", provincia: "AL" },
  { code: "401001218", nome: "RIVAROSSA", provincia: "TO" },
  { code: "406030095", nome: "RIVE D\'ARCANO", provincia: "UD" },
  { code: "401002115", nome: "RIVE", provincia: "VC" },
  { code: "417076068", nome: "RIVELLO", provincia: "PZ" },
  { code: "408033038", nome: "RIVERGARO", provincia: "PC" },
  { code: "406030188", nome: "RIVIGNANO TEOR", provincia: "UD" },
  { code: "413066078", nome: "RIVISONDOLI", provincia: "AQ" },
  { code: "412057060", nome: "RIVODUTRI", provincia: "RI" },
  { code: "405023062", nome: "RIVOLI VERONESE", provincia: "VR" },
  { code: "401001219", nome: "RIVOLI", provincia: "TO" },
  { code: "403019084", nome: "RIVOLTA D\'ADDA", provincia: "CR" },
  { code: "418080065", nome: "RIZZICONI", provincia: "RC" },
  { code: "405024085", nome: "ROANA", provincia: "VI" },
  { code: "401004183", nome: "ROASCHIA", provincia: "CN" },
  { code: "401004184", nome: "ROASCIO", provincia: "CN" },
  { code: "401002116", nome: "ROASIO", provincia: "VC" },
  { code: "401005091", nome: "ROATTO", provincia: "AT" },
  { code: "401001220", nome: "ROBASSOMERO", provincia: "TO" },
  { code: "403097071", nome: "ROBBIATE", provincia: "LC" },
  { code: "403018123", nome: "ROBBIO", provincia: "PV" },
  { code: "403015183", nome: "ROBECCHETTO CON INDUNO", provincia: "MI" },
  { code: "403019085", nome: "ROBECCO D\'OGLIO", provincia: "CR" },
  { code: "403018124", nome: "ROBECCO PAVESE", provincia: "PV" },
  { code: "403015184", nome: "ROBECCO SUL NAVIGLIO", provincia: "MI" },
  { code: "401005092", nome: "ROBELLA", provincia: "AT" },
  { code: "401004185", nome: "ROBILANTE", provincia: "CN" },
  { code: "401004186", nome: "ROBURENT", provincia: "CN" },
  { code: "401001221", nome: "ROCCA CANAVESE", provincia: "TO" },
  { code: "412058084", nome: "ROCCA CANTERANO", provincia: "RM" },
  { code: "401004188", nome: "ROCCA CIGLIE\'", provincia: "CN" },
  { code: "401005093", nome: "ROCCA D\'ARAZZO", provincia: "AT" },
  { code: "412060059", nome: "ROCCA D\'ARCE", provincia: "FR" },
  { code: "415061069", nome: "ROCCA D\'EVANDRO", provincia: "CE" },
  { code: "401004189", nome: "ROCCA DE\' BALDI", provincia: "CN" },
  { code: "403018125", nome: "ROCCA DE\' GIORGI", provincia: "PV" },
  { code: "413066080", nome: "ROCCA DI BOTTE", provincia: "AQ" },
  { code: "413066081", nome: "ROCCA DI CAMBIO", provincia: "AQ" },
  { code: "412058085", nome: "ROCCA DI CAVE", provincia: "RM" },
  { code: "413066082", nome: "ROCCA DI MEZZO", provincia: "AQ" },
  { code: "418101019", nome: "ROCCA DI NETO", provincia: "KR" },
  { code: "412058086", nome: "ROCCA DI PAPA", provincia: "RM" },
  { code: "401006147", nome: "ROCCA GRIMALDA", provincia: "AL" },
  { code: "418078103", nome: "ROCCA IMPERIALE", provincia: "CS" },
  { code: "412059022", nome: "ROCCA MASSIMA", provincia: "LT" },
  { code: "413066083", nome: "ROCCA PIA", provincia: "AQ" },
  { code: "405025044", nome: "ROCCA PIETORE", provincia: "BL" },
  { code: "412058088", nome: "ROCCA PRIORA", provincia: "RM" },
  { code: "408140036", nome: "ROCCA SAN CASCIANO", provincia: "FC" },
  { code: "415064079", nome: "ROCCA SAN FELICE", provincia: "AV" },
  { code: "413069074", nome: "ROCCA SAN GIOVANNI", provincia: "CH" },
  { code: "413067036", nome: "ROCCA SANTA MARIA", provincia: "TE" },
  { code: "412058089", nome: "ROCCA SANTO STEFANO", provincia: "RM" },
  { code: "412057062", nome: "ROCCA SINIBALDA", provincia: "RI" },
  { code: "403018126", nome: "ROCCA SUSELLA", provincia: "PV" },
  { code: "415064078", nome: "ROCCABASCERANA", provincia: "AV" },
  { code: "418101018", nome: "ROCCABERNARDA", provincia: "KR" },
  { code: "408034030", nome: "ROCCABIANCA", provincia: "PR" },
  { code: "401004187", nome: "ROCCABRUNA", provincia: "CN" },
  { code: "413066079", nome: "ROCCACASALE", provincia: "AQ" },
  { code: "415065106", nome: "ROCCADASPIDE", provincia: "SA" },
  { code: "419083071", nome: "ROCCAFIORITA", provincia: "ME" },
  { code: "411044064", nome: "ROCCAFLUVIONE", provincia: "AP" },
  { code: "418080066", nome: "ROCCAFORTE DEL GRECO", provincia: "RC" },
  { code: "401006146", nome: "ROCCAFORTE LIGURE", provincia: "AL" },
  { code: "401004190", nome: "ROCCAFORTE MONDOVI\'", provincia: "CN" },
  { code: "416073023", nome: "ROCCAFORZATA", provincia: "TA" },
  { code: "403017162", nome: "ROCCAFRANCA", provincia: "BS" },
  { code: "412058087", nome: "ROCCAGIOVINE", provincia: "RM" },
  { code: "415065107", nome: "ROCCAGLORIOSA", provincia: "SA" },
  { code: "412059021", nome: "ROCCAGORGA", provincia: "LT" },
  { code: "409053020", nome: "ROCCALBEGNA", provincia: "GR" },
  { code: "419083072", nome: "ROCCALUMERA", provincia: "ME" },
  { code: "414094040", nome: "ROCCAMANDOLFI", provincia: "IS" },
  { code: "419082061", nome: "ROCCAMENA", provincia: "PA" },
  { code: "415061070", nome: "ROCCAMONFINA", provincia: "CE" },
  { code: "413069073", nome: "ROCCAMONTEPIANO", provincia: "CH" },
  { code: "413068034", nome: "ROCCAMORICE", provincia: "PE" },
  { code: "417076069", nome: "ROCCANOVA", provincia: "PZ" },
  { code: "412057061", nome: "ROCCANTICA", provincia: "RI" },
  { code: "419082062", nome: "ROCCAPALUMBA", provincia: "PA" },
  { code: "415065108", nome: "ROCCAPIEMONTE", provincia: "SA" },
  { code: "415063065", nome: "ROCCARAINOLA", provincia: "NA" },
  { code: "413066084", nome: "ROCCARASO", provincia: "AQ" },
  { code: "415061071", nome: "ROCCAROMANA", provincia: "CE" },
  { code: "413069075", nome: "ROCCASCALEGNA", provincia: "CH" },
  { code: "412059023", nome: "ROCCASECCA DEI VOLSCI", provincia: "LT" },
  { code: "412060060", nome: "ROCCASECCA", provincia: "FR" },
  { code: "414094041", nome: "ROCCASICURA", provincia: "IS" },
  { code: "401004191", nome: "ROCCASPARVERA", provincia: "CN" },
  { code: "413069076", nome: "ROCCASPINALVETI", provincia: "CH" },
  { code: "409053021", nome: "ROCCASTRADA", provincia: "GR" },
  { code: "419083073", nome: "ROCCAVALDINA", provincia: "ME" },
  { code: "401005094", nome: "ROCCAVERANO", provincia: "AT" },
  { code: "407009054", nome: "ROCCAVIGNALE", provincia: "SV" },
  { code: "401004192", nome: "ROCCAVIONE", provincia: "CN" },
  { code: "414070060", nome: "ROCCAVIVARA", provincia: "CB" },
  { code: "418080067", nome: "ROCCELLA IONICA", provincia: "RC" },
  { code: "419083074", nome: "ROCCELLA VALDEMONE", provincia: "ME" },
  { code: "414094042", nome: "ROCCHETTA A VOLTURNO", provincia: "IS" },
  { code: "401004193", nome: "ROCCHETTA BELBO", provincia: "CN" },
  { code: "407011025", nome: "ROCCHETTA DI VARA", provincia: "SP" },
  { code: "415061072", nome: "ROCCHETTA E CROCE", provincia: "CE" },
  { code: "401006148", nome: "ROCCHETTA LIGURE", provincia: "AL" },
  { code: "407008051", nome: "ROCCHETTA NERVINA", provincia: "IM" },
  { code: "401005095", nome: "ROCCHETTA PALAFEA", provincia: "AT" },
  { code: "416071042", nome: "ROCCHETTA SANT\'ANTONIO", provincia: "FG" },
  { code: "401005096", nome: "ROCCHETTA TANARO", provincia: "AT" },
  { code: "403015185", nome: "RODANO", provincia: "MI" },
  { code: "401004194", nome: "RODDI", provincia: "CN" },
  { code: "401004195", nome: "RODDINO", provincia: "CN" },
  { code: "401004196", nome: "RODELLO", provincia: "CN" },
  { code: "404021075", nome: "RODENGO", provincia: "BZ" },
  { code: "403017163", nome: "RODENGO-SAIANO", provincia: "BS" },
  { code: "403013197", nome: "RODERO", provincia: "CO" },
  { code: "416071043", nome: "RODI GARGANICO", provincia: "FG" },
  { code: "419083075", nome: "RODI\' MILICI", provincia: "ME" },
  { code: "403020051", nome: "RODIGO", provincia: "MN" },
  { code: "403017164", nome: "ROE\' VOLCIANO", provincia: "BS" },
  { code: "415065109", nome: "ROFRANO", provincia: "SA" },
  { code: "403097072", nome: "ROGENO", provincia: "LC" },
  { code: "418078104", nome: "ROGGIANO GRAVINA", provincia: "CS" },
  { code: "418080068", nome: "ROGHUDI", provincia: "RC" },
  { code: "418078105", nome: "ROGLIANO", provincia: "CS" },
  { code: "403018127", nome: "ROGNANO", provincia: "PV" },
  { code: "403016182", nome: "ROGNO", provincia: "BG" },
  { code: "403014056", nome: "ROGOLO", provincia: "SO" },
  { code: "412058090", nome: "ROIATE", provincia: "RM" },
  { code: "413069077", nome: "ROIO DEL SANGRO", provincia: "CH" },
  { code: "402007057", nome: "ROISAN", provincia: "AO" },
  { code: "401001222", nome: "ROLETTO", provincia: "TO" },
  { code: "408035035", nome: "ROLO", provincia: "RE" },
  { code: "412058091", nome: "ROMA", provincia: "RM" },
  { code: "415065110", nome: "ROMAGNANO AL MONTE", provincia: "SA" },
  { code: "401003130", nome: "ROMAGNANO SESIA", provincia: "NO" },
  { code: "403018128", nome: "ROMAGNESE", provincia: "PV" },
  { code: "420090061", nome: "ROMANA", provincia: "SS" },
  { code: "403019086", nome: "ROMANENGO", provincia: "CR" },
  { code: "401001223", nome: "ROMANO CANAVESE", provincia: "TO" },
  { code: "405024086", nome: "ROMANO D\'EZZELINO", provincia: "VI" },
  { code: "403016183", nome: "ROMANO DI LOMBARDIA", provincia: "BG" },
  { code: "406031015", nome: "ROMANS D\'ISONZO", provincia: "GO" },
  { code: "418102031", nome: "ROMBIOLO", provincia: "VV" },
  { code: "404022155", nome: "ROMENO", provincia: "TN" },
  { code: "401003131", nome: "ROMENTINO", provincia: "NO" },
  { code: "419083076", nome: "ROMETTA", provincia: "ME" },
  { code: "405023063", nome: "RONCA\'", provincia: "VR" },
  { code: "405026069", nome: "RONCADE", provincia: "TV" },
  { code: "403017165", nome: "RONCADELLE", provincia: "BS" },
  { code: "403018129", nome: "RONCARO", provincia: "PV" },
  { code: "404022156", nome: "RONCEGNO", provincia: "TN" },
  { code: "403108055", nome: "RONCELLO", provincia: "MB" },
  { code: "406031016", nome: "RONCHI DEI LEGIONARI", provincia: "GO" },
  { code: "404022157", nome: "RONCHI VALSUGANA", provincia: "TN" },
  { code: "406030097", nome: "RONCHIS", provincia: "UD" },
  { code: "412056045", nome: "RONCIGLIONE", provincia: "VT" },
  { code: "405023064", nome: "RONCO ALL\'ADIGE", provincia: "VR" },
  { code: "401096053", nome: "RONCO BIELLESE", provincia: "BI" },
  { code: "403108038", nome: "RONCO BRIANTINO", provincia: "MB" },
  { code: "401001224", nome: "RONCO CANAVESE", provincia: "TO" },
  { code: "407010049", nome: "RONCO SCRIVIA", provincia: "GE" },
  { code: "403016184", nome: "RONCOBELLO", provincia: "BG" },
  { code: "403020052", nome: "RONCOFERRARO", provincia: "MN" },
  { code: "408140037", nome: "RONCOFREDDO", provincia: "FC" },
  { code: "403016185", nome: "RONCOLA", provincia: "BG" },
  { code: "407010050", nome: "RONDANINA", provincia: "GE" },
  { code: "401001225", nome: "RONDISSONE", provincia: "TO" },
  { code: "401002118", nome: "RONSECCO", provincia: "VC" },
  { code: "404022135", nome: "RONZO-CHIENIS", provincia: "TN" },
  { code: "404022159", nome: "RONZONE", provincia: "TN" },
  { code: "401096054", nome: "ROPPOLO", provincia: "BI" },
  { code: "401001226", nome: "RORA\'", provincia: "TO" },
  { code: "401001227", nome: "RORETO CHISONE", provincia: "TO" },
  { code: "405024087", nome: "ROSA\'", provincia: "VI" },
  { code: "418080069", nome: "ROSARNO", provincia: "RC" },
  { code: "403018130", nome: "ROSASCO", provincia: "PV" },
  { code: "403015188", nome: "ROSATE", provincia: "MI" },
  { code: "401096055", nome: "ROSAZZA", provincia: "BI" },
  { code: "413068035", nome: "ROSCIANO", provincia: "PE" },
  { code: "415065111", nome: "ROSCIGNO", provincia: "SA" },
  { code: "418078106", nome: "ROSE", provincia: "CS" },
  { code: "413069078", nome: "ROSELLO", provincia: "CH" },
  { code: "418078107", nome: "ROSETO CAPO SPULICO", provincia: "CS" },
  { code: "413067037", nome: "ROSETO DEGLI ABRUZZI", provincia: "TE" },
  { code: "416071044", nome: "ROSETO VALFORTORE", provincia: "FG" },
  { code: "409049017", nome: "ROSIGNANO MARITTIMO", provincia: "LI" },
  { code: "401006149", nome: "ROSIGNANO MONFERRATO", provincia: "AL" },
  { code: "405029040", nome: "ROSOLINA", provincia: "RO" },
  { code: "419089016", nome: "ROSOLINI", provincia: "SR" },
  { code: "411042040", nome: "ROSORA", provincia: "AN" },
  { code: "401002121", nome: "ROSSA", provincia: "VC" },
  { code: "401004197", nome: "ROSSANA", provincia: "CN" },
  { code: "405024088", nome: "ROSSANO VENETO", provincia: "VI" },
  { code: "407010051", nome: "ROSSIGLIONE", provincia: "GE" },
  { code: "401001228", nome: "ROSTA", provincia: "TO" },
  { code: "403016186", nome: "ROTA D\'IMAGNA", provincia: "BG" },
  { code: "418078109", nome: "ROTA GRECA", provincia: "CS" },
  { code: "411044065", nome: "ROTELLA", provincia: "AP" },
  { code: "414070061", nome: "ROTELLO", provincia: "CB" },
  { code: "417076070", nome: "ROTONDA", provincia: "PZ" },
  { code: "417077023", nome: "ROTONDELLA", provincia: "MT" },
  { code: "415064080", nome: "ROTONDI", provincia: "AV" },
  { code: "408033039", nome: "ROTTOFRENO", provincia: "PC" },
  { code: "405024089", nome: "ROTZO", provincia: "VI" },
  { code: "401001571", nome: "ROURE", provincia: "TO" },
  { code: "401002122", nome: "ROVASENDA", provincia: "VC" },
  { code: "403017166", nome: "ROVATO", provincia: "BS" },
  { code: "407010052", nome: "ROVEGNO", provincia: "GE" },
  { code: "403013201", nome: "ROVELLASCA", provincia: "CO" },
  { code: "403013202", nome: "ROVELLO PORRO", provincia: "CO" },
  { code: "403020053", nome: "ROVERBELLA", provincia: "MN" },
  { code: "405023065", nome: "ROVERCHIARA", provincia: "VR" },
  { code: "404022160", nome: "ROVERE\' DELLA LUNA", provincia: "TN" },
  { code: "405023067", nome: "ROVERE\' VERONESE", provincia: "VR" },
  { code: "405023066", nome: "ROVEREDO DI GUA\'", provincia: "VR" },
  { code: "406093036", nome: "ROVEREDO IN PIANO", provincia: "PN" },
  { code: "404022161", nome: "ROVERETO", provincia: "TN" },
  { code: "403018131", nome: "ROVESCALA", provincia: "PV" },
  { code: "403016187", nome: "ROVETTA", provincia: "BG" },
  { code: "412058092", nome: "ROVIANO", provincia: "RM" },
  { code: "405029041", nome: "ROVIGO", provincia: "RO" },
  { code: "418078110", nome: "ROVITO", provincia: "CS" },
  { code: "405028071", nome: "ROVOLON", provincia: "PD" },
  { code: "403015189", nome: "ROZZANO", provincia: "MI" },
  { code: "405028072", nome: "RUBANO", provincia: "PD" },
  { code: "401001229", nome: "RUBIANA", provincia: "TO" },
  { code: "408035036", nome: "RUBIERA", provincia: "RE" },
  { code: "406030098", nome: "RUDA", provincia: "UD" },
  { code: "403017167", nome: "RUDIANO", provincia: "BS" },
  { code: "401001230", nome: "RUEGLIO", provincia: "TO" },
  { code: "416075064", nome: "RUFFANO", provincia: "LE" },
  { code: "401004198", nome: "RUFFIA", provincia: "CN" },
  { code: "404022962", nome: "RUFFRE\'-MENDOLA", provincia: "TN" },
  { code: "409048037", nome: "RUFINA", provincia: "FI" },
  { code: "420095044", nome: "RUINAS", provincia: "OR" },
  { code: "404022163", nome: "RUMO", provincia: "TN" },
  { code: "417076071", nome: "RUOTI", provincia: "PZ" },
  { code: "408039016", nome: "RUSSI", provincia: "RA" },
  { code: "416072037", nome: "RUTIGLIANO", provincia: "BA" },
  { code: "415065112", nome: "RUTINO", provincia: "SA" },
  { code: "415061073", nome: "RUVIANO", provincia: "CE" },
  { code: "417076072", nome: "RUVO DEL MONTE", provincia: "PZ" },
  { code: "416072038", nome: "RUVO DI PUGLIA", provincia: "BA" },
  { code: "412059024", nome: "SABAUDIA", provincia: "LT" },
  { code: "403017168", nome: "SABBIO CHIESE", provincia: "BS" },
  { code: "403020054", nome: "SABBIONETA", provincia: "MN" },
  { code: "415065113", nome: "SACCO", provincia: "SA" },
  { code: "405028073", nome: "SACCOLONGO", provincia: "PD" },
  { code: "406093037", nome: "SACILE", provincia: "PN" },
  { code: "412058093", nome: "SACROFANO", provincia: "RM" },
  { code: "420091074", nome: "SADALI", provincia: "NU" },
  { code: "420091075", nome: "SAGAMA", provincia: "NU" },
  { code: "401096056", nome: "SAGLIANO MICCA", provincia: "BI" },
  { code: "406031017", nome: "SAGRADO", provincia: "GO" },
  { code: "404022164", nome: "SAGRON MIS", provincia: "TN" },
  { code: "402007058", nome: "SAINT-CHRISTOPHE", provincia: "AO" },
  { code: "402007059", nome: "SAINT-DENIS", provincia: "AO" },
  { code: "402007060", nome: "SAINT-MARCEL", provincia: "AO" },
  { code: "402007061", nome: "SAINT-NICOLAS", provincia: "AO" },
  { code: "402007062", nome: "SAINT-OYEN", provincia: "AO" },
  { code: "402007063", nome: "SAINT-PIERRE", provincia: "AO" },
  { code: "402007964", nome: "SAINT-RHEMY-EN-BOSSES", provincia: "AO" },
  { code: "402007065", nome: "SAINT-VINCENT", provincia: "AO" },
  { code: "408034031", nome: "SALA BAGANZA", provincia: "PR" },
  { code: "401096057", nome: "SALA BIELLESE", provincia: "BI" },
  { code: "408037050", nome: "SALA BOLOGNESE", provincia: "BO" },
  { code: "403013203", nome: "SALA COMACINA", provincia: "CO" },
  { code: "415065114", nome: "SALA CONSILINA", provincia: "SA" },
  { code: "401006150", nome: "SALA MONFERRATO", provincia: "AL" },
  { code: "417077024", nome: "SALANDRA", provincia: "MT" },
  { code: "419081017", nome: "SALAPARUTA", provincia: "TP" },
  { code: "405029042", nome: "SALARA", provincia: "RO" },
  { code: "401002126", nome: "SALASCO", provincia: "VC" },
  { code: "401001231", nome: "SALASSA", provincia: "TO" },
  { code: "401001232", nome: "SALBERTRAND", provincia: "TO" },
  { code: "405024090", nome: "SALCEDO", provincia: "VI" },
  { code: "414070062", nome: "SALCITO", provincia: "CB" },
  { code: "401004199", nome: "SALE DELLE LANGHE", provincia: "CN" },
  { code: "403017169", nome: "SALE MARASINO", provincia: "BS" },
  { code: "401004200", nome: "SALE SAN GIOVANNI", provincia: "CN" },
  { code: "401006151", nome: "SALE", provincia: "AL" },
  { code: "419081018", nome: "SALEMI", provincia: "TP" },
  { code: "415065115", nome: "SALENTO", provincia: "SA" },
  { code: "401001233", nome: "SALERANO CANAVESE", provincia: "TO" },
  { code: "403098046", nome: "SALERANO SUL LAMBRO", provincia: "LO" },
  { code: "415065116", nome: "SALERNO", provincia: "SA" },
  { code: "405026070", nome: "SALGAREDA", provincia: "TV" },
  { code: "401002127", nome: "SALI VERCELLESE", provincia: "VC" },
  { code: "416075065", nome: "SALICE SALENTINO", provincia: "LE" },
  { code: "401004201", nome: "SALICETO", provincia: "CN" },
  { code: "412057063", nome: "SALISANO", provincia: "RI" },
  { code: "405023068", nome: "SALIZZOLE", provincia: "VR" },
  { code: "413068036", nome: "SALLE", provincia: "PE" },
  { code: "401004202", nome: "SALMOUR", provincia: "CN" },
  { code: "403017170", nome: "SALO\'", provincia: "BS" },
  { code: "404021976", nome: "SALORNO SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "408034032", nome: "SALSOMAGGIORE TERME", provincia: "PR" },
  { code: "403012117", nome: "SALTRIO", provincia: "VA" },
  { code: "408099015", nome: "SALUDECIO", provincia: "RN" },
  { code: "401002128", nome: "SALUGGIA", provincia: "VC" },
  { code: "401096058", nome: "SALUSSOLA", provincia: "BI" },
  { code: "401004203", nome: "SALUZZO", provincia: "CN" },
  { code: "416075066", nome: "SALVE", provincia: "LE" },
  { code: "403019087", nome: "SALVIROLA", provincia: "CR" },
  { code: "415065117", nome: "SALVITELLE", provincia: "SA" },
  { code: "401001234", nome: "SALZA DI PINEROLO", provincia: "TO" },
  { code: "415064081", nome: "SALZA IRPINA", provincia: "AV" },
  { code: "405027032", nome: "SALZANO", provincia: "VE" },
  { code: "403012118", nome: "SAMARATE", provincia: "VA" },
  { code: "420092052", nome: "SAMASSI", provincia: "CA" },
  { code: "420092053", nome: "SAMATZAI", provincia: "CA" },
  { code: "419084034", nome: "SAMBUCA DI SICILIA", provincia: "AG" },
  { code: "409047018", nome: "SAMBUCA PISTOIESE", provincia: "PT" },
  { code: "412058094", nome: "SAMBUCI", provincia: "RM" },
  { code: "401004204", nome: "SAMBUCO", provincia: "CN" },
  { code: "416072039", nome: "SAMMICHELE DI BARI", provincia: "BA" },
  { code: "418080070", nome: "SAMO", provincia: "RC" },
  { code: "403014057", nome: "SAMOLACO", provincia: "SO" },
  { code: "404022165", nome: "SAMONE", provincia: "TN" },
  { code: "401001235", nome: "SAMONE", provincia: "TO" },
  { code: "401004205", nome: "SAMPEYRE", provincia: "CN" },
  { code: "420095045", nome: "SAMUGHEO", provincia: "OR" },
  { code: "407008052", nome: "SAN BARTOLOMEO AL MARE", provincia: "IM" },
  { code: "415062057", nome: "SAN BARTOLOMEO IN GALDO", provincia: "BN" },
  { code: "403013204", nome: "SAN BARTOLOMEO VAL CAVARGNA", provincia: "CO" },
  { code: "418078111", nome: "SAN BASILE", provincia: "CS" },
  { code: "420092054", nome: "SAN BASILIO", provincia: "CA" },
  { code: "403019088", nome: "SAN BASSANO", provincia: "CR" },
  { code: "405029043", nome: "SAN BELLINO", provincia: "RO" },
  { code: "401004206", nome: "SAN BENEDETTO BELBO", provincia: "CN" },
  { code: "413066085", nome: "SAN BENEDETTO DEI MARSI", provincia: "AQ" },
  { code: "411044066", nome: "SAN BENEDETTO DEL TRONTO", provincia: "AP" },
  { code: "413066086", nome: "SAN BENEDETTO IN PERILLIS", provincia: "AQ" },
  { code: "403020055", nome: "SAN BENEDETTO PO", provincia: "MN" },
  { code: "418078112", nome: "SAN BENEDETTO ULLANO", provincia: "CS" },
  { code: "408037051", nome: "SAN BENEDETTO VAL DI SAMBRO", provincia: "BO" },
  { code: "401001236", nome: "SAN BENIGNO CANAVESE", provincia: "TO" },
  { code: "401103061", nome: "SAN BERNARDINO VERBANO", provincia: "VB" },
  { code: "407008053", nome: "SAN BIAGIO DELLA CIMA", provincia: "IM" },
  { code: "405026071", nome: "SAN BIAGIO DI CALLALTA", provincia: "TV" },
  { code: "419084035", nome: "SAN BIAGIO PLATANI", provincia: "AG" },
  { code: "412060061", nome: "SAN BIAGIO SARACINISCO", provincia: "FR" },
  { code: "414070063", nome: "SAN BIASE", provincia: "CB" },
  { code: "405023069", nome: "SAN BONIFACIO", provincia: "VR" },
  { code: "413069079", nome: "SAN BUONO", provincia: "CH" },
  { code: "418102032", nome: "SAN CALOGERO", provincia: "VV" },
  { code: "404021077", nome: "SAN CANDIDO", provincia: "BZ" },
  { code: "406031018", nome: "SAN CANZIAN D\'ISONZO", provincia: "GO" },
  { code: "401001237", nome: "SAN CARLO CANAVESE", provincia: "TO" },
  { code: "409052027", nome: "SAN CASCIANO DEI BAGNI", provincia: "SI" },
  { code: "409048038", nome: "SAN CASCIANO IN VAL DI PESA", provincia: "FI" },
  { code: "416075095", nome: "SAN CASSIANO", provincia: "LE" },
  { code: "419085016", nome: "SAN CATALDO", provincia: "CL" },
  { code: "412058119", nome: "SAN CESAREO", provincia: "RM" },
  { code: "416075068", nome: "SAN CESARIO DI LECCE", provincia: "LE" },
  { code: "408036036", nome: "SAN CESARIO SUL PANARO", provincia: "MO" },
  { code: "417076073", nome: "SAN CHIRICO NUOVO", provincia: "PZ" },
  { code: "417076074", nome: "SAN CHIRICO RAPARO", provincia: "PZ" },
  { code: "419082063", nome: "SAN CIPIRELLO", provincia: "PA" },
  { code: "415061074", nome: "SAN CIPRIANO D\'AVERSA", provincia: "CE" },
  { code: "415065118", nome: "SAN CIPRIANO PICENTINO", provincia: "SA" },
  { code: "403018133", nome: "SAN CIPRIANO PO", provincia: "PV" },
  { code: "408099016", nome: "SAN CLEMENTE", provincia: "RN" },
  { code: "403015191", nome: "SAN COLOMBANO AL LAMBRO", provincia: "MI" },
  { code: "401001238", nome: "SAN COLOMBANO BELMONTE", provincia: "TO" },
  { code: "407010053", nome: "SAN COLOMBANO CERTENOLI", provincia: "GE" },
  { code: "419087040", nome: "SAN CONO", provincia: "CT" },
  { code: "418078113", nome: "SAN COSMO ALBANESE", provincia: "CS" },
  { code: "417076075", nome: "SAN COSTANTINO ALBANESE", provincia: "PZ" },
  { code: "418102033", nome: "SAN COSTANTINO CALABRO", provincia: "VV" },
  { code: "411141051", nome: "SAN COSTANZO", provincia: "PU" },
  { code: "401006152", nome: "SAN CRISTOFORO", provincia: "AL" },
  { code: "403018134", nome: "SAN DAMIANO AL COLLE", provincia: "PV" },
  { code: "401005097", nome: "SAN DAMIANO D\'ASTI", provincia: "AT" },
  { code: "401004207", nome: "SAN DAMIANO MACRA", provincia: "CN" },
  { code: "406030099", nome: "SAN DANIELE DEL FRIULI", provincia: "UD" },
  { code: "403019089", nome: "SAN DANIELE PO", provincia: "CR" },
  { code: "418078114", nome: "SAN DEMETRIO CORONE", provincia: "CS" },
  { code: "413066087", nome: "SAN DEMETRIO NE\' VESTINI", provincia: "AQ" },
  { code: "401001239", nome: "SAN DIDERO", provincia: "TO" },
  { code: "405027033", nome: "SAN DONA\' DI PIAVE", provincia: "VE" },
  { code: "416074013", nome: "SAN DONACI", provincia: "BR" },
  { code: "416075069", nome: "SAN DONATO DI LECCE", provincia: "LE" },
  { code: "418078115", nome: "SAN DONATO DI NINEA", provincia: "CS" },
  { code: "403015192", nome: "SAN DONATO MILANESE", provincia: "MI" },
  { code: "412060062", nome: "SAN DONATO VAL DI COMINO", provincia: "FR" },
  { code: "406032004", nome: "SAN DORLIGO DELLA VALLE", provincia: "TS" },
  { code: "417076076", nome: "SAN FELE", provincia: "PZ" },
  { code: "415061075", nome: "SAN FELICE A CANCELLO", provincia: "CE" },
  { code: "412059025", nome: "SAN FELICE CIRCEO", provincia: "LT" },
  { code: "403017171", nome: "SAN FELICE DEL BENACO", provincia: "BS" },
  { code: "414070064", nome: "SAN FELICE DEL MOLISE", provincia: "CB" },
  { code: "408036037", nome: "SAN FELICE SUL PANARO", provincia: "MO" },
  { code: "416110007", nome: "SAN FERDINANDO DI PUGLIA", provincia: "BT" },
  { code: "418080097", nome: "SAN FERDINANDO", provincia: "RC" },
  { code: "403013206", nome: "SAN FERMO DELLA BATTAGLIA", provincia: "CO" },
  { code: "418078116", nome: "SAN FILI", provincia: "CS" },
  { code: "419083077", nome: "SAN FILIPPO DEL MELA", provincia: "ME" },
  { code: "405026072", nome: "SAN FIOR", provincia: "TV" },
  { code: "403098047", nome: "SAN FIORANO", provincia: "LO" },
  { code: "406031019", nome: "SAN FLORIANO DEL COLLIO", provincia: "GO" },
  { code: "418079108", nome: "SAN FLORO", provincia: "CZ" },
  { code: "401001240", nome: "SAN FRANCESCO AL CAMPO", provincia: "TO" },
  { code: "419083078", nome: "SAN FRATELLO", provincia: "ME" },
  { code: "420092055", nome: "SAN GAVINO MONREALE", provincia: "CA" },
  { code: "410055029", nome: "SAN GEMINI", provincia: "TR" },
  { code: "404021079", nome: "SAN GENESIO ATESINO", provincia: "BZ" },
  { code: "403018135", nome: "SAN GENESIO ED UNITI", provincia: "PV" },
  { code: "415063066", nome: "SAN GENNARO VESUVIANO", provincia: "NA" },
  { code: "401001242", nome: "SAN GERMANO CHISONE", provincia: "TO" },
  { code: "401002131", nome: "SAN GERMANO VERCELLESE", provincia: "VC" },
  { code: "403017172", nome: "SAN GERVASIO BRESCIANO", provincia: "BS" },
  { code: "414070065", nome: "SAN GIACOMO DEGLI SCHIAVONI", provincia: "CB" },
  { code: "403020056", nome: "SAN GIACOMO DELLE SEGNATE", provincia: "MN" },
  { code: "403014058", nome: "SAN GIACOMO FILIPPO", provincia: "SO" },
  { code: "401002035", nome: "SAN GIACOMO VERCELLESE", provincia: "VC" },
  { code: "401001243", nome: "SAN GILLIO", provincia: "TO" },
  { code: "409052028", nome: "SAN GIMIGNANO", provincia: "SI" },
  { code: "411043046", nome: "SAN GINESIO", provincia: "MC" },
  { code: "415063067", nome: "SAN GIORGIO A CREMANO", provincia: "NA" },
  { code: "412060063", nome: "SAN GIORGIO A LIRI", provincia: "FR" },
  { code: "418078118", nome: "SAN GIORGIO ALBANESE", provincia: "CS" },
  { code: "403020957", nome: "SAN GIORGIO BIGARELLO", provincia: "MN" },
  { code: "401001244", nome: "SAN GIORGIO CANAVESE", provincia: "TO" },
  { code: "415062058", nome: "SAN GIORGIO DEL SANNIO", provincia: "BN" },
  { code: "406093038", nome: "SAN GIORGIO DELLA RICHINVELDA", provincia: "PN" },
  { code: "405028075", nome: "SAN GIORGIO DELLE PERTICHE", provincia: "PD" },
  { code: "403018136", nome: "SAN GIORGIO DI LOMELLINA", provincia: "PV" },
  { code: "406030100", nome: "SAN GIORGIO DI NOGARO", provincia: "UD" },
  { code: "408037052", nome: "SAN GIORGIO DI PIANO", provincia: "BO" },
  { code: "405028076", nome: "SAN GIORGIO IN BOSCO", provincia: "PD" },
  { code: "416073024", nome: "SAN GIORGIO IONICO", provincia: "TA" },
  { code: "415062059", nome: "SAN GIORGIO LA MOLARA", provincia: "BN" },
  { code: "417077025", nome: "SAN GIORGIO LUCANO", provincia: "MT" },
  { code: "401006153", nome: "SAN GIORGIO MONFERRATO", provincia: "AL" },
  { code: "418080071", nome: "SAN GIORGIO MORGETO", provincia: "RC" },
  { code: "408033040", nome: "SAN GIORGIO PIACENTINO", provincia: "PC" },
  { code: "401005098", nome: "SAN GIORGIO SCARAMPI", provincia: "AT" },
  { code: "403015194", nome: "SAN GIORGIO SU LEGNANO", provincia: "MI" },
  { code: "401001245", nome: "SAN GIORIO DI SUSA", provincia: "TO" },
  { code: "415065119", nome: "SAN GIOVANNI A PIRO", provincia: "SA" },
  { code: "406030101", nome: "SAN GIOVANNI AL NATISONE", provincia: "UD" },
  { code: "403016188", nome: "SAN GIOVANNI BIANCO", provincia: "BG" },
  { code: "403020058", nome: "SAN GIOVANNI DEL DOSSO", provincia: "MN" },
  { code: "404022950", nome: "SAN GIOVANNI DI FASSA-SEN JAN", provincia: "TN" },
  { code: "418080072", nome: "SAN GIOVANNI DI GERACE", provincia: "RC" },
  { code: "419084036", nome: "SAN GIOVANNI GEMINI", provincia: "AG" },
  { code: "405023070", nome: "SAN GIOVANNI ILARIONE", provincia: "VR" },
  { code: "403019090", nome: "SAN GIOVANNI IN CROCE", provincia: "CR" },
  { code: "418078119", nome: "SAN GIOVANNI IN FIORE", provincia: "CS" },
  { code: "414070066", nome: "SAN GIOVANNI IN GALDO", provincia: "CB" },
  { code: "408099017", nome: "SAN GIOVANNI IN MARIGNANO", provincia: "RN" },
  { code: "408037053", nome: "SAN GIOVANNI IN PERSICETO", provincia: "BO" },
  { code: "412060064", nome: "SAN GIOVANNI INCARICO", provincia: "FR" },
  { code: "419087041", nome: "SAN GIOVANNI LA PUNTA", provincia: "CT" },
  { code: "413069080", nome: "SAN GIOVANNI LIPIONI", provincia: "CH" },
  { code: "405023071", nome: "SAN GIOVANNI LUPATOTO", provincia: "VR" },
  { code: "416071046", nome: "SAN GIOVANNI ROTONDO", provincia: "FG" },
  { code: "420092056", nome: "SAN GIOVANNI SUERGIU", provincia: "CA" },
  { code: "413069081", nome: "SAN GIOVANNI TEATINO", provincia: "CH" },
  { code: "409051033", nome: "SAN GIOVANNI VALDARNO", provincia: "AR" },
  { code: "414070067", nome: "SAN GIULIANO DEL SANNIO", provincia: "CB" },
  { code: "414070068", nome: "SAN GIULIANO DI PUGLIA", provincia: "CB" },
  { code: "403015195", nome: "SAN GIULIANO MILANESE", provincia: "MI" },
  { code: "409050031", nome: "SAN GIULIANO TERME", provincia: "PI" },
  { code: "419082064", nome: "SAN GIUSEPPE IATO", provincia: "PA" },
  { code: "415063068", nome: "SAN GIUSEPPE VESUVIANO", provincia: "NA" },
  { code: "410054044", nome: "SAN GIUSTINO", provincia: "PG" },
  { code: "401001246", nome: "SAN GIUSTO CANAVESE", provincia: "TO" },
  { code: "409048039", nome: "SAN GODENZO", provincia: "FI" },
  { code: "418102034", nome: "SAN GREGORIO D\'IPPONA", provincia: "VV" },
  { code: "412058095", nome: "SAN GREGORIO DA SASSOLA", provincia: "RM" },
  { code: "419087042", nome: "SAN GREGORIO DI CATANIA", provincia: "CT" },
  { code: "415065120", nome: "SAN GREGORIO MAGNO", provincia: "SA" },
  { code: "415061076", nome: "SAN GREGORIO MATESE", provincia: "CE" },
  { code: "405025045", nome: "SAN GREGORIO NELLE ALPI", provincia: "BL" },
  { code: "408037054", nome: "SAN LAZZARO DI SAVENA", provincia: "BO" },
  { code: "408099025", nome: "SAN LEO", provincia: "RN" },
  { code: "404021080", nome: "SAN LEONARDO IN PASSIRIA", provincia: "BZ" },
  { code: "406030102", nome: "SAN LEONARDO", provincia: "UD" },
  { code: "415062060", nome: "SAN LEUCIO DEL SANNIO", provincia: "BN" },
  { code: "415062061", nome: "SAN LORENZELLO", provincia: "BN" },
  { code: "407008054", nome: "SAN LORENZO AL MARE", provincia: "IM" },
  { code: "418078120", nome: "SAN LORENZO BELLIZZI", provincia: "CS" },
  { code: "418078121", nome: "SAN LORENZO DEL VALLO", provincia: "CS" },
  { code: "404021081", nome: "SAN LORENZO DI SEBATO", provincia: "BZ" },
  { code: "404022231", nome: "SAN LORENZO DORSINO", provincia: "TN" },
  { code: "411141054", nome: "SAN LORENZO IN CAMPO", provincia: "PU" },
  { code: "406031020", nome: "SAN LORENZO ISONTINO", provincia: "GO" },
  { code: "415062062", nome: "SAN LORENZO MAGGIORE", provincia: "BN" },
  { code: "412056047", nome: "SAN LORENZO NUOVO", provincia: "VT" },
  { code: "418080073", nome: "SAN LORENZO", provincia: "RC" },
  { code: "418080074", nome: "SAN LUCA", provincia: "RC" },
  { code: "418078122", nome: "SAN LUCIDO", provincia: "CS" },
  { code: "415062063", nome: "SAN LUPO", provincia: "BN" },
  { code: "418079110", nome: "SAN MANGO D\'AQUINO", provincia: "CZ" },
  { code: "415065121", nome: "SAN MANGO PIEMONTE", provincia: "SA" },
  { code: "415064082", nome: "SAN MANGO SUL CALORE", provincia: "AV" },
  { code: "415061077", nome: "SAN MARCELLINO", provincia: "CE" },
  { code: "409047024", nome: "SAN MARCELLO PITEGLIO", provincia: "PT" },
  { code: "411042041", nome: "SAN MARCELLO", provincia: "AN" },
  { code: "418078123", nome: "SAN MARCO ARGENTANO", provincia: "CS" },
  { code: "419083079", nome: "SAN MARCO D\'ALUNZIO", provincia: "ME" },
  { code: "415062064", nome: "SAN MARCO DEI CAVOTI", provincia: "BN" },
  { code: "415061104", nome: "SAN MARCO EVANGELISTA", provincia: "CE" },
  { code: "416071047", nome: "SAN MARCO IN LAMIS", provincia: "FG" },
  { code: "416071048", nome: "SAN MARCO LA CATOLA", provincia: "FG" },
  { code: "406093039", nome: "SAN MARTINO AL TAGLIAMENTO", provincia: "PN" },
  { code: "401005099", nome: "SAN MARTINO ALFIERI", provincia: "AT" },
  { code: "405023073", nome: "SAN MARTINO BUON ALBERGO", provincia: "VR" },
  { code: "401001247", nome: "SAN MARTINO CANAVESE", provincia: "TO" },
  { code: "417076077", nome: "SAN MARTINO D\'AGRI", provincia: "PZ" },
  { code: "403020059", nome: "SAN MARTINO DALL\'ARGINE", provincia: "MN" },
  { code: "403019091", nome: "SAN MARTINO DEL LAGO", provincia: "CR" },
  { code: "418078124", nome: "SAN MARTINO DI FINITA", provincia: "CS" },
  { code: "405028077", nome: "SAN MARTINO DI LUPARI", provincia: "PD" },
  { code: "405029044", nome: "SAN MARTINO DI VENEZZE", provincia: "RO" },
  { code: "404021082", nome: "SAN MARTINO IN BADIA", provincia: "BZ" },
  { code: "404021083", nome: "SAN MARTINO IN PASSIRIA", provincia: "BZ" },
  { code: "414070069", nome: "SAN MARTINO IN PENSILIS", provincia: "CB" },
  { code: "408035037", nome: "SAN MARTINO IN RIO", provincia: "RE" },
  { code: "403098048", nome: "SAN MARTINO IN STRADA", provincia: "LO" },
  { code: "415062065", nome: "SAN MARTINO SANNITA", provincia: "BN" },
  { code: "403018137", nome: "SAN MARTINO SICCOMARIO", provincia: "PV" },
  { code: "413069082", nome: "SAN MARTINO SULLA MARRUCINA", provincia: "CH" },
  { code: "415064083", nome: "SAN MARTINO VALLE CAUDINA", provincia: "AV" },
  { code: "416073025", nome: "SAN MARZANO DI SAN GIUSEPPE", provincia: "TA" },
  { code: "401005100", nome: "SAN MARZANO OLIVETO", provincia: "AT" },
  { code: "415065122", nome: "SAN MARZANO SUL SARNO", provincia: "SA" },
  { code: "414070070", nome: "SAN MASSIMO", provincia: "CB" },
  { code: "401001248", nome: "SAN MAURIZIO CANAVESE", provincia: "TO" },
  { code: "401003133", nome: "SAN MAURIZIO D\'OPAGLIO", provincia: "NO" },
  { code: "419082065", nome: "SAN MAURO CASTELVERDE", provincia: "PA" },
  { code: "415065123", nome: "SAN MAURO CILENTO", provincia: "SA" },
  { code: "405023074", nome: "SAN MAURO DI SALINE", provincia: "VR" },
  { code: "417077026", nome: "SAN MAURO FORTE", provincia: "MT" },
  { code: "415065124", nome: "SAN MAURO LA BRUCA", provincia: "SA" },
  { code: "418101020", nome: "SAN MAURO MARCHESATO", provincia: "KR" },
  { code: "408140041", nome: "SAN MAURO PASCOLI", provincia: "FC" },
  { code: "401001249", nome: "SAN MAURO TORINESE", provincia: "TO" },
  { code: "405027034", nome: "SAN MICHELE AL TAGLIAMENTO", provincia: "VE" },
  { code: "404022167", nome: "SAN MICHELE ALL\'ADIGE", provincia: "TN" },
  { code: "419087043", nome: "SAN MICHELE DI GANZARIA", provincia: "CT" },
  { code: "415064084", nome: "SAN MICHELE DI SERINO", provincia: "AV" },
  { code: "401004210", nome: "SAN MICHELE MONDOVI\'", provincia: "CN" },
  { code: "416074014", nome: "SAN MICHELE SALENTINO", provincia: "BR" },
  { code: "409050032", nome: "SAN MINIATO", provincia: "PI" },
  { code: "401003134", nome: "SAN NAZZARO SESIA", provincia: "NO" },
  { code: "403013207", nome: "SAN NAZZARO VAL CAVARGNA", provincia: "CO" },
  { code: "415062066", nome: "SAN NAZZARO", provincia: "BN" },
  { code: "416071049", nome: "SAN NICANDRO GARGANICO", provincia: "FG" },
  { code: "418078125", nome: "SAN NICOLA ARCELLA", provincia: "CS" },
  { code: "415064085", nome: "SAN NICOLA BARONIA", provincia: "AV" },
  { code: "418102035", nome: "SAN NICOLA DA CRISSA", provincia: "VV" },
  { code: "418101021", nome: "SAN NICOLA DELL\'ALTO", provincia: "KR" },
  { code: "415061078", nome: "SAN NICOLA LA STRADA", provincia: "CE" },
  { code: "415062067", nome: "SAN NICOLA MANFREDI", provincia: "BN" },
  { code: "420095046", nome: "SAN NICOLO\' D\'ARCIDANO", provincia: "OR" },
  { code: "405025046", nome: "SAN NICOLO\' DI COMELICO", provincia: "BL" },
  { code: "420092058", nome: "SAN NICOLO\' GERREI", provincia: "CA" },
  { code: "416074015", nome: "SAN PANCRAZIO SALENTINO", provincia: "BR" },
  { code: "404021084", nome: "SAN PANCRAZIO", provincia: "BZ" },
  { code: "417076020", nome: "SAN PAOLO ALBANESE", provincia: "PZ" },
  { code: "415063069", nome: "SAN PAOLO BEL SITO", provincia: "NA" },
  { code: "403016189", nome: "SAN PAOLO D\'ARGON", provincia: "BG" },
  { code: "416071050", nome: "SAN PAOLO DI CIVITATE", provincia: "FG" },
  { code: "411042042", nome: "SAN PAOLO DI JESI", provincia: "AN" },
  { code: "401005101", nome: "SAN PAOLO SOLBRITO", provincia: "AT" },
  { code: "403017138", nome: "SAN PAOLO", provincia: "BS" },
  { code: "403016190", nome: "SAN PELLEGRINO TERME", provincia: "BG" },
  { code: "406031021", nome: "SAN PIER D\'ISONZO", provincia: "GO" },
  { code: "419083080", nome: "SAN PIER NICETO", provincia: "ME" },
  { code: "419083081", nome: "SAN PIERO PATTI", provincia: "ME" },
  { code: "418079114", nome: "SAN PIETRO A MAIDA", provincia: "CZ" },
  { code: "406030103", nome: "SAN PIETRO AL NATISONE", provincia: "UD" },
  { code: "415065125", nome: "SAN PIETRO AL TANAGRO", provincia: "SA" },
  { code: "418079115", nome: "SAN PIETRO APOSTOLO", provincia: "CZ" },
  { code: "414094043", nome: "SAN PIETRO AVELLANA", provincia: "IS" },
  { code: "419087044", nome: "SAN PIETRO CLARENZA", provincia: "CT" },
  { code: "405025047", nome: "SAN PIETRO DI CADORE", provincia: "BL" },
  { code: "418080075", nome: "SAN PIETRO DI CARIDA\'", provincia: "RC" },
  { code: "405026073", nome: "SAN PIETRO DI FELETTO", provincia: "TV" },
  { code: "405023075", nome: "SAN PIETRO DI MORUBIO", provincia: "VR" },
  { code: "418078126", nome: "SAN PIETRO IN AMANTEA", provincia: "CS" },
  { code: "405023076", nome: "SAN PIETRO IN CARIANO", provincia: "VR" },
  { code: "408037055", nome: "SAN PIETRO IN CASALE", provincia: "BO" },
  { code: "408033041", nome: "SAN PIETRO IN CERRO", provincia: "PC" },
  { code: "405028078", nome: "SAN PIETRO IN GU", provincia: "PD" },
  { code: "418078127", nome: "SAN PIETRO IN GUARANO", provincia: "CS" },
  { code: "416075071", nome: "SAN PIETRO IN LAMA", provincia: "LE" },
  { code: "415061079", nome: "SAN PIETRO INFINE", provincia: "CE" },
  { code: "401003135", nome: "SAN PIETRO MOSEZZO", provincia: "NO" },
  { code: "405024094", nome: "SAN PIETRO MUSSOLINO", provincia: "VI" },
  { code: "401001250", nome: "SAN PIETRO VAL LEMINA", provincia: "TO" },
  { code: "416074016", nome: "SAN PIETRO VERNOTICO", provincia: "BR" },
  { code: "405028079", nome: "SAN PIETRO VIMINARIO", provincia: "PD" },
  { code: "413066088", nome: "SAN PIO DELLE CAMERE", provincia: "AQ" },
  { code: "408035038", nome: "SAN POLO D\'ENZA", provincia: "RE" },
  { code: "412058096", nome: "SAN POLO DEI CAVALIERI", provincia: "RM" },
  { code: "405026074", nome: "SAN POLO DI PIAVE", provincia: "TV" },
  { code: "414070071", nome: "SAN POLO MATESE", provincia: "CB" },
  { code: "401001251", nome: "SAN PONSO", provincia: "TO" },
  { code: "408036038", nome: "SAN POSSIDONIO", provincia: "MO" },
  { code: "415061080", nome: "SAN POTITO SANNITICO", provincia: "CE" },
  { code: "415064086", nome: "SAN POTITO ULTRA", provincia: "AV" },
  { code: "415061081", nome: "SAN PRISCO", provincia: "CE" },
  { code: "418080076", nome: "SAN PROCOPIO", provincia: "RC" },
  { code: "408036039", nome: "SAN PROSPERO", provincia: "MO" },
  { code: "409052030", nome: "SAN QUIRICO D\'ORCIA", provincia: "SI" },
  { code: "406093040", nome: "SAN QUIRINO", provincia: "PN" },
  { code: "401001252", nome: "SAN RAFFAELE CIMENA", provincia: "TO" },
  { code: "418080077", nome: "SAN ROBERTO", provincia: "RC" },
  { code: "403098049", nome: "SAN ROCCO AL PORTO", provincia: "LO" },
  { code: "409046027", nome: "SAN ROMANO IN GARFAGNANA", provincia: "LU" },
  { code: "415065126", nome: "SAN RUFO", provincia: "SA" },
  { code: "419083082", nome: "SAN SALVATORE DI FITALIA", provincia: "ME" },
  { code: "401006154", nome: "SAN SALVATORE MONFERRATO", provincia: "AL" },
  { code: "415062068", nome: "SAN SALVATORE TELESINO", provincia: "BN" },
  { code: "413069083", nome: "SAN SALVO", provincia: "CH" },
  { code: "415063070", nome: "SAN SEBASTIANO AL VESUVIO", provincia: "NA" },
  { code: "401006155", nome: "SAN SEBASTIANO CURONE", provincia: "AL" },
  { code: "401001253", nome: "SAN SEBASTIANO DA PO", provincia: "TO" },
  { code: "401001254", nome: "SAN SECONDO DI PINEROLO", provincia: "TO" },
  { code: "408034033", nome: "SAN SECONDO PARMENSE", provincia: "PR" },
  { code: "417076078", nome: "SAN SEVERINO LUCANO", provincia: "PZ" },
  { code: "411043047", nome: "SAN SEVERINO MARCHE", provincia: "MC" },
  { code: "416071051", nome: "SAN SEVERO", provincia: "FG" },
  { code: "403013248", nome: "SAN SIRO", provincia: "CO" },
  { code: "415064087", nome: "SAN SOSSIO BARONIA", provincia: "AV" },
  { code: "418079116", nome: "SAN SOSTENE", provincia: "CZ" },
  { code: "418078128", nome: "SAN SOSTI", provincia: "CS" },
  { code: "420092059", nome: "SAN SPERATE", provincia: "CA" },
  { code: "405027936", nome: "SAN STINO DI LIVENZA", provincia: "VE" },
  { code: "415061085", nome: "SAN TAMMARO", provincia: "CE" },
  { code: "419083090", nome: "SAN TEODORO", provincia: "ME" },
  { code: "420091076", nome: "SAN TEODORO", provincia: "NU" },
  { code: "405025049", nome: "SAN TOMASO AGORDINO", provincia: "BL" },
  { code: "413068038", nome: "SAN VALENTINO IN ABRUZZO CITERIORE", provincia: "PE" },
  { code: "415065132", nome: "SAN VALENTINO TORIO", provincia: "SA" },
  { code: "410055030", nome: "SAN VENANZO", provincia: "TR" },
  { code: "405026076", nome: "SAN VENDEMIANO", provincia: "TV" },
  { code: "420095050", nome: "SAN VERO MILIS", provincia: "OR" },
  { code: "418078135", nome: "SAN VINCENZO LA COSTA", provincia: "CS" },
  { code: "413066092", nome: "SAN VINCENZO VALLE ROVETO", provincia: "AQ" },
  { code: "409049018", nome: "SAN VINCENZO", provincia: "LI" },
  { code: "415063075", nome: "SAN VITALIANO", provincia: "NA" },
  { code: "406093041", nome: "SAN VITO AL TAGLIAMENTO", provincia: "PN" },
  { code: "406030105", nome: "SAN VITO AL TORRE", provincia: "UD" },
  { code: "413069086", nome: "SAN VITO CHIETINO", provincia: "CH" },
  { code: "416074017", nome: "SAN VITO DEI NORMANNI", provincia: "BR" },
  { code: "405025051", nome: "SAN VITO DI CADORE", provincia: "BL" },
  { code: "406030106", nome: "SAN VITO DI FAGAGNA", provincia: "UD" },
  { code: "405024096", nome: "SAN VITO DI LEGUZZANO", provincia: "VI" },
  { code: "419081020", nome: "SAN VITO LO CAPO", provincia: "TP" },
  { code: "412058100", nome: "SAN VITO ROMANO", provincia: "RM" },
  { code: "418079122", nome: "SAN VITO SULLO IONIO", provincia: "CZ" },
  { code: "420092064", nome: "SAN VITO", provincia: "CA" },
  { code: "412060070", nome: "SAN VITTORE DEL LAZIO", provincia: "FR" },
  { code: "403015201", nome: "SAN VITTORE OLONA", provincia: "MI" },
  { code: "405023079", nome: "SAN ZENO DI MONTAGNA", provincia: "VR" },
  { code: "403017173", nome: "SAN ZENO NAVIGLIO", provincia: "BS" },
  { code: "403015202", nome: "SAN ZENONE AL LAMBRO", provincia: "MI" },
  { code: "403018145", nome: "SAN ZENONE AL PO", provincia: "PV" },
  { code: "405026077", nome: "SAN ZENONE DEGLI EZZELINI", provincia: "TV" },
  { code: "416075067", nome: "SANARICA", provincia: "LE" },
  { code: "401096059", nome: "SANDIGLIANO", provincia: "BI" },
  { code: "405024091", nome: "SANDRIGO", provincia: "VI" },
  { code: "401004208", nome: "SANFRE\'", provincia: "CN" },
  { code: "401004209", nome: "SANFRONT", provincia: "CN" },
  { code: "401001241", nome: "SANGANO", provincia: "TO" },
  { code: "403012141", nome: "SANGIANO", provincia: "VA" },
  { code: "418078117", nome: "SANGINETO", provincia: "CS" },
  { code: "405023072", nome: "SANGUINETTO", provincia: "VR" },
  { code: "420092057", nome: "SANLURI", provincia: "CA" },
  { code: "403018138", nome: "SANNAZZARO DE\' BURGONDI", provincia: "PV" },
  { code: "416072040", nome: "SANNICANDRO DI BARI", provincia: "BA" },
  { code: "416075070", nome: "SANNICOLA", provincia: "LE" },
  { code: "407008055", nome: "SANREMO", provincia: "IM" },
  { code: "409051034", nome: "SANSEPOLCRO", provincia: "AR" },
  { code: "414094044", nome: "SANT\'AGAPITO", provincia: "IS" },
  { code: "408037056", nome: "SANT\'AGATA BOLOGNESE", provincia: "BO" },
  { code: "415062070", nome: "SANT\'AGATA DE\' GOTI", provincia: "BN" },
  { code: "418080079", nome: "SANT\'AGATA DEL BIANCO", provincia: "RC" },
  { code: "418078131", nome: "SANT\'AGATA DI ESARO", provincia: "CS" },
  { code: "419083084", nome: "SANT\'AGATA DI MILITELLO", provincia: "ME" },
  { code: "416071052", nome: "SANT\'AGATA DI PUGLIA", provincia: "FG" },
  { code: "408099026", nome: "SANT\'AGATA FELTRIA", provincia: "RN" },
  { code: "401006156", nome: "SANT\'AGATA FOSSILI", provincia: "AL" },
  { code: "419087045", nome: "SANT\'AGATA LI BATTIATI", provincia: "CT" },
  { code: "408039017", nome: "SANT\'AGATA SUL SANTERNO", provincia: "RA" },
  { code: "415063071", nome: "SANT\'AGNELLO", provincia: "NA" },
  { code: "401004211", nome: "SANT\'ALBANO STURA", provincia: "CN" },
  { code: "403018141", nome: "SANT\'ALESSIO CON VIALONE", provincia: "PV" },
  { code: "418080080", nome: "SANT\'ALESSIO IN ASPROMONTE", provincia: "RC" },
  { code: "419083085", nome: "SANT\'ALESSIO SICULO", provincia: "ME" },
  { code: "419087046", nome: "SANT\'ALFIO", provincia: "CT" },
  { code: "401001255", nome: "SANT\'AMBROGIO DI TORINO", provincia: "TO" },
  { code: "405023077", nome: "SANT\'AMBROGIO DI VALPOLICELLA", provincia: "VR" },
  { code: "412060065", nome: "SANT\'AMBROGIO SUL GARIGLIANO", provincia: "FR" },
  { code: "415063072", nome: "SANT\'ANASTASIA", provincia: "NA" },
  { code: "410054045", nome: "SANT\'ANATOLIA DI NARCO", provincia: "PG" },
  { code: "418079118", nome: "SANT\'ANDREA APOSTOLO DELLO IONIO", provincia: "CZ" },
  { code: "412060066", nome: "SANT\'ANDREA DEL GARIGLIANO", provincia: "FR" },
  { code: "415064089", nome: "SANT\'ANDREA DI CONZA", provincia: "AV" },
  { code: "420092061", nome: "SANT\'ANDREA FRIUS", provincia: "CA" },
  { code: "415062071", nome: "SANT\'ANGELO A CUPOLO", provincia: "BN" },
  { code: "415065128", nome: "SANT\'ANGELO A FASANELLA", provincia: "SA" },
  { code: "415064091", nome: "SANT\'ANGELO A SCALA", provincia: "AV" },
  { code: "415064090", nome: "SANT\'ANGELO ALL\'ESCA", provincia: "AV" },
  { code: "415061086", nome: "SANT\'ANGELO D\'ALIFE", provincia: "CE" },
  { code: "415064092", nome: "SANT\'ANGELO DEI LOMBARDI", provincia: "AV" },
  { code: "414094046", nome: "SANT\'ANGELO DEL PESCO", provincia: "IS" },
  { code: "419083088", nome: "SANT\'ANGELO DI BROLO", provincia: "ME" },
  { code: "405028082", nome: "SANT\'ANGELO DI PIOVE DI SACCO", provincia: "PD" },
  { code: "411043048", nome: "SANT\'ANGELO IN PONTANO", provincia: "MC" },
  { code: "411141057", nome: "SANT\'ANGELO IN VADO", provincia: "PU" },
  { code: "417076079", nome: "SANT\'ANGELO LE FRATTE", provincia: "PZ" },
  { code: "414070073", nome: "SANT\'ANGELO LIMOSANO", provincia: "CB" },
  { code: "403098050", nome: "SANT\'ANGELO LODIGIANO", provincia: "LO" },
  { code: "403018144", nome: "SANT\'ANGELO LOMELLINA", provincia: "PV" },
  { code: "419084039", nome: "SANT\'ANGELO MUXARO", provincia: "AG" },
  { code: "412058098", nome: "SANT\'ANGELO ROMANO", provincia: "RM" },
  { code: "420092062", nome: "SANT\'ANNA ARRESI", provincia: "CA" },
  { code: "405023078", nome: "SANT\'ANNA D\'ALFAEDO", provincia: "VR" },
  { code: "415063073", nome: "SANT\'ANTIMO", provincia: "NA" },
  { code: "420092063", nome: "SANT\'ANTIOCO", provincia: "CA" },
  { code: "401001256", nome: "SANT\'ANTONINO DI SUSA", provincia: "TO" },
  { code: "415063074", nome: "SANT\'ANTONIO ABATE", provincia: "NA" },
  { code: "420090085", nome: "SANT\'ANTONIO DI GALLURA", provincia: "SS" },
  { code: "412060067", nome: "SANT\'APOLLINARE", provincia: "FR" },
  { code: "415062078", nome: "SANT\'ARCANGELO TRIMONTE", provincia: "BN" },
  { code: "417076080", nome: "SANT\'ARCANGELO", provincia: "PZ" },
  { code: "415061087", nome: "SANT\'ARPINO", provincia: "CE" },
  { code: "415065129", nome: "SANT\'ARSENIO", provincia: "SA" },
  { code: "413067038", nome: "SANT\'EGIDIO ALLA VIBRATA", provincia: "TE" },
  { code: "415065130", nome: "SANT\'EGIDIO DEL MONTE ALBINO", provincia: "SA" },
  { code: "414094047", nome: "SANT\'ELENA SANNITA", provincia: "IS" },
  { code: "405028083", nome: "SANT\'ELENA", provincia: "PD" },
  { code: "414070074", nome: "SANT\'ELIA A PIANISI", provincia: "CB" },
  { code: "412060068", nome: "SANT\'ELIA FIUMERAPIDO", provincia: "FR" },
  { code: "411109037", nome: "SANT\'ELPIDIO A MARE", provincia: "FM" },
  { code: "413068037", nome: "SANT\'EUFEMIA A MAIELLA", provincia: "PE" },
  { code: "418080081", nome: "SANT\'EUFEMIA D\'ASPROMONTE", provincia: "RC" },
  { code: "413069085", nome: "SANT\'EUSANIO DEL SANGRO", provincia: "CH" },
  { code: "413066090", nome: "SANT\'EUSANIO FORCONESE", provincia: "AQ" },
  { code: "408035039", nome: "SANT\'ILARIO D\'ENZA", provincia: "RE" },
  { code: "418080082", nome: "SANT\'ILARIO DELLO IONIO", provincia: "RC" },
  { code: "411141058", nome: "SANT\'IPPOLITO", provincia: "PU" },
  { code: "407010055", nome: "SANT\'OLCESE", provincia: "GE" },
  { code: "413067039", nome: "SANT\'OMERO", provincia: "TE" },
  { code: "403016992", nome: "SANT\'OMOBONO TERME", provincia: "BG" },
  { code: "418102036", nome: "SANT\'ONOFRIO", provincia: "VV" },
  { code: "412058099", nome: "SANT\'ORESTE", provincia: "RM" },
  { code: "404022168", nome: "SANT\'ORSOLA TERME", provincia: "TN" },
  { code: "405028084", nome: "SANT\'URBANO", provincia: "PD" },
  { code: "403016191", nome: "SANTA BRIGIDA", provincia: "BG" },
  { code: "418078129", nome: "SANTA CATERINA ALBANESE", provincia: "CS" },
  { code: "405028108", nome: "SANTA CATERINA D\'ESTE", provincia: "PD" },
  { code: "418079117", nome: "SANTA CATERINA DELLO IONIO", provincia: "CZ" },
  { code: "419085017", nome: "SANTA CATERINA VILLARMOSA", provincia: "CL" },
  { code: "416075072", nome: "SANTA CESAREA TERME", provincia: "LE" },
  { code: "418080078", nome: "SANTA CRISTINA D\'ASPROMONTE", provincia: "RC" },
  { code: "403018139", nome: "SANTA CRISTINA E BISSONE", provincia: "PV" },
  { code: "419082066", nome: "SANTA CRISTINA GELA", provincia: "PA" },
  { code: "404021085", nome: "SANTA CRISTINA VALGARDENA", provincia: "BZ" },
  { code: "419088010", nome: "SANTA CROCE CAMERINA", provincia: "RG" },
  { code: "415062069", nome: "SANTA CROCE DEL SANNIO", provincia: "BN" },
  { code: "414070072", nome: "SANTA CROCE DI MAGLIANO", provincia: "CB" },
  { code: "409050033", nome: "SANTA CROCE SULL\'ARNO", provincia: "PI" },
  { code: "418078130", nome: "SANTA DOMENICA TALAO", provincia: "CS" },
  { code: "419083083", nome: "SANTA DOMENICA VITTORIA", provincia: "ME" },
  { code: "419084037", nome: "SANTA ELISABETTA", provincia: "AG" },
  { code: "409053022", nome: "SANTA FIORA", provincia: "GR" },
  { code: "419082067", nome: "SANTA FLAVIA", provincia: "PA" },
  { code: "403018140", nome: "SANTA GIULETTA", provincia: "PV" },
  { code: "420095047", nome: "SANTA GIUSTA", provincia: "OR" },
  { code: "405028080", nome: "SANTA GIUSTINA IN COLLE", provincia: "PD" },
  { code: "405025048", nome: "SANTA GIUSTINA", provincia: "BL" },
  { code: "409050034", nome: "SANTA LUCE", provincia: "PI" },
  { code: "419083086", nome: "SANTA LUCIA DEL MELA", provincia: "ME" },
  { code: "405026075", nome: "SANTA LUCIA DI PIAVE", provincia: "TV" },
  { code: "415064088", nome: "SANTA LUCIA DI SERINO", provincia: "AV" },
  { code: "419084038", nome: "SANTA MARGHERITA DI BELICE", provincia: "AG" },
  { code: "403018142", nome: "SANTA MARGHERITA DI STAFFORA", provincia: "PV" },
  { code: "407010054", nome: "SANTA MARGHERITA LIGURE", provincia: "GE" },
  { code: "409050035", nome: "SANTA MARIA A MONTE", provincia: "PI" },
  { code: "415061082", nome: "SANTA MARIA A VICO", provincia: "CE" },
  { code: "415061083", nome: "SANTA MARIA CAPUA VETERE", provincia: "CE" },
  { code: "420090087", nome: "SANTA MARIA COGHINAS", provincia: "SS" },
  { code: "418078132", nome: "SANTA MARIA DEL CEDRO", provincia: "CS" },
  { code: "414094045", nome: "SANTA MARIA DEL MOLISE", provincia: "IS" },
  { code: "403018143", nome: "SANTA MARIA DELLA VERSA", provincia: "PV" },
  { code: "419087047", nome: "SANTA MARIA DI LICODIA", provincia: "CT" },
  { code: "405027035", nome: "SANTA MARIA DI SALA", provincia: "VE" },
  { code: "403097074", nome: "SANTA MARIA HOE\'", provincia: "LC" },
  { code: "413069084", nome: "SANTA MARIA IMBARO", provincia: "CH" },
  { code: "415063090", nome: "SANTA MARIA LA CARITA\'", provincia: "NA" },
  { code: "415061084", nome: "SANTA MARIA LA FOSSA", provincia: "CE" },
  { code: "406030104", nome: "SANTA MARIA LA LONGA", provincia: "UD" },
  { code: "401103062", nome: "SANTA MARIA MAGGIORE", provincia: "VB" },
  { code: "411042043", nome: "SANTA MARIA NUOVA", provincia: "AN" },
  { code: "419083087", nome: "SANTA MARINA SALINA", provincia: "ME" },
  { code: "415065127", nome: "SANTA MARINA", provincia: "SA" },
  { code: "412058097", nome: "SANTA MARINELLA", provincia: "RM" },
  { code: "419081019", nome: "SANTA NINFA", provincia: "TP" },
  { code: "415064093", nome: "SANTA PAOLINA", provincia: "AV" },
  { code: "418101022", nome: "SANTA SEVERINA", provincia: "KR" },
  { code: "418078133", nome: "SANTA SOFIA D\'EPIRO", provincia: "CS" },
  { code: "408140043", nome: "SANTA SOFIA", provincia: "FC" },
  { code: "419083089", nome: "SANTA TERESA DI RIVA", provincia: "ME" },
  { code: "420090063", nome: "SANTA TERESA GALLURA", provincia: "SS" },
  { code: "419087048", nome: "SANTA VENERINA", provincia: "CT" },
  { code: "401004212", nome: "SANTA VITTORIA D\'ALBA", provincia: "CN" },
  { code: "411109036", nome: "SANTA VITTORIA IN MATENANO", provincia: "FM" },
  { code: "420092060", nome: "SANTADI", provincia: "CA" },
  { code: "408099018", nome: "SANTARCANGELO DI ROMAGNA", provincia: "RN" },
  { code: "413066089", nome: "SANTE MARIE", provincia: "AQ" },
  { code: "401001257", nome: "SANTENA", provincia: "TO" },
  { code: "416072041", nome: "SANTERAMO IN COLLE", provincia: "BA" },
  { code: "401002133", nome: "SANTHIA\'", provincia: "VC" },
  { code: "412059026", nome: "SANTI COSMA E DAMIANO", provincia: "LT" },
  { code: "407008056", nome: "SANTO STEFANO AL MARE", provincia: "IM" },
  { code: "401004213", nome: "SANTO STEFANO BELBO", provincia: "CN" },
  { code: "407010056", nome: "SANTO STEFANO D\'AVETO", provincia: "GE" },
  { code: "415064095", nome: "SANTO STEFANO DEL SOLE", provincia: "AV" },
  { code: "405025050", nome: "SANTO STEFANO DI CADORE", provincia: "BL" },
  { code: "419083091", nome: "SANTO STEFANO DI CAMASTRA", provincia: "ME" },
  { code: "407011026", nome: "SANTO STEFANO DI MAGRA", provincia: "SP" },
  { code: "418078134", nome: "SANTO STEFANO DI ROGLIANO", provincia: "CS" },
  { code: "413066091", nome: "SANTO STEFANO DI SESSANIO", provincia: "AQ" },
  { code: "418080083", nome: "SANTO STEFANO IN ASPROMONTE", provincia: "RC" },
  { code: "403098051", nome: "SANTO STEFANO LODIGIANO", provincia: "LO" },
  { code: "419084040", nome: "SANTO STEFANO QUISQUINA", provincia: "AG" },
  { code: "401004214", nome: "SANTO STEFANO ROERO", provincia: "CN" },
  { code: "403015200", nome: "SANTO STEFANO TICINO", provincia: "MI" },
  { code: "415065131", nome: "SANTOMENNA", provincia: "SA" },
  { code: "412060069", nome: "SANTOPADRE", provincia: "FR" },
  { code: "405024095", nome: "SANTORSO", provincia: "VI" },
  { code: "420095049", nome: "SANTU LUSSURGIU", provincia: "OR" },
  { code: "415065133", nome: "SANZA", provincia: "SA" },
  { code: "404022169", nome: "SANZENO", provincia: "TN" },
  { code: "405028085", nome: "SAONARA", provincia: "PD" },
  { code: "419083092", nome: "SAPONARA", provincia: "ME" },
  { code: "405030189", nome: "SAPPADA", provincia: "UD" },
  { code: "415065134", nome: "SAPRI", provincia: "SA" },
  { code: "418078136", nome: "SARACENA", provincia: "CS" },
  { code: "412058101", nome: "SARACINESCO", provincia: "RM" },
  { code: "405024097", nome: "SARCEDO", provincia: "VI" },
  { code: "417076081", nome: "SARCONI", provincia: "PZ" },
  { code: "420092065", nome: "SARDARA", provincia: "CA" },
  { code: "401006157", nome: "SARDIGLIANO", provincia: "AL" },
  { code: "405024098", nome: "SAREGO", provincia: "VI" },
  { code: "404021086", nome: "SARENTINO", provincia: "BZ" },
  { code: "401006158", nome: "SAREZZANO", provincia: "AL" },
  { code: "403017174", nome: "SAREZZO", provincia: "BS" },
  { code: "408033042", nome: "SARMATO", provincia: "PC" },
  { code: "405026078", nome: "SARMEDE", provincia: "TV" },
  { code: "411043049", nome: "SARNANO", provincia: "MC" },
  { code: "403016193", nome: "SARNICO", provincia: "BG" },
  { code: "415065135", nome: "SARNO", provincia: "SA" },
  { code: "404022170", nome: "SARNONICO", provincia: "TN" },
  { code: "403012119", nome: "SARONNO", provincia: "VA" },
  { code: "402007066", nome: "SARRE", provincia: "AO" },
  { code: "420092066", nome: "SARROCH", provincia: "CA" },
  { code: "408140044", nome: "SARSINA", provincia: "FC" },
  { code: "409052031", nome: "SARTEANO", provincia: "SI" },
  { code: "403018146", nome: "SARTIRANA LOMELLINA", provincia: "PV" },
  { code: "420091077", nome: "SARULE", provincia: "NU" },
  { code: "407011027", nome: "SARZANA", provincia: "SP" },
  { code: "415065136", nome: "SASSANO", provincia: "SA" },
  { code: "420090064", nome: "SASSARI", provincia: "SS" },
  { code: "407009055", nome: "SASSELLO", provincia: "SV" },
  { code: "409049019", nome: "SASSETTA", provincia: "LI" },
  { code: "415062072", nome: "SASSINORO", provincia: "BN" },
  { code: "417076082", nome: "SASSO DI CASTALDA", provincia: "PZ" },
  { code: "408037057", nome: "SASSO MARCONI", provincia: "BO" },
  { code: "411141071", nome: "SASSOCORVARO AUDITORE", provincia: "PU" },
  { code: "411099031", nome: "SASSOFELTRIO", provincia: "RN" },
  { code: "411042044", nome: "SASSOFERRATO", provincia: "AN" },
  { code: "408036040", nome: "SASSUOLO", provincia: "MO" },
  { code: "417076083", nome: "SATRIANO DI LUCANIA", provincia: "PZ" },
  { code: "418079123", nome: "SATRIANO", provincia: "CZ" },
  { code: "406030107", nome: "SAURIS", provincia: "UD" },
  { code: "401001259", nome: "SAUZE D\'OULX", provincia: "TO" },
  { code: "401001258", nome: "SAUZE DI CESANA", provincia: "TO" },
  { code: "416073026", nome: "SAVA", provincia: "TA" },
  { code: "418101023", nome: "SAVELLI", provincia: "KR" },
  { code: "415063076", nome: "SAVIANO", provincia: "NA" },
  { code: "401004215", nome: "SAVIGLIANO", provincia: "CN" },
  { code: "415064096", nome: "SAVIGNANO IRPINO", provincia: "AV" },
  { code: "408036041", nome: "SAVIGNANO SUL PANARO", provincia: "MO" },
  { code: "408140045", nome: "SAVIGNANO SUL RUBICONE", provincia: "FC" },
  { code: "407010057", nome: "SAVIGNONE", provincia: "GE" },
  { code: "403017175", nome: "SAVIORE DELL\'ADAMELLO", provincia: "BS" },
  { code: "419083093", nome: "SAVOCA", provincia: "ME" },
  { code: "406031022", nome: "SAVOGNA D\'ISONZO", provincia: "GO" },
  { code: "406030108", nome: "SAVOGNA", provincia: "UD" },
  { code: "417076084", nome: "SAVOIA DI LUCANIA", provincia: "PZ" },
  { code: "407009056", nome: "SAVONA", provincia: "SV" },
  { code: "413068039", nome: "SCAFA", provincia: "PE" },
  { code: "415065137", nome: "SCAFATI", provincia: "SA" },
  { code: "401004216", nome: "SCAGNELLO", provincia: "CN" },
  { code: "418078137", nome: "SCALA COELI", provincia: "CS" },
  { code: "415065138", nome: "SCALA", provincia: "SA" },
  { code: "403018147", nome: "SCALDASOLE", provincia: "PV" },
  { code: "418078138", nome: "SCALEA", provincia: "CS" },
  { code: "401001260", nome: "SCALENGHE", provincia: "TO" },
  { code: "419083094", nome: "SCALETTA ZANCLEA", provincia: "ME" },
  { code: "415064097", nome: "SCAMPITELLA", provincia: "AV" },
  { code: "418101024", nome: "SCANDALE", provincia: "KR" },
  { code: "408035040", nome: "SCANDIANO", provincia: "RE" },
  { code: "409048041", nome: "SCANDICCI", provincia: "FI" },
  { code: "403019092", nome: "SCANDOLARA RAVARA", provincia: "CR" },
  { code: "403019093", nome: "SCANDOLARA RIPA D\'OGLIO", provincia: "CR" },
  { code: "412057064", nome: "SCANDRIGLIA", provincia: "RI" },
  { code: "413066093", nome: "SCANNO", provincia: "AQ" },
  { code: "420095051", nome: "SCANO DI MONTIFERRO", provincia: "OR" },
  { code: "409053023", nome: "SCANSANO", provincia: "GR" },
  { code: "417077031", nome: "SCANZANO JONICO", provincia: "MT" },
  { code: "403016194", nome: "SCANZOROSCIATE", provincia: "BG" },
  { code: "414094048", nome: "SCAPOLI", provincia: "IS" },
  { code: "409053024", nome: "SCARLINO", provincia: "GR" },
  { code: "401001261", nome: "SCARMAGNO", provincia: "TO" },
  { code: "401004217", nome: "SCARNAFIGI", provincia: "CN" },
  { code: "409048053", nome: "SCARPERIA E SAN PIERO", provincia: "FI" },
  { code: "404021087", nome: "SCENA", provincia: "BZ" },
  { code: "413069087", nome: "SCERNI", provincia: "CH" },
  { code: "410054046", nome: "SCHEGGIA E PASCELUPO", provincia: "PG" },
  { code: "410054047", nome: "SCHEGGINO", provincia: "PG" },
  { code: "413069088", nome: "SCHIAVI DI ABRUZZO", provincia: "CH" },
  { code: "405024099", nome: "SCHIAVON", provincia: "VI" },
  { code: "403013211", nome: "SCHIGNANO", provincia: "CO" },
  { code: "403016195", nome: "SCHILPARIO", provincia: "BG" },
  { code: "405024100", nome: "SCHIO", provincia: "VI" },
  { code: "403020060", nome: "SCHIVENOGLIA", provincia: "MN" },
  { code: "419084041", nome: "SCIACCA", provincia: "AG" },
  { code: "419082068", nome: "SCIARA", provincia: "PA" },
  { code: "419088011", nome: "SCICLI", provincia: "RG" },
  { code: "418080084", nome: "SCIDO", provincia: "RC" },
  { code: "418078139", nome: "SCIGLIANO", provincia: "CS" },
  { code: "418080085", nome: "SCILLA", provincia: "RC" },
  { code: "419082081", nome: "SCILLATO", provincia: "PA" },
  { code: "401001262", nome: "SCIOLZE", provincia: "TO" },
  { code: "415063077", nome: "SCISCIANO", provincia: "NA" },
  { code: "419082069", nome: "SCLAFANI BAGNI", provincia: "PA" },
  { code: "413066094", nome: "SCONTRONE", provincia: "AQ" },
  { code: "401002134", nome: "SCOPA", provincia: "VC" },
  { code: "401002135", nome: "SCOPELLO", provincia: "VC" },
  { code: "413066095", nome: "SCOPPITO", provincia: "AQ" },
  { code: "419087049", nome: "SCORDIA", provincia: "CT" },
  { code: "416075073", nome: "SCORRANO", provincia: "LE" },
  { code: "405027037", nome: "SCORZE\'", provincia: "VE" },
  { code: "413066096", nome: "SCURCOLA MARSICANA", provincia: "AQ" },
  { code: "404022171", nome: "SCURELLE", provincia: "TN" },
  { code: "401005103", nome: "SCURZOLENGO", provincia: "AT" },
  { code: "407008057", nome: "SEBORGA", provincia: "IM" },
  { code: "413066097", nome: "SECINARO", provincia: "AQ" },
  { code: "416075074", nome: "SECLI\'", provincia: "LE" },
  { code: "403098052", nome: "SECUGNAGO", provincia: "LO" },
  { code: "406030109", nome: "SEDEGLIANO", provincia: "UD" },
  { code: "405025053", nome: "SEDICO", provincia: "BL" },
  { code: "420095052", nome: "SEDILO", provincia: "OR" },
  { code: "420090065", nome: "SEDINI", provincia: "SS" },
  { code: "403015204", nome: "SEDRIANO", provincia: "MI" },
  { code: "403016196", nome: "SEDRINA", provincia: "BG" },
  { code: "411043050", nome: "SEFRO", provincia: "MC" },
  { code: "420092067", nome: "SEGARIU", provincia: "CA" },
  { code: "409053025", nome: "SEGGIANO", provincia: "GR" },
  { code: "412058102", nome: "SEGNI", provincia: "RM" },
  { code: "404022172", nome: "SEGONZANO", provincia: "TN" },
  { code: "403015205", nome: "SEGRATE", provincia: "MI" },
  { code: "405026079", nome: "SEGUSINO", provincia: "TV" },
  { code: "420092068", nome: "SELARGIUS", provincia: "CA" },
  { code: "412057065", nome: "SELCI", provincia: "RI" },
  { code: "420092069", nome: "SELEGAS", provincia: "CA" },
  { code: "404022246", nome: "SELLA GIUDICARIE", provincia: "TN" },
  { code: "410054048", nome: "SELLANO", provincia: "PG" },
  { code: "403017176", nome: "SELLERO", provincia: "BS" },
  { code: "418079127", nome: "SELLIA MARINA", provincia: "CZ" },
  { code: "418079126", nome: "SELLIA", provincia: "CZ" },
  { code: "404021088", nome: "SELVA DEI MOLINI", provincia: "BZ" },
  { code: "405025054", nome: "SELVA DI CADORE", provincia: "BL" },
  { code: "405023080", nome: "SELVA DI PROGNO", provincia: "VR" },
  { code: "404021089", nome: "SELVA DI VAL GARDENA", provincia: "BZ" },
  { code: "405028086", nome: "SELVAZZANO DENTRO", provincia: "PD" },
  { code: "403016197", nome: "SELVINO", provincia: "BG" },
  { code: "420090066", nome: "SEMESTENE", provincia: "SS" },
  { code: "403018148", nome: "SEMIANA", provincia: "PV" },
  { code: "418080086", nome: "SEMINARA", provincia: "RC" },
  { code: "409053028", nome: "SEMPRONIANO", provincia: "GR" },
  { code: "403015206", nome: "SENAGO", provincia: "MI" },
  { code: "404021118", nome: "SENALE-SAN FELICE", provincia: "BZ" },
  { code: "404021091", nome: "SENALES", provincia: "BZ" },
  { code: "420095053", nome: "SENEGHE", provincia: "OR" },
  { code: "415064098", nome: "SENERCHIA", provincia: "AV" },
  { code: "403017177", nome: "SENIGA", provincia: "BS" },
  { code: "411042045", nome: "SENIGALLIA", provincia: "AN" },
  { code: "420095054", nome: "SENIS", provincia: "OR" },
  { code: "417076085", nome: "SENISE", provincia: "PZ" },
  { code: "403013212", nome: "SENNA COMASCO", provincia: "CO" },
  { code: "403098053", nome: "SENNA LODIGIANA", provincia: "LO" },
  { code: "420095055", nome: "SENNARIOLO", provincia: "OR" },
  { code: "420090067", nome: "SENNORI", provincia: "SS" },
  { code: "420092070", nome: "SENORBI\'", provincia: "CA" },
  { code: "414070075", nome: "SEPINO", provincia: "CB" },
  { code: "406093042", nome: "SEQUALS", provincia: "PN" },
  { code: "409046028", nome: "SERAVEZZA", provincia: "LU" },
  { code: "420092071", nome: "SERDIANA", provincia: "CA" },
  { code: "403108039", nome: "SEREGNO", provincia: "MB" },
  { code: "405025055", nome: "SEREN DEL GRAPPA", provincia: "BL" },
  { code: "403019094", nome: "SERGNANO", provincia: "CR" },
  { code: "403016198", nome: "SERIATE", provincia: "BG" },
  { code: "403016199", nome: "SERINA", provincia: "BG" },
  { code: "415064099", nome: "SERINO", provincia: "AV" },
  { code: "403017178", nome: "SERLE", provincia: "BS" },
  { code: "403020961", nome: "SERMIDE E FELONICA", provincia: "MN" },
  { code: "412059027", nome: "SERMONETA", provincia: "LT" },
  { code: "405026080", nome: "SERNAGLIA DELLA BATTAGLIA", provincia: "TV" },
  { code: "403014059", nome: "SERNIO", provincia: "SO" },
  { code: "401005104", nome: "SEROLE", provincia: "AT" },
  { code: "418078140", nome: "SERRA D\'AIELLO", provincia: "CS" },
  { code: "411042046", nome: "SERRA DE\' CONTI", provincia: "AN" },
  { code: "407010058", nome: "SERRA RICCO\'", provincia: "GE" },
  { code: "418102037", nome: "SERRA SAN BRUNO", provincia: "VV" },
  { code: "411042047", nome: "SERRA SAN QUIRICO", provincia: "AN" },
  { code: "411141061", nome: "SERRA SANT\'ABBONDIO", provincia: "PU" },
  { code: "416071053", nome: "SERRACAPRIOLA", provincia: "FG" },
  { code: "419085018", nome: "SERRADIFALCO", provincia: "CL" },
  { code: "401004218", nome: "SERRALUNGA D\'ALBA", provincia: "CN" },
  { code: "401006159", nome: "SERRALUNGA DI CREA", provincia: "AL" },
  { code: "420092072", nome: "SERRAMANNA", provincia: "CA" },
  { code: "408036042", nome: "SERRAMAZZONI", provincia: "MO" },
  { code: "415065139", nome: "SERRAMEZZANA", provincia: "SA" },
  { code: "413068040", nome: "SERRAMONACESCA", provincia: "PE" },
  { code: "411043051", nome: "SERRAPETRONA", provincia: "MC" },
  { code: "415063078", nome: "SERRARA FONTANA", provincia: "NA" },
  { code: "418079129", nome: "SERRASTRETTA", provincia: "CZ" },
  { code: "418080087", nome: "SERRATA", provincia: "RC" },
  { code: "403020062", nome: "SERRAVALLE A PO", provincia: "MN" },
  { code: "411043052", nome: "SERRAVALLE DI CHIENTI", provincia: "MC" },
  { code: "401004219", nome: "SERRAVALLE LANGHE", provincia: "CN" },
  { code: "409047020", nome: "SERRAVALLE PISTOIESE", provincia: "PT" },
  { code: "401006160", nome: "SERRAVALLE SCRIVIA", provincia: "AL" },
  { code: "401002137", nome: "SERRAVALLE SESIA", provincia: "VC" },
  { code: "415065140", nome: "SERRE", provincia: "SA" },
  { code: "420092073", nome: "SERRENTI", provincia: "CA" },
  { code: "420092120", nome: "SERRI", provincia: "CA" },
  { code: "412060071", nome: "SERRONE", provincia: "FR" },
  { code: "418079130", nome: "SERSALE", provincia: "CZ" },
  { code: "411109038", nome: "SERVIGLIANO", provincia: "FM" },
  { code: "415061088", nome: "SESSA AURUNCA", provincia: "CE" },
  { code: "415065141", nome: "SESSA CILENTO", provincia: "SA" },
  { code: "401005105", nome: "SESSAME", provincia: "AT" },
  { code: "414094049", nome: "SESSANO DEL MOLISE", provincia: "IS" },
  { code: "407011028", nome: "SESTA GODANO", provincia: "SP" },
  { code: "409051035", nome: "SESTINO", provincia: "AR" },
  { code: "406093043", nome: "SESTO AL REGHENA", provincia: "PN" },
  { code: "403012120", nome: "SESTO CALENDE", provincia: "VA" },
  { code: "414094050", nome: "SESTO CAMPANO", provincia: "IS" },
  { code: "403019095", nome: "SESTO ED UNITI", provincia: "CR" },
  { code: "409048043", nome: "SESTO FIORENTINO", provincia: "FI" },
  { code: "403015209", nome: "SESTO SAN GIOVANNI", provincia: "MI" },
  { code: "404021092", nome: "SESTO", provincia: "BZ" },
  { code: "408036043", nome: "SESTOLA", provincia: "MO" },
  { code: "407010059", nome: "SESTRI LEVANTE", provincia: "GE" },
  { code: "401001263", nome: "SESTRIERE", provincia: "TO" },
  { code: "420092074", nome: "SESTU", provincia: "CA" },
  { code: "403015210", nome: "SETTALA", provincia: "MI" },
  { code: "412060072", nome: "SETTEFRATI", provincia: "FR" },
  { code: "405025075", nome: "SETTEVILLE", provincia: "BL" },
  { code: "401005106", nome: "SETTIME", provincia: "AT" },
  { code: "403015211", nome: "SETTIMO MILANESE", provincia: "MI" },
  { code: "401001264", nome: "SETTIMO ROTTARO", provincia: "TO" },
  { code: "420092075", nome: "SETTIMO SAN PIETRO", provincia: "CA" },
  { code: "401001265", nome: "SETTIMO TORINESE", provincia: "TO" },
  { code: "401001266", nome: "SETTIMO VITTONE", provincia: "TO" },
  { code: "418079131", nome: "SETTINGIANO", provincia: "CZ" },
  { code: "420092076", nome: "SETZU", provincia: "CA" },
  { code: "420091081", nome: "SEUI", provincia: "NU" },
  { code: "420091082", nome: "SEULO", provincia: "NU" },
  { code: "403108040", nome: "SEVESO", provincia: "MB" },
  { code: "401006161", nome: "SEZZADIO", provincia: "AL" },
  { code: "412059028", nome: "SEZZE", provincia: "LT" },
  { code: "404022173", nome: "SFRUZ", provincia: "TN" },
  { code: "406032005", nome: "SGONICO", provincia: "TS" },
  { code: "412060073", nome: "SGURGOLA", provincia: "FR" },
  { code: "420095056", nome: "SIAMAGGIORE", provincia: "OR" },
  { code: "420095057", nome: "SIAMANNA", provincia: "OR" },
  { code: "415065142", nome: "SIANO", provincia: "SA" },
  { code: "420095076", nome: "SIAPICCIA", provincia: "OR" },
  { code: "415065143", nome: "SICIGNANO DEGLI ALBURNI", provincia: "SA" },
  { code: "419084042", nome: "SICULIANA", provincia: "AG" },
  { code: "420092077", nome: "SIDDI", provincia: "CA" },
  { code: "418080088", nome: "SIDERNO", provincia: "RC" },
  { code: "409052032", nome: "SIENA", provincia: "SI" },
  { code: "410054049", nome: "SIGILLO", provincia: "PG" },
  { code: "409048044", nome: "SIGNA", provincia: "FI" },
  { code: "404021093", nome: "SILANDRO", provincia: "BZ" },
  { code: "420091083", nome: "SILANUS", provincia: "NU" },
  { code: "405026081", nome: "SILEA", provincia: "TV" },
  { code: "420090068", nome: "SILIGO", provincia: "SS" },
  { code: "420092078", nome: "SILIQUA", provincia: "CA" },
  { code: "420092079", nome: "SILIUS", provincia: "CA" },
  { code: "409046037", nome: "SILLANO GIUNCUGNANO", provincia: "LU" },
  { code: "401003138", nome: "SILLAVENGO", provincia: "NO" },
  { code: "401006162", nome: "SILVANO D\'ORBA", provincia: "AL" },
  { code: "403018149", nome: "SILVANO PIETRA", provincia: "PV" },
  { code: "413067040", nome: "SILVI", provincia: "TE" },
  { code: "420095058", nome: "SIMALA", provincia: "OR" },
  { code: "420095059", nome: "SIMAXIS", provincia: "OR" },
  { code: "418102038", nome: "SIMBARIO", provincia: "VV" },
  { code: "418079133", nome: "SIMERI CRICHI", provincia: "CZ" },
  { code: "419083095", nome: "SINAGRA", provincia: "ME" },
  { code: "409052033", nome: "SINALUNGA", provincia: "SI" },
  { code: "420091084", nome: "SINDIA", provincia: "NU" },
  { code: "420095060", nome: "SINI", provincia: "OR" },
  { code: "401004220", nome: "SINIO", provincia: "CN" },
  { code: "420091085", nome: "SINISCOLA", provincia: "NU" },
  { code: "420092080", nome: "SINNAI", provincia: "CA" },
  { code: "418080089", nome: "SINOPOLI", provincia: "RC" },
  { code: "419089017", nome: "SIRACUSA", provincia: "SR" },
  { code: "415064100", nome: "SIRIGNANO", provincia: "AV" },
  { code: "420095061", nome: "SIRIS", provincia: "OR" },
  { code: "403017179", nome: "SIRMIONE", provincia: "BS" },
  { code: "411042048", nome: "SIROLO", provincia: "AN" },
  { code: "403097075", nome: "SIRONE", provincia: "LC" },
  { code: "403097076", nome: "SIRTORI", provincia: "LC" },
  { code: "408034049", nome: "SISSA TRECASALI", provincia: "PR" },
  { code: "420092081", nome: "SIURGUS DONIGALA", provincia: "CA" },
  { code: "403018150", nome: "SIZIANO", provincia: "PV" },
  { code: "401003139", nome: "SIZZANO", provincia: "NO" },
  { code: "404021094", nome: "SLUDERNO", provincia: "BZ" },
  { code: "411109039", nome: "SMERILLO", provincia: "FM" },
  { code: "405023081", nome: "SOAVE", provincia: "VR" },
  { code: "406030110", nome: "SOCCHIEVE", provincia: "UD" },
  { code: "420095078", nome: "SODDI", provincia: "OR" },
  { code: "408140046", nome: "SOGLIANO AL RUBICONE", provincia: "FC" },
  { code: "416075075", nome: "SOGLIANO CAVOUR", provincia: "LE" },
  { code: "401005107", nome: "SOGLIO", provincia: "AT" },
  { code: "403017180", nome: "SOIANO DEL LAGO", provincia: "BS" },
  { code: "405024101", nome: "SOLAGNA", provincia: "VI" },
  { code: "419089018", nome: "SOLARINO", provincia: "SR" },
  { code: "403015213", nome: "SOLARO", provincia: "MI" },
  { code: "403019096", nome: "SOLAROLO RAINERIO", provincia: "CR" },
  { code: "408039018", nome: "SOLAROLO", provincia: "RA" },
  { code: "420095062", nome: "SOLARUSSA", provincia: "OR" },
  { code: "403012121", nome: "SOLBIATE ARNO", provincia: "VA" },
  { code: "403013255", nome: "SOLBIATE CON CAGNO", provincia: "CO" },
  { code: "403012122", nome: "SOLBIATE OLONA", provincia: "VA" },
  { code: "407008058", nome: "SOLDANO", provincia: "IM" },
  { code: "420092082", nome: "SOLEMINIS", provincia: "CA" },
  { code: "401006163", nome: "SOLERO", provincia: "AL" },
  { code: "405028087", nome: "SOLESINO", provincia: "PD" },
  { code: "416075076", nome: "SOLETO", provincia: "LE" },
  { code: "403020063", nome: "SOLFERINO", provincia: "MN" },
  { code: "408036044", nome: "SOLIERA", provincia: "MO" },
  { code: "408034035", nome: "SOLIGNANO", provincia: "PR" },
  { code: "415064101", nome: "SOLOFRA", provincia: "AV" },
  { code: "401006164", nome: "SOLONGHELLO", provincia: "AL" },
  { code: "415062073", nome: "SOLOPACA", provincia: "BN" },
  { code: "403016200", nome: "SOLTO COLLINA", provincia: "BG" },
  { code: "403016251", nome: "SOLZA", provincia: "BG" },
  { code: "403098054", nome: "SOMAGLIA", provincia: "LO" },
  { code: "401004221", nome: "SOMANO", provincia: "CN" },
  { code: "403012123", nome: "SOMMA LOMBARDO", provincia: "VA" },
  { code: "415063079", nome: "SOMMA VESUVIANA", provincia: "NA" },
  { code: "405023082", nome: "SOMMACAMPAGNA", provincia: "VR" },
  { code: "401004222", nome: "SOMMARIVA DEL BOSCO", provincia: "CN" },
  { code: "401004223", nome: "SOMMARIVA PERNO", provincia: "CN" },
  { code: "419085019", nome: "SOMMATINO", provincia: "CL" },
  { code: "403018151", nome: "SOMMO", provincia: "PV" },
  { code: "405023083", nome: "SONA", provincia: "VR" },
  { code: "403019097", nome: "SONCINO", provincia: "CR" },
  { code: "403014060", nome: "SONDALO", provincia: "SO" },
  { code: "403014061", nome: "SONDRIO", provincia: "SO" },
  { code: "403016201", nome: "SONGAVAZZO", provincia: "BG" },
  { code: "403017181", nome: "SONICO", provincia: "BS" },
  { code: "412059029", nome: "SONNINO", provincia: "LT" },
  { code: "412060074", nome: "SORA", provincia: "FR" },
  { code: "404022976", nome: "SORAGA DI FASSA", provincia: "TN" },
  { code: "408034036", nome: "SORAGNA", provincia: "PR" },
  { code: "409053026", nome: "SORANO", provincia: "GR" },
  { code: "418079134", nome: "SORBO SAN BASILE", provincia: "CZ" },
  { code: "415064102", nome: "SORBO SERPICO", provincia: "AV" },
  { code: "408034051", nome: "SORBOLO MEZZANI", provincia: "PR" },
  { code: "401096063", nome: "SORDEVOLO", provincia: "BI" },
  { code: "403098055", nome: "SORDIO", provincia: "LO" },
  { code: "403019098", nome: "SORESINA", provincia: "CR" },
  { code: "405023084", nome: "SORGA\'", provincia: "VR" },
  { code: "420091086", nome: "SORGONO", provincia: "NU" },
  { code: "407010060", nome: "SORI", provincia: "GE" },
  { code: "418102039", nome: "SORIANELLO", provincia: "VV" },
  { code: "418102040", nome: "SORIANO CALABRO", provincia: "VV" },
  { code: "412056048", nome: "SORIANO NEL CIMINO", provincia: "VT" },
  { code: "403013216", nome: "SORICO", provincia: "CO" },
  { code: "401003140", nome: "SORISO", provincia: "NO" },
  { code: "403016202", nome: "SORISOLE", provincia: "BG" },
  { code: "403013217", nome: "SORMANO", provincia: "CO" },
  { code: "420095063", nome: "SORRADILE", provincia: "OR" },
  { code: "415063080", nome: "SORRENTO", provincia: "NA" },
  { code: "420090069", nome: "SORSO", provincia: "SS" },
  { code: "419089019", nome: "SORTINO", provincia: "SR" },
  { code: "403019099", nome: "SOSPIRO", provincia: "CR" },
  { code: "405025056", nome: "SOSPIROLO", provincia: "BL" },
  { code: "405024102", nome: "SOSSANO", provincia: "VI" },
  { code: "401096064", nome: "SOSTEGNO", provincia: "BI" },
  { code: "403016203", nome: "SOTTO IL MONTE GIOVANNI XXIII", provincia: "BG" },
  { code: "404022177", nome: "SOVER", provincia: "TN" },
  { code: "418079137", nome: "SOVERATO", provincia: "CZ" },
  { code: "403016204", nome: "SOVERE", provincia: "BG" },
  { code: "418079138", nome: "SOVERIA MANNELLI", provincia: "CZ" },
  { code: "418079139", nome: "SOVERIA SIMERI", provincia: "CZ" },
  { code: "405025057", nome: "SOVERZENE", provincia: "BL" },
  { code: "409052034", nome: "SOVICILLE", provincia: "SI" },
  { code: "403108041", nome: "SOVICO", provincia: "MB" },
  { code: "405024128", nome: "SOVIZZO", provincia: "VI" },
  { code: "405025058", nome: "SOVRAMONTE", provincia: "BL" },
  { code: "401003141", nome: "SOZZAGO", provincia: "NO" },
  { code: "419083096", nome: "SPADAFORA", provincia: "ME" },
  { code: "418102041", nome: "SPADOLA", provincia: "VV" },
  { code: "415061089", nome: "SPARANISE", provincia: "CE" },
  { code: "401001267", nome: "SPARONE", provincia: "TO" },
  { code: "416075077", nome: "SPECCHIA", provincia: "LE" },
  { code: "410054050", nome: "SPELLO", provincia: "PG" },
  { code: "419086017", nome: "SPERLINGA", provincia: "EN" },
  { code: "412059030", nome: "SPERLONGA", provincia: "LT" },
  { code: "415064103", nome: "SPERONE", provincia: "AV" },
  { code: "403018152", nome: "SPESSA", provincia: "PV" },
  { code: "418078142", nome: "SPEZZANO ALBANESE", provincia: "CS" },
  { code: "418078143", nome: "SPEZZANO DELLA SILA", provincia: "CS" },
  { code: "404022179", nome: "SPIAZZO", provincia: "TN" },
  { code: "401006165", nome: "SPIGNO MONFERRATO", provincia: "AL" },
  { code: "412059031", nome: "SPIGNO SATURNIA", provincia: "LT" },
  { code: "408036045", nome: "SPILAMBERTO", provincia: "MO" },
  { code: "406093044", nome: "SPILIMBERGO", provincia: "PN" },
  { code: "418102042", nome: "SPILINGA", provincia: "VV" },
  { code: "403019100", nome: "SPINADESCO", provincia: "CR" },
  { code: "416110008", nome: "SPINAZZOLA", provincia: "BT" },
  { code: "405027038", nome: "SPINEA", provincia: "VE" },
  { code: "403019101", nome: "SPINEDA", provincia: "CR" },
  { code: "414070076", nome: "SPINETE", provincia: "CB" },
  { code: "401006166", nome: "SPINETO SCRIVIA", provincia: "AL" },
  { code: "411044071", nome: "SPINETOLI", provincia: "AP" },
  { code: "403019102", nome: "SPINO D\'ADDA", provincia: "CR" },
  { code: "403016205", nome: "SPINONE AL LAGO", provincia: "BG" },
  { code: "417076086", nome: "SPINOSO", provincia: "PZ" },
  { code: "403016206", nome: "SPIRANO", provincia: "BG" },
  { code: "410054051", nome: "SPOLETO", provincia: "PG" },
  { code: "413068041", nome: "SPOLTORE", provincia: "PE" },
  { code: "416075078", nome: "SPONGANO", provincia: "LE" },
  { code: "404022180", nome: "SPORMAGGIORE", provincia: "TN" },
  { code: "404022181", nome: "SPORMINORE", provincia: "TN" },
  { code: "407009057", nome: "SPOTORNO", provincia: "SV" },
  { code: "405026082", nome: "SPRESIANO", provincia: "TV" },
  { code: "403014062", nome: "SPRIANA", provincia: "SO" },
  { code: "418079142", nome: "SQUILLACE", provincia: "CZ" },
  { code: "416075079", nome: "SQUINZANO", provincia: "LE" },
  { code: "411042049", nome: "STAFFOLO", provincia: "AN" },
  { code: "403019103", nome: "STAGNO LOMBARDO", provincia: "CR" },
  { code: "418080090", nome: "STAITI", provincia: "RC" },
  { code: "418079143", nome: "STALETTI", provincia: "CZ" },
  { code: "405028088", nome: "STANGHELLA", provincia: "PD" },
  { code: "406031023", nome: "STARANZANO", provincia: "GO" },
  { code: "416073029", nome: "STATTE", provincia: "TA" },
  { code: "401006167", nome: "STAZZANO", provincia: "AL" },
  { code: "409046030", nome: "STAZZEMA", provincia: "LU" },
  { code: "403013218", nome: "STAZZONA", provincia: "CO" },
  { code: "418102043", nome: "STEFANACONI", provincia: "VV" },
  { code: "415065144", nome: "STELLA CILENTO", provincia: "SA" },
  { code: "407009058", nome: "STELLA", provincia: "SV" },
  { code: "407009059", nome: "STELLANELLO", provincia: "SV" },
  { code: "404021095", nome: "STELVIO", provincia: "BZ" },
  { code: "404022182", nome: "STENICO", provincia: "TN" },
  { code: "416075080", nome: "STERNATIA", provincia: "LE" },
  { code: "403016207", nome: "STEZZANO", provincia: "BG" },
  { code: "405029045", nome: "STIENTA", provincia: "RO" },
  { code: "417077027", nome: "STIGLIANO", provincia: "MT" },
  { code: "418080091", nome: "STIGNANO", provincia: "RC" },
  { code: "418080092", nome: "STILO", provincia: "RC" },
  { code: "412057066", nome: "STIMIGLIANO", provincia: "RI" },
  { code: "420090089", nome: "STINTINO", provincia: "SS" },
  { code: "415065145", nome: "STIO", provincia: "SA" },
  { code: "416071054", nome: "STORNARA", provincia: "FG" },
  { code: "416071055", nome: "STORNARELLA", provincia: "FG" },
  { code: "404022183", nome: "STORO", provincia: "TN" },
  { code: "405027039", nome: "STRA", provincia: "VE" },
  { code: "403018153", nome: "STRADELLA", provincia: "PV" },
  { code: "401001268", nome: "STRAMBINELLO", provincia: "TO" },
  { code: "401001269", nome: "STRAMBINO", provincia: "TO" },
  { code: "412060075", nome: "STRANGOLAGALLI", provincia: "FR" },
  { code: "406030111", nome: "STREGNA", provincia: "UD" },
  { code: "404022184", nome: "STREMBO", provincia: "TN" },
  { code: "401103064", nome: "STRESA", provincia: "VB" },
  { code: "401006168", nome: "STREVI", provincia: "AL" },
  { code: "415063081", nome: "STRIANO", provincia: "NA" },
  { code: "401096065", nome: "STRONA", provincia: "BI" },
  { code: "410055031", nome: "STRONCONE", provincia: "TR" },
  { code: "418101025", nome: "STRONGOLI", provincia: "KR" },
  { code: "401002142", nome: "STROPPIANA", provincia: "VC" },
  { code: "401004224", nome: "STROPPO", provincia: "CN" },
  { code: "403016208", nome: "STROZZA", provincia: "BG" },
  { code: "415064104", nome: "STURNO", provincia: "AV" },
  { code: "403018154", nome: "SUARDI", provincia: "PV" },
  { code: "409051037", nome: "SUBBIANO", provincia: "AR" },
  { code: "412058103", nome: "SUBIACO", provincia: "RM" },
  { code: "415061090", nome: "SUCCIVO", provincia: "CE" },
  { code: "403097077", nome: "SUEGLIO", provincia: "LC" },
  { code: "420092083", nome: "SUELLI", provincia: "CA" },
  { code: "403097078", nome: "SUELLO", provincia: "LC" },
  { code: "403016209", nome: "SUISIO", provincia: "BG" },
  { code: "403108042", nome: "SULBIATE", provincia: "MB" },
  { code: "413066098", nome: "SULMONA", provincia: "AQ" },
  { code: "403017182", nome: "SULZANO", provincia: "BS" },
  { code: "403012124", nome: "SUMIRAGO", provincia: "VA" },
  { code: "415064105", nome: "SUMMONTE", provincia: "AV" },
  { code: "420091087", nome: "SUNI", provincia: "NU" },
  { code: "401003143", nome: "SUNO", provincia: "NO" },
  { code: "416075081", nome: "SUPERSANO", provincia: "LE" },
  { code: "412060076", nome: "SUPINO", provincia: "FR" },
  { code: "416075082", nome: "SURANO", provincia: "LE" },
  { code: "416075083", nome: "SURBO", provincia: "LE" },
  { code: "401001270", nome: "SUSA", provincia: "TO" },
  { code: "405026083", nome: "SUSEGANA", provincia: "TV" },
  { code: "403020064", nome: "SUSTINENTE", provincia: "MN" },
  { code: "419085020", nome: "SUTERA", provincia: "CL" },
  { code: "412056049", nome: "SUTRI", provincia: "VT" },
  { code: "406030112", nome: "SUTRIO", provincia: "UD" },
  { code: "409049020", nome: "SUVERETO", provincia: "LI" },
  { code: "403020065", nome: "SUZZARA", provincia: "MN" },
  { code: "403097079", nome: "TACENO", provincia: "LC" },
  { code: "420095064", nome: "TADASUNI", provincia: "OR" },
  { code: "407008059", nome: "TAGGIA", provincia: "IM" },
  { code: "413066099", nome: "TAGLIACOZZO", provincia: "AQ" },
  { code: "405029046", nome: "TAGLIO DI PO", provincia: "RO" },
  { code: "401006169", nome: "TAGLIOLO MONFERRATO", provincia: "AL" },
  { code: "405025059", nome: "TAIBON AGORDINO", provincia: "BL" },
  { code: "403012125", nome: "TAINO", provincia: "VA" },
  { code: "406030113", nome: "TAIPANA", provincia: "UD" },
  { code: "408099027", nome: "TALAMELLO", provincia: "RN" },
  { code: "403014063", nome: "TALAMONA", provincia: "SO" },
  { code: "420091088", nome: "TALANA", provincia: "NU" },
  { code: "403016210", nome: "TALEGGIO", provincia: "BG" },
  { code: "409051038", nome: "TALLA", provincia: "AR" },
  { code: "406030114", nome: "TALMASSONS", provincia: "UD" },
  { code: "405025060", nome: "TAMBRE", provincia: "BL" },
  { code: "419083097", nome: "TAORMINA", provincia: "ME" },
  { code: "412057067", nome: "TARANO", provincia: "RI" },
  { code: "413069089", nome: "TARANTA PELIGNA", provincia: "CH" },
  { code: "401004225", nome: "TARANTASCA", provincia: "CN" },
  { code: "416073027", nome: "TARANTO", provincia: "TA" },
  { code: "406030116", nome: "TARCENTO", provincia: "UD" },
  { code: "412056050", nome: "TARQUINIA", provincia: "VT" },
  { code: "418078145", nome: "TARSIA", provincia: "CS" },
  { code: "403014064", nome: "TARTANO", provincia: "SO" },
  { code: "406030117", nome: "TARVISIO", provincia: "UD" },
  { code: "405026084", nome: "TARZO", provincia: "TV" },
  { code: "401006170", nome: "TASSAROLO", provincia: "AL" },
  { code: "415064106", nome: "TAURANO", provincia: "AV" },
  { code: "415064107", nome: "TAURASI", provincia: "AV" },
  { code: "418080093", nome: "TAURIANOVA", provincia: "RC" },
  { code: "416075084", nome: "TAURISANO", provincia: "LE" },
  { code: "406030118", nome: "TAVAGNACCO", provincia: "UD" },
  { code: "401001271", nome: "TAVAGNASCO", provincia: "TO" },
  { code: "403098056", nome: "TAVAZZANO CON VILLAVESCO", provincia: "LO" },
  { code: "414070077", nome: "TAVENNA", provincia: "CB" },
  { code: "418079146", nome: "TAVERNA", provincia: "CZ" },
  { code: "403013222", nome: "TAVERNERIO", provincia: "CO" },
  { code: "403016211", nome: "TAVERNOLA BERGAMASCA", provincia: "BG" },
  { code: "403017183", nome: "TAVERNOLE SUL MELLA", provincia: "BS" },
  { code: "416075085", nome: "TAVIANO", provincia: "LE" },
  { code: "401096066", nome: "TAVIGLIANO", provincia: "BI" },
  { code: "411141064", nome: "TAVOLETO", provincia: "PU" },
  { code: "411141065", nome: "TAVULLIA", provincia: "PU" },
  { code: "417076087", nome: "TEANA", provincia: "PZ" },
  { code: "415061091", nome: "TEANO", provincia: "CE" },
  { code: "415065146", nome: "TEGGIANO", provincia: "SA" },
  { code: "405027040", nome: "TEGLIO VENETO", provincia: "VE" },
  { code: "403014065", nome: "TEGLIO", provincia: "SO" },
  { code: "415062074", nome: "TELESE TERME", provincia: "BN" },
  { code: "403016212", nome: "TELGATE", provincia: "BG" },
  { code: "420090080", nome: "TELTI", provincia: "SS" },
  { code: "404022189", nome: "TELVE DI SOPRA", provincia: "TN" },
  { code: "404022188", nome: "TELVE", provincia: "TN" },
  { code: "420090070", nome: "TEMPIO PAUSANIA", provincia: "SS" },
  { code: "403017184", nome: "TEMU\'", provincia: "BS" },
  { code: "404022190", nome: "TENNA", provincia: "TN" },
  { code: "404022191", nome: "TENNO", provincia: "TN" },
  { code: "405028089", nome: "TEOLO", provincia: "PD" },
  { code: "415064108", nome: "TEORA", provincia: "AV" },
  { code: "413067041", nome: "TERAMO", provincia: "TE" },
  { code: "401003144", nome: "TERDOBBIATE", provincia: "NO" },
  { code: "412060077", nome: "TERELLE", provincia: "FR" },
  { code: "404021096", nome: "TERENTO", provincia: "BZ" },
  { code: "408034038", nome: "TERENZO", provincia: "PR" },
  { code: "420090086", nome: "TERGU", provincia: "SS" },
  { code: "404021097", nome: "TERLANO", provincia: "BZ" },
  { code: "416072043", nome: "TERLIZZI", provincia: "BA" },
  { code: "419083106", nome: "TERME VIGLIATORE", provincia: "ME" },
  { code: "404021098", nome: "TERMENO SULLA STRADA DEL VINO", provincia: "BZ" },
  { code: "419082070", nome: "TERMINI IMERESE", provincia: "PA" },
  { code: "414070078", nome: "TERMOLI", provincia: "CB" },
  { code: "403012126", nome: "TERNATE", provincia: "VA" },
  { code: "401096067", nome: "TERNENGO", provincia: "BI" },
  { code: "410055032", nome: "TERNI", provincia: "TR" },
  { code: "403016213", nome: "TERNO D\'ISOLA", provincia: "BG" },
  { code: "412059032", nome: "TERRACINA", provincia: "LT" },
  { code: "404022193", nome: "TERRAGNOLO", provincia: "TN" },
  { code: "420095065", nome: "TERRALBA", provincia: "OR" },
  { code: "418078146", nome: "TERRANOVA DA SIBARI", provincia: "CS" },
  { code: "403098057", nome: "TERRANOVA DEI PASSERINI", provincia: "LO" },
  { code: "417076088", nome: "TERRANOVA DI POLLINO", provincia: "PZ" },
  { code: "418080094", nome: "TERRANOVA SAPPO MINULIO", provincia: "RC" },
  { code: "409051039", nome: "TERRANUOVA BRACCIOLINI", provincia: "AR" },
  { code: "419082071", nome: "TERRASINI", provincia: "PA" },
  { code: "405028090", nome: "TERRASSA PADOVANA", provincia: "PD" },
  { code: "418078147", nome: "TERRAVECCHIA", provincia: "CS" },
  { code: "405023085", nome: "TERRAZZO", provincia: "VR" },
  { code: "404022251", nome: "TERRE D\'ADIGE", provincia: "TN" },
  { code: "408038028", nome: "TERRE DEL RENO", provincia: "FE" },
  { code: "411141070", nome: "TERRE ROVERESCHE", provincia: "PU" },
  { code: "409050036", nome: "TERRICCIOLA", provincia: "PI" },
  { code: "401006171", nome: "TERRUGGIA", provincia: "AL" },
  { code: "420091089", nome: "TERTENIA", provincia: "NU" },
  { code: "415063082", nome: "TERZIGNO", provincia: "NA" },
  { code: "406030120", nome: "TERZO DI AQUILEIA", provincia: "UD" },
  { code: "401006172", nome: "TERZO", provincia: "AL" },
  { code: "404022195", nome: "TERZOLAS", provincia: "TN" },
  { code: "407008060", nome: "TERZORIO", provincia: "IM" },
  { code: "404022196", nome: "TESERO", provincia: "TN" },
  { code: "404021099", nome: "TESIMO", provincia: "BZ" },
  { code: "412056051", nome: "TESSENNANO", provincia: "VT" },
  { code: "407009060", nome: "TESTICO", provincia: "SV" },
  { code: "420091090", nome: "TETI", provincia: "NU" },
  { code: "420092084", nome: "TEULADA", provincia: "CA" },
  { code: "415061092", nome: "TEVEROLA", provincia: "CE" },
  { code: "405024104", nome: "TEZZE SUL BRENTA", provincia: "VI" },
  { code: "405024105", nome: "THIENE", provincia: "VI" },
  { code: "420090071", nome: "THIESI", provincia: "SS" },
  { code: "420091091", nome: "TIANA", provincia: "NU" },
  { code: "403019104", nome: "TICENGO", provincia: "CR" },
  { code: "401006173", nome: "TICINETO", provincia: "AL" },
  { code: "416075086", nome: "TIGGIANO", provincia: "LE" },
  { code: "407010061", nome: "TIGLIETO", provincia: "GE" },
  { code: "401005108", nome: "TIGLIOLE", provincia: "AT" },
  { code: "403017185", nome: "TIGNALE", provincia: "BS" },
  { code: "420091092", nome: "TINNURA", provincia: "NU" },
  { code: "413066100", nome: "TIONE DEGLI ABRUZZI", provincia: "AQ" },
  { code: "404022199", nome: "TIONE DI TRENTO", provincia: "TN" },
  { code: "403014066", nome: "TIRANO", provincia: "SO" },
  { code: "404021100", nome: "TIRES", provincia: "BZ" },
  { code: "418079147", nome: "TIRIOLO", provincia: "CZ" },
  { code: "404021101", nome: "TIROLO", provincia: "BZ" },
  { code: "420090072", nome: "TISSI", provincia: "SS" },
  { code: "417076089", nome: "TITO", provincia: "PZ" },
  { code: "412058104", nome: "TIVOLI", provincia: "RM" },
  { code: "408034039", nome: "TIZZANO VAL PARMA", provincia: "PR" },
  { code: "408035041", nome: "TOANO", provincia: "RE" },
  { code: "415062075", nome: "TOCCO CAUDIO", provincia: "BN" },
  { code: "413068042", nome: "TOCCO DA CASAURIA", provincia: "PE" },
  { code: "401103065", nome: "TOCENO", provincia: "VB" },
  { code: "410054052", nome: "TODI", provincia: "PG" },
  { code: "412057068", nome: "TOFFIA", provincia: "RI" },
  { code: "407009061", nome: "TOIRANO", provincia: "SV" },
  { code: "411043053", nome: "TOLENTINO", provincia: "MC" },
  { code: "412058105", nome: "TOLFA", provincia: "RM" },
  { code: "401096068", nome: "TOLLEGNO", provincia: "BI" },
  { code: "413069090", nome: "TOLLO", provincia: "CH" },
  { code: "406030121", nome: "TOLMEZZO", provincia: "UD" },
  { code: "417076090", nome: "TOLVE", provincia: "PZ" },
  { code: "405028091", nome: "TOMBOLO", provincia: "PD" },
  { code: "404022200", nome: "TON", provincia: "TN" },
  { code: "420091093", nome: "TONARA", provincia: "NU" },
  { code: "401005109", nome: "TONCO", provincia: "AT" },
  { code: "405024106", nome: "TONEZZA DEL CIMONE", provincia: "VI" },
  { code: "415061093", nome: "TORA E PICCILLI", provincia: "CE" },
  { code: "418078148", nome: "TORANO CASTELLO", provincia: "CS" },
  { code: "413067042", nome: "TORANO NUOVO", provincia: "TE" },
  { code: "403017186", nome: "TORBOLE CASAGLIA", provincia: "BS" },
  { code: "404022202", nome: "TORCEGNO", provincia: "TN" },
  { code: "415065147", nome: "TORCHIARA", provincia: "SA" },
  { code: "416074018", nome: "TORCHIAROLO", provincia: "BR" },
  { code: "415064109", nome: "TORELLA DEI LOMBARDI", provincia: "AV" },
  { code: "414070079", nome: "TORELLA DEL SANNIO", provincia: "CB" },
  { code: "410054053", nome: "TORGIANO", provincia: "PG" },
  { code: "402007067", nome: "TORGNON", provincia: "AO" },
  { code: "413069091", nome: "TORINO DI SANGRO", provincia: "CH" },
  { code: "401001272", nome: "TORINO", provincia: "TO" },
  { code: "416072044", nome: "TORITTO", provincia: "BA" },
  { code: "403019105", nome: "TORLINO VIMERCATI", provincia: "CR" },
  { code: "401003146", nome: "TORNACO", provincia: "NO" },
  { code: "413069092", nome: "TORNARECCIO", provincia: "CH" },
  { code: "403019106", nome: "TORNATA", provincia: "CR" },
  { code: "413066101", nome: "TORNIMPARTE", provincia: "AQ" },
  { code: "403013223", nome: "TORNO", provincia: "CO" },
  { code: "408034040", nome: "TORNOLO", provincia: "PR" },
  { code: "414070080", nome: "TORO", provincia: "CB" },
  { code: "420091094", nome: "TORPE\'", provincia: "NU" },
  { code: "415065148", nome: "TORRACA", provincia: "SA" },
  { code: "420090073", nome: "TORRALBA", provincia: "SS" },
  { code: "403018155", nome: "TORRAZZA COSTE", provincia: "PV" },
  { code: "401001273", nome: "TORRAZZA PIEMONTE", provincia: "TO" },
  { code: "401096069", nome: "TORRAZZO", provincia: "BI" },
  { code: "415063083", nome: "TORRE ANNUNZIATA", provincia: "NA" },
  { code: "403018156", nome: "TORRE BERETTI E CASTELLARO", provincia: "PV" },
  { code: "403016214", nome: "TORRE BOLDONE", provincia: "BG" },
  { code: "401004226", nome: "TORRE BORMIDA", provincia: "CN" },
  { code: "412060078", nome: "TORRE CAJETANI", provincia: "FR" },
  { code: "401001274", nome: "TORRE CANAVESE", provincia: "TO" },
  { code: "403018157", nome: "TORRE D\'ARESE", provincia: "PV" },
  { code: "403018159", nome: "TORRE D\'ISOLA", provincia: "PV" },
  { code: "403016215", nome: "TORRE DE\' BUSI", provincia: "BG" },
  { code: "413068043", nome: "TORRE DE\' PASSERI", provincia: "PE" },
  { code: "403019107", nome: "TORRE DE\' PICENARDI", provincia: "CR" },
  { code: "403016216", nome: "TORRE DE\' ROVERI", provincia: "BG" },
  { code: "403018158", nome: "TORRE DEI NEGRI", provincia: "PV" },
  { code: "415063084", nome: "TORRE DEL GRECO", provincia: "NA" },
  { code: "405027041", nome: "TORRE DI MOSTO", provincia: "VE" },
  { code: "418079148", nome: "TORRE DI RUGGIERO", provincia: "CZ" },
  { code: "403014067", nome: "TORRE DI SANTA MARIA", provincia: "SO" },
  { code: "415064110", nome: "TORRE LE NOCELLE", provincia: "AV" },
  { code: "401004227", nome: "TORRE MONDOVI\'", provincia: "CN" },
  { code: "415065149", nome: "TORRE ORSAIA", provincia: "SA" },
  { code: "403016217", nome: "TORRE PALLAVICINA", provincia: "BG" },
  { code: "401001275", nome: "TORRE PELLICE", provincia: "TO" },
  { code: "401004228", nome: "TORRE SAN GIORGIO", provincia: "CN" },
  { code: "411109040", nome: "TORRE SAN PATRIZIO", provincia: "FM" },
  { code: "416074019", nome: "TORRE SANTA SUSANNA", provincia: "BR" },
  { code: "406030122", nome: "TORREANO", provincia: "UD" },
  { code: "405024107", nome: "TORREBELVICINO", provincia: "VI" },
  { code: "413069093", nome: "TORREBRUNA", provincia: "CH" },
  { code: "415062076", nome: "TORRECUSO", provincia: "BN" },
  { code: "405028092", nome: "TORREGLIA", provincia: "PD" },
  { code: "419083098", nome: "TORREGROTTA", provincia: "ME" },
  { code: "416071056", nome: "TORREMAGGIORE", provincia: "FG" },
  { code: "419083108", nome: "TORRENOVA", provincia: "ME" },
  { code: "401004229", nome: "TORRESINA", provincia: "CN" },
  { code: "419082072", nome: "TORRETTA", provincia: "PA" },
  { code: "403018160", nome: "TORREVECCHIA PIA", provincia: "PV" },
  { code: "413069094", nome: "TORREVECCHIA TEATINA", provincia: "CH" },
  { code: "405023086", nome: "TORRI DEL BENACO", provincia: "VR" },
  { code: "405024108", nome: "TORRI DI QUARTESOLO", provincia: "VI" },
  { code: "412057070", nome: "TORRI IN SABINA", provincia: "RI" },
  { code: "412060079", nome: "TORRICE", provincia: "FR" },
  { code: "403019108", nome: "TORRICELLA DEL PIZZO", provincia: "CR" },
  { code: "412057069", nome: "TORRICELLA IN SABINA", provincia: "RI" },
  { code: "413069095", nome: "TORRICELLA PELIGNA", provincia: "CH" },
  { code: "413067043", nome: "TORRICELLA SICURA", provincia: "TE" },
  { code: "403018161", nome: "TORRICELLA VERZATE", provincia: "PV" },
  { code: "416073028", nome: "TORRICELLA", provincia: "TA" },
  { code: "407010062", nome: "TORRIGLIA", provincia: "GE" },
  { code: "408034041", nome: "TORRILE", provincia: "PR" },
  { code: "415064111", nome: "TORRIONI", provincia: "AV" },
  { code: "409052035", nome: "TORRITA DI SIENA", provincia: "SI" },
  { code: "412058106", nome: "TORRITA TIBERINA", provincia: "RM" },
  { code: "420091095", nome: "TORTOLI\'", provincia: "NU" },
  { code: "401006174", nome: "TORTONA", provincia: "AL" },
  { code: "418078149", nome: "TORTORA", provincia: "CS" },
  { code: "415065150", nome: "TORTORELLA", provincia: "SA" },
  { code: "413067044", nome: "TORTORETO", provincia: "TE" },
  { code: "419083099", nome: "TORTORICI", provincia: "ME" },
  { code: "406030123", nome: "TORVISCOSA", provincia: "UD" },
  { code: "403017187", nome: "TOSCOLANO MADERNO", provincia: "BS" },
  { code: "413067045", nome: "TOSSICIA", provincia: "TE" },
  { code: "403014068", nome: "TOVO DI SANT\'AGATA", provincia: "SO" },
  { code: "407009062", nome: "TOVO SAN GIACOMO", provincia: "SV" },
  { code: "419082073", nome: "TRABIA", provincia: "PA" },
  { code: "403012127", nome: "TRADATE", provincia: "VA" },
  { code: "420095066", nome: "TRAMATZA", provincia: "OR" },
  { code: "404022203", nome: "TRAMBILENO", provincia: "TN" },
  { code: "406093045", nome: "TRAMONTI DI SOPRA", provincia: "PN" },
  { code: "406093046", nome: "TRAMONTI DI SOTTO", provincia: "PN" },
  { code: "415065151", nome: "TRAMONTI", provincia: "SA" },
  { code: "417076091", nome: "TRAMUTOLA", provincia: "PZ" },
  { code: "401001276", nome: "TRANA", provincia: "TO" },
  { code: "416110009", nome: "TRANI", provincia: "BT" },
  { code: "403014069", nome: "TRAONA", provincia: "SO" },
  { code: "419081021", nome: "TRAPANI", provincia: "TP" },
  { code: "419082074", nome: "TRAPPETO", provincia: "PA" },
  { code: "401103066", nome: "TRAREGO-VIGGIONA", provincia: "VB" },
  { code: "413066102", nome: "TRASACCO", provincia: "AQ" },
  { code: "406030124", nome: "TRASAGHIS", provincia: "UD" },
  { code: "401103067", nome: "TRASQUERA", provincia: "VB" },
  { code: "420092085", nome: "TRATALIAS", provincia: "CA" },
  { code: "403018162", nome: "TRAVACO\' SICCOMARIO", provincia: "PV" },
  { code: "403017188", nome: "TRAVAGLIATO", provincia: "BS" },
  { code: "403012128", nome: "TRAVEDONA-MONATE", provincia: "VA" },
  { code: "401001278", nome: "TRAVERSELLA", provincia: "TO" },
  { code: "408034042", nome: "TRAVERSETOLO", provincia: "PR" },
  { code: "401001279", nome: "TRAVES", provincia: "TO" },
  { code: "406093047", nome: "TRAVESIO", provincia: "PN" },
  { code: "408033043", nome: "TRAVO", provincia: "PC" },
  { code: "404022247", nome: "TRE VILLE", provincia: "TN" },
  { code: "405028093", nome: "TREBASELEGHE", provincia: "PD" },
  { code: "418078150", nome: "TREBISACCE", provincia: "CS" },
  { code: "415063091", nome: "TRECASE", provincia: "NA" },
  { code: "419087050", nome: "TRECASTAGNI", provincia: "CT" },
  { code: "411042050", nome: "TRECASTELLI", provincia: "AN" },
  { code: "401003149", nome: "TRECATE", provincia: "NO" },
  { code: "417076092", nome: "TRECCHINA", provincia: "PZ" },
  { code: "405029047", nome: "TRECENTA", provincia: "RO" },
  { code: "408140049", nome: "TREDOZIO", provincia: "FC" },
  { code: "413069096", nome: "TREGLIO", provincia: "CH" },
  { code: "405023087", nome: "TREGNAGO", provincia: "VR" },
  { code: "411043054", nome: "TREIA", provincia: "MC" },
  { code: "401004230", nome: "TREISO", provincia: "CN" },
  { code: "419087051", nome: "TREMESTIERI ETNEO", provincia: "CT" },
  { code: "403013252", nome: "TREMEZZINA", provincia: "CO" },
  { code: "403017989", nome: "TREMOSINE SUL GARDA", provincia: "BS" },
  { code: "415065152", nome: "TRENTINARA", provincia: "SA" },
  { code: "404022205", nome: "TRENTO", provincia: "TN" },
  { code: "415061094", nome: "TRENTOLA-DUCENTA", provincia: "CE" },
  { code: "403017190", nome: "TRENZANO", provincia: "BS" },
  { code: "406030126", nome: "TREPPO GRANDE", provincia: "UD" },
  { code: "406030191", nome: "TREPPO LIGOSULLO", provincia: "UD" },
  { code: "416075087", nome: "TREPUZZI", provincia: "LE" },
  { code: "409052036", nome: "TREQUANDA", provincia: "SI" },
  { code: "409045015", nome: "TRESANA", provincia: "MS" },
  { code: "403016218", nome: "TRESCORE BALNEARIO", provincia: "BG" },
  { code: "403019109", nome: "TRESCORE CREMASCO", provincia: "CR" },
  { code: "408038030", nome: "TRESIGNANA", provincia: "FE" },
  { code: "403014070", nome: "TRESIVIO", provincia: "SO" },
  { code: "420095067", nome: "TRESNURAGHES", provincia: "OR" },
  { code: "405023088", nome: "TREVENZUOLO", provincia: "VR" },
  { code: "412060080", nome: "TREVI NEL LAZIO", provincia: "FR" },
  { code: "410054054", nome: "TREVI", provincia: "PG" },
  { code: "415064112", nome: "TREVICO", provincia: "AV" },
  { code: "403016219", nome: "TREVIGLIO", provincia: "BG" },
  { code: "412058107", nome: "TREVIGNANO ROMANO", provincia: "RM" },
  { code: "405026085", nome: "TREVIGNANO", provincia: "TV" },
  { code: "401006175", nome: "TREVILLE", provincia: "AL" },
  { code: "403016220", nome: "TREVIOLO", provincia: "BG" },
  { code: "403017191", nome: "TREVISO BRESCIANO", provincia: "BS" },
  { code: "405026086", nome: "TREVISO", provincia: "TV" },
  { code: "403015219", nome: "TREZZANO ROSA", provincia: "MI" },
  { code: "403015220", nome: "TREZZANO SUL NAVIGLIO", provincia: "MI" },
  { code: "403015221", nome: "TREZZO SULL\'ADDA", provincia: "MI" },
  { code: "401004231", nome: "TREZZO TINELLA", provincia: "CN" },
  { code: "403013226", nome: "TREZZONE", provincia: "CO" },
  { code: "405028094", nome: "TRIBANO", provincia: "PD" },
  { code: "403015222", nome: "TRIBIANO", provincia: "MI" },
  { code: "407010063", nome: "TRIBOGNA", provincia: "GE" },
  { code: "417077028", nome: "TRICARICO", provincia: "MT" },
  { code: "416075088", nome: "TRICASE", provincia: "LE" },
  { code: "401002147", nome: "TRICERRO", provincia: "VC" },
  { code: "406030127", nome: "TRICESIMO", provincia: "UD" },
  { code: "420091097", nome: "TRIEI", provincia: "NU" },
  { code: "406032006", nome: "TRIESTE", provincia: "TS" },
  { code: "416072046", nome: "TRIGGIANO", provincia: "BA" },
  { code: "403019110", nome: "TRIGOLO", provincia: "CR" },
  { code: "420090074", nome: "TRINITA\' D\'AGULTU E VIGNOLA", provincia: "SS" },
  { code: "401004232", nome: "TRINITA\'", provincia: "CN" },
  { code: "416110010", nome: "TRINITAPOLI", provincia: "BT" },
  { code: "401002148", nome: "TRINO", provincia: "VC" },
  { code: "407008061", nome: "TRIORA", provincia: "IM" },
  { code: "419083100", nome: "TRIPI", provincia: "ME" },
  { code: "401006176", nome: "TRISOBBIO", provincia: "AL" },
  { code: "405024110", nome: "TRISSINO", provincia: "VI" },
  { code: "403108043", nome: "TRIUGGIO", provincia: "MB" },
  { code: "414070081", nome: "TRIVENTO", provincia: "CB" },
  { code: "412060081", nome: "TRIVIGLIANO", provincia: "FR" },
  { code: "406030128", nome: "TRIVIGNANO UDINESE", provincia: "UD" },
  { code: "417076093", nome: "TRIVIGNO", provincia: "PZ" },
  { code: "403018163", nome: "TRIVOLZIO", provincia: "PV" },
  { code: "404021902", nome: "TRODENA NEL PARCO NATURALE", provincia: "BZ" },
  { code: "401001280", nome: "TROFARELLO", provincia: "TO" },
  { code: "416071058", nome: "TROIA", provincia: "FG" },
  { code: "419086018", nome: "TROINA", provincia: "EN" },
  { code: "403018164", nome: "TROMELLO", provincia: "PV" },
  { code: "401103068", nome: "TRONTANO", provincia: "VB" },
  { code: "403012129", nome: "TRONZANO LAGO MAGGIORE", provincia: "VA" },
  { code: "401002150", nome: "TRONZANO VERCELLESE", provincia: "VC" },
  { code: "418102044", nome: "TROPEA", provincia: "VV" },
  { code: "403018165", nome: "TROVO", provincia: "PV" },
  { code: "403015224", nome: "TRUCCAZZANO", provincia: "MI" },
  { code: "404021103", nome: "TUBRE", provincia: "BZ" },
  { code: "414070082", nome: "TUFARA", provincia: "CB" },
  { code: "413069097", nome: "TUFILLO", provincia: "CH" },
  { code: "415063085", nome: "TUFINO", provincia: "NA" },
  { code: "415064113", nome: "TUFO", provincia: "AV" },
  { code: "416075089", nome: "TUGLIE", provincia: "LE" },
  { code: "420092086", nome: "TUILI", provincia: "CA" },
  { code: "420090075", nome: "TULA", provincia: "SS" },
  { code: "410054055", nome: "TUORO SUL TRASIMENO", provincia: "PG" },
  { code: "412057071", nome: "TURANIA", provincia: "RI" },
  { code: "403098058", nome: "TURANO LODIGIANO", provincia: "LO" },
  { code: "403013227", nome: "TURATE", provincia: "CO" },
  { code: "403015226", nome: "TURBIGO", provincia: "MI" },
  { code: "416072047", nome: "TURI", provincia: "BA" },
  { code: "420092087", nome: "TURRI", provincia: "CA" },
  { code: "406031024", nome: "TURRIACO", provincia: "GO" },
  { code: "413068044", nome: "TURRIVALIGNANI", provincia: "PE" },
  { code: "417077029", nome: "TURSI", provincia: "MT" },
  { code: "419083101", nome: "TUSA", provincia: "ME" },
  { code: "412056052", nome: "TUSCANIA", provincia: "VT" },
  { code: "403016221", nome: "UBIALE CLANEZZO", provincia: "BG" },
  { code: "403012130", nome: "UBOLDO", provincia: "VA" },
  { code: "419083102", nome: "UCRIA", provincia: "ME" },
  { code: "406030129", nome: "UDINE", provincia: "UD" },
  { code: "416075090", nome: "UGENTO", provincia: "LE" },
  { code: "416075091", nome: "UGGIANO LA CHIESA", provincia: "LE" },
  { code: "403013256", nome: "UGGIATE CON RONAGO", provincia: "CO" },
  { code: "420095068", nome: "ULA\' TIRSO", provincia: "OR" },
  { code: "420091098", nome: "ULASSAI", provincia: "NU" },
  { code: "404021104", nome: "ULTIMO", provincia: "BZ" },
  { code: "410054056", nome: "UMBERTIDE", provincia: "PG" },
  { code: "418101026", nome: "UMBRIATICO", provincia: "KR" },
  { code: "403017192", nome: "URAGO D\'OGLIO", provincia: "BS" },
  { code: "420095069", nome: "URAS", provincia: "OR" },
  { code: "405028095", nome: "URBANA", provincia: "PD" },
  { code: "411141066", nome: "URBANIA", provincia: "PU" },
  { code: "407009063", nome: "URBE", provincia: "SV" },
  { code: "411141067", nome: "URBINO", provincia: "PU" },
  { code: "411043055", nome: "URBISAGLIA", provincia: "MC" },
  { code: "403016222", nome: "URGNANO", provincia: "BG" },
  { code: "420090076", nome: "URI", provincia: "SS" },
  { code: "414070083", nome: "URURI", provincia: "CB" },
  { code: "420091099", nome: "URZULEI", provincia: "NU" },
  { code: "407010064", nome: "USCIO", provincia: "GE" },
  { code: "420095070", nome: "USELLUS", provincia: "OR" },
  { code: "420090077", nome: "USINI", provincia: "SS" },
  { code: "403108044", nome: "USMATE VELATE", provincia: "MB" },
  { code: "420092088", nome: "USSANA", provincia: "CA" },
  { code: "420092089", nome: "USSARAMANNA", provincia: "CA" },
  { code: "420091100", nome: "USSASSAI", provincia: "NU" },
  { code: "401001281", nome: "USSEAUX", provincia: "TO" },
  { code: "401001282", nome: "USSEGLIO", provincia: "TO" },
  { code: "411043056", nome: "USSITA", provincia: "MC" },
  { code: "419082075", nome: "USTICA", provincia: "PA" },
  { code: "420092090", nome: "UTA", provincia: "CA" },
  { code: "409047021", nome: "UZZANO", provincia: "PT" },
  { code: "418078152", nome: "VACCARIZZO ALBANESE", provincia: "CS" },
  { code: "412057072", nome: "VACONE", provincia: "RI" },
  { code: "413069098", nome: "VACRI", provincia: "CH" },
  { code: "404021105", nome: "VADENA", provincia: "BZ" },
  { code: "407009064", nome: "VADO LIGURE", provincia: "SV" },
  { code: "409046031", nome: "VAGLI SOTTO", provincia: "LU" },
  { code: "409048046", nome: "VAGLIA", provincia: "FI" },
  { code: "417076094", nome: "VAGLIO BASILICATA", provincia: "PZ" },
  { code: "401005111", nome: "VAGLIO SERRA", provincia: "AT" },
  { code: "403019111", nome: "VAIANO CREMASCO", provincia: "CR" },
  { code: "409100006", nome: "VAIANO", provincia: "PO" },
  { code: "401001283", nome: "VAIE", provincia: "TO" },
  { code: "403019112", nome: "VAILATE", provincia: "CR" },
  { code: "415061095", nome: "VAIRANO PATENORA", provincia: "CE" },
  { code: "406093052", nome: "VAJONT", provincia: "PN" },
  { code: "403016253", nome: "VAL BREMBILLA", provincia: "BG" },
  { code: "401001284", nome: "VAL DELLA TORRE", provincia: "TO" },
  { code: "401001317", nome: "VAL DI CHY", provincia: "TO" },
  { code: "403018166", nome: "VAL DI NIZZA", provincia: "PV" },
  { code: "404021107", nome: "VAL DI VIZZE", provincia: "BZ" },
  { code: "405025073", nome: "VAL DI ZOLDO", provincia: "BL" },
  { code: "405024123", nome: "VAL LIONA", provincia: "VI" },
  { code: "403014074", nome: "VAL MASINO", provincia: "SO" },
  { code: "403013233", nome: "VAL REZZO", provincia: "CO" },
  { code: "403016223", nome: "VALBONDIONE", provincia: "BG" },
  { code: "403016224", nome: "VALBREMBO", provincia: "BG" },
  { code: "405024125", nome: "VALBRENTA", provincia: "VI" },
  { code: "407010065", nome: "VALBREVENNA", provincia: "GE" },
  { code: "403013229", nome: "VALBRONA", provincia: "CO" },
  { code: "401001318", nome: "VALCHIUSA", provincia: "TO" },
  { code: "405024111", nome: "VALDAGNO", provincia: "VI" },
  { code: "404022232", nome: "VALDAONE", provincia: "TN" },
  { code: "404021106", nome: "VALDAORA", provincia: "BZ" },
  { code: "405024112", nome: "VALDASTICO", provincia: "VI" },
  { code: "401096071", nome: "VALDENGO", provincia: "BI" },
  { code: "419081022", nome: "VALDERICE", provincia: "TP" },
  { code: "403014071", nome: "VALDIDENTRO", provincia: "SO" },
  { code: "401004233", nome: "VALDIERI", provincia: "CN" },
  { code: "401096088", nome: "VALDILANA", provincia: "BI" },
  { code: "419083103", nome: "VALDINA", provincia: "ME" },
  { code: "403014072", nome: "VALDISOTTO", provincia: "SO" },
  { code: "405026087", nome: "VALDOBBIADENE", provincia: "TV" },
  { code: "401002152", nome: "VALDUGGIA", provincia: "VC" },
  { code: "405023089", nome: "VALEGGIO SUL MINCIO", provincia: "VR" },
  { code: "403018167", nome: "VALEGGIO", provincia: "PV" },
  { code: "412056053", nome: "VALENTANO", provincia: "VT" },
  { code: "401006177", nome: "VALENZA", provincia: "AL" },
  { code: "416072048", nome: "VALENZANO", provincia: "BA" },
  { code: "403098059", nome: "VALERA FRATTA", provincia: "LO" },
  { code: "410054057", nome: "VALFABBRICA", provincia: "PG" },
  { code: "401005112", nome: "VALFENERA", provincia: "AT" },
  { code: "404022209", nome: "VALFLORIANA", provincia: "TN" },
  { code: "411043058", nome: "VALFORNACE", provincia: "MC" },
  { code: "403014073", nome: "VALFURVA", provincia: "SO" },
  { code: "403012131", nome: "VALGANNA", provincia: "VA" },
  { code: "401001285", nome: "VALGIOIE", provincia: "TO" },
  { code: "403016225", nome: "VALGOGLIO", provincia: "BG" },
  { code: "401004234", nome: "VALGRANA", provincia: "CN" },
  { code: "403097082", nome: "VALGREGHENTINO", provincia: "LC" },
  { code: "402007068", nome: "VALGRISENCHE", provincia: "AO" },
  { code: "419086019", nome: "VALGUARNERA CAROPEPE", provincia: "EN" },
  { code: "405025062", nome: "VALLADA AGORDINA", provincia: "BL" },
  { code: "401096072", nome: "VALLANZENGO", provincia: "BI" },
  { code: "404022210", nome: "VALLARSA", provincia: "TN" },
  { code: "415064114", nome: "VALLATA", provincia: "AV" },
  { code: "415061096", nome: "VALLE AGRICOLA", provincia: "CE" },
  { code: "404021108", nome: "VALLE AURINA", provincia: "BZ" },
  { code: "401103079", nome: "VALLE CANNOBINA", provincia: "VB" },
  { code: "413067046", nome: "VALLE CASTELLANA", provincia: "TE" },
  { code: "415065153", nome: "VALLE DELL\'ANGELO", provincia: "SA" },
  { code: "405025063", nome: "VALLE DI CADORE", provincia: "BL" },
  { code: "404021109", nome: "VALLE DI CASIES", provincia: "BZ" },
  { code: "415061097", nome: "VALLE DI MADDALONI", provincia: "CE" },
  { code: "403018168", nome: "VALLE LOMELLINA", provincia: "PV" },
  { code: "403018169", nome: "VALLE SALIMBENE", provincia: "PV" },
  { code: "401096074", nome: "VALLE SAN NICOLAO", provincia: "BI" },
  { code: "407008062", nome: "VALLEBONA", provincia: "IM" },
  { code: "412060082", nome: "VALLECORSA", provincia: "FR" },
  { code: "407008063", nome: "VALLECROSIA", provincia: "IM" },
  { code: "419082076", nome: "VALLEDOLMO", provincia: "PA" },
  { code: "420090079", nome: "VALLEDORIA", provincia: "SS" },
  { code: "418079151", nome: "VALLEFIORITA", provincia: "CZ" },
  { code: "411141068", nome: "VALLEFOGLIA", provincia: "PU" },
  { code: "404022248", nome: "VALLELAGHI", provincia: "TN" },
  { code: "418102045", nome: "VALLELONGA", provincia: "VV" },
  { code: "419085021", nome: "VALLELUNGA PRATAMENO", provincia: "CL" },
  { code: "412060083", nome: "VALLEMAIO", provincia: "FR" },
  { code: "412058108", nome: "VALLEPIETRA", provincia: "RM" },
  { code: "412056054", nome: "VALLERANO", provincia: "VT" },
  { code: "420092091", nome: "VALLERMOSA", provincia: "CA" },
  { code: "412060084", nome: "VALLEROTONDA", provincia: "FR" },
  { code: "415064115", nome: "VALLESACCARDA", provincia: "AV" },
  { code: "403016226", nome: "VALLEVE", provincia: "BG" },
  { code: "405024113", nome: "VALLI DEL PASUBIO", provincia: "VI" },
  { code: "412058109", nome: "VALLINFREDA", provincia: "RM" },
  { code: "403017999", nome: "VALLIO TERME", provincia: "BS" },
  { code: "415065154", nome: "VALLO DELLA LUCANIA", provincia: "SA" },
  { code: "410054058", nome: "VALLO DI NERA", provincia: "PG" },
  { code: "401001286", nome: "VALLO TORINESE", provincia: "TO" },
  { code: "401004235", nome: "VALLORIATE", provincia: "CN" },
  { code: "401006178", nome: "VALMACCA", provincia: "AL" },
  { code: "403097083", nome: "VALMADRERA", provincia: "LC" },
  { code: "412058110", nome: "VALMONTONE", provincia: "RM" },
  { code: "403013232", nome: "VALMOREA", provincia: "CO" },
  { code: "408034044", nome: "VALMOZZOLA", provincia: "PR" },
  { code: "403016227", nome: "VALNEGRA", provincia: "BG" },
  { code: "402007069", nome: "VALPELLINE", provincia: "AO" },
  { code: "401001287", nome: "VALPERGA", provincia: "TO" },
  { code: "401001288", nome: "VALPRATO SOANA", provincia: "TO" },
  { code: "408037061", nome: "VALSAMOGGIA", provincia: "BO" },
  { code: "402007070", nome: "VALSAVARENCHE", provincia: "AO" },
  { code: "417077030", nome: "VALSINNI", provincia: "MT" },
  { code: "403013234", nome: "VALSOLDA", provincia: "CO" },
  { code: "401103069", nome: "VALSTRONA", provincia: "VB" },
  { code: "410054059", nome: "VALTOPINA", provincia: "PG" },
  { code: "403016229", nome: "VALTORTA", provincia: "BG" },
  { code: "402007071", nome: "VALTOURNENCHE", provincia: "AO" },
  { code: "415065155", nome: "VALVA", provincia: "SA" },
  { code: "403097093", nome: "VALVARRONE", provincia: "LC" },
  { code: "406093053", nome: "VALVASONE ARZENE", provincia: "PN" },
  { code: "419087052", nome: "VALVERDE", provincia: "CT" },
  { code: "403017194", nome: "VALVESTINO", provincia: "BS" },
  { code: "404021110", nome: "VANDOIES", provincia: "BZ" },
  { code: "403015249", nome: "VANZAGHELLO", provincia: "MI" },
  { code: "403015229", nome: "VANZAGO", provincia: "MI" },
  { code: "401103070", nome: "VANZONE CON SAN CARLO", provincia: "VB" },
  { code: "403015230", nome: "VAPRIO D\'ADDA", provincia: "MI" },
  { code: "401003153", nome: "VAPRIO D\'AGOGNA", provincia: "NO" },
  { code: "401003154", nome: "VARALLO POMBIA", provincia: "NO" },
  { code: "401002156", nome: "VARALLO", provincia: "VC" },
  { code: "403012132", nome: "VARANO BORGHI", provincia: "VA" },
  { code: "408034045", nome: "VARANO DE\' MELEGARI", provincia: "PR" },
  { code: "418080095", nome: "VARAPODIO", provincia: "RC" },
  { code: "407009065", nome: "VARAZZE", provincia: "SV" },
  { code: "412057073", nome: "VARCO SABINO", provincia: "RI" },
  { code: "403108045", nome: "VAREDO", provincia: "MB" },
  { code: "403097084", nome: "VARENNA", provincia: "LC" },
  { code: "407011029", nome: "VARESE LIGURE", provincia: "SP" },
  { code: "403012133", nome: "VARESE", provincia: "VA" },
  { code: "401001289", nome: "VARISELLA", provincia: "TO" },
  { code: "406030130", nome: "VARMO", provincia: "UD" },
  { code: "404021111", nome: "VARNA", provincia: "BZ" },
  { code: "408034046", nome: "VARSI", provincia: "PR" },
  { code: "403018171", nome: "VARZI", provincia: "PV" },
  { code: "401103071", nome: "VARZO", provincia: "VB" },
  { code: "412056055", nome: "VASANELLO", provincia: "VT" },
  { code: "407008064", nome: "VASIA", provincia: "IM" },
  { code: "413069099", nome: "VASTO", provincia: "CH" },
  { code: "414094051", nome: "VASTOGIRARDI", provincia: "IS" },
  { code: "401001290", nome: "VAUDA CANAVESE", provincia: "TO" },
  { code: "418102046", nome: "VAZZANO", provincia: "VV" },
  { code: "405026088", nome: "VAZZOLA", provincia: "TV" },
  { code: "409050037", nome: "VECCHIANO", provincia: "PI" },
  { code: "403108046", nome: "VEDANO AL LAMBRO", provincia: "MB" },
  { code: "403012134", nome: "VEDANO OLONA", provincia: "VA" },
  { code: "405026089", nome: "VEDELAGO", provincia: "TV" },
  { code: "403016230", nome: "VEDESETA", provincia: "BG" },
  { code: "403108047", nome: "VEDUGGIO CON COLZANO", provincia: "MB" },
  { code: "405028096", nome: "VEGGIANO", provincia: "PD" },
  { code: "416075092", nome: "VEGLIE", provincia: "LE" },
  { code: "401096075", nome: "VEGLIO", provincia: "BI" },
  { code: "412056056", nome: "VEJANO", provincia: "VT" },
  { code: "403013236", nome: "VELESO", provincia: "CO" },
  { code: "403018172", nome: "VELEZZO LOMELLINA", provincia: "PV" },
  { code: "412058111", nome: "VELLETRI", provincia: "RM" },
  { code: "403018173", nome: "VELLEZZO BELLINI", provincia: "PV" },
  { code: "405024115", nome: "VELO D\'ASTICO", provincia: "VI" },
  { code: "405023090", nome: "VELO VERONESE", provincia: "VR" },
  { code: "404021116", nome: "VELTURNO", provincia: "BZ" },
  { code: "414094052", nome: "VENAFRO", provincia: "IS" },
  { code: "401001292", nome: "VENARIA REALE", provincia: "TO" },
  { code: "411044073", nome: "VENAROTTA", provincia: "AP" },
  { code: "401004237", nome: "VENASCA", provincia: "CN" },
  { code: "401001291", nome: "VENAUS", provincia: "TO" },
  { code: "407009066", nome: "VENDONE", provincia: "SV" },
  { code: "403012136", nome: "VENEGONO INFERIORE", provincia: "VA" },
  { code: "403012137", nome: "VENEGONO SUPERIORE", provincia: "VA" },
  { code: "419083104", nome: "VENETICO", provincia: "ME" },
  { code: "405027042", nome: "VENEZIA", provincia: "VE" },
  { code: "403013238", nome: "VENIANO", provincia: "CO" },
  { code: "417076095", nome: "VENOSA", provincia: "PZ" },
  { code: "408035046", nome: "VENTASSO", provincia: "RE" },
  { code: "415064116", nome: "VENTICANO", provincia: "AV" },
  { code: "419082077", nome: "VENTIMIGLIA DI SICILIA", provincia: "PA" },
  { code: "407008065", nome: "VENTIMIGLIA", provincia: "IM" },
  { code: "412059033", nome: "VENTOTENE", provincia: "LT" },
  { code: "406030131", nome: "VENZONE", provincia: "UD" },
  { code: "403108048", nome: "VERANO BRIANZA", provincia: "MB" },
  { code: "404021112", nome: "VERANO", provincia: "BZ" },
  { code: "401103072", nome: "VERBANIA", provincia: "VB" },
  { code: "418078153", nome: "VERBICARO", provincia: "CS" },
  { code: "403013239", nome: "VERCANA", provincia: "CO" },
  { code: "403014075", nome: "VERCEIA", provincia: "SO" },
  { code: "401002158", nome: "VERCELLI", provincia: "VC" },
  { code: "403097086", nome: "VERCURAGO", provincia: "LC" },
  { code: "403016232", nome: "VERDELLINO", provincia: "BG" },
  { code: "403016233", nome: "VERDELLO", provincia: "BG" },
  { code: "403097091", nome: "VERDERIO", provincia: "LC" },
  { code: "401004238", nome: "VERDUNO", provincia: "CN" },
  { code: "408037059", nome: "VERGATO", provincia: "BO" },
  { code: "408140050", nome: "VERGHERETO", provincia: "FC" },
  { code: "403012138", nome: "VERGIATE", provincia: "VA" },
  { code: "403015251", nome: "VERMEZZO CON ZELO", provincia: "MI" },
  { code: "404022213", nome: "VERMIGLIO", provincia: "TN" },
  { code: "401004239", nome: "VERNANTE", provincia: "CN" },
  { code: "408033044", nome: "VERNASCA", provincia: "PC" },
  { code: "403015236", nome: "VERNATE", provincia: "MI" },
  { code: "407011030", nome: "VERNAZZA", provincia: "SP" },
  { code: "409100007", nome: "VERNIO", provincia: "PO" },
  { code: "416075093", nome: "VERNOLE", provincia: "LE" },
  { code: "403017195", nome: "VEROLANUOVA", provincia: "BS" },
  { code: "403017196", nome: "VEROLAVECCHIA", provincia: "BS" },
  { code: "401001293", nome: "VEROLENGO", provincia: "TO" },
  { code: "412060085", nome: "VEROLI", provincia: "FR" },
  { code: "405023091", nome: "VERONA", provincia: "VR" },
  { code: "405023092", nome: "VERONELLA", provincia: "VR" },
  { code: "402007072", nome: "VERRAYES", provincia: "AO" },
  { code: "402007073", nome: "VERRES", provincia: "AO" },
  { code: "403018174", nome: "VERRETTO", provincia: "PV" },
  { code: "401096076", nome: "VERRONE", provincia: "BI" },
  { code: "403018175", nome: "VERRUA PO", provincia: "PV" },
  { code: "401001294", nome: "VERRUA SAVOIA", provincia: "TO" },
  { code: "403013242", nome: "VERTEMATE CON MINOPRIO", provincia: "CO" },
  { code: "403016234", nome: "VERTOVA", provincia: "BG" },
  { code: "408099020", nome: "VERUCCHIO", provincia: "RN" },
  { code: "403014076", nome: "VERVIO", provincia: "SO" },
  { code: "406030132", nome: "VERZEGNIS", provincia: "UD" },
  { code: "418101027", nome: "VERZINO", provincia: "KR" },
  { code: "401004240", nome: "VERZUOLO", provincia: "CN" },
  { code: "405028097", nome: "VESCOVANA", provincia: "PD" },
  { code: "403019113", nome: "VESCOVATO", provincia: "CR" },
  { code: "401005113", nome: "VESIME", provincia: "AT" },
  { code: "401003158", nome: "VESPOLATE", provincia: "NO" },
  { code: "407008066", nome: "VESSALICO", provincia: "IM" },
  { code: "405023093", nome: "VESTENANOVA", provincia: "VR" },
  { code: "401001295", nome: "VESTIGNE\'", provincia: "TO" },
  { code: "403017197", nome: "VESTONE", provincia: "BS" },
  { code: "412056057", nome: "VETRALLA", provincia: "VT" },
  { code: "408035042", nome: "VETTO", provincia: "RE" },
  { code: "401004241", nome: "VEZZA D\'ALBA", provincia: "CN" },
  { code: "403017198", nome: "VEZZA D\'OGLIO", provincia: "BS" },
  { code: "407011031", nome: "VEZZANO LIGURE", provincia: "SP" },
  { code: "408035043", nome: "VEZZANO SUL CROSTOLO", provincia: "RE" },
  { code: "407009067", nome: "VEZZI PORTIO", provincia: "SV" },
  { code: "403020066", nome: "VIADANA", provincia: "MN" },
  { code: "403016235", nome: "VIADANICA", provincia: "BG" },
  { code: "419087053", nome: "VIAGRANDE", provincia: "CT" },
  { code: "401005114", nome: "VIALE D\'ASTI", provincia: "AT" },
  { code: "401001296", nome: "VIALFRE\'", provincia: "TO" },
  { code: "408035044", nome: "VIANO", provincia: "RE" },
  { code: "409046033", nome: "VIAREGGIO", provincia: "LU" },
  { code: "401005115", nome: "VIARIGI", provincia: "AT" },
  { code: "418102047", nome: "VIBO VALENTIA", provincia: "VV" },
  { code: "415065156", nome: "VIBONATI", provincia: "SA" },
  { code: "412060086", nome: "VICALVI", provincia: "FR" },
  { code: "419082078", nome: "VICARI", provincia: "PA" },
  { code: "409048049", nome: "VICCHIO", provincia: "FI" },
  { code: "405024116", nome: "VICENZA", provincia: "VI" },
  { code: "416071059", nome: "VICO DEL GARGANO", provincia: "FG" },
  { code: "415063086", nome: "VICO EQUENSE", provincia: "NA" },
  { code: "412060087", nome: "VICO NEL LAZIO", provincia: "FR" },
  { code: "401004242", nome: "VICOFORTE", provincia: "CN" },
  { code: "413068045", nome: "VICOLI", provincia: "PE" },
  { code: "401003159", nome: "VICOLUNGO", provincia: "NO" },
  { code: "409050038", nome: "VICOPISANO", provincia: "PI" },
  { code: "412058112", nome: "VICOVARO", provincia: "RM" },
  { code: "420090082", nome: "VIDDALBA", provincia: "SS" },
  { code: "403018176", nome: "VIDIGULFO", provincia: "PV" },
  { code: "405026090", nome: "VIDOR", provincia: "TV" },
  { code: "401001298", nome: "VIDRACCO", provincia: "TO" },
  { code: "416071060", nome: "VIESTE", provincia: "FG" },
  { code: "417076096", nome: "VIETRI DI POTENZA", provincia: "PZ" },
  { code: "415065157", nome: "VIETRI SUL MARE", provincia: "SA" },
  { code: "403016236", nome: "VIGANO SAN MARTINO", provincia: "BG" },
  { code: "403097090", nome: "VIGANO\'", provincia: "LC" },
  { code: "408038022", nome: "VIGARANO MAINARDA", provincia: "FE" },
  { code: "405023094", nome: "VIGASIO", provincia: "VR" },
  { code: "403018177", nome: "VIGEVANO", provincia: "PV" },
  { code: "417076097", nome: "VIGGIANELLO", provincia: "PZ" },
  { code: "417076098", nome: "VIGGIANO", provincia: "PZ" },
  { code: "403012139", nome: "VIGGIU\'", provincia: "VA" },
  { code: "401096077", nome: "VIGLIANO BIELLESE", provincia: "BI" },
  { code: "401005116", nome: "VIGLIANO D\'ASTI", provincia: "AT" },
  { code: "401006179", nome: "VIGNALE MONFERRATO", provincia: "AL" },
  { code: "412056058", nome: "VIGNANELLO", provincia: "VT" },
  { code: "403015237", nome: "VIGNATE", provincia: "MI" },
  { code: "408036046", nome: "VIGNOLA", provincia: "MO" },
  { code: "404022216", nome: "VIGNOLA-FALESINA", provincia: "TN" },
  { code: "401006180", nome: "VIGNOLE BORBERA", provincia: "AL" },
  { code: "401004243", nome: "VIGNOLO", provincia: "CN" },
  { code: "401103074", nome: "VIGNONE", provincia: "VB" },
  { code: "405025065", nome: "VIGO DI CADORE", provincia: "BL" },
  { code: "405028099", nome: "VIGODARZERE", provincia: "PD" },
  { code: "403016237", nome: "VIGOLO", provincia: "BG" },
  { code: "408033045", nome: "VIGOLZONE", provincia: "PC" },
  { code: "401001299", nome: "VIGONE", provincia: "TO" },
  { code: "405027043", nome: "VIGONOVO", provincia: "VE" },
  { code: "405028100", nome: "VIGONZA", provincia: "PD" },
  { code: "401006181", nome: "VIGUZZOLO", provincia: "AL" },
  { code: "405023095", nome: "VILLA BARTOLOMEA", provincia: "VR" },
  { code: "409046034", nome: "VILLA BASILICA", provincia: "LU" },
  { code: "403018178", nome: "VILLA BISCOSSI", provincia: "PV" },
  { code: "403017199", nome: "VILLA CARCINA", provincia: "BS" },
  { code: "416074020", nome: "VILLA CASTELLI", provincia: "BR" },
  { code: "413068046", nome: "VILLA CELIERA", provincia: "PE" },
  { code: "409046035", nome: "VILLA COLLEMANDINA", provincia: "LU" },
  { code: "403015248", nome: "VILLA CORTESE", provincia: "MI" },
  { code: "403016238", nome: "VILLA D\'ADDA", provincia: "BG" },
  { code: "403016239", nome: "VILLA D\'ALME\'", provincia: "BG" },
  { code: "403016241", nome: "VILLA D\'OGNA", provincia: "BG" },
  { code: "401096078", nome: "VILLA DEL BOSCO", provincia: "BI" },
  { code: "405028101", nome: "VILLA DEL CONTE", provincia: "PD" },
  { code: "415061098", nome: "VILLA DI BRIANO", provincia: "CE" },
  { code: "403014077", nome: "VILLA DI CHIAVENNA", provincia: "SO" },
  { code: "403016240", nome: "VILLA DI SERIO", provincia: "BG" },
  { code: "403014078", nome: "VILLA DI TIRANO", provincia: "SO" },
  { code: "405028102", nome: "VILLA ESTENSE", provincia: "PD" },
  { code: "407008067", nome: "VILLA FARALDI", provincia: "IM" },
  { code: "403013245", nome: "VILLA GUARDIA", provincia: "CO" },
  { code: "404022222", nome: "VILLA LAGARINA", provincia: "TN" },
  { code: "412060088", nome: "VILLA LATINA", provincia: "FR" },
  { code: "415061099", nome: "VILLA LITERNO", provincia: "CE" },
  { code: "408035045", nome: "VILLA MINOZZO", provincia: "RE" },
  { code: "412056046", nome: "VILLA SAN GIOVANNI IN TUSCIA", provincia: "VT" },
  { code: "418080096", nome: "VILLA SAN GIOVANNI", provincia: "RC" },
  { code: "420092099", nome: "VILLA SAN PIETRO", provincia: "CA" },
  { code: "401005119", nome: "VILLA SAN SECONDO", provincia: "AT" },
  { code: "413066105", nome: "VILLA SANT\'ANGELO", provincia: "AQ" },
  { code: "420095048", nome: "VILLA SANT\'ANTONIO", provincia: "OR" },
  { code: "413066104", nome: "VILLA SANTA LUCIA DEGLI ABRUZZI", provincia: "AQ" },
  { code: "412060089", nome: "VILLA SANTA LUCIA", provincia: "FR" },
  { code: "413069102", nome: "VILLA SANTA MARIA", provincia: "CH" },
  { code: "406030133", nome: "VILLA SANTINA", provincia: "UD" },
  { code: "412060090", nome: "VILLA SANTO STEFANO", provincia: "FR" },
  { code: "420095073", nome: "VILLA VERDE", provincia: "OR" },
  { code: "404021113", nome: "VILLABASSA", provincia: "BZ" },
  { code: "419082079", nome: "VILLABATE", provincia: "PA" },
  { code: "403017200", nome: "VILLACHIARA", provincia: "BS" },
  { code: "420092092", nome: "VILLACIDRO", provincia: "CA" },
  { code: "401006182", nome: "VILLADEATI", provincia: "AL" },
  { code: "405029048", nome: "VILLADOSE", provincia: "RO" },
  { code: "401103075", nome: "VILLADOSSOLA", provincia: "VB" },
  { code: "401004244", nome: "VILLAFALLETTO", provincia: "CN" },
  { code: "401005117", nome: "VILLAFRANCA D\'ASTI", provincia: "AT" },
  { code: "405023096", nome: "VILLAFRANCA DI VERONA", provincia: "VR" },
  { code: "409045016", nome: "VILLAFRANCA IN LUNIGIANA", provincia: "MS" },
  { code: "405028103", nome: "VILLAFRANCA PADOVANA", provincia: "PD" },
  { code: "401001300", nome: "VILLAFRANCA PIEMONTE", provincia: "TO" },
  { code: "419084043", nome: "VILLAFRANCA SICULA", provincia: "AG" },
  { code: "419083105", nome: "VILLAFRANCA TIRRENA", provincia: "ME" },
  { code: "419082080", nome: "VILLAFRATI", provincia: "PA" },
  { code: "405024117", nome: "VILLAGA", provincia: "VI" },
  { code: "420091101", nome: "VILLAGRANDE STRISAILI", provincia: "NU" },
  { code: "413066103", nome: "VILLALAGO", provincia: "AQ" },
  { code: "419085022", nome: "VILLALBA", provincia: "CL" },
  { code: "413069100", nome: "VILLALFONSINA", provincia: "CH" },
  { code: "401006183", nome: "VILLALVERNIA", provincia: "AL" },
  { code: "413069101", nome: "VILLAMAGNA", provincia: "CH" },
  { code: "415064117", nome: "VILLAMAINA", provincia: "AV" },
  { code: "420092093", nome: "VILLAMAR", provincia: "CA" },
  { code: "405029049", nome: "VILLAMARZANA", provincia: "RO" },
  { code: "420092094", nome: "VILLAMASSARGIA", provincia: "CA" },
  { code: "401006184", nome: "VILLAMIROGLIO", provincia: "AL" },
  { code: "404021114", nome: "VILLANDRO", provincia: "BZ" },
  { code: "401096079", nome: "VILLANOVA BIELLESE", provincia: "BI" },
  { code: "401001301", nome: "VILLANOVA CANAVESE", provincia: "TO" },
  { code: "407009068", nome: "VILLANOVA D\'ALBENGA", provincia: "SV" },
  { code: "403018179", nome: "VILLANOVA D\'ARDENGHI", provincia: "PV" },
  { code: "401005118", nome: "VILLANOVA D\'ASTI", provincia: "AT" },
  { code: "415064118", nome: "VILLANOVA DEL BATTISTA", provincia: "AV" },
  { code: "405029050", nome: "VILLANOVA DEL GHEBBO", provincia: "RO" },
  { code: "403098060", nome: "VILLANOVA DEL SILLARO", provincia: "LO" },
  { code: "405028104", nome: "VILLANOVA DI CAMPOSAMPIERO", provincia: "PD" },
  { code: "405029051", nome: "VILLANOVA MARCHESANA", provincia: "RO" },
  { code: "401004245", nome: "VILLANOVA MONDOVI\'", provincia: "CN" },
  { code: "401006185", nome: "VILLANOVA MONFERRATO", provincia: "AL" },
  { code: "420090078", nome: "VILLANOVA MONTELEONE", provincia: "SS" },
  { code: "401004246", nome: "VILLANOVA SOLARO", provincia: "CN" },
  { code: "408033046", nome: "VILLANOVA SULL\'ARDA", provincia: "PC" },
  { code: "420095071", nome: "VILLANOVA TRUSCHEDU", provincia: "OR" },
  { code: "420091102", nome: "VILLANOVA TULO", provincia: "NU" },
  { code: "420092095", nome: "VILLANOVAFORRU", provincia: "CA" },
  { code: "420092096", nome: "VILLANOVAFRANCA", provincia: "CA" },
  { code: "403018180", nome: "VILLANTERIO", provincia: "PV" },
  { code: "403017201", nome: "VILLANUOVA SUL CLISI", provincia: "BS" },
  { code: "420092104", nome: "VILLAPERUCCIO", provincia: "CA" },
  { code: "418078154", nome: "VILLAPIANA", provincia: "CS" },
  { code: "420092097", nome: "VILLAPUTZU", provincia: "CA" },
  { code: "401001303", nome: "VILLAR DORA", provincia: "TO" },
  { code: "401001305", nome: "VILLAR FOCCHIARDO", provincia: "TO" },
  { code: "401001306", nome: "VILLAR PELLICE", provincia: "TO" },
  { code: "401001307", nome: "VILLAR PEROSA", provincia: "TO" },
  { code: "401004247", nome: "VILLAR SAN COSTANZO", provincia: "CN" },
  { code: "401001302", nome: "VILLARBASSE", provincia: "TO" },
  { code: "401002163", nome: "VILLARBOIT", provincia: "VC" },
  { code: "401001304", nome: "VILLAREGGIA", provincia: "TO" },
  { code: "415063087", nome: "VILLARICCA", provincia: "NA" },
  { code: "401006186", nome: "VILLAROMAGNANO", provincia: "AL" },
  { code: "419086020", nome: "VILLAROSA", provincia: "EN" },
  { code: "420092098", nome: "VILLASALTO", provincia: "CA" },
  { code: "403108049", nome: "VILLASANTA", provincia: "MB" },
  { code: "420092100", nome: "VILLASIMIUS", provincia: "CA" },
  { code: "420092101", nome: "VILLASOR", provincia: "CA" },
  { code: "420092102", nome: "VILLASPECIOSA", provincia: "CA" },
  { code: "401001308", nome: "VILLASTELLONE", provincia: "TO" },
  { code: "401002164", nome: "VILLATA", provincia: "VC" },
  { code: "420095072", nome: "VILLAURBANA", provincia: "OR" },
  { code: "413066106", nome: "VILLAVALLELONGA", provincia: "AQ" },
  { code: "405024118", nome: "VILLAVERLA", provincia: "VI" },
  { code: "404022249", nome: "VILLE D\'ANAUNIA", provincia: "TN" },
  { code: "404022254", nome: "VILLE DI FIEMME", provincia: "TN" },
  { code: "402007074", nome: "VILLENEUVE", provincia: "AO" },
  { code: "406031025", nome: "VILLESSE", provincia: "GO" },
  { code: "413066107", nome: "VILLETTA BARREA", provincia: "AQ" },
  { code: "401103076", nome: "VILLETTE", provincia: "VB" },
  { code: "403020068", nome: "VILLIMPENTA", provincia: "MN" },
  { code: "403016242", nome: "VILLONGO", provincia: "BG" },
  { code: "405026091", nome: "VILLORBA", provincia: "TV" },
  { code: "403016243", nome: "VILMINORE DI SCALVE", provincia: "BG" },
  { code: "403108050", nome: "VIMERCATE", provincia: "MB" },
  { code: "403015242", nome: "VIMODRONE", provincia: "MI" },
  { code: "401004248", nome: "VINADIO", provincia: "CN" },
  { code: "414070084", nome: "VINCHIATURO", provincia: "CB" },
  { code: "401005120", nome: "VINCHIO", provincia: "AT" },
  { code: "409048050", nome: "VINCI", provincia: "FI" },
  { code: "401001309", nome: "VINOVO", provincia: "TO" },
  { code: "401003164", nome: "VINZAGLIO", provincia: "NO" },
  { code: "401004249", nome: "VIOLA", provincia: "CN" },
  { code: "403017202", nome: "VIONE", provincia: "BS" },
  { code: "404021115", nome: "VIPITENO", provincia: "BZ" },
  { code: "401001310", nome: "VIRLE PIEMONTE", provincia: "TO" },
  { code: "403017203", nome: "VISANO", provincia: "BS" },
  { code: "401001311", nome: "VISCHE", provincia: "TO" },
  { code: "415063088", nome: "VISCIANO", provincia: "NA" },
  { code: "406030135", nome: "VISCO", provincia: "UD" },
  { code: "401006187", nome: "VISONE", provincia: "AL" },
  { code: "411043057", nome: "VISSO", provincia: "MC" },
  { code: "403018181", nome: "VISTARINO", provincia: "PV" },
  { code: "401001312", nome: "VISTRORIO", provincia: "TO" },
  { code: "419081023", nome: "VITA", provincia: "TP" },
  { code: "412056059", nome: "VITERBO", provincia: "VT" },
  { code: "412060091", nome: "VITICUSO", provincia: "FR" },
  { code: "406093049", nome: "VITO D\'ASIO", provincia: "PN" },
  { code: "412056060", nome: "VITORCHIANO", provincia: "VT" },
  { code: "419088012", nome: "VITTORIA", provincia: "RG" },
  { code: "405026092", nome: "VITTORIO VENETO", provincia: "TV" },
  { code: "413066108", nome: "VITTORITO", provincia: "AQ" },
  { code: "403015243", nome: "VITTUONE", provincia: "MI" },
  { code: "415062077", nome: "VITULANO", provincia: "BN" },
  { code: "415061100", nome: "VITULAZIO", provincia: "CE" },
  { code: "401001313", nome: "VIU\'", provincia: "TO" },
  { code: "412058113", nome: "VIVARO ROMANO", provincia: "RM" },
  { code: "406093050", nome: "VIVARO", provincia: "PN" },
  { code: "401096080", nome: "VIVERONE", provincia: "BI" },
  { code: "419087054", nome: "VIZZINI", provincia: "CT" },
  { code: "403012140", nome: "VIZZOLA TICINO", provincia: "VA" },
  { code: "403015244", nome: "VIZZOLO PREDABISSI", provincia: "MI" },
  { code: "405028105", nome: "VO", provincia: "PD" },
  { code: "403017204", nome: "VOBARNO", provincia: "BS" },
  { code: "407010066", nome: "VOBBIA", provincia: "GE" },
  { code: "401002166", nome: "VOCCA", provincia: "VC" },
  { code: "405025066", nome: "VODO DI CADORE", provincia: "BL" },
  { code: "403018182", nome: "VOGHERA", provincia: "PV" },
  { code: "408038023", nome: "VOGHIERA", provincia: "FE" },
  { code: "401103077", nome: "VOGOGNA", provincia: "VB" },
  { code: "404022224", nome: "VOLANO", provincia: "TN" },
  { code: "415063089", nome: "VOLLA", provincia: "NA" },
  { code: "403019114", nome: "VOLONGO", provincia: "CR" },
  { code: "405026093", nome: "VOLPAGO DEL MONTELLO", provincia: "TV" },
  { code: "403018183", nome: "VOLPARA", provincia: "PV" },
  { code: "401006188", nome: "VOLPEDO", provincia: "AL" },
  { code: "401006189", nome: "VOLPEGLINO", provincia: "AL" },
  { code: "401001314", nome: "VOLPIANO", provincia: "TO" },
  { code: "403020070", nome: "VOLTA MANTOVANA", provincia: "MN" },
  { code: "401006190", nome: "VOLTAGGIO", provincia: "AL" },
  { code: "405025067", nome: "VOLTAGO AGORDINO", provincia: "BL" },
  { code: "409050039", nome: "VOLTERRA", provincia: "PI" },
  { code: "403019115", nome: "VOLTIDO", provincia: "CR" },
  { code: "416071061", nome: "VOLTURARA APPULA", provincia: "FG" },
  { code: "415064119", nome: "VOLTURARA IRPINA", provincia: "AV" },
  { code: "416071062", nome: "VOLTURINO", provincia: "FG" },
  { code: "401001315", nome: "VOLVERA", provincia: "TO" },
  { code: "401004250", nome: "VOTTIGNASCO", provincia: "CN" },
  { code: "418102048", nome: "ZACCANOPOLI", provincia: "VV" },
  { code: "419087055", nome: "ZAFFERANA ETNEA", provincia: "CT" },
  { code: "418079157", nome: "ZAGARISE", provincia: "CZ" },
  { code: "412058114", nome: "ZAGAROLO", provincia: "RM" },
  { code: "418102049", nome: "ZAMBRONE", provincia: "VV" },
  { code: "403016244", nome: "ZANDOBBIO", provincia: "BG" },
  { code: "405024119", nome: "ZANE\'", provincia: "VI" },
  { code: "403016245", nome: "ZANICA", provincia: "BG" },
  { code: "416071064", nome: "ZAPPONETA", provincia: "FG" },
  { code: "403018184", nome: "ZAVATTARELLO", provincia: "PV" },
  { code: "403018185", nome: "ZECCONE", provincia: "PV" },
  { code: "420095074", nome: "ZEDDIANI", provincia: "OR" },
  { code: "403013246", nome: "ZELBIO", provincia: "CO" },
  { code: "403098061", nome: "ZELO BUON PERSICO", provincia: "LO" },
  { code: "403018186", nome: "ZEME", provincia: "PV" },
  { code: "403018187", nome: "ZENEVREDO", provincia: "PV" },
  { code: "405026094", nome: "ZENSON DI PIAVE", provincia: "TV" },
  { code: "408033047", nome: "ZERBA", provincia: "PC" },
  { code: "403018188", nome: "ZERBO", provincia: "PV" },
  { code: "403018189", nome: "ZERBOLO\'", provincia: "PV" },
  { code: "420095075", nome: "ZERFALIU", provincia: "OR" },
  { code: "409045017", nome: "ZERI", provincia: "MS" },
  { code: "405024120", nome: "ZERMEGHEDO", provincia: "VI" },
  { code: "405026095", nome: "ZERO BRANCO", provincia: "TV" },
  { code: "405023097", nome: "ZEVIO", provincia: "VR" },
  { code: "404022226", nome: "ZIANO DI FIEMME", provincia: "TN" },
  { code: "408033048", nome: "ZIANO PIACENTINO", provincia: "PC" },
  { code: "403015247", nome: "ZIBIDO SAN GIACOMO", provincia: "MI" },
  { code: "407011032", nome: "ZIGNAGO", provincia: "SP" },
  { code: "405023098", nome: "ZIMELLA", provincia: "VR" },
  { code: "401096081", nome: "ZIMONE", provincia: "BI" },
  { code: "403018190", nome: "ZINASCO", provincia: "PV" },
  { code: "407010067", nome: "ZOAGLI", provincia: "GE" },
  { code: "408036047", nome: "ZOCCA", provincia: "MO" },
  { code: "403016246", nome: "ZOGNO", provincia: "BG" },
  { code: "408037060", nome: "ZOLA PREDOSA", provincia: "BO" },
  { code: "416075094", nome: "ZOLLINO", provincia: "LE" },
  { code: "403017205", nome: "ZONE", provincia: "BS" },
  { code: "405025069", nome: "ZOPPE\' DI CADORE", provincia: "BL" },
  { code: "406093051", nome: "ZOPPOLA", provincia: "PN" },
  { code: "405024121", nome: "ZOVENCEDO", provincia: "VI" },
  { code: "401096082", nome: "ZUBIENA", provincia: "BI" },
  { code: "407009069", nome: "ZUCCARELLO", provincia: "SV" },
  { code: "405024122", nome: "ZUGLIANO", provincia: "VI" },
  { code: "406030136", nome: "ZUGLIO", provincia: "UD" },
  { code: "401096083", nome: "ZUMAGLIA", provincia: "BI" },
  { code: "418078155", nome: "ZUMPANO", provincia: "CS" },
  { code: "415064120", nome: "ZUNGOLI", provincia: "AV" },
  { code: "418102050", nome: "ZUNGRI", provincia: "VV" },
];

/**
 * Cerca un comune per codice Alloggiati Web.
 * @param {string} code
 * @returns {{ code, nome, provincia } | undefined}
 */
export function findComuneByCode(code) {
  if (!code) return undefined;
  return ALLOGGIATI_COMUNI.find(c => c.code === String(code).trim());
}

/**
 * Restituisce il nome visualizzato per un codice Alloggiati Web.
 * Fallback: il codice grezzo.
 * @param {string} code
 * @returns {string}
 */
export function getComuneLabel(code) {
  if (!code) return "";
  const c = findComuneByCode(code);
  return c ? `${c.nome} (${c.provincia})` : code;
}
